var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDataAssurance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 460,
    height: 460,
    viewBox: "0 0 460 460",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M148.496 385.754C148.496 385.754 148.502 385.751 148.507 385.748C153.134 382.418 156.883 378.304 159.803 373.549C159.81 373.538 159.817 373.528 159.825 373.517C161.805 370.284 163.4 366.761 164.617 362.99C165.525 360.183 166.227 357.236 166.729 354.169L166.726 354.164C166.785 353.851 166.831 353.537 166.878 353.217C166.877 353.203 166.884 353.194 166.884 353.18C167.77 347.151 167.888 340.679 167.253 333.909C166.672 327.541 165.43 320.903 163.555 314.129C161.788 307.688 159.448 301.123 156.565 294.527C154.093 288.864 151.22 283.182 147.961 277.541C144.703 271.899 141.22 266.569 137.549 261.592C133.282 255.803 128.766 250.494 124.08 245.745C119.143 240.732 114.021 236.335 108.795 232.643C103.256 228.719 97.5989 225.587 91.9427 223.342C91.9427 223.342 91.9378 223.34 91.928 223.338C91.6153 223.211 91.3056 223.09 90.9874 222.975L90.9843 222.97C88.0768 221.867 85.1653 220.997 82.2749 220.384L82.2665 220.382C78.3786 219.552 74.5201 219.175 70.7246 219.277C65.1552 219.43 59.7176 220.62 54.5238 222.958C54.5238 222.958 54.5203 222.961 54.5132 222.965C53.2026 223.554 51.9067 224.216 50.6285 224.954C50.0533 225.286 49.4986 225.625 48.95 225.976C45.9532 227.885 43.2905 230.103 40.9538 232.59C40.4416 233.132 39.9471 233.684 39.4707 234.252C36.8717 237.324 34.7193 240.769 33.0049 244.522C32.8881 244.756 32.7829 244.989 32.6931 245.215C32.1403 246.471 31.6344 247.763 31.1792 249.084C31.1792 249.084 31.1779 249.089 31.1753 249.098C30.7515 250.335 30.3616 251.597 30.0209 252.886C30.0102 252.926 30.0009 252.944 30.0009 252.944C28.279 259.429 27.585 266.572 27.8794 274.151C27.8802 274.165 27.8786 274.171 27.8763 274.179C27.9234 275.297 27.9883 276.424 28.071 277.561C28.0732 277.586 28.0733 277.611 28.078 277.644C28.1668 278.858 28.2832 280.087 28.4297 281.322L28.4274 281.33C29.2903 288.854 31.0429 296.721 33.6416 304.739C35.8803 311.649 38.7505 318.671 42.2232 325.679C43.8508 328.972 45.6113 332.264 47.503 335.537C49.3946 338.811 51.3634 341.981 53.3995 345.034C57.7355 351.551 62.3819 357.548 67.2462 362.941C73.7274 370.13 80.5859 376.247 87.6181 381.093C87.6421 381.113 87.6719 381.128 87.6958 381.148C88.7349 381.865 89.7761 382.549 90.8235 383.21C90.8235 383.21 90.8273 383.213 90.835 383.218C97.2578 387.264 103.796 390.241 110.277 391.988C110.277 391.988 110.297 391.989 110.337 392C111.608 392.345 112.882 392.639 114.151 392.887C115.544 393.154 116.934 393.371 118.321 393.527C118.567 393.55 118.815 393.574 119.061 393.599C119.061 393.599 119.065 393.599 119.074 393.598C123.181 393.99 127.241 393.849 131.201 393.134C131.919 393.006 132.639 392.857 133.355 392.689C137.294 391.766 141.14 390.25 144.835 388.118C146.113 387.38 147.334 386.589 148.5 385.749L148.496 385.754ZM110.495 332.988C108.025 330.647 104.799 327.264 101.274 322.735C98.4549 319.11 95.441 314.741 92.4629 309.583C89.4849 304.425 87.2121 299.634 85.4784 295.376C83.3164 290.054 82.0026 285.574 81.2071 282.259C80.2464 278.233 80.0473 275.927 80.0473 275.927C80.0473 275.927 80.3715 276.153 80.9634 276.616C81.5136 277.049 82.2991 277.696 83.2782 278.562C87.5373 282.341 95.3843 290.33 102.992 303.506C103.943 305.155 104.823 306.77 105.639 308.335C111.317 319.302 113.736 328.17 114.734 333.046C114.995 334.326 115.16 335.33 115.262 336.023C115.366 336.769 115.401 337.161 115.401 337.161C115.401 337.161 113.503 335.833 110.497 332.991L110.495 332.988Z",
    fill: "#141332"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110.443 392.283C105.175 390.871 99.7877 388.624 94.3238 385.544C76.929 375.737 60.237 358.015 47.3193 335.641C34.4032 313.27 27.4022 289.951 27.6047 269.983C27.8184 248.939 35.7436 233.307 50.5203 224.776C65.2969 216.245 82.7995 217.198 101.128 227.534C118.523 237.343 135.215 255.065 148.133 277.436C161.049 299.808 168.05 323.127 167.848 343.095C167.634 364.138 159.709 379.77 144.932 388.302C134.56 394.29 122.844 395.606 110.443 392.283ZM84.9116 221.194C72.6128 217.899 61.0026 219.2 50.7269 225.131C36.0828 233.587 28.2287 249.097 28.0155 269.987C27.8126 289.881 34.7954 313.125 47.6741 335.435C60.5548 357.745 77.194 375.412 94.5239 385.183C112.722 395.446 130.08 396.399 144.726 387.943C159.371 379.486 167.225 363.977 167.438 343.086C167.641 323.19 160.658 299.946 147.779 277.639C134.899 255.329 118.259 237.662 100.929 227.89C95.499 224.828 90.1431 222.596 84.9116 221.194Z",
    fill: "url(#paint0_linear_376_6503)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M115.35 337.354C115.327 337.348 115.305 337.338 115.286 337.324C115.168 337.243 103.388 328.918 92.2835 309.684C81.1785 290.449 79.859 276.086 79.8456 275.942C79.8401 275.862 79.8782 275.787 79.9475 275.747C80.0167 275.707 80.101 275.712 80.1678 275.756C80.2856 275.838 92.0652 284.162 103.17 303.397C114.275 322.631 115.595 336.995 115.608 337.138C115.614 337.218 115.575 337.293 115.506 337.333C115.458 337.361 115.402 337.368 115.35 337.354ZM80.3057 276.367C80.6281 278.961 82.6904 292.25 92.6377 309.479C102.586 326.711 113.06 335.138 115.147 336.715C114.825 334.121 112.763 320.832 102.815 303.603C92.8672 286.369 82.3931 277.944 80.3057 276.367Z",
    fill: "url(#paint1_linear_376_6503)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4449 335.738C47.3945 335.725 47.3492 335.692 47.3199 335.641C47.2631 335.543 47.2963 335.419 47.3948 335.362L92.3559 309.404C92.4544 309.347 92.5783 309.38 92.6352 309.479C92.6921 309.577 92.6589 309.701 92.5603 309.758L47.5993 335.716C47.5513 335.744 47.4932 335.751 47.4428 335.737L47.4449 335.738Z",
    fill: "url(#paint2_linear_376_6503)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1672 325.887C42.1525 325.883 42.1357 325.879 42.1227 325.868C42.0229 325.812 41.986 325.69 42.042 325.59C44.8743 320.413 65.9651 310.285 72.3616 307.306C85.3742 301.242 88.5507 302.156 88.6882 302.197C88.7957 302.233 88.8544 302.35 88.8194 302.455C88.7844 302.56 88.6685 302.615 88.5635 302.587C88.4711 302.562 85.1916 301.78 72.5368 307.677C59.4136 313.792 44.6053 321.761 42.4031 325.788C42.3579 325.873 42.2596 325.912 42.1714 325.888L42.1672 325.887Z",
    fill: "url(#paint3_linear_376_6503)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3054 315.111C37.3054 315.111 37.2844 315.105 37.2744 315.1C37.1718 315.055 37.1259 314.932 37.1714 314.83C37.3106 314.52 40.7928 307.136 59.3976 299.817C75.7025 293.404 81.4986 293.287 85.5651 295.189C85.6672 295.237 85.711 295.359 85.6634 295.461C85.6158 295.563 85.4917 295.606 85.3917 295.559C81.4172 293.708 75.7147 293.837 59.5479 300.197C41.0992 307.454 37.5807 314.923 37.5473 314.998C37.5046 315.09 37.4041 315.137 37.3075 315.111L37.3054 315.111Z",
    fill: "url(#paint4_linear_376_6503)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5874 304.95C33.4824 304.922 33.4182 304.817 33.4401 304.71C34.987 297.307 46.3351 291.742 55.583 288.379C75.8676 280.999 82.7779 287.889 83.063 288.186C83.1402 288.267 83.1391 288.397 83.0576 288.474C82.9756 288.554 82.848 288.551 82.7687 288.469C82.7003 288.397 75.7254 281.488 55.7253 288.764C46.5745 292.092 35.3523 297.574 33.8432 304.793C33.8202 304.904 33.7114 304.974 33.6005 304.951L33.59 304.948L33.5874 304.95Z",
    fill: "url(#paint5_linear_376_6503)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7219 294.775C30.64 294.753 30.5779 294.682 30.5704 294.593C30.5408 294.191 30.0786 284.667 52.2103 277.787C74.3371 270.907 81.3148 282.04 81.3836 282.153C81.441 282.249 81.4094 282.376 81.3129 282.433C81.2159 282.493 81.0915 282.462 81.0325 282.363C80.9652 282.252 74.1326 271.402 52.3329 278.177C30.5109 284.96 30.9734 294.466 30.9797 294.56C30.9878 294.673 30.9028 294.772 30.7903 294.78C30.7677 294.78 30.7434 294.778 30.7224 294.773L30.7219 294.775Z",
    fill: "url(#paint6_linear_376_6503)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3708 281.531C28.3561 281.527 28.3414 281.523 28.3278 281.515C28.2275 281.461 28.1884 281.338 28.2423 281.238C28.306 281.118 34.8588 269.07 54.6891 266.528C74.5638 263.98 80.1784 275.721 80.2344 275.84C80.2812 275.943 80.2354 276.063 80.1323 276.112C80.0291 276.161 79.9086 276.115 79.8603 276.01C79.8058 275.894 74.3 264.427 54.7403 266.933C35.1341 269.446 28.6673 281.307 28.6035 281.427C28.5583 281.512 28.4596 281.553 28.3692 281.529L28.3708 281.531Z",
    fill: "url(#paint7_linear_376_6503)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27.82 274.403C27.7276 274.378 27.6632 274.291 27.669 274.194C27.6773 274.045 28.8654 259.228 52.7963 257.066C61.5256 256.276 69.5763 258.582 74.8798 263.395C78.0346 266.255 79.9329 269.823 79.958 272.938C79.9593 273.051 79.867 273.144 79.7541 273.145C79.6439 273.145 79.5484 273.056 79.5477 272.941C79.5259 269.939 77.6764 266.484 74.6052 263.698C69.3858 258.966 61.4489 256.697 52.8332 257.475C29.2715 259.602 28.0882 274.074 28.0784 274.22C28.0707 274.333 27.9732 274.419 27.8605 274.412C27.8473 274.41 27.8321 274.409 27.8195 274.405L27.82 274.403Z",
    fill: "url(#paint8_linear_376_6503)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M127.095 343.52C123.403 342.531 119.44 340.476 115.349 337.39L115.258 337.307C115.176 337.229 115.172 337.1 115.25 337.017C115.329 336.934 115.458 336.931 115.541 337.009L115.612 337.078C124.496 343.785 132.759 345.544 138.856 342.025C151.164 334.919 146.17 307.177 133.782 285.724C121.394 264.271 99.8667 246.072 87.5607 253.179C81.4673 256.699 78.8613 264.728 80.2258 275.79L80.248 275.884C80.2725 275.994 80.2026 276.103 80.0925 276.128C79.9824 276.152 79.8728 276.082 79.8483 275.972L79.8243 275.86C78.4351 264.604 81.1132 256.433 87.3583 252.825C93.2413 249.427 101.609 251.406 110.919 258.396C119.401 264.763 127.865 274.65 134.139 285.518C140.415 296.388 144.744 308.661 146.018 319.188C147.416 330.745 144.946 338.982 139.061 342.377C135.639 344.353 131.563 344.715 127.093 343.517L127.095 343.52Z",
    fill: "url(#paint9_linear_376_6503)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M123.215 342.138C123.121 342.113 123.055 342.021 123.064 341.92C123.076 341.808 123.175 341.725 123.287 341.734C126.058 342.004 128.586 341.493 130.801 340.214C141.748 333.893 137.288 309.182 126.255 290.068C115.219 270.953 96.0484 254.735 85.1005 261.058C82.887 262.337 81.1784 264.27 80.0266 266.805C79.979 266.907 79.8575 266.948 79.7559 266.908C79.6538 266.86 79.6073 266.74 79.6534 266.635C80.8424 264.02 82.6038 262.025 84.8939 260.703C90.1425 257.673 97.6058 259.441 105.909 265.677C113.47 271.356 121.014 280.173 126.609 289.864C132.203 299.554 136.065 310.495 137.206 319.881C138.457 330.191 136.254 337.537 131.006 340.568C128.715 341.89 126.106 342.42 123.248 342.142C123.237 342.14 123.226 342.139 123.214 342.136L123.215 342.138Z",
    fill: "url(#paint10_linear_376_6503)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M122.348 341.735C122.294 341.72 122.245 341.683 122.219 341.63C122.167 341.529 122.209 341.407 122.308 341.355C122.488 341.264 122.667 341.168 122.843 341.066C133.029 335.183 128.897 312.221 118.643 294.464C108.391 276.708 90.5703 261.646 80.3845 267.526C80.2088 267.628 80.0361 267.735 79.8671 267.845C79.7716 267.907 79.646 267.88 79.5838 267.784C79.5216 267.689 79.5485 267.563 79.6439 267.501C79.8183 267.388 79.9969 267.276 80.18 267.172C85.0719 264.348 92.0231 265.985 99.7503 271.783C106.782 277.06 113.798 285.252 118.999 294.26C124.201 303.269 127.787 313.441 128.84 322.169C129.998 331.76 127.941 338.599 123.049 341.423C122.866 341.527 122.681 341.628 122.496 341.723C122.449 341.746 122.398 341.751 122.35 341.738L122.348 341.735Z",
    fill: "url(#paint11_linear_376_6503)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M120.096 340.539C120.096 340.539 120.075 340.534 120.065 340.529C119.962 340.483 119.916 340.361 119.962 340.258C123.904 331.462 120.335 313.943 111.477 298.602C102.62 283.26 89.23 271.411 79.6434 270.427C79.5302 270.413 79.4486 270.314 79.4605 270.203C79.4729 270.089 79.5734 270.008 79.685 270.02C89.3949 271.014 102.914 282.952 111.831 298.397C120.749 313.842 124.325 331.519 120.336 340.426C120.293 340.518 120.19 340.565 120.096 340.539Z",
    fill: "url(#paint12_linear_376_6503)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M117.161 338.681C117.064 338.656 116.999 338.562 117.01 338.461C118.055 329.312 113.751 314.495 106.3 301.59C98.8476 288.685 88.1681 277.549 79.7242 273.88C79.6216 273.834 79.573 273.713 79.6185 273.61C79.6646 273.506 79.7824 273.461 79.8877 273.505C88.4065 277.205 99.1645 288.41 106.656 301.386C114.147 314.36 118.473 329.28 117.418 338.51C117.406 338.623 117.304 338.702 117.192 338.69C117.182 338.687 117.171 338.686 117.162 338.684L117.161 338.681Z",
    fill: "url(#paint13_linear_376_6503)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M115.208 336.218C115.126 336.196 115.064 336.126 115.057 336.036C114.356 327.092 109.882 314.539 103.38 303.277C96.8764 292.013 88.2425 281.862 80.8465 276.785C80.7532 276.722 80.7289 276.594 80.7943 276.501C80.8597 276.408 80.9872 276.386 81.0784 276.449C88.5218 281.558 97.2029 291.761 103.733 303.075C110.264 314.387 114.759 327.006 115.465 336.008C115.473 336.12 115.39 336.22 115.278 336.228C115.254 336.231 115.23 336.229 115.209 336.223L115.208 336.218Z",
    fill: "url(#paint14_linear_376_6503)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M132.627 348.451C118.875 344.766 102.861 328.478 92.0777 309.8C84.535 296.736 79.4617 282.411 78.1564 270.498C76.7492 257.646 79.7684 248.377 86.6554 244.399C93.4698 240.465 103.131 242.7 113.856 250.692C123.636 257.979 133.377 269.314 140.581 281.795C147.786 294.273 152.733 308.378 154.154 320.491C155.713 333.777 152.818 343.262 146.003 347.196C142.044 349.48 137.474 349.75 132.625 348.451L132.627 348.451ZM99.5469 243.684C94.6975 242.385 90.3845 242.722 86.8614 244.756C80.1215 248.647 77.1764 257.774 78.5643 270.454C79.8637 282.313 84.9168 296.579 92.434 309.596C106.92 334.686 130.842 355.475 145.801 346.842C152.464 342.993 155.286 333.654 153.749 320.54C152.334 308.48 147.407 294.433 140.228 282.002C133.05 269.569 123.348 258.278 113.612 251.023C108.621 247.304 103.871 244.843 99.5469 243.684Z",
    fill: "url(#paint15_linear_376_6503)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M120.038 391.511C98.5001 385.74 74.4518 363.465 55.6211 330.85C32.7761 291.281 26.9517 252.667 40.779 232.473C40.8422 232.38 40.9703 232.356 41.0631 232.421C41.1564 232.485 41.1806 232.613 41.1174 232.706C27.3766 252.77 33.2102 291.215 55.9753 330.645C78.7418 370.078 109.119 394.348 133.364 392.482C133.477 392.474 133.576 392.557 133.584 392.67C133.592 392.782 133.509 392.881 133.395 392.889C129.106 393.219 124.627 392.739 120.036 391.509L120.038 391.511Z",
    fill: "url(#paint16_linear_376_6503)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M114.157 393.102L114.155 393.101C92.2172 386.917 68.4452 364.737 50.5662 333.769C32.6852 302.801 25.3622 271.124 30.9758 249.031C31.0051 248.922 31.1154 248.855 31.2246 248.884L31.2267 248.884C31.3359 248.914 31.4011 249.023 31.3718 249.133C25.7836 271.122 33.0922 302.685 50.9189 333.562C68.7456 364.439 92.4259 386.55 114.263 392.705C114.373 392.734 114.437 392.848 114.405 392.957C114.376 393.066 114.263 393.128 114.155 393.099L114.157 393.102Z",
    fill: "url(#paint17_linear_376_6503)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6413 381.351C87.6182 381.345 87.5963 381.335 87.5754 381.32C72.8041 370.753 59.0475 354.862 47.7934 335.37C36.447 315.717 29.5528 295.705 27.8559 277.499C27.8457 277.386 27.9286 277.286 28.0416 277.276C28.1547 277.266 28.254 277.349 28.2642 277.462C29.9563 295.61 36.8325 315.564 48.1496 335.166C59.3766 354.609 73.0913 370.454 87.8157 380.986C87.9085 381.052 87.928 381.181 87.8632 381.271C87.8124 381.343 87.7238 381.371 87.644 381.35L87.6413 381.351Z",
    fill: "url(#paint18_linear_376_6503)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M136.444 355.975C131.594 354.675 126.346 352.002 120.881 347.992C109.696 339.783 98.2732 326.398 89.5368 311.269C80.8026 296.141 74.9214 279.555 73.4061 265.763C71.7697 250.893 75.2495 240.174 83.2064 235.581C91.1419 230.999 102.2 233.404 114.342 242.352C125.559 250.616 136.946 263.941 145.587 278.906C154.227 293.872 160.073 310.398 161.621 324.243C163.3 339.234 159.854 350.011 151.918 354.593C147.567 357.105 142.295 357.542 136.439 355.974L136.444 355.975ZM98.4643 234.62C92.7476 233.088 87.6257 233.503 83.4129 235.935C75.6052 240.443 72.1974 251.019 73.8146 265.717C75.3266 279.454 81.1877 295.98 89.8937 311.063C98.6024 326.144 109.983 339.485 121.125 347.661C133.045 356.41 143.908 358.747 151.716 354.239C159.502 349.744 162.877 339.107 161.217 324.29C159.675 310.497 153.847 294.031 145.235 279.112C136.621 264.191 125.275 250.913 114.1 242.681C108.591 238.621 103.314 235.919 98.4643 234.62Z",
    fill: "url(#paint19_linear_376_6503)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M127.068 387.855C120.44 386.079 113.279 382.454 105.834 377.031C90.4317 365.811 74.7272 347.478 62.7505 326.734C50.7738 305.99 42.7487 283.225 40.7336 264.274C38.5628 243.864 43.4224 229.13 54.415 222.783C54.5135 222.726 54.6374 222.759 54.6943 222.858C54.7512 222.957 54.718 223.08 54.6195 223.137C43.776 229.398 38.99 243.992 41.1415 264.23C43.1517 283.123 51.1562 305.831 63.1073 326.528C75.0564 347.224 90.7188 365.512 106.076 376.7C122.527 388.682 137.559 391.834 148.402 385.574C148.501 385.517 148.625 385.55 148.682 385.649C148.738 385.747 148.705 385.871 148.607 385.928C142.549 389.426 135.211 390.037 127.068 387.855Z",
    fill: "url(#paint20_linear_376_6503)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M137.898 364.891C132.284 363.387 126.172 360.248 119.787 355.523C107.033 346.088 94.1515 331.031 84.4404 314.214C74.7299 297.394 68.133 278.708 66.3369 262.948C64.3886 245.831 68.2544 233.555 77.2211 228.376C86.2085 223.187 98.7398 225.917 112.506 236.068C125.228 245.447 138.145 260.565 147.949 277.547C157.753 294.529 164.386 313.274 166.147 328.98C168.056 345.976 164.153 358.195 155.166 363.384C150.333 366.174 144.456 366.65 137.895 364.892L137.898 364.891ZM94.503 227.238C88.0176 225.5 82.2055 225.971 77.4255 228.73C58.0313 239.928 66.1478 281.715 84.7925 314.009C94.4753 330.78 107.32 345.791 120.028 355.193C133.738 365.336 146.145 368.118 154.962 363.028C163.8 357.925 167.628 345.85 165.741 329.025C163.986 313.374 157.372 294.683 147.595 277.751C137.818 260.818 124.941 245.746 112.263 236.397C106.005 231.783 100.01 228.713 94.503 227.238Z",
    fill: "url(#paint21_linear_376_6503)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M132.877 381.551C126.318 379.794 119.181 376.135 111.725 370.628C96.799 359.605 81.7273 342.002 70.3711 322.336C59.0171 302.67 51.3084 280.816 49.2257 262.378C46.9643 242.365 51.5006 228.006 61.9985 221.943C64.6641 220.404 67.6127 219.438 70.7649 219.074C70.8764 219.061 70.9784 219.142 70.9913 219.254C71.0042 219.365 70.9249 219.468 70.8113 219.48C67.7146 219.839 64.8201 220.788 62.203 222.297C51.8548 228.272 47.3899 242.49 49.6326 262.33C51.7094 280.714 59.3979 302.509 70.7259 322.129C82.0538 341.75 97.0841 359.306 111.967 370.296C128.03 382.157 142.573 385.401 152.922 379.426C155.532 377.918 157.798 375.889 159.656 373.395C159.723 373.305 159.852 373.288 159.942 373.353C160.033 373.42 160.052 373.549 159.985 373.641C158.093 376.18 155.786 378.247 153.128 379.781C147.461 383.053 140.568 383.612 132.877 381.551Z",
    fill: "url(#paint22_linear_376_6503)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M136.439 373.555C130.288 371.907 123.592 368.47 116.595 363.295C102.614 352.956 88.4901 336.453 77.8464 318.018C67.2026 299.582 59.973 279.099 58.0095 261.821C55.8778 243.062 60.1184 229.605 69.9473 223.931C76.0587 220.402 83.4792 220.137 92.0021 223.15C92.1091 223.188 92.1657 223.304 92.128 223.411C92.0903 223.518 91.968 223.58 91.8669 223.537C83.4645 220.57 76.1582 220.82 70.1533 224.287C60.4735 229.876 56.305 243.19 58.4179 261.775C60.3755 279 67.5845 299.426 78.2026 317.814C88.8182 336.203 102.902 352.662 116.841 362.967C131.882 374.088 145.494 377.136 155.176 371.548C161.171 368.088 165.04 361.894 166.679 353.141C166.7 353.029 166.807 352.957 166.919 352.977C167.023 352.992 167.103 353.105 167.082 353.217C165.422 362.093 161.486 368.381 155.382 371.905C150.083 374.965 143.636 375.486 136.443 373.559L136.439 373.555Z",
    fill: "url(#paint23_linear_376_6503)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2014 262.604C28.2014 262.604 28.1888 262.601 28.1825 262.599C28.0761 262.56 28.0216 262.444 28.0614 262.337C30.2188 256.453 39.2675 246.054 58.0835 248.817C78.0308 251.736 80.0364 266.42 80.0529 266.569C80.0673 266.683 79.9865 266.783 79.8745 266.798C79.7651 266.811 79.6604 266.732 79.6454 266.62C79.6278 266.475 77.6429 252.1 58.0224 249.222C39.4663 246.496 30.5596 256.702 28.4445 262.478C28.4085 262.579 28.3016 262.633 28.1987 262.606L28.2014 262.604Z",
    fill: "url(#paint24_linear_376_6503)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8298 266.53L79.8214 266.528C79.7133 266.494 79.652 266.379 79.6854 266.271C81.0616 261.84 79.6821 256.563 75.8959 251.792C70.0329 244.405 60.1266 240.069 50.6613 240.749C34.1173 241.939 30.2278 252.901 30.1912 253.013C30.1556 253.121 30.0451 253.197 29.9316 253.142C29.8241 253.106 29.7675 252.99 29.8031 252.882C29.8424 252.769 33.8021 241.553 50.6312 240.34C60.2297 239.651 70.2731 244.046 76.2182 251.539C80.088 256.418 81.4943 261.83 80.0779 266.394C80.045 266.5 79.9343 266.56 79.8293 266.532L79.8298 266.53Z",
    fill: "url(#paint25_linear_376_6503)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7694 267.094C79.7547 267.09 79.7378 267.086 79.7248 267.075C79.6245 267.021 79.5881 266.897 79.6414 266.799C79.7263 266.641 87.8482 250.922 68.3984 238.242C59.3976 232.375 51.3406 233.109 46.1653 234.756C39.3118 236.938 34.2928 241.707 32.8782 245.289C32.8363 245.395 32.7131 245.443 32.611 245.405C32.5051 245.363 32.4539 245.243 32.4952 245.139C33.9472 241.468 39.0661 236.586 46.04 234.367C51.2991 232.692 59.4882 231.945 68.621 237.899C88.3968 250.79 80.087 266.833 80.0015 266.992C79.9564 267.077 79.8576 267.118 79.7694 267.094Z",
    fill: "url(#paint26_linear_376_6503)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7504 267.307C79.7294 267.302 79.7089 267.294 79.6902 267.28C79.5947 267.216 79.57 267.09 79.6311 266.996C87.5052 255.033 81.2101 243.991 78.1372 239.8C76.8204 238.002 69.615 228.997 57.0001 228.133C46.2236 227.398 39.679 234.324 39.6129 234.394C39.5366 234.477 39.4062 234.485 39.3242 234.404C39.2411 234.328 39.2354 234.198 39.3138 234.116C39.3804 234.043 46.0488 226.975 57.0286 227.724C69.8259 228.596 77.1329 237.735 78.4683 239.556C81.5901 243.816 87.9887 255.043 79.9739 267.221C79.9246 267.296 79.8328 267.327 79.7509 267.305L79.7504 267.307Z",
    fill: "url(#paint27_linear_376_6503)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7291 267.529C79.6892 267.518 79.6527 267.495 79.6253 267.463C79.5519 267.376 79.5641 267.246 79.6507 267.175C79.7031 267.13 84.9683 262.619 85.7858 253.965C86.7847 243.398 81.5238 233.361 71.7177 227.113C60.4708 219.951 49.1573 226.093 49.0413 226.156C48.9433 226.211 48.8179 226.175 48.7631 226.077C48.7083 225.979 48.7442 225.854 48.8421 225.799C48.9582 225.735 60.4784 219.469 71.9361 226.769C81.8753 233.099 87.2034 243.281 86.1918 254.004C85.3565 262.833 79.9658 267.444 79.9113 267.488C79.8588 267.532 79.7879 267.545 79.727 267.528L79.7291 267.529Z",
    fill: "url(#paint28_linear_376_6503)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6597 268.559C79.6093 268.545 79.564 268.513 79.5369 268.463C79.4794 268.367 79.5132 268.241 79.6117 268.184C79.6836 268.142 86.9421 263.802 89.0919 252.108C90.2187 245.979 88.3873 236.021 81.7019 228.645C78.0291 224.593 71.5046 219.943 61.2742 220.799C61.1638 220.807 61.0624 220.724 61.0522 220.611C61.0419 220.498 61.1269 220.399 61.24 220.389C71.6362 219.519 78.2702 224.248 82.0035 228.368C88.7826 235.848 90.6373 245.954 89.4909 252.181C87.3041 264.073 79.8886 268.494 79.8141 268.537C79.7662 268.565 79.708 268.572 79.6576 268.558L79.6597 268.559Z",
    fill: "url(#paint29_linear_376_6503)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6226 269.545C79.5638 269.529 79.5139 269.489 79.489 269.43C79.4428 269.326 79.4907 269.206 79.5953 269.159C79.7457 269.094 94.7277 262.274 92.9367 242.74C91.9726 232.233 86.7106 226.56 82.4658 223.651C77.8316 220.473 72.7367 219.41 70.6163 219.485C70.5044 219.491 70.4073 219.4 70.4034 219.289C70.4 219.175 70.4881 219.082 70.6 219.076C72.7732 218.996 77.9801 220.078 82.6962 223.312C87.0129 226.271 92.3646 232.039 93.3434 242.7C95.1637 262.538 79.914 269.465 79.7583 269.534C79.7148 269.554 79.6667 269.557 79.6226 269.545Z",
    fill: "url(#paint30_linear_376_6503)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6152 270.97C79.5459 270.951 79.4883 270.897 79.47 270.823C79.4407 270.713 79.507 270.601 79.6177 270.574C79.7024 270.552 88.0729 268.304 93.0137 259.962C95.5786 255.632 99.5386 244.776 96.1678 234.682C94.0212 228.261 89.3168 223.514 82.1813 220.573C82.0761 220.529 82.0269 220.41 82.0709 220.305C82.1148 220.2 82.2386 220.15 82.3391 220.195C89.5898 223.184 94.3729 228.016 96.5582 234.553C99.5294 243.441 96.9868 254.064 93.3699 260.17C88.3395 268.661 79.8076 270.949 79.7228 270.971C79.6868 270.98 79.6509 270.979 79.6194 270.971L79.6152 270.97Z",
    fill: "url(#paint31_linear_376_6503)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7087 273.267C79.6373 273.248 79.5765 273.189 79.5615 273.111C79.5391 273.001 79.609 272.892 79.7212 272.868C79.881 272.834 95.6982 269.358 100.653 252.784C105.156 237.714 99.1574 226.474 90.9042 223.16C90.7984 223.118 90.7471 222.999 90.7911 222.893C90.833 222.787 90.9567 222.737 91.0578 222.78C99.4838 226.163 105.62 237.595 101.047 252.901C96.0234 269.716 79.9692 273.236 79.8073 273.269C79.776 273.276 79.7428 273.274 79.7134 273.266L79.7087 273.267Z",
    fill: "url(#paint32_linear_376_6503)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7967 274.392C79.7064 274.368 79.6393 274.282 79.6451 274.185C79.6507 274.071 79.7461 273.984 79.8594 273.99C86.2933 274.307 92.7409 271.33 98.018 265.606C102.769 260.451 106.178 253.373 107.136 246.674C109.016 233.542 101.142 228.024 101.064 227.969C100.971 227.906 100.946 227.778 101.01 227.684C101.073 227.591 101.201 227.567 101.294 227.63C101.376 227.686 109.461 233.334 107.544 246.732C105.55 260.656 93.9444 275.097 79.8419 274.4C79.8267 274.398 79.8135 274.396 79.7988 274.393L79.7967 274.392Z",
    fill: "url(#paint33_linear_376_6503)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M81.299 276.287C80.4443 276.058 79.9389 275.844 79.9227 275.837C79.8174 275.793 79.7709 275.673 79.817 275.568C79.863 275.463 79.9757 275.412 80.0867 275.46C80.1454 275.485 85.8511 277.889 91.5969 275.062C96.7257 272.537 104.145 267.975 109.355 257.547C114.484 247.277 114.194 237.554 108.621 232.772C108.535 232.697 108.525 232.568 108.6 232.482C108.674 232.396 108.805 232.389 108.889 232.461C114.611 237.368 114.94 247.286 109.725 257.729C104.46 268.269 96.9631 272.878 91.7816 275.431C87.5807 277.5 83.3977 276.847 81.3059 276.286L81.299 276.287Z",
    fill: "url(#paint34_linear_376_6503)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3175 279.566C84.5762 279.367 83.864 279.093 83.1838 278.742C83.0828 278.69 83.0438 278.567 83.0956 278.466C83.1474 278.365 83.2704 278.326 83.3713 278.378C91.6005 282.647 105.019 275.06 113.916 261.102C122.684 247.347 117.214 239.588 117.157 239.512C117.092 239.42 117.11 239.292 117.201 239.224C117.293 239.157 117.418 239.177 117.486 239.267C117.544 239.345 123.188 247.314 114.26 261.32C105.977 274.315 93.7687 281.83 85.3133 279.565L85.3175 279.566Z",
    fill: "url(#paint35_linear_376_6503)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8845 283.366C87.9541 283.117 87.4448 282.825 87.3868 282.789C87.2897 282.732 87.2581 282.606 87.3156 282.509C87.3731 282.412 87.4987 282.38 87.5964 282.436C87.6365 282.462 91.8917 284.879 99.2261 281.482C106.818 277.965 118.961 267.038 122.656 258.743C125.356 252.682 125.771 248.343 123.89 245.844C123.822 245.754 123.841 245.626 123.932 245.556C124.022 245.488 124.152 245.507 124.218 245.597C126.195 248.222 125.797 252.701 123.03 258.908C119.299 267.282 107.053 278.307 99.3965 281.854C94.3488 284.193 90.76 283.869 88.8824 283.366L88.8845 283.366Z",
    fill: "url(#paint36_linear_376_6503)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M92.579 287.963C92.0204 287.813 91.7486 287.634 91.7048 287.604C91.612 287.539 91.5899 287.412 91.6553 287.319C91.7207 287.226 91.846 287.203 91.9394 287.267C91.9847 287.299 96.4691 290.137 109.612 281.479C122.552 272.953 133.432 258.997 131.169 253.823C131.123 253.719 131.171 253.599 131.276 253.553C131.38 253.508 131.5 253.556 131.547 253.659C133.92 259.09 123.169 273.039 109.84 281.821C99.5012 288.633 94.4461 288.463 92.5811 287.963L92.579 287.963Z",
    fill: "url(#paint37_linear_376_6503)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M102.938 303.699C102.888 303.685 102.842 303.653 102.813 303.602C102.756 303.504 102.789 303.38 102.888 303.323L147.854 277.362C147.953 277.305 148.077 277.338 148.134 277.436C148.19 277.535 148.157 277.659 148.059 277.716L103.092 303.677C103.044 303.705 102.986 303.712 102.936 303.698L102.938 303.699Z",
    fill: "url(#paint38_linear_376_6503)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1072 293.182C96.0085 293.155 95.9427 293.057 95.9592 292.953C95.9759 292.841 96.0816 292.765 96.192 292.781C96.242 292.788 101.369 293.462 112.86 285.972C124.508 278.379 138.028 265.826 137.343 261.629C137.325 261.518 137.401 261.413 137.511 261.395C137.622 261.375 137.728 261.453 137.747 261.564C138.454 265.909 124.832 278.657 113.082 286.318C101.425 293.918 96.337 293.223 96.1277 293.19C96.1214 293.188 96.113 293.186 96.1067 293.184L96.1072 293.182Z",
    fill: "url(#paint39_linear_376_6503)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8417 298.626C99.7661 298.606 99.7065 298.543 99.692 298.463C99.6723 298.351 99.75 298.246 99.8611 298.226C99.9341 298.215 107.497 296.864 123.687 286.058C140.99 274.508 142.501 270.867 142.997 269.672C143.041 269.567 143.161 269.522 143.265 269.562C143.37 269.606 143.419 269.725 143.375 269.83C142.493 271.955 139.516 275.983 123.912 286.4C107.632 297.268 100.001 298.62 99.9255 298.633C99.8948 298.638 99.8663 298.635 99.839 298.628L99.8417 298.626Z",
    fill: "url(#paint40_linear_376_6503)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3373 345.234C53.247 345.209 53.1836 345.127 53.1868 345.031C53.1903 344.917 53.2841 344.828 53.3958 344.831C57.9841 344.937 72.2897 336.097 84.1476 327.79C95.6927 319.7 96.5611 316.485 96.5696 316.453C96.5967 316.343 96.7049 316.275 96.8137 316.298C96.9317 316.336 96.9924 316.429 96.97 316.538C96.9414 316.67 96.1512 319.879 84.3819 328.125C78.6013 332.174 59.2847 345.375 53.3852 345.24C53.3673 345.239 53.352 345.238 53.3373 345.234Z",
    fill: "url(#paint41_linear_376_6503)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2394 354.833C60.1449 354.808 60.0794 354.716 60.0885 354.615C60.101 354.501 60.2015 354.42 60.3131 354.432C60.3942 354.44 68.6481 355.105 84.131 342.779C97.7226 331.958 100.689 327.08 101.07 322.717C101.08 322.602 101.179 322.519 101.291 322.531C101.399 322.537 101.487 322.639 101.477 322.752C101.087 327.223 98.0911 332.188 84.3851 343.099C68.7445 355.552 60.6084 354.876 60.2688 354.841C60.2583 354.838 60.2472 354.837 60.2367 354.835L60.2394 354.833Z",
    fill: "url(#paint42_linear_376_6503)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6362 363.268C67.4786 363.226 67.3223 363.18 67.167 363.129C67.0595 363.094 67.0002 362.979 67.0358 362.871C67.0714 362.764 67.1798 362.712 67.2938 362.74C74.3047 365.062 84.6611 358.065 92.1191 351.805C108.42 338.122 105.922 328.627 105.896 328.532C105.864 328.422 105.926 328.31 106.036 328.279C106.145 328.248 106.259 328.31 106.289 328.419C106.403 328.814 108.915 338.241 92.3812 352.121C85.0051 358.311 74.7994 365.19 67.6335 363.27L67.6362 363.268Z",
    fill: "url(#paint43_linear_376_6503)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1006 371.337C75.1051 371.07 74.5756 370.728 74.4958 370.673C74.4025 370.61 74.3782 370.482 74.4415 370.388C74.5048 370.295 74.6323 370.273 74.7262 370.334C74.8065 370.387 82.841 375.509 99.5909 360.033C116.359 344.542 110.378 333.199 110.316 333.086C110.262 332.986 110.297 332.862 110.395 332.808C110.495 332.753 110.619 332.789 110.673 332.887C110.737 333.001 116.89 344.61 99.868 360.335C86.9567 372.263 79.2257 372.174 76.0985 371.336L76.1006 371.337Z",
    fill: "url(#paint44_linear_376_6503)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8521 379.359C84.7618 379.335 84.6968 379.25 84.6999 379.154C84.7034 379.04 84.7988 378.953 84.9127 378.956C85.0486 378.961 98.5539 379.291 110.533 363.568C122.483 347.884 115.308 337.379 115.232 337.275C115.167 337.184 115.19 337.057 115.282 336.989C115.374 336.924 115.503 336.945 115.569 337.037C115.644 337.143 123.005 347.878 110.86 363.816C98.7429 379.72 85.0354 379.372 84.8973 379.366C84.8821 379.365 84.8668 379.363 84.8521 379.359Z",
    fill: "url(#paint45_linear_376_6503)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2266 383.91C91.2752 383.655 90.7384 383.399 90.7122 383.387C90.6107 383.338 90.5696 383.214 90.6193 383.113C90.669 383.011 90.7878 382.971 90.894 383.02C91.0232 383.084 104.149 389.297 117.774 369.954C122.755 362.879 124.759 354.874 123.27 347.988C122.393 343.935 120.325 340.605 117.736 339.086C117.639 339.028 117.606 338.902 117.663 338.805C117.721 338.708 117.846 338.676 117.944 338.731C120.63 340.309 122.77 343.737 123.671 347.901C125.184 354.9 123.157 363.025 118.109 370.19C106.985 385.983 96.1267 384.955 92.2266 383.91Z",
    fill: "url(#paint46_linear_376_6503)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M101.159 388.969C101.058 388.942 100.992 388.842 101.01 388.736C101.028 388.624 101.136 388.549 101.245 388.569C107.306 389.624 120.597 387.015 127.515 369.582C134.832 351.147 123.377 342.248 123.261 342.158C123.171 342.091 123.152 341.962 123.221 341.87C123.291 341.781 123.417 341.761 123.509 341.83C123.629 341.919 135.333 350.998 127.898 369.732C120.883 387.409 107.35 390.048 101.176 388.972C101.17 388.97 101.163 388.968 101.157 388.967L101.159 388.969Z",
    fill: "url(#paint47_linear_376_6503)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M110.223 392.19C110.118 392.162 110.053 392.059 110.075 391.952C110.098 391.841 110.204 391.771 110.316 391.792C110.431 391.814 121.867 393.928 131.172 380.196C136.496 372.34 137.694 361.593 134.226 352.821C131.986 347.158 128.117 343.301 123.581 342.302C123.458 342.266 123.401 342.166 123.426 342.055C123.451 341.945 123.56 341.875 123.673 341.901C128.333 342.972 132.317 346.88 134.608 352.671C138.124 361.566 136.909 372.462 131.512 380.429C122.048 394.397 110.354 392.221 110.237 392.196L110.224 392.193L110.223 392.19Z",
    fill: "url(#paint48_linear_376_6503)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M118.264 393.728C118.165 393.701 118.098 393.605 118.113 393.499C118.13 393.386 118.234 393.31 118.346 393.327C122.157 393.891 128.796 391.931 134.112 387.086C138.126 383.428 142.79 376.817 142.21 366.089C140.954 342.903 123.279 342.079 123.1 342.074C122.984 342.072 122.899 341.975 122.902 341.863C122.906 341.75 123.002 341.66 123.113 341.665C123.296 341.67 141.342 342.496 142.618 366.068C143.208 376.956 138.466 383.672 134.386 387.392C128.975 392.321 122.19 394.312 118.285 393.733C118.276 393.731 118.27 393.73 118.261 393.727L118.264 393.728Z",
    fill: "url(#paint49_linear_376_6503)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M131.143 393.339C131.072 393.319 131.015 393.264 130.997 393.187C130.973 393.077 131.04 392.967 131.151 392.942C131.244 392.922 140.514 390.717 145.265 381.017C150.826 369.665 146.629 358.917 145.732 356.878C143.637 352.121 137.222 341.149 122.925 341.986C122.812 341.994 122.714 341.905 122.708 341.793C122.703 341.679 122.787 341.582 122.901 341.577C137.453 340.722 143.977 351.877 146.107 356.713C147.019 358.781 151.274 369.681 145.634 381.196C140.793 391.08 131.337 393.323 131.241 393.344C131.207 393.351 131.174 393.351 131.142 393.343L131.143 393.339Z",
    fill: "url(#paint50_linear_376_6503)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M143.052 389.268C143.002 389.255 142.959 389.223 142.929 389.175C142.871 389.078 142.903 388.952 143 388.894C143.11 388.827 154.089 382.101 153.509 368.777C153.001 357.161 146.939 347.586 137.291 343.169C129.384 339.553 122.848 341.854 122.783 341.877C122.676 341.914 122.558 341.859 122.521 341.755C122.482 341.648 122.536 341.531 122.643 341.493C122.71 341.468 129.399 339.103 137.46 342.798C147.253 347.281 153.404 356.988 153.918 368.761C154.509 382.333 143.324 389.179 143.211 389.246C143.163 389.276 143.105 389.283 143.052 389.268Z",
    fill: "url(#paint51_linear_376_6503)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M153.87 381.294C153.847 381.288 153.827 381.278 153.806 381.264C153.714 381.199 153.689 381.07 153.755 380.978C159.613 372.548 158.846 364.573 157.173 359.366C154.127 349.89 146.42 343.323 140.548 341.234C129.345 337.251 121.96 341.366 121.886 341.407C121.788 341.463 121.664 341.43 121.607 341.332C121.55 341.233 121.584 341.107 121.682 341.052C121.756 341.009 129.303 336.794 140.685 340.85C146.649 342.972 154.476 349.632 157.564 359.241C159.266 364.534 160.044 372.646 154.093 381.212C154.042 381.284 153.953 381.314 153.871 381.292L153.87 381.294Z",
    fill: "url(#paint52_linear_376_6503)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M159.797 373.663C159.78 373.658 159.764 373.652 159.748 373.643C159.651 373.587 159.617 373.461 159.672 373.364C161.77 369.703 166.376 353.748 150.583 342.593C134.563 331.273 121.167 340.838 121.032 340.937C120.94 341.004 120.812 340.986 120.744 340.894C120.677 340.801 120.697 340.674 120.788 340.606C120.925 340.505 134.547 330.764 150.817 342.257C166.863 353.593 162.161 369.837 160.025 373.566C159.979 373.648 159.883 373.686 159.795 373.662L159.797 373.663Z",
    fill: "url(#paint53_linear_376_6503)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M164.555 363.214C164.456 363.188 164.392 363.092 164.406 362.99C165.427 355.34 163.668 348.89 159.18 343.823C152.126 335.857 140.745 333.859 135.713 333.915C126.018 334.023 119.884 340.147 119.824 340.21C119.744 340.29 119.614 340.289 119.535 340.214C119.455 340.134 119.454 340.005 119.532 339.925C119.593 339.862 125.839 333.617 135.709 333.507C142.808 333.428 153.277 336.537 159.489 343.554C164.059 348.716 165.852 355.274 164.814 363.047C164.799 363.16 164.695 363.238 164.584 363.224C164.575 363.222 164.567 363.22 164.559 363.218L164.555 363.214Z",
    fill: "url(#paint54_linear_376_6503)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M166.671 354.368C166.572 354.341 166.506 354.245 166.522 354.141C167.778 345.336 161.033 334.53 145.741 330.887C128.911 326.888 117.991 338.85 117.883 338.97C117.806 339.055 117.677 339.059 117.595 338.987C117.509 338.91 117.503 338.782 117.578 338.697C117.688 338.573 128.761 326.429 145.837 330.487C161.386 334.178 168.213 345.21 166.928 354.198C166.911 354.311 166.807 354.388 166.697 354.372C166.688 354.37 166.68 354.368 166.674 354.366L166.671 354.368Z",
    fill: "url(#paint55_linear_376_6503)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M116.748 338.393C116.735 338.39 116.72 338.386 116.707 338.378C116.606 338.326 116.567 338.203 116.619 338.102C123.067 325.538 141.378 322.701 154.433 327.946C166.994 332.984 167.843 342.81 167.851 342.909C167.859 343.021 167.774 343.12 167.661 343.128C167.549 343.134 167.45 343.051 167.442 342.939C167.434 342.842 166.594 333.266 154.281 328.328C148.002 325.811 140.167 325.222 133.324 326.758C125.729 328.464 119.924 332.561 116.984 338.292C116.941 338.379 116.84 338.42 116.749 338.396L116.748 338.393Z",
    fill: "url(#paint56_linear_376_6503)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M115.565 337.533C115.468 337.507 115.403 337.413 115.415 337.311C115.423 337.248 116.212 330.918 121.692 327.249C126.492 324.038 134.234 319.85 145.994 320.561C157.645 321.266 166.071 326.508 167.46 333.917C167.48 334.028 167.408 334.135 167.297 334.157C167.188 334.177 167.079 334.105 167.057 333.993C165.705 326.775 157.428 321.665 145.968 320.971C134.332 320.268 126.671 324.412 121.918 327.591C116.592 331.155 115.826 337.297 115.819 337.358C115.807 337.47 115.704 337.55 115.593 337.538C115.582 337.536 115.573 337.535 115.563 337.533L115.565 337.533Z",
    fill: "url(#paint57_linear_376_6503)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M114.683 333.241C114.593 333.217 114.528 333.132 114.532 333.034C114.958 323.562 128.412 315.565 145.157 314.827C161.751 314.096 165.83 322.969 165.868 323.06C165.912 323.164 165.867 323.285 165.762 323.331C165.66 323.376 165.537 323.329 165.491 323.225C165.453 323.138 161.471 314.521 145.173 315.237C128.639 315.963 115.357 323.788 114.939 333.051C114.934 333.164 114.838 333.251 114.725 333.246C114.71 333.244 114.694 333.242 114.682 333.239L114.683 333.241Z",
    fill: "url(#paint58_linear_376_6503)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M113.278 327.566C113.192 327.543 113.128 327.465 113.126 327.37C113.123 327.162 113.141 322.222 119.941 317.435C126.841 312.578 142.513 307.485 151.629 308.442C158.39 309.151 162.468 311.045 163.751 314.069C163.795 314.174 163.747 314.296 163.643 314.34C163.539 314.382 163.419 314.336 163.374 314.232C162.153 311.354 158.186 309.544 151.587 308.852C142.556 307.904 127.021 312.957 120.179 317.773C113.554 322.438 113.538 327.32 113.539 327.368C113.54 327.481 113.45 327.574 113.337 327.575C113.316 327.576 113.299 327.574 113.28 327.569L113.278 327.566Z",
    fill: "url(#paint59_linear_376_6503)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M111.267 321.404C111.187 321.383 111.123 321.311 111.117 321.224C111.097 320.998 110.806 315.624 125.19 308.412C139.461 301.258 156.917 298.923 160.433 303.694C160.499 303.784 160.48 303.914 160.39 303.982C160.3 304.048 160.172 304.03 160.102 303.939C156.752 299.395 139.225 301.836 125.373 308.781C111.296 315.836 111.52 321.139 111.524 321.191C111.532 321.304 111.449 321.403 111.337 321.411C111.314 321.414 111.289 321.412 111.266 321.406L111.267 321.404Z",
    fill: "url(#paint60_linear_376_6503)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M108.631 314.872C108.631 314.872 108.616 314.868 108.61 314.866C108.504 314.825 108.452 314.707 108.491 314.603C108.567 314.403 110.511 309.652 122.92 303.356C135.427 297.01 153.28 291.59 156.687 294.373C156.774 294.444 156.789 294.574 156.716 294.66C156.643 294.749 156.513 294.763 156.427 294.689C153.128 291.99 135.504 297.429 123.103 303.722C110.869 309.928 108.889 314.705 108.87 314.752C108.833 314.85 108.726 314.902 108.625 314.875L108.631 314.872Z",
    fill: "url(#paint61_linear_376_6503)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M105.783 308.916C105.756 308.908 105.73 308.895 105.706 308.877C105.619 308.806 105.606 308.677 105.677 308.588C105.725 308.529 110.71 302.599 128.264 293.934C145.085 285.628 150.065 285.065 152.346 285.363C152.454 285.381 152.537 285.48 152.523 285.593C152.508 285.706 152.406 285.784 152.293 285.77C151.01 285.602 147.102 285.09 128.448 294.3C110.994 302.918 106.044 308.79 105.994 308.849C105.941 308.913 105.859 308.936 105.783 308.916Z",
    fill: "url(#paint62_linear_376_6503)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M201.673 355.052C201.673 355.052 201.678 355.049 201.684 355.046C206.31 351.716 210.06 347.602 212.979 342.847C212.987 342.835 212.994 342.826 213.002 342.814C214.982 339.581 216.577 336.058 217.794 332.287C218.701 329.481 219.403 326.533 219.905 323.467L219.902 323.461C219.961 323.148 220.007 322.834 220.055 322.514C220.054 322.5 220.061 322.491 220.06 322.477C220.947 316.448 221.064 309.976 220.429 303.206C219.849 296.838 218.606 290.2 216.732 283.427C214.964 276.986 212.624 270.421 209.741 263.825C207.27 258.161 204.396 252.479 201.138 246.839C197.88 241.196 194.397 235.866 190.726 230.89C186.459 225.1 181.943 219.791 177.257 215.042C172.32 210.03 167.198 205.632 161.972 201.94C156.433 198.016 150.776 194.884 145.119 192.639C145.119 192.639 145.115 192.638 145.105 192.635C144.792 192.509 144.482 192.387 144.164 192.273L144.161 192.267C141.254 191.164 138.342 190.294 135.452 189.682L135.443 189.679C131.555 188.849 127.697 188.473 123.901 188.574C118.332 188.727 112.894 189.918 107.701 192.256L107.69 192.262C106.379 192.852 105.083 193.513 103.805 194.251C103.23 194.583 102.675 194.923 102.127 195.273C99.13 197.183 96.4672 199.4 94.1306 201.887C93.6183 202.43 93.1238 202.981 92.6475 203.549C90.0484 206.621 87.8961 210.067 86.1816 213.819C86.0648 214.053 85.9596 214.286 85.8699 214.512C85.3171 215.769 84.8112 217.06 84.356 218.381C84.356 218.381 84.3547 218.386 84.352 218.396C83.9283 219.633 83.5384 220.895 83.1976 222.183C83.1869 222.223 83.1777 222.241 83.1777 222.241C81.4578 228.727 80.7617 235.869 81.0562 243.448C81.057 243.462 81.0553 243.468 81.0531 243.477C81.1002 244.595 81.1651 245.722 81.2478 246.858C81.25 246.884 81.2516 246.911 81.2548 246.941C81.3435 248.156 81.46 249.384 81.6064 250.619L81.6042 250.627C82.467 258.152 84.2197 266.018 86.8184 274.037C89.0571 280.946 91.9273 287.968 95.4 294.977C97.0276 298.269 98.7881 301.561 100.68 304.835C102.571 308.11 104.54 311.278 106.576 314.331C110.912 320.848 115.559 326.845 120.423 332.239C126.904 339.427 133.763 345.544 140.795 350.39C140.819 350.41 140.849 350.425 140.873 350.445C141.912 351.162 142.953 351.847 144 352.508C144 352.508 144.004 352.51 144.012 352.515C150.435 356.561 156.973 359.538 163.453 361.286C163.453 361.286 163.473 361.287 163.513 361.297C164.785 361.642 166.059 361.937 167.327 362.184C168.721 362.452 170.11 362.669 171.498 362.824C171.744 362.848 171.992 362.871 172.237 362.896C172.237 362.896 172.242 362.896 172.251 362.896C176.358 363.287 180.418 363.146 184.378 362.431C185.096 362.304 185.816 362.154 186.532 361.986C190.471 361.063 194.316 359.548 198.012 357.416C199.29 356.678 200.511 355.886 201.677 355.046L201.673 355.052ZM163.672 302.285C161.202 299.944 157.976 296.561 154.451 292.033C151.632 288.407 148.618 284.039 145.64 278.881C142.662 273.723 140.389 268.931 138.655 264.674C136.493 259.352 135.179 254.871 134.384 251.556C133.423 247.531 133.224 245.224 133.224 245.224C133.224 245.224 133.548 245.451 134.14 245.913C134.69 246.346 135.476 246.994 136.455 247.859C140.714 251.639 148.561 259.627 156.168 272.804C157.12 274.452 157.999 276.068 158.816 277.632C164.494 288.599 166.913 297.468 167.911 302.343C168.171 303.624 168.337 304.627 168.439 305.321C168.543 306.067 168.578 306.458 168.578 306.458C168.578 306.458 166.68 305.131 163.674 302.288L163.672 302.285Z",
    fill: "#27E6D6"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M163.623 361.578C158.356 360.167 152.967 357.922 147.504 354.839C130.109 345.033 113.417 327.311 100.502 304.937C87.5855 282.566 80.5839 259.249 80.7885 239.282C81.0022 218.238 88.9275 202.606 103.704 194.075C118.481 185.544 135.981 186.498 154.312 196.833C171.707 206.639 188.399 224.361 201.315 246.733C214.231 269.104 221.233 292.421 221.028 312.388C220.815 333.432 212.889 349.064 198.113 357.595C187.741 363.584 176.025 364.899 163.623 361.576L163.623 361.578ZM138.091 190.494C125.792 187.199 114.182 188.5 103.906 194.431C89.2624 202.885 81.4078 218.397 81.1945 239.287C80.9917 259.181 87.9745 282.425 100.853 304.735C113.734 327.045 130.371 344.711 147.703 354.483C165.901 364.744 183.259 365.699 197.906 357.243C212.549 348.788 220.404 333.277 220.617 312.386C220.82 292.492 213.837 269.248 200.958 246.939C188.078 224.629 171.441 206.962 154.108 197.19C148.678 194.128 143.322 191.896 138.091 190.494Z",
    fill: "url(#paint63_linear_376_6503)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M168.536 306.67C168.513 306.664 168.491 306.653 168.472 306.639C168.354 306.558 156.575 298.233 145.47 278.999C134.365 259.765 133.045 245.401 133.034 245.258C133.028 245.18 133.067 245.103 133.136 245.063C133.205 245.023 133.29 245.027 133.356 245.072C133.474 245.153 145.253 253.48 156.358 272.715C167.464 291.947 168.783 306.313 168.794 306.455C168.799 306.535 168.761 306.611 168.692 306.651C168.644 306.678 168.588 306.686 168.536 306.672L168.536 306.67ZM133.492 245.683C133.814 248.277 135.877 261.565 145.824 278.795C155.77 296.021 166.247 304.451 168.334 306.03C168.011 303.436 165.949 290.148 156.001 272.921C146.055 255.694 135.579 247.262 133.492 245.685L133.492 245.683Z",
    fill: "url(#paint64_linear_376_6503)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M153.048 267.929C152.998 267.916 152.968 267.901 152.953 267.89C152.859 267.827 152.835 267.699 152.898 267.605C152.958 267.518 153.074 267.488 153.164 267.539C153.263 267.566 154.99 268.015 165.505 261.856C176.883 255.189 194.602 243.455 196.495 239.449C196.543 239.345 196.664 239.303 196.768 239.351C196.871 239.399 196.914 239.521 196.866 239.625C194.915 243.757 177.475 255.321 165.714 262.211C155.791 268.025 153.51 268.053 153.048 267.929Z",
    fill: "url(#paint65_linear_376_6503)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M146.508 257.995C145.638 257.762 145.289 257.403 145.257 257.369C145.181 257.286 145.186 257.157 145.27 257.08C145.353 257.003 145.482 257.009 145.557 257.09C145.587 257.122 147.272 258.756 152.843 256.876C158.326 255.028 168.408 248.687 176.286 240.58C181.98 234.721 186.878 227.202 185.216 224.171C185.162 224.071 185.197 223.948 185.298 223.893C185.398 223.839 185.521 223.874 185.575 223.974C187.413 227.33 182.201 235.081 176.579 240.866C168.654 249.018 158.503 255.399 152.973 257.264C149.644 258.387 147.635 258.299 146.505 257.996L146.508 257.995Z",
    fill: "url(#paint66_linear_376_6503)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M140.085 250.466C138.551 250.055 137.828 249.395 137.769 249.339C137.686 249.261 137.682 249.133 137.76 249.051C137.839 248.968 137.968 248.965 138.051 249.041C138.078 249.066 140.887 251.595 147.454 249.611C154.33 247.539 164.643 240.108 171.038 228.691C176.694 218.594 174.536 213.248 172.746 210.959C172.675 210.87 172.691 210.742 172.78 210.671C172.871 210.601 172.999 210.617 173.068 210.705C174.921 213.074 177.165 218.585 171.394 228.89C164.944 240.404 154.524 247.906 147.572 250.003C144.112 251.045 141.667 250.888 140.085 250.464L140.085 250.466Z",
    fill: "url(#paint67_linear_376_6503)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M133.183 245.438C133.108 245.418 133.046 245.354 133.034 245.272C133.031 245.251 132.713 243.16 132.718 240.555C132.721 238.939 132.891 237.499 133.055 236.107C133.165 235.175 133.278 234.213 133.336 233.216C133.477 230.876 133.349 218.871 116.986 212.227C108.962 208.967 100.24 209.183 93.0637 212.82C87.8235 215.474 84.0542 219.603 82.9799 223.865C82.9507 223.974 82.8404 224.041 82.7306 224.014L82.7285 224.013C82.6214 223.985 82.5541 223.874 82.5834 223.765C83.686 219.39 87.5355 215.163 92.88 212.455C100.162 208.766 109.005 208.544 117.141 211.85C133.764 218.6 133.89 230.856 133.748 233.243C133.687 234.251 133.574 235.22 133.463 236.156C133.3 237.537 133.133 238.964 133.13 240.555C133.125 243.129 133.437 245.189 133.44 245.21C133.458 245.323 133.383 245.426 133.27 245.443C133.242 245.447 133.213 245.446 133.186 245.439L133.183 245.438Z",
    fill: "url(#paint68_linear_376_6503)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M133.812 244.957C133.357 244.834 133.1 244.725 133.062 244.708C132.957 244.662 132.911 244.542 132.957 244.437C133.003 244.332 133.127 244.289 133.228 244.332C133.266 244.349 137.069 245.958 143.208 243.69C149.898 241.219 156.735 234.662 160.63 226.983C163.989 220.358 167.887 206.173 158.603 199.91C158.51 199.847 158.485 199.719 158.549 199.625C158.612 199.532 158.738 199.507 158.833 199.571C168.356 205.994 164.411 220.433 160.996 227.169C156.997 235.054 150.237 241.533 143.352 244.075C138.58 245.838 135.233 245.335 133.815 244.955L133.812 244.957Z",
    fill: "url(#paint69_linear_376_6503)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M132.887 241.815C132.803 241.793 132.74 241.717 132.735 241.626C132.729 241.512 132.818 241.416 132.93 241.41C132.971 241.408 137.083 241.182 141.57 238.215C145.477 235.631 152.383 229.513 154.731 217.577C156.918 206.447 151.78 195.044 143.275 192.16C143.167 192.124 143.11 192.008 143.146 191.9C143.182 191.793 143.307 191.736 143.406 191.772C152.099 194.72 157.361 206.332 155.133 217.656C152.757 229.739 145.757 235.938 141.796 238.557C137.211 241.59 132.992 241.819 132.948 241.821C132.928 241.822 132.906 241.818 132.885 241.813L132.887 241.815Z",
    fill: "url(#paint70_linear_376_6503)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M132.93 239.096C132.873 239.081 132.823 239.041 132.795 238.984C132.749 238.881 132.793 238.758 132.895 238.711C135.388 237.567 142.005 234.528 145.668 223.865C147.76 217.778 147.877 207.606 143.193 199.659C139.7 193.734 134.232 190.081 126.939 188.796C126.826 188.772 126.752 188.669 126.773 188.558C126.792 188.446 126.9 188.371 127.011 188.392C134.431 189.7 139.992 193.419 143.548 199.45C148.299 207.51 148.181 217.823 146.058 223.996C142.337 234.826 135.361 238.028 133.069 239.082C133.022 239.103 132.974 239.106 132.93 239.094L132.93 239.096Z",
    fill: "url(#paint71_linear_376_6503)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M133.122 237.053C133.077 237.041 133.037 237.014 133.009 236.975C132.944 236.884 132.965 236.756 133.055 236.688C133.136 236.629 141.272 230.604 140.62 218.148C140.115 208.45 135.39 200.116 127.659 195.283C120.969 191.1 113.081 190.253 106.554 193.02C106.45 193.064 106.331 193.014 106.286 192.912C106.242 192.808 106.29 192.688 106.394 192.644C113.043 189.824 121.072 190.682 127.875 194.938C135.722 199.845 140.516 208.297 141.03 218.13C141.692 230.816 133.378 236.961 133.294 237.022C133.241 237.06 133.178 237.07 133.121 237.055L133.122 237.053Z",
    fill: "url(#paint72_linear_376_6503)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M133.226 236.158C133.21 236.153 133.191 236.146 133.176 236.138C133.078 236.08 133.045 235.954 133.102 235.857C136.492 230.059 136.897 223.595 134.304 216.638C131.567 209.294 121.796 198.883 108.656 198.729C95.504 198.575 89.916 207.508 89.8623 207.6C89.8027 207.696 89.6798 207.727 89.5806 207.668C89.484 207.609 89.4523 207.483 89.512 207.387C89.5684 207.294 95.2788 198.163 108.659 198.32C122.75 198.483 132.102 209.556 134.686 216.495C137.324 223.572 136.91 230.156 133.454 236.064C133.408 236.146 133.31 236.18 133.224 236.157L133.226 236.158Z",
    fill: "url(#paint73_linear_376_6503)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9412 241.556C80.8467 241.531 80.7812 241.439 80.7903 241.338C81.5966 233.415 87.2725 228.185 98.657 224.878C107.505 222.309 120.476 224.6 126.985 229.887C133.283 235.003 133.13 240.817 133.128 240.875C133.125 240.989 133.029 241.076 132.916 241.072C132.797 241.067 132.715 240.973 132.718 240.859C132.72 240.803 132.856 235.186 126.725 230.204C120.308 224.994 107.506 222.734 98.7696 225.273C87.5658 228.527 81.983 233.644 81.1957 241.379C81.1833 241.493 81.0828 241.574 80.9711 241.562C80.9606 241.559 80.9496 241.559 80.9391 241.556L80.9412 241.556Z",
    fill: "url(#paint74_linear_376_6503)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6298 258.047C82.5311 258.02 82.4668 257.924 82.4806 257.822C83.2691 252.115 88.4823 247.059 97.1608 243.586C104.521 240.639 113.455 239.31 119.921 240.199C132.456 241.923 133.87 248.137 133.923 248.401C133.945 248.512 133.874 248.619 133.764 248.642C133.652 248.666 133.546 248.592 133.523 248.483C133.511 248.421 132.089 242.286 119.866 240.605C106.771 238.804 84.5306 245.98 82.8884 257.879C82.8718 257.992 82.7697 258.071 82.6571 258.054C82.6487 258.052 82.6403 258.049 82.6319 258.047L82.6298 258.047Z",
    fill: "url(#paint75_linear_376_6503)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6626 276.919C87.6059 276.904 87.5554 276.866 87.5284 276.807C87.4481 276.628 85.6889 272.348 98.2821 264.976C110.868 257.606 132.628 253.314 136.818 259.182C136.884 259.274 136.862 259.403 136.771 259.469C136.679 259.534 136.551 259.514 136.484 259.421C132.519 253.857 110.788 258.13 98.4887 265.33C86.2848 272.476 87.8858 276.599 87.902 276.639C87.9461 276.743 87.9003 276.864 87.7962 276.908C87.7526 276.927 87.7046 276.93 87.6605 276.919L87.6626 276.919Z",
    fill: "url(#paint76_linear_376_6503)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2062 294.9C95.1075 294.873 95.0417 294.774 95.0561 294.67C95.3224 292.945 99.2077 290.072 108.473 284.755C116.847 279.949 130.851 273.761 136.017 272.257C140.969 270.815 141.905 271.548 141.995 271.637C142.075 271.717 142.077 271.846 141.999 271.926C141.922 272.005 141.797 272.007 141.717 271.936C141.679 271.91 140.73 271.311 136.132 272.65C130.988 274.149 117.03 280.315 108.677 285.109C102.314 288.764 95.7654 292.762 95.4627 294.732C95.4461 294.845 95.3404 294.92 95.2299 294.904C95.2215 294.901 95.2152 294.9 95.2089 294.898L95.2062 294.9Z",
    fill: "url(#paint77_linear_376_6503)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M105.227 312.565C105.124 312.538 105.059 312.435 105.079 312.327C105.1 312.216 105.209 312.144 105.318 312.164C108.055 312.695 116.437 307.522 125.311 302.044C134.009 296.676 142.812 290.049 146.022 287.26C148.68 284.949 148.713 284.283 148.711 284.255C148.677 284.147 148.741 284.049 148.85 284.015C148.956 283.981 149.077 284.058 149.109 284.166C149.163 284.34 149.125 285.106 146.29 287.568C143.069 290.365 134.243 297.011 125.526 302.392C116.194 308.152 108.136 313.126 105.241 312.564C105.236 312.563 105.232 312.562 105.226 312.56L105.227 312.565Z",
    fill: "url(#paint78_linear_376_6503)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M118.16 329.039C117.288 328.805 116.878 328.464 116.841 328.431C116.755 328.359 116.747 328.228 116.82 328.142C116.895 328.056 117.025 328.048 117.109 328.12C117.13 328.137 119.138 329.774 124.078 328.047C130.273 325.885 137.848 320.953 144.344 314.855C154.044 305.747 158.321 298.931 156.711 295.139C156.667 295.035 156.715 294.913 156.819 294.869C156.921 294.824 157.043 294.875 157.087 294.977C158.795 298.997 154.601 305.784 144.623 315.151C138.088 321.285 130.457 326.25 124.212 328.43C121.259 329.46 119.308 329.342 118.159 329.034L118.16 329.039Z",
    fill: "url(#paint79_linear_376_6503)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M132.226 343.005C131.35 342.77 130.524 342.407 129.765 341.898C129.672 341.834 129.645 341.708 129.708 341.614C129.772 341.519 129.899 341.492 129.993 341.558C135.896 345.503 145.976 340.389 153.347 333.571C159.774 327.622 164.683 319.792 166.156 313.136C167.617 306.534 164.868 303.679 164.839 303.651C164.759 303.571 164.76 303.441 164.84 303.361C164.92 303.281 165.048 303.282 165.129 303.36C165.25 303.48 168.069 306.383 166.555 313.225C165.066 319.96 160.11 327.87 153.624 333.871C147.069 339.937 138.375 344.653 132.226 343.005Z",
    fill: "url(#paint80_linear_376_6503)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M146.454 353.656C145.543 353.412 144.66 353.069 143.8 352.625C143.699 352.573 143.66 352.45 143.712 352.349C143.763 352.248 143.887 352.209 143.987 352.261C148.311 354.491 153.343 354.115 158.936 351.146C166.092 347.348 174.351 338.081 176.674 325.94C179.127 313.125 171.109 308.386 171.027 308.339C170.929 308.284 170.895 308.158 170.951 308.06C171.006 307.962 171.13 307.928 171.23 307.984C171.314 308.031 179.587 312.904 177.076 326.019C174.726 338.294 166.367 347.665 159.126 351.51C154.51 353.96 150.259 354.678 146.452 353.658L146.454 353.656Z",
    fill: "url(#paint81_linear_376_6503)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M160.384 360.581C159.939 360.461 159.503 360.315 159.077 360.14C158.972 360.096 158.923 359.977 158.967 359.872C159.011 359.767 159.127 359.719 159.235 359.762C166.474 362.744 177.081 357.223 181.719 350.297C187.233 342.062 189.028 333.73 187.207 324.828C185.13 314.685 176.702 311.175 176.616 311.141C176.511 311.099 176.461 310.98 176.503 310.874C176.545 310.768 176.669 310.725 176.77 310.761C176.857 310.795 185.486 314.381 187.607 324.746C189.452 333.761 187.636 342.194 182.059 350.526C177.604 357.179 167.72 362.546 160.384 360.581Z",
    fill: "url(#paint82_linear_376_6503)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M177.51 363.303C177.424 363.28 177.361 363.205 177.359 363.112C177.356 362.999 177.444 362.905 177.557 362.902C185.133 362.663 194.821 356.041 197.265 345.763C199.736 335.372 198.267 327.238 192.503 319.386C186.756 311.559 177.339 311.377 177.245 311.376C177.131 311.373 177.041 311.281 177.042 311.169C177.043 311.057 177.135 310.964 177.249 310.966C177.346 310.967 186.962 311.144 192.835 319.142C198.677 327.1 200.166 335.339 197.665 345.856C195.176 356.323 185.297 363.067 177.571 363.311C177.551 363.312 177.531 363.309 177.512 363.304L177.51 363.303Z",
    fill: "url(#paint83_linear_376_6503)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M198.654 357.204C198.605 357.192 198.562 357.162 198.532 357.113C198.472 357.016 198.501 356.891 198.598 356.832C203.127 354.034 206.607 348.281 207.681 341.818C208.968 334.084 206.78 326.297 201.521 319.891C190.294 306.219 176.462 310.907 176.322 310.957C176.215 310.994 176.098 310.938 176.06 310.833C176.024 310.727 176.078 310.608 176.184 310.572C176.324 310.521 190.421 305.729 201.836 319.631C207.172 326.127 209.392 334.031 208.085 341.883C206.992 348.458 203.438 354.32 198.811 357.179C198.76 357.21 198.703 357.215 198.65 357.201L198.654 357.204Z",
    fill: "url(#paint84_linear_376_6503)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M212.958 342.987C212.937 342.982 212.919 342.975 212.9 342.963C212.804 342.901 212.777 342.774 212.839 342.678C214.909 339.47 216.137 333.174 214.21 326.344C212.749 321.171 209.019 314.049 199.538 309.503C184.296 302.189 174.646 310.016 174.551 310.094C174.464 310.167 174.334 310.155 174.263 310.069C174.19 309.981 174.202 309.852 174.288 309.781C174.387 309.699 184.229 301.705 199.716 309.132C209.334 313.746 213.122 320.978 214.607 326.234C216.57 333.187 215.307 339.614 213.185 342.899C213.135 342.976 213.042 343.01 212.958 342.987Z",
    fill: "url(#paint85_linear_376_6503)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M219.473 325.751C219.378 325.725 219.312 325.635 219.321 325.534C219.873 319.737 217.946 314.368 213.749 310.004C207.107 303.097 196.665 300.366 189.775 300.751C177.803 301.419 172.209 308.715 172.152 308.79C172.086 308.88 171.957 308.897 171.866 308.832C171.777 308.763 171.757 308.636 171.826 308.545C171.883 308.47 177.593 301.021 189.754 300.342C196.735 299.953 207.313 302.722 214.046 309.721C218.327 314.173 220.294 319.654 219.729 325.574C219.719 325.688 219.618 325.769 219.506 325.76C219.495 325.759 219.485 325.756 219.472 325.753L219.473 325.751Z",
    fill: "url(#paint86_linear_376_6503)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M169.405 307.292C169.3 307.264 169.236 307.159 169.258 307.053C169.273 306.98 170.871 299.84 181.937 295.076C189.367 291.876 203.102 291.693 212.333 296.969C217.357 299.842 220.352 304.048 220.995 309.134C221.01 309.246 220.931 309.348 220.816 309.363C220.706 309.378 220.602 309.299 220.587 309.184C219.952 304.161 217.107 300.171 212.13 297.325C203.296 292.272 189.469 292.277 182.099 295.452C171.245 300.125 169.675 307.067 169.661 307.136C169.638 307.247 169.529 307.317 169.418 307.294C169.414 307.292 169.41 307.291 169.406 307.29L169.405 307.292Z",
    fill: "url(#paint87_linear_376_6503)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M167.76 302.023C167.686 302.003 167.626 301.942 167.611 301.864C167.556 301.572 166.397 294.659 179.005 288.064C185.728 284.546 200.875 281.287 210.66 284.613C214.634 285.962 217.392 288.243 218.857 291.397C218.904 291.5 218.86 291.621 218.757 291.67C218.654 291.716 218.533 291.673 218.484 291.57C217.068 288.523 214.391 286.313 210.526 285.003C200.836 281.717 185.853 284.946 179.195 288.43C166.883 294.871 168 301.723 168.013 301.791C168.033 301.903 167.961 302.01 167.85 302.031C167.819 302.037 167.788 302.035 167.759 302.027L167.76 302.023Z",
    fill: "url(#paint88_linear_376_6503)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M164.83 291.771C164.757 291.751 164.697 291.69 164.682 291.612C164.638 291.38 163.775 285.874 177.176 278.971C191.029 271.838 210.82 268.391 214.168 274.549C214.222 274.649 214.184 274.771 214.086 274.826C213.986 274.88 213.864 274.843 213.809 274.743C210.619 268.882 190.772 272.426 177.365 279.332C164.233 286.096 165.077 291.481 165.088 291.534C165.107 291.645 165.036 291.752 164.924 291.774C164.894 291.779 164.862 291.777 164.833 291.769L164.83 291.771Z",
    fill: "url(#paint89_linear_376_6503)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M159.812 279.903C159.726 279.88 159.662 279.802 159.66 279.709C159.613 276.891 173.31 269.187 186.905 262.8C203.015 255.231 206.364 256.462 206.502 256.524C206.608 256.567 206.657 256.686 206.613 256.792C206.569 256.895 206.449 256.948 206.349 256.903C206.303 256.889 202.845 255.766 187.08 263.173C171.392 270.542 160.032 277.495 160.071 279.704C160.072 279.817 159.982 279.91 159.869 279.911C159.848 279.912 159.831 279.91 159.812 279.905L159.812 279.903Z",
    fill: "url(#paint90_linear_376_6503)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M217.282 330.951C216.15 330.648 213.776 329.334 207.454 325.544C198.309 320.064 185.389 314.14 179.06 312.043C172.787 309.966 168.507 306.667 168.464 306.636C168.375 306.567 168.359 306.439 168.428 306.349C168.497 306.26 168.628 306.243 168.717 306.314C168.757 306.347 172.986 309.601 179.191 311.657C185.542 313.762 198.498 319.703 207.666 325.196C216.898 330.729 217.544 330.866 218.193 330.477C218.289 330.42 218.416 330.451 218.473 330.548C218.533 330.645 218.501 330.771 218.403 330.828C218.113 331.003 217.857 331.107 217.284 330.954L217.282 330.951Z",
    fill: "url(#paint91_linear_376_6503)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M164.537 290.948C164.478 290.932 164.428 290.892 164.402 290.83C164.364 290.746 160.758 282.115 163.282 269.587C164.108 265.489 165.36 261.782 166.689 257.856C169.085 250.773 171.56 243.45 171.454 233.452C171.385 226.93 169.029 216.797 162.625 207.926C155.006 197.371 143.268 190.791 128.688 188.901C128.575 188.887 128.497 188.784 128.511 188.671C128.526 188.558 128.628 188.48 128.741 188.494C143.439 190.398 155.272 197.037 162.957 207.686C169.417 216.636 171.795 226.862 171.865 233.447C171.973 243.513 169.486 250.871 167.079 257.988C165.756 261.901 164.507 265.596 163.686 269.668C161.188 282.073 164.745 290.585 164.781 290.669C164.825 290.773 164.777 290.893 164.673 290.937C164.629 290.957 164.582 290.957 164.54 290.946L164.537 290.948Z",
    fill: "url(#paint92_linear_376_6503)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1886 255.477C82.1109 255.457 82.0497 255.391 82.0379 255.309C78.9924 233.315 88.0244 215.502 96.6827 206.929C108.095 195.632 123.145 191.944 135.95 197.298C147.338 202.058 155.515 213.345 156.777 226.05C157.697 235.3 155.237 242.306 153.065 248.488C152.378 250.449 151.726 252.3 151.23 254.103C149.22 261.385 153.005 267.252 153.044 267.309C153.106 267.405 153.079 267.531 152.986 267.593C152.89 267.656 152.764 267.631 152.702 267.535C152.662 267.475 148.775 261.459 150.835 253.995C151.335 252.18 151.988 250.322 152.68 248.355C154.836 242.214 157.28 235.254 156.369 226.094C155.121 213.536 147.045 202.382 135.792 197.678C123.134 192.389 108.263 196.047 96.9705 207.224C88.3777 215.729 79.419 233.412 82.4439 255.255C82.4589 255.368 82.3817 255.471 82.2691 255.488C82.2411 255.492 82.2147 255.489 82.1874 255.482L82.1886 255.477Z",
    fill: "url(#paint93_linear_376_6503)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8969 294.271C94.8381 294.255 94.7845 294.211 94.7602 294.151C85.1805 270.652 90.4767 249.811 94.4874 239.48C96.7555 233.636 105.357 214.28 120.778 210.594C126.781 209.159 132.155 209.962 136.321 212.913C140.458 215.843 143.261 220.783 143.817 226.125C144.72 234.795 139.733 241.24 137.603 243.992C137.286 244.4 137.035 244.724 136.867 244.972C135.637 246.776 136.582 247.698 136.624 247.736C136.707 247.815 136.713 247.942 136.634 248.025C136.558 248.108 136.43 248.114 136.347 248.038C136.335 248.026 135.089 246.852 136.528 244.741C136.703 244.484 136.957 244.156 137.278 243.742C139.378 241.03 144.295 234.676 143.409 226.169C142.865 220.942 140.127 216.112 136.085 213.248C132.017 210.367 126.756 209.587 120.873 210.994C105.647 214.632 97.1199 233.831 94.8689 239.627C90.8803 249.901 85.6124 270.628 95.14 293.994C95.1815 294.099 95.1315 294.219 95.0279 294.261C94.9849 294.278 94.9395 294.28 94.8975 294.268L94.8969 294.271Z",
    fill: "url(#paint94_linear_376_6503)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M116.118 327.504C116.068 327.49 116.024 327.458 115.996 327.412C105.664 310.334 105.36 290.114 106.925 276.158C108.682 260.487 113.598 246.122 117.547 240.028C121.899 233.312 126.33 229.259 130.021 228.616C131.385 228.38 132.599 228.629 133.528 229.337C135.651 230.957 134.497 234.038 134.448 234.169C134.406 234.275 134.288 234.322 134.185 234.287C134.078 234.248 134.027 234.128 134.066 234.024C134.076 233.995 135.159 231.098 133.28 229.665C132.445 229.027 131.341 228.803 130.092 229.022C128.021 229.383 123.68 231.32 117.892 240.254C113.97 246.305 109.084 260.599 107.333 276.204C105.776 290.099 106.076 310.224 116.35 327.201C116.409 327.298 116.378 327.425 116.281 327.482C116.232 327.514 116.175 327.519 116.122 327.505L116.118 327.504Z",
    fill: "url(#paint95_linear_376_6503)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M139.976 350.059C139.951 350.052 139.929 350.042 139.907 350.024C128.272 341.403 129.105 282.068 129.118 281.473C129.399 269.302 132.542 254.404 132.899 252.746C133.503 249.936 133.529 248.514 133.528 248.5C133.529 248.388 133.623 248.296 133.735 248.297C133.852 248.299 133.939 248.392 133.939 248.504C133.939 248.563 133.916 249.975 133.299 252.83C132.943 254.486 129.807 269.349 129.528 281.481C129.173 296.875 130.365 342.446 140.15 349.696C140.24 349.763 140.26 349.892 140.193 349.982C140.14 350.051 140.054 350.08 139.974 350.058L139.976 350.059Z",
    fill: "url(#paint96_linear_376_6503)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M163.406 361.487C163.375 361.478 163.345 361.462 163.32 361.439C162.592 360.762 161.674 359.224 159.202 348.75C157.724 342.495 154.687 326.755 152.007 312.871C150.078 302.875 148.256 293.437 147.343 289.239C145.202 279.396 142.61 273.756 142.582 273.699C142.535 273.597 142.579 273.475 142.682 273.427C142.785 273.378 142.906 273.421 142.955 273.527C142.98 273.583 145.592 279.26 147.742 289.153C148.656 293.355 150.48 302.796 152.409 312.793C155.088 326.675 158.125 342.411 159.6 348.658C162.044 359.019 162.945 360.535 163.598 361.14C163.681 361.216 163.687 361.346 163.609 361.429C163.555 361.486 163.475 361.506 163.406 361.487Z",
    fill: "url(#paint97_linear_376_6503)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M186.67 362.14C186.565 362.112 186.501 362.007 186.523 361.9C186.59 361.576 186.661 360.092 184.774 354.65C182.966 349.434 174.691 327.579 168.688 314.941C162.959 302.878 157.392 295.957 157.336 295.89C157.265 295.801 157.279 295.674 157.366 295.603C157.454 295.532 157.584 295.544 157.655 295.633C157.711 295.702 163.309 302.656 169.059 314.767C175.067 327.418 183.352 349.298 185.161 354.517C186.963 359.711 187.039 361.427 186.923 361.985C186.9 362.096 186.792 362.166 186.68 362.145L186.668 362.142L186.67 362.14Z",
    fill: "url(#paint98_linear_376_6503)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M206.81 350.83C206.758 350.816 206.709 350.78 206.682 350.728C205.893 349.229 197.125 336.496 188.791 325.945C180.333 315.233 169.906 307.647 169.802 307.572C169.71 307.507 169.69 307.378 169.758 307.285C169.823 307.193 169.953 307.171 170.044 307.241C170.15 307.316 180.618 314.934 189.116 325.692C197.625 336.468 206.228 348.986 207.048 350.538C207.1 350.637 207.062 350.762 206.963 350.814C206.916 350.84 206.863 350.844 206.814 350.831L206.81 350.83Z",
    fill: "url(#paint99_linear_376_6503)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M176.67 311.159C176.596 311.14 176.538 311.081 176.523 311.003C176.501 310.891 176.572 310.784 176.682 310.762C176.725 310.753 180.95 309.902 184.567 309.629C188.135 309.358 196.646 309.081 202.699 309.292C203.823 309.33 204.902 309.378 205.936 309.423C210.466 309.624 214.043 309.781 216.55 309.028C220.057 307.976 220.403 306.248 220.426 305.743C220.432 305.629 220.527 305.542 220.64 305.548C220.755 305.556 220.841 305.649 220.835 305.762C220.803 306.496 220.329 308.323 216.667 309.422C214.092 310.193 210.486 310.035 205.919 309.833C204.886 309.788 203.808 309.74 202.684 309.7C196.646 309.491 188.156 309.767 184.597 310.038C181.005 310.311 176.804 311.155 176.763 311.164C176.732 311.172 176.699 311.169 176.669 311.162L176.67 311.159Z",
    fill: "url(#paint100_linear_376_6503)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M171.253 308.649C171.253 308.649 171.232 308.644 171.222 308.639C171.119 308.593 171.071 308.472 171.117 308.367C171.133 308.333 172.662 304.896 175.149 300.98C177.236 297.696 181.68 292.35 185.959 287.975L186.586 287.337C190.645 283.212 199.089 274.624 201.59 266.063C203.971 257.909 202.581 249.521 197.455 241.131C197.395 241.034 197.427 240.907 197.523 240.85C197.62 240.79 197.747 240.822 197.804 240.918C202.993 249.411 204.399 257.909 201.982 266.18C199.453 274.839 190.959 283.476 186.876 287.627L186.25 288.265C182.056 292.55 177.534 297.992 175.495 301.203C173.025 305.093 171.506 308.503 171.49 308.537C171.45 308.63 171.346 308.679 171.25 308.653L171.253 308.649Z",
    fill: "url(#paint101_linear_376_6503)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M168.679 306.778C168.597 306.756 168.533 306.683 168.528 306.593C168.525 306.536 168.192 300.682 169.492 294.636C170.947 287.872 173.269 283.263 177.118 275.628C177.892 274.091 178.728 272.431 179.631 270.609C184.647 260.475 187.87 251.697 187.292 241.791C186.787 233.165 184.736 223.513 173.229 211.41C173.151 211.328 173.155 211.199 173.237 211.119C173.319 211.04 173.448 211.043 173.527 211.127C185.124 223.326 187.193 233.062 187.703 241.769C188.286 251.766 185.045 260.602 180.001 270.791C179.098 272.613 178.262 274.273 177.487 275.812C173.653 283.417 171.34 288.009 169.897 294.722C168.609 300.711 168.937 306.512 168.942 306.569C168.948 306.681 168.863 306.78 168.749 306.785C168.726 306.786 168.704 306.785 168.683 306.779L168.679 306.778Z",
    fill: "url(#paint102_linear_376_6503)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M174.749 309.847C174.705 309.836 174.665 309.809 174.635 309.767C174.57 309.676 174.59 309.548 174.683 309.481L175.438 308.94C178.799 306.534 182.983 303.54 189.679 300.358C190.572 299.933 191.701 299.441 193.01 298.871C196.124 297.515 200.001 295.826 203.578 293.797C208.81 290.83 212.318 287.702 213.456 284.991C215.405 280.349 214.409 276.445 213.89 274.982L213.869 274.923C213.833 274.816 213.889 274.699 213.996 274.662C214.102 274.625 214.22 274.681 214.257 274.788L214.276 274.843C214.811 276.35 215.837 280.375 213.833 285.148C212.661 287.943 209.089 291.141 203.781 294.151C200.184 296.19 196.298 297.884 193.174 299.244C191.869 299.812 190.74 300.302 189.855 300.725C183.194 303.894 179.025 306.876 175.678 309.27L174.921 309.81C174.869 309.846 174.805 309.856 174.749 309.841L174.749 309.847Z",
    fill: "url(#paint103_linear_376_6503)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M160.424 360.328C155.409 358.984 152.362 357.369 152.295 357.333C152.195 357.279 152.158 357.154 152.212 357.056C152.266 356.956 152.389 356.915 152.49 356.973C152.642 357.057 167.845 365.103 186.544 360.036C206.749 354.56 213.949 337.826 214.934 329.743C216.225 319.127 215.936 307.664 205.166 295.765C200.983 291.144 195.811 287.6 189.355 284.929C183.764 282.614 178.286 281.394 173.457 280.313C171.48 279.871 169.628 279.447 167.959 279.007C158.56 276.457 153.14 268.207 153.086 268.122C153.024 268.027 153.051 267.899 153.146 267.839C153.242 267.777 153.369 267.806 153.429 267.899C153.482 267.981 158.823 276.104 168.067 278.61C169.711 279.053 171.573 279.471 173.546 279.912C178.395 280.995 183.89 282.222 189.513 284.548C196.025 287.243 201.247 290.823 205.471 295.489C216.353 307.51 216.647 319.08 215.341 329.792C214.346 337.968 207.068 354.897 186.653 360.43C176.146 363.276 166.731 362.018 160.426 360.329L160.424 360.328Z",
    fill: "url(#paint104_linear_376_6503)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M150.321 349.213C140.962 346.706 128.854 341.321 118.004 329.805C117.927 329.722 117.93 329.594 118.012 329.515C118.095 329.438 118.223 329.441 118.302 329.523C133.358 345.499 150.848 349.604 159.935 350.63C169.556 351.716 178.06 350.33 182.812 348.672C192.905 345.153 204.542 336.446 204.113 323.496C203.781 313.485 199.056 306.036 189.666 300.722C184.983 298.071 177.399 297.374 172.867 296.959C171.288 296.812 170.042 296.699 169.329 296.546C166.489 295.929 164.974 292.419 164.912 292.27C164.868 292.166 164.918 292.046 165.022 292.002C165.124 291.958 165.246 292.006 165.29 292.112C165.305 292.148 166.78 295.582 169.415 296.146C170.103 296.294 171.34 296.408 172.906 296.553C177.47 296.974 185.111 297.678 189.869 300.368C199.393 305.759 204.188 313.322 204.523 323.487C204.957 336.659 193.173 345.497 182.946 349.062C178.152 350.735 169.577 352.131 159.889 351.039C157.297 350.747 154.023 350.205 150.321 349.213Z",
    fill: "url(#paint105_linear_376_6503)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M144.399 329.23C138.798 327.729 132.492 325.566 126.112 322.45C112.687 315.891 102.343 306.787 95.3681 295.392C95.3085 295.295 95.3402 295.168 95.4366 295.111C95.5336 295.051 95.6602 295.083 95.7182 295.177C112 321.782 143.263 329.276 155.947 331.261C171.453 333.692 182.705 329.126 186.977 323.524C188.76 321.186 189.377 318.801 188.81 316.439C188.076 313.372 185.501 311.165 183.338 310.121C179.094 308.075 174.065 309.881 174.015 309.899C173.908 309.94 173.79 309.884 173.753 309.777C173.714 309.672 173.768 309.554 173.875 309.515C173.928 309.495 179.117 307.635 183.518 309.751C185.767 310.835 188.443 313.137 189.212 316.341C189.799 318.795 189.14 321.364 187.304 323.772C182.959 329.471 171.558 334.123 155.886 331.666C152.682 331.163 148.753 330.396 144.399 329.23Z",
    fill: "url(#paint106_linear_376_6503)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M150.254 307.953C144.17 306.322 136.954 303.765 129.467 299.758C112.463 290.66 91.3005 279.332 83.347 262.122C83.3002 262.019 83.3439 261.898 83.4471 261.849C83.5502 261.8 83.6708 261.846 83.7196 261.949C91.6161 279.036 112.713 290.326 129.663 299.399C147.444 308.913 163.684 310.216 166.761 310.379C170.391 310.573 172.971 309.673 172.996 309.664C173.103 309.627 173.221 309.683 173.258 309.788C173.297 309.895 173.241 310.011 173.134 310.049C173.027 310.088 170.456 310.986 166.739 310.787C164.944 310.691 158.687 310.21 150.257 307.951L150.254 307.953Z",
    fill: "url(#paint107_linear_376_6503)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M155.805 293.999C155.769 293.989 155.736 293.969 155.708 293.941C155.683 293.917 153.271 291.359 146.848 286.858C145.09 285.624 143.171 284.302 141.117 282.885C135.438 278.968 129.004 274.527 121.952 269.27C121.471 268.912 120.889 268.479 120.219 267.982C103.776 255.781 81.8283 238.9 81.0854 233.179C81.0704 233.067 81.1497 232.964 81.2618 232.949C81.3738 232.934 81.4764 233.014 81.4914 233.126C82.2988 239.336 111.024 260.649 120.462 267.653C121.133 268.15 121.717 268.584 122.197 268.942C129.241 274.197 135.675 278.633 141.349 282.549C143.405 283.966 145.323 285.291 147.084 286.523C153.546 291.055 155.982 293.639 156.007 293.664C156.084 293.747 156.081 293.877 155.997 293.954C155.944 294.002 155.869 294.019 155.804 294.001L155.805 293.999Z",
    fill: "url(#paint108_linear_376_6503)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M141.031 270.393C140.976 270.378 140.928 270.341 140.902 270.287C137.61 263.737 134.043 258.524 113.706 236.125C100.791 221.898 94.5011 216.206 90.3372 212.441C89.4494 211.638 88.6649 210.928 87.9406 210.245C87.8581 210.167 87.8545 210.038 87.9329 209.955C88.0113 209.873 88.1405 209.869 88.2231 209.947C88.9458 210.627 89.7287 211.335 90.6145 212.137C94.7835 215.908 101.08 221.609 114.012 235.849C134.384 258.287 137.961 263.518 141.269 270.101C141.32 270.203 141.279 270.325 141.177 270.376C141.13 270.4 141.079 270.404 141.031 270.391L141.031 270.393Z",
    fill: "url(#paint109_linear_376_6503)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M133.594 248.232C133.518 248.211 133.459 248.148 133.445 248.066C132.895 244.634 129.577 236.384 126.723 230.175C124.106 224.476 109.472 197.836 104.691 193.84C104.604 193.767 104.592 193.638 104.664 193.552C104.737 193.465 104.866 193.453 104.953 193.525C109.88 197.641 124.386 224.101 127.095 230.002C129.152 234.481 133.209 244.005 133.85 248.001C133.867 248.111 133.792 248.217 133.681 248.235C133.65 248.24 133.622 248.237 133.597 248.23L133.594 248.232Z",
    fill: "url(#paint110_linear_376_6503)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M132.944 238.854C132.851 238.829 132.785 238.739 132.794 238.64C132.798 238.581 133.256 232.632 133.006 226.783C132.922 224.795 132.09 216.685 131.039 210.771C130.279 206.493 129.372 201.946 128.574 197.935C127.679 193.438 126.97 189.885 126.853 188.632C126.843 188.519 126.926 188.42 127.039 188.409C127.152 188.399 127.251 188.482 127.261 188.595C127.376 189.83 128.082 193.371 128.976 197.856C129.775 201.87 130.682 206.416 131.443 210.699C132.477 216.52 133.319 224.523 133.416 226.766C133.665 232.641 133.206 238.613 133.201 238.673C133.194 238.786 133.094 238.871 132.982 238.862C132.969 238.86 132.956 238.859 132.945 238.856L132.944 238.854Z",
    fill: "url(#paint111_linear_376_6503)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M134.417 233.812C134.402 233.808 134.389 233.805 134.376 233.796C134.275 233.745 134.236 233.622 134.285 233.52C134.327 233.439 138.417 225.36 140.627 218.078C141.505 215.189 142.456 212.04 143.343 209.1C144.746 204.46 145.957 200.454 146.521 198.626C147.436 195.666 148.472 194.402 149.883 194.532C149.997 194.543 150.078 194.643 150.068 194.755C150.058 194.868 149.957 194.951 149.845 194.941C148.663 194.833 147.759 196.007 146.912 198.747C146.346 200.572 145.138 204.579 143.735 209.218C142.845 212.16 141.894 215.307 141.018 218.196C138.797 225.513 134.692 233.625 134.65 233.706C134.606 233.793 134.505 233.836 134.415 233.811L134.417 233.812Z",
    fill: "url(#paint112_linear_376_6503)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M133.087 237.356C133.035 237.342 132.988 237.307 132.961 237.257C132.906 237.157 132.944 237.034 133.042 236.979C135.194 235.803 140.213 231.873 143.569 228.732C146.66 225.842 151.507 221.074 154.706 217.866C154.869 217.7 155.052 217.515 155.253 217.312C158.743 213.761 166.914 205.445 173.199 210.886C173.285 210.961 173.294 211.09 173.221 211.176C173.146 211.262 173.018 211.27 172.931 211.197C166.944 206.005 158.957 214.129 155.547 217.6C155.346 217.803 155.163 217.991 154.999 218.156C151.798 221.366 146.945 226.139 143.851 229.033C140.474 232.193 135.415 236.152 133.24 237.341C133.193 237.366 133.137 237.372 133.089 237.359L133.087 237.356Z",
    fill: "url(#paint113_linear_376_6503)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M132.873 240.534C132.795 240.513 132.732 240.447 132.724 240.361C132.709 240.249 132.79 240.147 132.902 240.132C132.951 240.125 137.899 239.519 141.395 238.655C144.604 237.861 149.695 236.107 156.524 233.444C157.042 233.243 157.661 232.983 158.369 232.685C161.425 231.401 166.044 229.46 171.235 228.492C179.54 226.945 187.639 226.457 195.476 237.322C195.541 237.414 195.521 237.541 195.428 237.609C195.337 237.674 195.209 237.653 195.142 237.561C187.447 226.889 179.477 227.372 171.308 228.894C166.159 229.854 161.565 231.785 158.524 233.062C157.811 233.361 157.19 233.622 156.67 233.825C149.823 236.495 144.716 238.255 141.489 239.052C137.969 239.923 132.997 240.533 132.946 240.538C132.921 240.542 132.894 240.54 132.869 240.533L132.873 240.534Z",
    fill: "url(#paint114_linear_376_6503)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M213.136 272.613C213.077 272.597 213.027 272.557 213.001 272.496C207.434 259.626 198.796 251.416 187.326 248.093C179.16 245.713 166.291 246.589 157.768 247.155C156.044 247.269 154.557 247.368 153.298 247.429C146.311 247.765 139.747 246.245 136.454 245.304C134.136 244.645 133.037 244.121 132.99 244.099C132.889 244.05 132.845 243.928 132.895 243.826C132.942 243.724 133.062 243.68 133.168 243.731C133.181 243.734 134.286 244.262 136.566 244.911C139.832 245.843 146.349 247.353 153.277 247.021C154.531 246.961 156.018 246.862 157.74 246.747C166.291 246.177 179.199 245.3 187.438 247.699C199.031 251.058 207.757 259.345 213.376 272.333C213.42 272.437 213.374 272.558 213.269 272.604C213.226 272.624 213.178 272.624 213.134 272.613L213.136 272.613Z",
    fill: "url(#paint115_linear_376_6503)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M220.759 313.172C220.672 313.149 220.609 313.073 220.607 312.98C220.501 309.713 220.112 306.865 220.108 306.836C217.416 288.456 209.754 279.711 199.079 272.236C189.712 265.677 173.478 263.425 167.367 262.575C166.577 262.465 165.933 262.375 165.466 262.302C161.286 261.632 156.985 260.795 150.368 257.928C143.876 255.117 138.924 250.445 138.873 250.398C138.791 250.319 138.787 250.19 138.865 250.108C138.944 250.025 139.073 250.021 139.156 250.1C139.204 250.147 144.108 254.77 150.53 257.551C157.103 260.399 161.375 261.231 165.528 261.893C165.994 261.969 166.635 262.057 167.42 262.166C173.558 263.018 189.863 265.281 199.312 271.896C210.076 279.433 217.8 288.248 220.512 306.776C220.517 306.806 220.908 309.673 221.014 312.966C221.018 313.079 220.929 313.172 220.816 313.176C220.795 313.177 220.776 313.174 220.757 313.169L220.759 313.172Z",
    fill: "url(#paint116_linear_376_6503)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M254.852 324.347C254.852 324.347 254.857 324.344 254.863 324.341C259.489 321.011 263.239 316.897 266.158 312.142C266.166 312.13 266.173 312.121 266.181 312.109C268.161 308.876 269.756 305.353 270.974 301.58C271.881 298.774 272.583 295.826 273.085 292.76L273.082 292.754C273.141 292.441 273.187 292.127 273.235 291.807C273.234 291.793 273.241 291.784 273.24 291.77C274.126 285.741 274.244 279.269 273.609 272.499C273.028 266.131 271.786 259.493 269.912 252.72C268.144 246.279 265.804 239.714 262.921 233.118C260.45 227.454 257.576 221.772 254.318 216.132C251.059 210.491 247.576 205.159 243.906 200.183C239.638 194.393 235.123 189.084 230.437 184.335C225.5 179.323 220.378 174.925 215.152 171.233C209.613 167.309 203.955 164.177 198.299 161.932C198.299 161.932 198.294 161.931 198.284 161.928C197.972 161.801 197.662 161.68 197.344 161.566L197.341 161.56C194.433 160.457 191.522 159.587 188.631 158.975L188.623 158.972C184.735 158.142 180.877 157.766 177.081 157.867C171.512 158.02 166.074 159.211 160.88 161.549C160.88 161.549 160.877 161.551 160.87 161.555C159.559 162.145 158.263 162.806 156.985 163.544C156.41 163.876 155.855 164.216 155.306 164.566C152.31 166.476 149.647 168.693 147.31 171.18C146.798 171.723 146.304 172.274 145.827 172.842C143.228 175.914 141.076 179.36 139.361 183.112C139.245 183.346 139.139 183.579 139.05 183.805C138.497 185.062 137.991 186.353 137.536 187.674C137.536 187.674 137.534 187.679 137.532 187.689C137.108 188.926 136.718 190.188 136.377 191.476C136.367 191.516 136.357 191.534 136.357 191.534C134.635 198.019 133.941 205.162 134.236 212.741C134.237 212.755 134.235 212.761 134.233 212.77C134.28 213.888 134.345 215.015 134.427 216.151C134.43 216.177 134.431 216.204 134.434 216.234C134.523 217.449 134.64 218.677 134.786 219.912L134.784 219.92C135.647 227.445 137.399 235.311 139.998 243.33C142.237 250.239 145.107 257.261 148.58 264.27C150.207 267.562 151.968 270.854 153.859 274.128C155.75 277.403 157.72 280.571 159.756 283.624C164.092 290.141 168.738 296.138 173.603 301.532C180.084 308.72 186.942 314.837 193.975 319.683C193.999 319.703 194.028 319.718 194.052 319.738C195.091 320.455 196.133 321.14 197.18 321.801C197.18 321.801 197.184 321.803 197.191 321.808C203.614 325.854 210.153 328.831 216.633 330.579C216.633 330.579 216.653 330.58 216.693 330.59C217.965 330.935 219.239 331.23 220.507 331.477C221.901 331.745 223.29 331.962 224.678 332.117C224.924 332.141 225.172 332.164 225.417 332.189C225.417 332.189 225.422 332.189 225.431 332.189C229.537 332.58 233.598 332.439 237.558 331.724C238.276 331.597 238.996 331.447 239.712 331.279C243.651 330.356 247.496 328.84 251.192 326.709C252.47 325.971 253.691 325.179 254.857 324.339L254.852 324.347ZM216.851 271.58C214.381 269.239 211.155 265.856 207.63 261.328C204.811 257.702 201.797 253.334 198.819 248.176C195.841 243.018 193.568 238.226 191.834 233.969C189.672 228.647 188.358 224.166 187.563 220.851C186.602 216.826 186.403 214.519 186.403 214.519C186.403 214.519 186.727 214.746 187.319 215.208C187.87 215.641 188.655 216.289 189.634 217.154C193.893 220.934 201.74 228.923 209.347 242.099C210.299 243.747 211.179 245.363 211.995 246.927C217.673 257.894 220.092 266.763 221.09 271.638C221.35 272.919 221.516 273.922 221.618 274.616C221.722 275.362 221.757 275.754 221.757 275.754C221.757 275.754 219.859 274.426 216.853 271.583L216.851 271.58Z",
    fill: "#141332"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M216.801 330.875C211.534 329.464 206.146 327.217 200.682 324.137C183.287 314.33 166.595 296.608 153.678 274.234C140.762 251.863 133.761 228.544 133.963 208.576C134.177 187.532 142.102 171.9 156.879 163.369C171.655 154.837 189.158 155.791 207.487 166.127C224.881 175.935 241.574 193.655 254.491 216.029C267.407 238.401 274.408 261.719 274.206 281.688C273.992 302.731 266.067 318.363 251.29 326.895C240.918 332.883 229.203 334.198 216.801 330.875ZM191.269 159.789C178.971 156.494 167.36 157.795 157.085 163.726C142.441 172.18 134.587 187.692 134.373 208.582C134.17 228.478 141.153 251.72 154.032 274.03C166.913 296.34 183.552 314.007 200.882 323.778C219.08 334.039 236.438 334.994 251.084 326.538C265.728 318.081 273.582 302.572 273.796 281.681C273.999 261.785 267.016 238.543 254.137 216.234C241.256 193.924 224.617 176.256 207.287 166.485C201.857 163.423 196.501 161.191 191.269 159.789Z",
    fill: "url(#paint117_linear_376_6503)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M221.717 275.968C221.694 275.962 221.672 275.951 221.653 275.937C221.536 275.856 209.757 267.529 198.652 248.295C187.547 229.061 186.227 214.697 186.214 214.554C186.208 214.476 186.246 214.398 186.316 214.358C186.385 214.318 186.469 214.323 186.536 214.368C186.654 214.449 198.433 222.776 209.538 242.01C220.643 261.244 221.962 275.61 221.976 275.751C221.981 275.831 221.943 275.907 221.874 275.947C221.826 275.974 221.77 275.982 221.717 275.968ZM186.674 214.979C186.996 217.575 189.059 230.861 199.006 248.091C208.954 265.318 219.428 273.75 221.516 275.326C221.193 272.732 219.129 259.443 209.184 242.214C199.235 224.98 188.761 216.555 186.674 214.979Z",
    fill: "url(#paint118_linear_376_6503)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M231.727 281.194C229.18 280.511 225.637 279.024 221.646 275.931C221.557 275.862 221.539 275.733 221.61 275.644C221.679 275.555 221.808 275.537 221.897 275.608C229.187 281.258 235.011 281.448 235.636 281.282C235.985 281.191 236.146 281.007 236.417 280.703C236.723 280.358 237.145 279.883 238.061 279.314C238.374 279.119 239.051 278.796 239.908 278.386C242.507 277.147 247.344 274.837 248.152 273.023C249.394 270.236 248.324 268.128 247.086 265.692C246.179 263.904 245.152 261.88 244.999 259.343C244.851 256.881 245.427 255.014 245.983 253.209C246.786 250.608 247.541 248.15 246.327 243.987C245.1 239.78 242.533 237.327 239.815 234.73C237.85 232.853 235.82 230.914 234.309 228.242C232.693 225.385 232.14 222.812 231.605 220.324C230.952 217.292 230.337 214.431 227.916 211.182C224.999 207.267 220.86 205.944 217.209 204.777C215.026 204.079 213.141 203.477 211.885 202.418C210.512 201.26 209.474 199.688 208.473 198.166C207.073 196.042 205.749 194.035 203.682 193.373C203.663 193.368 203.646 193.363 203.627 193.358C201.708 192.844 195.849 196.159 192.689 197.948C191.805 198.449 191.105 198.845 190.742 199.015C189.923 199.399 189.602 199.37 189.345 199.346C189.187 199.332 189.091 199.322 188.856 199.449C188.314 199.742 186.963 201.787 186.484 205.935C186.017 209.97 186.618 214.464 186.624 214.508C186.639 214.62 186.562 214.724 186.45 214.739C186.338 214.754 186.235 214.676 186.22 214.564C186.214 214.52 185.606 209.977 186.077 205.889C186.562 201.695 187.919 199.493 188.662 199.091C189.005 198.903 189.198 198.921 189.382 198.939C189.591 198.959 189.848 198.981 190.567 198.644C190.916 198.481 191.609 198.088 192.487 197.592C196.929 195.079 201.816 192.447 203.74 192.963C203.763 192.969 203.786 192.975 203.809 192.982C206.015 193.687 207.377 195.754 208.817 197.941C209.804 199.439 210.824 200.986 212.151 202.105C213.345 203.111 215.194 203.703 217.336 204.388C220.863 205.515 225.252 206.918 228.247 210.938C230.721 214.257 231.347 217.162 232.008 220.238C232.538 222.696 233.084 225.238 234.669 228.042C236.149 230.66 238.158 232.58 240.101 234.436C242.737 236.954 245.465 239.56 246.722 243.872C247.973 248.153 247.161 250.786 246.376 253.33C245.832 255.1 245.267 256.93 245.411 259.318C245.557 261.77 246.521 263.67 247.454 265.504C248.686 267.93 249.85 270.223 248.528 273.189C247.658 275.142 242.917 277.403 240.086 278.756C239.241 279.16 238.573 279.478 238.279 279.66C237.412 280.198 237.031 280.629 236.724 280.975C236.437 281.299 236.212 281.553 235.744 281.678C235.385 281.773 233.93 281.784 231.731 281.195L231.727 281.194Z",
    fill: "url(#paint119_linear_376_6503)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M229.89 280.591C229.806 280.569 229.721 280.539 229.633 280.507C229.527 280.465 229.475 280.347 229.517 280.242C229.559 280.136 229.674 280.07 229.782 280.126C230.166 280.274 230.515 280.29 230.824 280.169C230.943 280.122 230.986 280.077 231.048 280.013C231.108 279.952 231.18 279.875 231.307 279.812C231.52 279.705 232.198 279.328 234.753 277.888C235.165 277.656 235.615 277.419 236.085 277.169C238.545 275.867 241.61 274.248 242.232 271.802C242.694 269.987 241.754 268.245 240.76 266.401C239.862 264.738 238.934 263.017 238.831 261.006C238.657 257.583 239.35 255.624 239.962 253.897C240.598 252.102 241.148 250.552 240.733 247.749C240.02 242.918 236.841 239.971 233.769 237.12C232.003 235.481 230.333 233.932 229.134 232.067C227.562 229.624 226.947 226.761 226.354 223.993C225.688 220.89 224.999 217.683 222.962 215.046C220.388 211.713 216.718 210.608 213.48 209.63C211.855 209.141 210.32 208.678 209.032 207.982C207.066 206.919 205.695 204.895 204.367 202.937C203.092 201.053 201.885 199.273 200.366 198.826C200.351 198.822 200.336 198.818 200.322 198.814C198.476 198.319 193.929 200.232 188.135 203.945L187.986 204.04C187.667 204.238 187.498 204.3 187.363 204.35C187.288 204.377 187.221 204.402 187.13 204.454C186.949 204.559 186.707 204.924 186.556 205.32C186.516 205.426 186.397 205.476 186.292 205.438C186.186 205.399 186.135 205.279 186.174 205.175C186.318 204.797 186.601 204.288 186.926 204.1C187.04 204.034 187.125 204.003 187.22 203.967C187.343 203.921 187.483 203.869 187.768 203.693L187.912 203.601C190.765 201.775 197.702 197.603 200.48 198.435C202.139 198.927 203.385 200.765 204.704 202.712C206.003 204.629 207.347 206.612 209.224 207.626C210.477 208.304 211.993 208.759 213.597 209.243C216.894 210.237 220.628 211.364 223.284 214.799C225.379 217.51 226.078 220.763 226.752 223.91C227.339 226.643 227.945 229.47 229.476 231.848C230.649 233.67 232.298 235.202 234.047 236.823C237.171 239.722 240.404 242.72 241.138 247.693C241.568 250.597 240.974 252.268 240.347 254.038C239.719 255.812 239.067 257.648 239.239 260.989C239.337 262.909 240.242 264.585 241.12 266.209C242.153 268.125 243.131 269.935 242.63 271.906C241.963 274.53 238.811 276.195 236.277 277.535C235.811 277.782 235.365 278.018 234.956 278.248C232.363 279.71 231.717 280.07 231.491 280.183C231.426 280.215 231.392 280.251 231.345 280.301C231.27 280.38 231.176 280.477 230.975 280.556C230.641 280.687 230.276 280.702 229.89 280.598L229.89 280.591Z",
    fill: "url(#paint120_linear_376_6503)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M228.648 280.108C228.602 280.095 228.558 280.065 228.529 280.022C228.467 279.926 228.494 279.801 228.587 279.738C228.71 279.658 228.893 279.545 229.125 279.403C231.007 278.252 236.731 274.748 236.364 271.474C236.201 270.023 235.607 269.166 234.978 268.26C233.986 266.83 232.861 265.207 233.079 260.973C233.168 259.273 233.593 257.84 234.002 256.453C234.719 254.038 235.395 251.759 234.374 248.195C233.186 244.052 230.586 241.899 228.071 239.818C226.314 238.363 224.654 236.989 223.516 235.012C221.895 232.196 221.425 229.524 220.972 226.94C220.457 224.013 219.972 221.247 217.798 218.731C215.086 215.589 212.656 214.895 209.844 214.092C208.118 213.601 206.335 213.091 204.315 211.967C201.79 210.561 200.987 208.721 200.279 207.095C199.623 205.589 199.053 204.286 197.203 203.747C197.172 203.739 197.142 203.731 197.111 203.723C193.194 202.673 186.387 206.646 186.317 206.688C186.221 206.745 186.094 206.713 186.038 206.615C185.98 206.518 186.012 206.392 186.11 206.335C186.396 206.166 193.136 202.234 197.217 203.328C197.25 203.337 197.284 203.346 197.317 203.355C199.353 203.95 199.987 205.398 200.656 206.932C201.339 208.498 202.113 210.272 204.517 211.609C206.495 212.711 208.256 213.214 209.958 213.7C212.714 214.485 215.317 215.23 218.113 218.464C220.36 221.067 220.856 223.886 221.38 226.869C221.827 229.418 222.291 232.054 223.876 234.809C224.978 236.722 226.61 238.074 228.338 239.505C230.901 241.625 233.55 243.818 234.773 248.083C235.829 251.763 235.102 254.206 234.401 256.571C233.997 257.935 233.579 259.342 233.495 260.994C233.284 265.089 234.318 266.581 235.32 268.025C235.98 268.976 236.603 269.875 236.777 271.427C237.172 274.961 231.485 278.441 229.344 279.752C229.116 279.891 228.935 280.002 228.815 280.08C228.763 280.114 228.705 280.123 228.65 280.108L228.648 280.108Z",
    fill: "url(#paint121_linear_376_6503)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M227.475 279.573C227.438 279.563 227.403 279.542 227.373 279.509C227.299 279.424 227.307 279.293 227.394 279.22L227.444 279.177C228.557 278.224 231.113 275.766 230.825 273.573C230.702 272.631 230.297 272.092 229.827 271.467C229.038 270.414 228.054 269.103 228.03 265.338C228.014 262.936 228.393 261.068 228.761 259.26C229.273 256.727 229.715 254.539 228.952 251.498C228.013 247.76 226.203 246.174 224.108 244.339C222.254 242.714 220.154 240.875 218.15 237.214C216.053 233.379 215.772 231.203 215.526 229.283C215.285 227.417 215.077 225.806 213.274 223.077C211.118 219.818 207.604 218.422 204.207 217.072C201.383 215.951 198.461 214.792 196.296 212.571C195.253 211.501 195.013 210.638 194.821 209.945C194.591 209.123 194.427 208.527 193.13 207.84C190.69 206.545 186.239 207.976 186.193 207.989C186.087 208.023 185.969 207.965 185.935 207.857C185.901 207.751 185.959 207.634 186.067 207.6C186.257 207.538 190.736 206.104 193.323 207.478C194.776 208.249 194.98 208.984 195.217 209.835C195.406 210.518 195.622 211.29 196.591 212.286C198.696 214.443 201.575 215.586 204.358 216.692C207.815 218.064 211.39 219.483 213.616 222.851C215.474 225.66 215.686 227.315 215.934 229.23C216.176 231.114 216.451 233.249 218.512 237.016C220.481 240.614 222.551 242.429 224.38 244.031C226.527 245.912 228.381 247.536 229.352 251.4C230.138 254.533 229.665 256.868 229.164 259.343C228.802 261.13 228.428 262.979 228.442 265.338C228.464 268.968 229.364 270.165 230.159 271.222C230.641 271.865 231.097 272.473 231.233 273.521C231.547 275.912 228.875 278.491 227.712 279.488L227.665 279.529C227.612 279.576 227.541 279.59 227.478 279.573L227.475 279.573Z",
    fill: "url(#paint122_linear_376_6503)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M225.929 278.766C225.929 278.766 225.913 278.762 225.902 278.759C225.797 278.715 225.748 278.596 225.792 278.491C226.615 276.519 225.957 274.11 225.261 271.559C224.879 270.167 224.486 268.727 224.354 267.357C224.244 266.238 224.379 264.96 224.537 263.48C224.819 260.823 225.168 257.515 224.094 253.885C223.113 250.565 220.906 248.043 218.569 245.372C217.028 243.611 215.436 241.791 214.211 239.712C212.726 237.189 211.934 234.735 211.169 232.362C210.372 229.886 209.618 227.548 208.149 225.378C205.884 222.03 201.488 219.902 198.28 218.351C197.431 217.941 196.63 217.554 195.968 217.192C193.747 215.98 192.108 214.114 190.79 212.615C190.221 211.967 189.729 211.408 189.306 211.04C187.972 209.883 186.09 209.642 186.073 209.64C185.96 209.621 185.881 209.523 185.893 209.412C185.907 209.298 186.009 209.22 186.121 209.232C186.204 209.243 188.144 209.488 189.574 210.729C190.018 211.113 190.518 211.682 191.098 212.341C192.395 213.817 194.008 215.651 196.164 216.828C196.816 217.185 197.613 217.57 198.458 217.978C201.708 219.551 206.16 221.703 208.488 225.145C209.989 227.366 210.754 229.73 211.559 232.235C212.317 234.588 213.102 237.02 214.564 239.502C215.771 241.55 217.349 243.355 218.878 245.102C221.244 247.807 223.481 250.362 224.488 253.768C225.584 257.474 225.23 260.828 224.945 263.522C224.791 264.98 224.658 266.239 224.761 267.315C224.89 268.651 225.281 270.072 225.655 271.449C226.339 273.953 227.047 276.544 226.169 278.646C226.13 278.741 226.024 278.791 225.927 278.766L225.929 278.766Z",
    fill: "url(#paint123_linear_376_6503)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M223.142 277.016C223.048 276.991 222.984 276.902 222.99 276.802C222.994 276.789 223.089 275.559 222.983 274.308C222.945 273.861 222.824 273.097 222.672 272.127C222.393 270.355 222.007 267.929 221.859 265.683C221.829 265.225 221.806 264.748 221.779 264.259C221.622 261.142 221.427 257.266 219.299 253.296C218.059 250.983 216.552 248.923 215.095 246.932C213.667 244.978 212.189 242.959 211.02 240.76C210.232 239.274 209.498 237.581 208.718 235.785C207.219 232.333 205.67 228.762 203.736 226.833C200.803 223.908 195.877 220.063 192.933 217.763L192.891 217.732C191.945 216.995 191.136 216.253 190.42 215.598C188.921 214.226 187.736 213.141 186.176 212.804C186.048 212.785 185.996 212.67 186.018 212.561C186.041 212.45 186.152 212.381 186.261 212.403C187.936 212.762 189.151 213.882 190.695 215.295C191.405 215.945 192.209 216.683 193.14 217.409L193.181 217.441C196.132 219.744 201.07 223.6 204.021 226.542C206.012 228.527 207.578 232.134 209.091 235.621C209.865 237.409 210.6 239.096 211.381 240.566C212.536 242.739 213.938 244.657 215.424 246.689C216.89 248.694 218.406 250.763 219.657 253.102C221.827 257.152 222.026 261.079 222.186 264.238C222.21 264.726 222.235 265.198 222.265 265.655C222.411 267.884 222.795 270.298 223.072 272.061C223.227 273.039 223.349 273.81 223.387 274.27C223.495 275.557 223.399 276.781 223.394 276.834C223.384 276.946 223.285 277.03 223.172 277.022C223.159 277.021 223.149 277.018 223.136 277.014L223.142 277.016Z",
    fill: "url(#paint124_linear_376_6503)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M221.071 271.95C220.999 271.931 220.941 271.873 220.924 271.794C220.678 270.634 220.482 269.251 220.273 267.788C219.855 264.851 219.333 261.198 218.153 257.487C216.844 253.375 214.154 249.156 211.781 245.436C210.938 244.114 210.141 242.863 209.431 241.664C208.431 239.971 207.839 238.726 207.269 237.519C206.266 235.398 205.318 233.393 202.262 229.247C197.531 222.827 187.348 215.493 187.246 215.418C187.153 215.353 187.134 215.224 187.199 215.133C187.264 215.04 187.394 215.019 187.484 215.086C187.586 215.158 197.822 222.531 202.593 229.005C205.672 233.181 206.626 235.204 207.64 237.344C208.206 238.543 208.793 239.78 209.784 241.457C210.491 242.651 211.284 243.896 212.128 245.219C214.515 248.96 217.218 253.203 218.543 257.366C219.735 261.109 220.256 264.783 220.679 267.735C220.887 269.191 221.081 270.567 221.324 271.712C221.348 271.822 221.276 271.931 221.166 271.956C221.133 271.962 221.102 271.961 221.07 271.952L221.071 271.95Z",
    fill: "url(#paint125_linear_376_6503)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M237.043 284.057C233.729 283.169 228.99 280.776 225.198 278.353C225.102 278.291 225.075 278.165 225.136 278.071C225.198 277.975 225.322 277.947 225.418 278.009C231.091 281.636 237.027 284.156 239.535 284.004C240.862 283.923 241.1 283.575 241.533 282.939C241.924 282.364 242.46 281.58 243.995 280.673C245.389 279.848 246.916 279.206 248.396 278.583C251.059 277.462 253.576 276.403 254.424 274.56C255.581 272.038 254.566 269.608 253.39 266.789C252.5 264.658 251.493 262.245 251.27 259.394C251.069 256.835 251.604 254.781 252.12 252.795C252.882 249.868 253.6 247.104 252.167 242.81C250.501 237.826 247.785 234.969 245.16 232.206C243.367 230.321 241.515 228.37 239.994 225.762C238.122 222.55 237.277 219.629 236.458 216.807C235.531 213.612 234.656 210.593 232.393 207.369C229.04 202.595 225.374 201.392 221.829 200.23C220.53 199.803 219.185 199.364 217.894 198.753C214.747 197.266 212.653 194.604 210.807 192.255C209.125 190.116 207.536 188.097 205.451 187.342C202.95 186.438 200.341 188.244 196.726 190.74L196.099 191.173C192.48 193.663 190.832 193.91 189.693 193.823C189.616 193.818 187.774 193.73 186.934 198.45C186.184 202.679 186.298 209.057 186.301 209.121C186.302 209.234 186.214 209.328 186.101 209.331C185.99 209.335 185.895 209.242 185.891 209.131C185.89 209.067 185.773 202.648 186.532 198.381C187.42 193.387 189.492 193.4 189.726 193.418C190.791 193.5 192.353 193.257 195.866 190.838L196.493 190.407C200.208 187.841 202.895 185.986 205.59 186.96C207.786 187.754 209.409 189.818 211.129 192.003C212.947 194.316 215.009 196.937 218.07 198.383C219.339 198.982 220.611 199.4 221.958 199.842C225.567 201.025 229.298 202.247 232.729 207.135C235.033 210.415 235.915 213.465 236.85 216.694C237.662 219.494 238.501 222.388 240.346 225.556C241.842 228.123 243.679 230.055 245.454 231.924C248.11 234.721 250.858 237.611 252.552 242.682C254.026 247.093 253.258 250.045 252.515 252.9C252.008 254.853 251.482 256.876 251.677 259.366C251.894 262.15 252.89 264.532 253.767 266.636C254.98 269.543 256.027 272.052 254.795 274.736C253.882 276.724 251.292 277.813 248.552 278.967C247.085 279.583 245.571 280.221 244.202 281.029C242.744 281.89 242.261 282.603 241.871 283.176C241.415 283.844 241.088 284.326 239.559 284.42C238.888 284.461 238.027 284.33 237.042 284.066L237.043 284.057Z",
    fill: "url(#paint126_linear_376_6503)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M240.616 288.115C237.512 287.284 233.915 284.706 230.982 282.603C229.717 281.697 228.626 280.914 227.775 280.418C224.296 278.39 219.072 275.11 213.886 270.054C208.499 264.804 201.17 252.47 201.097 252.347C201.04 252.251 201.072 252.124 201.17 252.067C201.267 252.01 201.393 252.041 201.45 252.14C201.523 252.263 208.824 264.549 214.171 269.763C219.326 274.787 224.522 278.05 227.982 280.066C228.848 280.571 229.947 281.36 231.222 282.271C234.36 284.521 238.27 287.32 241.438 287.879C244.628 288.441 245.624 287.335 247.005 285.803C247.46 285.297 247.979 284.722 248.623 284.167C249.899 283.069 251.864 282.303 253.766 281.564C256.646 280.442 259.624 279.284 260.137 276.991C260.673 274.606 259.849 271.758 258.976 268.74C258.267 266.288 257.535 263.751 257.475 261.27C257.426 259.285 257.701 257.535 257.99 255.684C258.51 252.368 259.049 248.937 257.808 243.664C256.497 238.088 253.249 233.947 249.809 229.561C248.19 227.498 246.516 225.363 244.985 223.002C242.791 219.616 241.56 216.227 240.372 212.95C238.952 209.041 237.612 205.348 234.78 201.922C231.191 197.581 227.058 195.877 223.411 194.373C221.761 193.693 220.203 193.05 218.855 192.225C216.895 191.022 214.741 188.829 212.655 186.708C210.204 184.212 207.669 181.633 205.615 180.88C201.898 179.515 199.226 181.707 196.378 184.489C193.951 186.862 191.826 187.265 190.118 187.589C189.791 187.65 189.478 187.71 189.176 187.78C187.889 188.079 185.659 189.288 185.187 194.004C184.899 196.885 185.052 198.911 185.333 202.592C185.451 204.15 185.598 206.087 185.738 208.49C186.191 216.292 187.073 222.626 190.056 230.079C192.979 237.384 197.274 244.986 197.317 245.06C197.371 245.158 197.338 245.284 197.24 245.339C197.142 245.394 197.016 245.36 196.961 245.262C196.918 245.186 192.609 237.562 189.675 230.23C186.673 222.726 185.786 216.357 185.329 208.514C185.19 206.115 185.043 204.178 184.924 202.622C184.643 198.918 184.489 196.878 184.78 193.962C185.277 188.99 187.69 187.703 189.083 187.379C189.39 187.308 189.71 187.248 190.042 187.183C191.781 186.855 193.753 186.483 196.093 184.195C198.932 181.419 201.807 179.04 205.758 180.493C207.898 181.276 210.351 183.772 212.949 186.417C215.014 188.522 217.153 190.695 219.071 191.873C220.389 192.681 221.934 193.318 223.568 193.992C227.259 195.515 231.443 197.239 235.096 201.657C237.974 205.139 239.327 208.862 240.759 212.807C241.942 216.063 243.162 219.429 245.332 222.775C246.851 225.12 248.521 227.247 250.133 229.304C253.6 233.726 256.876 237.902 258.206 243.564C259.465 248.914 258.919 252.385 258.394 255.74C258.108 257.572 257.835 259.304 257.883 261.253C257.941 263.682 258.666 266.192 259.368 268.62C260.254 271.689 261.092 274.588 260.536 277.073C259.975 279.581 256.892 280.778 253.913 281.938C252.044 282.666 250.111 283.418 248.888 284.47C248.265 285.008 247.778 285.546 247.307 286.07C245.894 287.639 244.779 288.877 241.366 288.276C241.12 288.233 240.87 288.177 240.618 288.109L240.616 288.115Z",
    fill: "url(#paint127_linear_376_6503)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M243.176 293.335C242.678 293.201 242.163 293.007 241.622 292.743C238.231 291.089 235.01 288.527 231.895 286.049C230.355 284.823 228.761 283.554 227.181 282.429C225.552 281.265 224.057 280.504 222.474 279.698C219.525 278.196 216.477 276.641 212.533 272.334C208.732 268.182 204.648 261.035 201.046 254.728C199.883 252.692 198.782 250.768 197.716 248.976C197.716 248.976 197.712 248.973 197.713 248.971C197.662 248.876 192.484 239.45 189.869 234.61C189.591 234.094 189.319 233.598 189.053 233.113C186.794 228.991 185.008 225.735 184.145 219.757C183.58 215.849 183.427 212.668 183.267 209.3C183.155 206.988 183.039 204.598 182.78 201.917C182.68 200.886 182.563 199.847 182.447 198.809C181.809 193.148 181.206 187.798 183.277 184.119C184.785 181.439 186.83 181.157 188.807 180.885C190.107 180.706 191.45 180.522 192.707 179.679C193.544 179.118 194.356 178.381 195.214 177.6C197.601 175.428 200.306 172.97 204.285 174.036L204.332 174.049C207.396 174.888 210.848 178.1 214.186 181.207C216.67 183.516 219.014 185.697 221.017 186.74C221.781 187.138 222.642 187.545 223.553 187.976C228.311 190.223 234.828 193.302 239.455 200.624C243.076 206.355 244.417 209.424 245.715 212.394C246.382 213.921 247.072 215.502 248.066 217.423C249.733 220.645 251.665 223.405 253.709 226.327C256.74 230.658 259.871 235.134 262.066 241.235C264.569 248.199 264.114 252.163 263.673 255.995C263.473 257.74 263.264 259.546 263.336 261.62C263.432 264.412 264.138 267.323 264.818 270.136C265.756 274.012 266.643 277.673 265.783 280.48C264.812 283.65 261.504 284.99 258.303 286.284C256.538 286.999 254.872 287.674 253.58 288.631C252.951 289.097 252.333 289.603 251.737 290.089C249.123 292.227 246.633 294.261 243.17 293.333L243.176 293.335ZM198.073 248.77C199.141 250.564 200.241 252.489 201.404 254.525C204.995 260.813 209.067 267.939 212.837 272.055C216.731 276.308 219.746 277.843 222.663 279.33C224.19 280.108 225.769 280.911 227.422 282.093C229.009 283.225 230.607 284.497 232.152 285.726C235.251 288.19 238.453 290.739 241.802 292.372C245.869 294.356 248.6 292.13 251.485 289.769C252.085 289.279 252.705 288.773 253.342 288.3C254.674 287.31 256.444 286.594 258.156 285.902C261.266 284.642 264.483 283.341 265.397 280.358C266.224 277.658 265.35 274.049 264.425 270.232C263.74 267.396 263.029 264.464 262.933 261.631C262.86 259.525 263.07 257.707 263.272 255.944C263.728 251.985 264.158 248.245 261.687 241.37C259.511 235.319 256.394 230.864 253.381 226.559C251.418 223.755 249.39 220.855 247.71 217.609C246.71 215.677 246.017 214.089 245.347 212.557C244.054 209.602 242.719 206.545 239.115 200.841C234.552 193.619 228.098 190.571 223.384 188.347C222.469 187.915 221.604 187.505 220.833 187.105C218.778 186.037 216.415 183.837 213.912 181.507C210.61 178.434 207.195 175.257 204.228 174.444L204.184 174.432C200.42 173.424 197.917 175.702 195.494 177.905C194.625 178.696 193.803 179.444 192.939 180.023C191.603 180.918 190.213 181.108 188.866 181.295C186.901 181.565 185.045 181.82 183.636 184.323C181.63 187.887 182.226 193.172 182.857 198.766C182.974 199.806 183.091 200.848 183.19 201.881C183.451 204.571 183.565 206.967 183.679 209.282C183.84 212.639 183.993 215.811 184.554 219.7C185.407 225.606 187.174 228.832 189.416 232.917C189.682 233.403 189.954 233.899 190.234 234.415C192.834 239.222 197.955 248.554 198.075 248.77L198.073 248.77Z",
    fill: "url(#paint128_linear_376_6503)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M245.534 300.518C245.447 300.495 245.362 300.469 245.278 300.438C240.683 298.835 237.158 295.955 233.427 292.902C231.874 291.631 230.268 290.318 228.51 289.032C226.229 287.361 223.832 286.041 221.516 284.765C217.695 282.661 213.743 280.483 210.067 276.642C207.15 273.593 201.77 263.875 197.843 256.779C196.434 254.234 195.217 252.037 194.439 250.741C193.727 249.558 192.929 248.27 192.078 246.894C187.669 239.782 181.632 230.038 179.1 220.788C177.011 213.151 177.295 208.707 177.568 204.411C177.689 202.532 177.81 200.591 177.727 198.425C177.649 196.462 177.316 194.37 176.992 192.347C176.146 187.053 175.274 181.579 178.809 177.644C180.65 175.594 183.66 175.014 186.316 174.501C187.76 174.221 189.122 173.958 190.129 173.492C191.245 172.976 192.378 172.049 193.579 171.069C196.089 169.018 198.931 166.696 202.423 167.632C202.442 167.637 202.461 167.642 202.48 167.647C205.702 168.542 209.662 171.725 213.492 174.805C215.764 176.631 217.912 178.359 219.889 179.618C220.397 179.941 220.917 180.27 221.448 180.603C226.445 183.75 232.664 187.665 238.532 194.444C243.302 199.954 246.595 206.155 249.498 211.626C250.569 213.644 251.58 215.549 252.628 217.361C253.398 218.695 254.343 220.251 255.344 221.9C259.504 228.756 265.202 238.146 266.798 245.435C268.023 251.028 268.101 254.409 268.184 257.988C268.233 260.142 268.285 262.368 268.602 265.15C268.858 267.402 269.246 269.795 269.62 272.111C270.477 277.407 271.286 282.41 270.513 285.284C269.618 288.61 265.835 290.639 261.829 292.787C260.812 293.332 259.76 293.896 258.761 294.482C257.672 295.12 256.551 295.843 255.467 296.543C251.738 298.952 248.21 301.232 245.536 300.516L245.534 300.518ZM202.311 168.025C199.025 167.144 196.385 169.3 193.834 171.385C192.613 172.382 191.46 173.324 190.298 173.864C189.246 174.352 187.86 174.62 186.391 174.903C183.798 175.404 180.86 175.972 179.111 177.919C175.705 181.708 176.563 187.084 177.394 192.283C177.72 194.318 178.054 196.422 178.133 198.411C178.221 200.597 178.095 202.551 177.975 204.439C177.703 208.704 177.422 213.113 179.492 220.684C182.006 229.877 188.027 239.589 192.422 246.683C193.276 248.059 194.076 249.35 194.787 250.535C195.568 251.836 196.786 254.036 198.197 256.584C202.115 263.659 207.48 273.351 210.361 276.361C213.992 280.156 217.917 282.318 221.711 284.408C224.039 285.691 226.448 287.016 228.749 288.702C230.514 289.997 232.126 291.313 233.685 292.586C237.387 295.613 240.886 298.473 245.413 300.053C247.917 300.913 251.479 298.633 255.242 296.202C256.328 295.5 257.454 294.773 258.549 294.13C259.554 293.542 260.61 292.976 261.63 292.428C265.555 290.324 269.264 288.335 270.113 285.181C270.865 282.394 270.063 277.431 269.212 272.179C268.837 269.859 268.448 267.461 268.19 265.2C267.87 262.397 267.818 260.161 267.769 257.999C267.688 254.438 267.612 251.077 266.394 245.522C264.811 238.3 259.134 228.943 254.991 222.111C253.99 220.461 253.045 218.904 252.272 217.565C251.222 215.746 250.209 213.838 249.136 211.817C246.241 206.366 242.963 200.187 238.222 194.712C232.393 187.977 226.203 184.081 221.23 180.95C220.698 180.616 220.178 180.288 219.668 179.964C217.67 178.693 215.516 176.961 213.233 175.125C209.437 172.07 205.508 168.913 202.367 168.042C202.351 168.038 202.332 168.033 202.313 168.028L202.311 168.025Z",
    fill: "url(#paint129_linear_376_6503)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M245.888 307.549C241.868 306.472 236.65 301.743 232.302 297.8C231.123 296.73 230.008 295.72 229.048 294.907C226.959 293.136 224.616 292.058 221.905 290.809C218.064 289.04 213.708 287.033 208.793 282.425C202.624 276.641 197.9 266.709 194.451 259.455C193.234 256.898 192.184 254.69 191.306 253.17C189.566 250.155 187.526 247.007 185.554 243.959C180.427 236.042 175.124 227.857 173.465 219.896C172.077 213.248 172.597 208.148 173.013 204.05C173.289 201.339 173.527 198.997 173.132 196.928C172.961 196.036 172.707 194.966 172.441 193.837C171.073 188.07 169.2 180.174 172.806 175.236C175.49 171.559 179.219 170.557 182.508 169.673C184.448 169.153 186.279 168.66 187.731 167.687C188.192 167.379 188.652 167.045 189.122 166.703C192.825 164.017 197.021 160.972 205.64 166.318C209.903 168.964 213.089 171.407 215.646 173.371C216.853 174.295 217.892 175.096 218.875 175.787C220.869 177.192 222.574 178.163 224.078 179.018C225.58 179.871 226.766 180.546 227.678 181.342C227.764 181.417 227.772 181.547 227.697 181.631C227.623 181.717 227.494 181.725 227.409 181.65C226.528 180.881 225.358 180.214 223.877 179.374C222.439 178.556 220.65 177.539 218.639 176.122C217.651 175.425 216.605 174.623 215.397 173.696C212.845 171.738 209.669 169.3 205.423 166.665C197.04 161.464 192.959 164.422 189.363 167.033C188.887 167.378 188.421 167.715 187.957 168.027C186.451 169.037 184.585 169.539 182.613 170.069C179.232 170.977 175.734 171.917 173.137 175.478C169.644 180.264 171.491 188.054 172.84 193.741C173.11 194.876 173.363 195.948 173.535 196.851C173.942 198.98 173.7 201.35 173.42 204.091C173.007 208.163 172.492 213.227 173.865 219.814C175.511 227.702 180.79 235.853 185.897 243.738C187.873 246.789 189.913 249.942 191.661 252.965C192.548 254.5 193.6 256.715 194.82 259.279C198.255 266.503 202.961 276.394 209.074 282.124C213.94 286.688 218.262 288.678 222.076 290.434C224.814 291.697 227.181 292.786 229.313 294.59C230.28 295.41 231.395 296.422 232.578 297.493C237.544 301.996 244.344 308.162 248.273 307.275C251.332 306.586 253.633 304.846 256.293 302.831C257.889 301.622 259.54 300.374 261.509 299.244C262.096 298.909 262.754 298.572 263.453 298.214C267.258 296.269 271.993 293.846 272.689 287.948C273.109 284.388 272.435 279.52 271.783 274.812C271.284 271.205 270.768 267.477 270.724 264.266C270.614 256.307 268.047 247.211 268.022 247.121C267.991 247.012 268.055 246.898 268.162 246.868C268.269 246.836 268.383 246.899 268.415 247.008C268.44 247.1 271.02 256.246 271.132 264.261C271.177 267.447 271.691 271.164 272.187 274.756C272.841 279.49 273.52 284.383 273.094 287.996C272.374 294.113 267.324 296.695 263.638 298.581C262.946 298.936 262.292 299.27 261.712 299.603C259.766 300.718 258.125 301.959 256.541 303.16C253.954 305.119 251.509 306.969 248.363 307.679C247.613 307.847 246.78 307.789 245.888 307.549Z",
    fill: "url(#paint130_linear_376_6503)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M244.644 313.904C240.578 312.814 236.436 308.834 232.705 305.251C230.788 303.409 228.976 301.667 227.267 300.377C224.864 298.56 222.106 297.224 219.187 295.81C214.981 293.773 210.214 291.463 205.128 287.106C199.026 281.879 194.656 271.902 191.143 263.884C189.663 260.504 188.383 257.584 187.201 255.536C186.079 253.592 184.108 251.016 181.828 248.033C176.604 241.201 169.449 231.842 167.929 223.626C166.73 217.13 167.042 211.364 167.32 206.277C167.545 202.152 167.755 198.258 167.174 194.463C166.929 192.857 166.607 191.236 166.295 189.669C164.901 182.651 163.586 176.023 168.501 170.157C170.817 167.394 173.858 166.248 177.08 165.038C179.002 164.315 180.987 163.569 183.046 162.43C187.218 160.124 190.22 158.884 196.658 161.093C196.765 161.131 196.821 161.248 196.786 161.355C196.748 161.462 196.63 161.518 196.524 161.483C190.451 159.401 187.691 160.332 183.242 162.791C181.157 163.943 179.157 164.695 177.222 165.423C173.915 166.666 171.059 167.74 168.812 170.422C164.024 176.137 165.322 182.673 166.696 189.592C167.009 191.164 167.332 192.79 167.579 194.405C168.165 198.242 167.953 202.158 167.727 206.303C167.438 211.616 167.139 217.109 168.331 223.556C169.831 231.674 176.952 240.988 182.151 247.788C184.441 250.783 186.418 253.368 187.552 255.335C188.745 257.402 190.029 260.33 191.513 263.722C195.009 271.702 199.358 281.63 205.388 286.798C210.434 291.121 215.176 293.418 219.36 295.444C222.299 296.866 225.074 298.211 227.509 300.052C229.237 301.357 231.055 303.107 232.982 304.958C237.44 309.243 242.496 314.098 247.174 313.771C251.732 313.453 255.487 310.729 258.8 308.328C260.286 307.252 261.688 306.235 262.956 305.62C263.458 305.376 263.955 305.151 264.447 304.93C267.842 303.397 270.776 302.076 272.32 295.699C272.347 295.589 272.458 295.522 272.567 295.549C272.689 295.598 272.744 295.687 272.717 295.796C271.123 302.367 267.961 303.794 264.614 305.305C264.127 305.524 263.633 305.747 263.136 305.99C261.901 306.591 260.513 307.597 259.041 308.663C255.85 310.977 251.878 313.857 247.203 314.182C246.355 314.241 245.497 314.139 244.636 313.908L244.644 313.904Z",
    fill: "url(#paint131_linear_376_6503)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M242.12 319.44C241.87 319.373 241.623 319.298 241.373 319.211C237.323 317.811 234.126 314.739 230.739 311.486C228.517 309.351 226.219 307.144 223.488 305.185C220.932 303.352 217.949 301.84 214.79 300.239C209.483 297.55 203.47 294.502 198.514 289.249C193.258 283.678 189.377 274.397 186.257 266.939C184.701 263.225 183.36 260.015 182.107 257.845C180.978 255.89 179.031 253.305 176.775 250.307C171.527 243.337 164.338 233.793 162.375 225.071C160.525 216.846 160.758 210.635 160.984 204.626C161.099 201.558 161.207 198.658 161.048 195.548C160.898 192.622 160.326 189.817 159.773 187.102C158.587 181.288 157.467 175.797 161.032 170.769C165.352 164.674 171.563 162.667 175.672 161.336C176.773 160.981 177.725 160.671 178.456 160.347C181.87 158.828 183.773 158.051 186.375 158.336C186.488 158.351 186.57 158.449 186.558 158.563C186.545 158.677 186.445 158.758 186.331 158.745C183.833 158.472 181.97 159.236 178.62 160.724C177.869 161.056 176.908 161.368 175.796 161.728C171.737 163.04 165.605 165.023 161.364 171.006C157.904 175.889 159.005 181.296 160.173 187.02C160.729 189.749 161.306 192.571 161.457 195.526C161.618 198.656 161.509 201.564 161.394 204.642C161.169 210.623 160.936 216.807 162.776 224.98C164.718 233.616 171.876 243.119 177.102 250.06C179.367 253.066 181.323 255.663 182.464 257.639C183.731 259.833 185.076 263.053 186.637 266.78C189.743 274.207 193.61 283.448 198.815 288.967C203.721 294.169 209.445 297.069 214.978 299.875C218.151 301.484 221.147 303.002 223.728 304.853C226.483 306.827 228.79 309.046 231.023 311.191C234.376 314.412 237.542 317.455 241.508 318.826C247.997 321.062 254.793 316.358 257.7 314.348L257.763 314.304C258.716 313.645 259.948 313.064 261.252 312.45C263.921 311.191 266.947 309.767 268.577 307.187C268.637 307.09 268.764 307.061 268.86 307.123C268.957 307.183 268.983 307.309 268.924 307.406C267.231 310.086 264.147 311.539 261.427 312.821C260.139 313.428 258.923 314 257.997 314.641L257.936 314.685C255.087 316.655 248.561 321.166 242.122 319.441L242.12 319.44Z",
    fill: "url(#paint132_linear_376_6503)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M239.85 324.358C235.982 323.322 232.219 320.31 228.284 317.16C225.482 314.917 222.582 312.593 219.374 310.71C217.76 309.762 216.095 308.811 214.484 307.893C206.235 303.194 197.702 298.334 191.333 290.872C186.753 285.508 184.347 279.107 182.017 272.916C180.486 268.843 178.9 264.63 176.726 260.865C175.067 257.991 172.687 254.709 170.167 251.236C164.315 243.169 157.685 234.025 156.25 225.107C155.136 218.191 155.108 211.633 155.083 205.846C155.062 201.104 155.045 197.009 154.372 194.229C154.263 193.779 154.14 193.296 154.013 192.789C152.395 186.41 149.687 175.733 158.037 167.504C163.151 162.465 168.022 160.649 171.938 159.19C173.281 158.69 174.441 158.258 175.445 157.753C175.544 157.703 175.669 157.743 175.72 157.845C175.772 157.946 175.73 158.068 175.629 158.119C174.604 158.633 173.434 159.069 172.081 159.573C168.202 161.019 163.374 162.818 158.326 167.795C150.141 175.86 152.814 186.392 154.411 192.686C154.54 193.196 154.663 193.679 154.772 194.131C155.455 196.957 155.473 201.074 155.494 205.841C155.519 211.612 155.547 218.154 156.655 225.04C158.075 233.862 164.676 242.964 170.5 250.994C173.027 254.476 175.411 257.766 177.081 260.658C179.272 264.453 180.862 268.681 182.401 272.769C184.717 278.927 187.11 285.293 191.644 290.602C197.969 298.01 206.468 302.851 214.686 307.533C216.297 308.451 217.965 309.4 219.581 310.351C222.813 312.25 225.725 314.581 228.54 316.835C233.694 320.962 238.146 324.525 243.015 324.315C247.939 324.101 253.285 321.984 258.906 318.02C260.102 317.177 261.097 316.579 261.896 316.1C263.057 315.405 263.895 314.9 264.626 314.11C264.703 314.027 264.833 314.021 264.916 314.098C264.999 314.174 265.005 314.304 264.928 314.387C264.157 315.223 263.297 315.737 262.108 316.452C261.274 316.953 260.327 317.521 259.143 318.354C253.456 322.363 248.036 324.505 243.034 324.723C241.962 324.769 240.902 324.633 239.85 324.351L239.85 324.358Z",
    fill: "url(#paint133_linear_376_6503)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M234.528 328.166C229.572 326.838 225.577 323.566 221.156 319.946C219.608 318.678 218.005 317.366 216.282 316.067C212.645 313.328 209.31 311.491 206.086 309.713C201.548 307.212 196.856 304.627 191.124 299.471C184.43 293.448 180.151 283.777 176.376 275.245C174.576 271.174 172.875 267.331 171.06 264.186C169.925 262.221 167.975 259.459 165.717 256.26C160.66 249.098 153.736 239.288 151.155 231.352C148.465 223.089 148.455 213.992 148.444 205.969C148.441 202.805 148.436 199.817 148.285 196.961C148.154 194.49 147.929 192.174 147.712 189.935C147.034 182.964 146.45 176.944 149.542 171.848C153.403 165.486 160.924 161.914 166.415 159.306C166.518 159.258 166.639 159.301 166.688 159.404C166.737 159.507 166.693 159.629 166.59 159.677C161.145 162.264 153.689 165.803 149.892 172.061C146.869 177.041 147.422 182.715 148.12 189.898C148.338 192.142 148.563 194.462 148.695 196.942C148.846 199.807 148.85 202.8 148.853 205.97C148.864 214.356 148.875 223.025 151.544 231.229C154.106 239.106 161.01 248.886 166.051 256.028C168.314 259.234 170.269 262.003 171.413 263.986C173.239 267.149 174.944 271.003 176.75 275.084C180.508 283.58 184.767 293.207 191.396 299.173C197.093 304.298 201.765 306.872 206.282 309.361C209.518 311.144 212.866 312.989 216.526 315.745C218.257 317.049 219.861 318.363 221.413 319.634C227.586 324.69 232.916 329.058 241.202 328.304C251.26 327.391 258.394 321.224 258.465 321.162C258.55 321.088 258.681 321.096 258.755 321.181C258.829 321.266 258.821 321.394 258.735 321.471C258.665 321.533 251.435 327.789 241.238 328.712C238.772 328.936 236.566 328.719 234.525 328.172L234.528 328.166Z",
    fill: "url(#paint134_linear_376_6503)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M230.535 330.988C225.566 329.656 219.756 325.673 213.65 321.489C212.503 320.702 211.345 319.908 210.182 319.126C207.806 317.525 205.373 316.07 203.024 314.662C197.165 311.151 191.105 307.522 185.08 301.217C180.032 295.932 174.385 284.276 170.264 275.766C168.516 272.157 167.005 269.042 165.883 267.096C164.95 265.48 163.31 263.19 161.41 260.538C155.435 252.197 146.408 239.591 144.306 227.493C142.415 216.614 142.844 209.409 143.187 203.617C143.351 200.854 143.494 198.466 143.37 196.114C143.295 194.721 143.099 193.27 142.889 191.733C141.982 185.081 140.952 177.541 148.954 169.243C149.032 169.161 149.161 169.159 149.243 169.237C149.324 169.315 149.327 169.447 149.249 169.527C141.385 177.68 142.4 185.117 143.296 191.678C143.506 193.222 143.706 194.682 143.781 196.091C143.906 198.466 143.765 200.864 143.6 203.64C143.258 209.41 142.831 216.591 144.714 227.423C146.801 239.428 155.793 251.987 161.746 260.299C163.651 262.959 165.298 265.258 166.24 266.892C167.37 268.849 168.883 271.972 170.633 275.588C174.744 284.072 180.374 295.695 185.377 300.934C191.36 307.199 197.397 310.815 203.233 314.31C205.588 315.72 208.022 317.178 210.41 318.786C211.575 319.571 212.733 320.365 213.882 321.152C220.882 325.95 227.494 330.483 232.81 330.999C238.935 331.593 246.718 328.74 246.796 328.711C246.901 328.672 247.019 328.726 247.059 328.831C247.098 328.936 247.044 329.054 246.939 329.094C246.861 329.123 238.991 332.009 232.771 331.405C232.047 331.334 231.302 331.191 230.535 330.986L230.535 330.988Z",
    fill: "url(#paint135_linear_376_6503)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M223.368 331.082C221.715 330.639 220.065 330.101 218.738 329.466C216.463 328.379 213.664 326.553 210.701 324.622C208.034 322.884 205.276 321.087 202.911 319.859C198.608 317.621 188.532 312.382 180.368 302.498C175.236 296.283 171.617 289.013 167.785 281.312C165.746 277.214 163.637 272.977 161.268 268.881C159.823 266.384 157.937 263.495 155.938 260.438C150.328 251.854 143.346 241.166 140.638 230.783C137.664 219.378 138.408 208.585 138.9 201.447C139.016 199.789 139.113 198.359 139.146 197.186C139.19 195.535 139.149 193.957 139.111 192.429C139.002 188.29 138.9 184.38 140.588 180.188C140.629 180.084 140.755 180.035 140.854 180.075C140.96 180.117 141.009 180.236 140.967 180.342C139.314 184.455 139.414 188.324 139.521 192.418C139.561 193.95 139.602 195.535 139.557 197.197C139.524 198.379 139.426 199.814 139.311 201.476C138.821 208.59 138.079 219.34 141.037 230.681C143.726 241 150.69 251.653 156.283 260.216C158.285 263.278 160.175 266.172 161.624 268.677C163.999 272.784 166.113 277.026 168.154 281.13C171.974 288.807 175.582 296.059 180.686 302.237C188.799 312.057 198.822 317.268 203.103 319.494C205.484 320.733 208.251 322.534 210.926 324.278C213.878 326.201 216.666 328.019 218.917 329.093C223.197 331.138 230.9 332.182 230.976 332.191C231.084 332.207 231.167 332.31 231.153 332.421C231.138 332.534 231.034 332.612 230.923 332.598C230.869 332.59 227.113 332.081 223.371 331.079L223.368 331.082Z",
    fill: "url(#paint136_linear_376_6503)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M210.967 328.968C210.967 328.968 210.948 328.963 210.938 328.958C210.482 328.761 209.394 328.017 208.015 327.074C206.424 325.986 204.444 324.632 202.891 323.758C202.481 323.529 201.958 323.25 201.337 322.919C197.479 320.861 190.298 317.032 183.329 310.857C173.471 302.124 166.213 288.324 160.914 278.251C159.459 275.484 158.203 273.097 157.049 271.097C155.805 268.941 154.526 266.786 153.17 264.502C146.365 253.029 139.329 241.165 136.814 229.648C134.055 217.01 134.911 208.852 135.737 200.964C135.814 200.232 135.891 199.501 135.965 198.769C136.099 197.439 136.107 196.072 136.114 194.751C136.124 193.135 136.134 191.611 136.376 190.382C136.399 190.271 136.506 190.198 136.617 190.221C136.723 190.245 136.8 190.351 136.777 190.462C136.542 191.653 136.532 193.158 136.523 194.754C136.515 196.085 136.507 197.46 136.37 198.81C136.298 199.543 136.221 200.274 136.144 201.007C135.32 208.863 134.469 216.986 137.213 229.562C139.714 241.014 146.733 252.848 153.521 264.295C154.876 266.578 156.155 268.735 157.4 270.894C158.557 272.901 159.816 275.292 161.274 278.061C166.559 288.11 173.796 301.869 183.597 310.553C190.532 316.697 197.683 320.511 201.528 322.56C202.152 322.894 202.68 323.175 203.089 323.404C204.659 324.284 206.648 325.645 208.244 326.737C209.551 327.632 210.679 328.402 211.099 328.585C211.204 328.629 211.25 328.749 211.207 328.854C211.165 328.949 211.062 328.998 210.966 328.972L210.967 328.968Z",
    fill: "url(#paint137_linear_376_6503)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M162.096 287.334C162.045 287.321 162 287.289 161.971 287.238C160.615 284.889 158.814 281.528 157.225 278.561C155.917 276.119 154.682 273.814 153.92 272.491C153.456 271.687 152.784 270.555 151.994 269.227C149.888 265.68 147.003 260.821 144.954 256.961C144.901 256.861 144.939 256.736 145.039 256.684C145.138 256.632 145.264 256.668 145.315 256.77C147.36 260.622 150.243 265.473 152.348 269.017C153.139 270.348 153.812 271.483 154.276 272.287C155.042 273.613 156.28 275.924 157.588 278.367C159.175 281.332 160.976 284.691 162.327 287.034C162.384 287.133 162.351 287.256 162.252 287.313C162.204 287.341 162.146 287.348 162.096 287.334Z",
    fill: "url(#paint138_linear_376_6503)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M307.425 293.995C307.425 293.995 307.431 293.992 307.436 293.989C312.007 290.689 315.704 286.606 318.577 281.879C318.585 281.867 318.592 281.858 318.597 281.846C320.546 278.632 322.109 275.127 323.297 271.371C324.183 268.576 324.865 265.639 325.347 262.586L325.344 262.58C325.401 262.269 325.444 261.956 325.491 261.638C325.49 261.624 325.497 261.615 325.496 261.601C326.345 255.594 326.431 249.14 325.769 242.386C325.162 236.033 323.897 229.407 322.006 222.645C320.22 216.212 317.869 209.655 314.98 203.065C312.503 197.406 309.624 191.725 306.366 186.083C303.108 180.44 299.63 175.109 295.965 170.13C291.705 164.335 287.2 159.02 282.531 154.26C277.612 149.239 272.511 144.829 267.31 141.121C261.797 137.182 256.174 134.032 250.553 131.765C250.553 131.765 250.548 131.763 250.538 131.761C250.228 131.633 249.921 131.512 249.603 131.395L249.6 131.39C246.711 130.274 243.821 129.394 240.952 128.769L240.943 128.767C237.085 127.919 233.257 127.527 229.495 127.608C223.973 127.733 218.587 128.892 213.45 131.201C213.45 131.201 213.447 131.203 213.44 131.207C212.142 131.789 210.862 132.443 209.598 133.171C209.03 133.499 208.481 133.835 207.938 134.183C204.976 136.072 202.347 138.269 200.04 140.74C199.536 141.278 199.047 141.824 198.578 142.39C196.016 145.44 193.899 148.866 192.218 152.6C192.102 152.832 191.999 153.066 191.912 153.29C191.37 154.54 190.875 155.826 190.43 157.14C190.43 157.14 190.429 157.145 190.426 157.155C190.011 158.385 189.631 159.643 189.3 160.928C189.29 160.968 189.28 160.985 189.28 160.985C187.606 167.445 186.952 174.565 187.281 182.122C187.282 182.136 187.281 182.142 187.278 182.151C187.331 183.265 187.4 184.392 187.488 185.525C187.491 185.55 187.493 185.576 187.495 185.608C187.59 186.819 187.711 188.045 187.863 189.276L187.861 189.285C188.753 196.792 190.53 204.645 193.146 212.655C195.399 219.554 198.279 226.573 201.757 233.578C203.388 236.869 205.149 240.159 207.04 243.434C208.931 246.71 210.899 249.88 212.931 252.932C217.262 259.452 221.898 265.455 226.749 270.856C233.209 278.057 240.041 284.189 247.038 289.058C247.062 289.078 247.091 289.092 247.115 289.112C248.149 289.833 249.185 290.52 250.227 291.184C250.227 291.184 250.231 291.187 250.239 291.192C256.627 295.258 263.123 298.257 269.56 300.033C269.56 300.033 269.58 300.034 269.62 300.045C270.881 300.394 272.147 300.695 273.405 300.947C274.788 301.22 276.167 301.444 277.544 301.605C277.789 301.631 278.032 301.655 278.278 301.681C278.278 301.681 278.282 301.68 278.291 301.68C282.366 302.09 286.389 301.97 290.314 301.277C291.025 301.152 291.737 301.008 292.447 300.845C296.348 299.943 300.154 298.451 303.807 296.343C305.072 295.613 306.276 294.831 307.429 293.998L307.425 293.995ZM269.489 241.192C267.027 238.844 263.814 235.455 260.296 230.922C257.485 227.294 254.474 222.922 251.496 217.764C248.518 212.606 246.24 207.818 244.501 203.563C242.333 198.246 241.006 193.772 240.202 190.463C239.231 186.444 239.021 184.143 239.021 184.143C239.021 184.143 239.343 184.369 239.934 184.836C240.482 185.271 241.264 185.919 242.239 186.786C246.48 190.574 254.3 198.581 261.907 211.755C262.859 213.403 263.739 215.018 264.556 216.581C270.239 227.545 272.681 236.399 273.693 241.267C273.958 242.547 274.127 243.547 274.23 244.238C274.337 244.983 274.371 245.374 274.371 245.374C274.371 245.374 272.482 244.042 269.489 241.192Z",
    fill: "#27E6D6"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M270 300.448C264.649 299.015 259.169 296.702 253.607 293.515C236.384 283.641 219.789 265.884 206.875 243.521C193.962 221.155 186.884 197.905 186.945 178.052C187.008 157.043 194.804 141.457 209.485 132.979C224.166 124.503 241.562 125.544 259.79 135.995C277.014 145.869 293.609 163.625 306.522 185.989C319.436 208.353 326.511 231.604 326.452 251.458C326.389 272.467 318.594 288.053 303.912 296.531C293.708 302.423 282.192 303.715 270 300.448ZM243.299 129.461C231.208 126.221 219.798 127.499 209.692 133.333C195.144 141.733 187.419 157.198 187.357 178.052C187.297 197.834 194.356 221.012 207.232 243.315C220.108 265.617 236.65 283.319 253.813 293.158C271.907 303.53 289.161 304.574 303.708 296.175C318.256 287.776 325.981 272.311 326.043 251.456C326.103 231.675 319.044 208.496 306.168 186.194C293.292 163.892 276.75 146.19 259.587 136.35C254.06 133.184 248.615 130.885 243.299 129.461Z",
    fill: "url(#paint139_linear_376_6503)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M274.476 245.848C274.453 245.842 274.431 245.832 274.41 245.817C274.29 245.733 262.421 237.124 251.302 217.865C240.183 198.607 238.668 184.031 238.656 183.886C238.647 183.807 238.688 183.73 238.758 183.688C238.827 183.648 238.916 183.654 238.98 183.698C239.099 183.784 250.965 192.382 262.084 211.64C273.203 230.898 274.722 245.482 274.737 245.628C274.745 245.709 274.706 245.786 274.635 245.826C274.587 245.853 274.531 245.861 274.478 245.847L274.476 245.848ZM239.12 184.321C239.479 186.972 241.704 200.423 251.656 217.661C261.607 234.895 272.149 243.559 274.266 245.196C273.905 242.542 271.675 229.082 261.725 211.848C251.771 194.608 241.236 185.957 239.12 184.321Z",
    fill: "url(#paint140_linear_376_6503)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M262.213 212.577C262.161 212.563 262.114 212.528 262.085 212.475C260.339 209.223 262.711 205.879 265.994 201.845C266.578 201.128 267.439 200.188 268.436 199.098C271.847 195.375 277.001 189.748 281.118 182.44C287.524 171.064 287.264 159.848 280.424 152.435C280.347 152.351 280.353 152.222 280.436 152.145C280.52 152.069 280.65 152.077 280.725 152.158C287.693 159.708 287.973 171.104 281.476 182.641C277.336 189.991 272.163 195.639 268.74 199.375C267.747 200.459 266.888 201.395 266.314 202.104C263.022 206.149 260.817 209.245 262.448 212.282C262.502 212.382 262.464 212.507 262.364 212.559C262.317 212.585 262.264 212.591 262.213 212.577Z",
    fill: "url(#paint141_linear_376_6503)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M257.296 204.658C257.25 204.645 257.206 204.616 257.177 204.572C256.011 202.801 258.606 200.021 261.353 197.079C261.644 196.767 261.937 196.454 262.226 196.14C262.537 195.802 262.924 195.399 263.371 194.932C266.706 191.456 273.646 184.222 277.167 174.887C280.585 165.829 282.145 153.027 270.173 143.469C270.084 143.398 270.071 143.271 270.14 143.181C270.209 143.092 270.341 143.079 270.428 143.148C282.593 152.859 281.017 165.846 277.552 175.031C274.001 184.443 267.022 191.716 263.667 195.213C263.221 195.677 262.836 196.08 262.525 196.416C262.236 196.73 261.943 197.043 261.652 197.357C259.133 200.054 256.528 202.845 257.517 204.346C257.579 204.441 257.555 204.567 257.459 204.629C257.407 204.663 257.347 204.671 257.294 204.657L257.296 204.658Z",
    fill: "url(#paint142_linear_376_6503)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M252.113 197.583C252.062 197.569 252.019 197.54 251.988 197.493C251.956 197.444 251.696 196.987 252.407 196.318C252.494 196.235 252.728 196.033 253.083 195.727C255.176 193.92 261.543 188.423 264.876 183.999C272.105 174.402 274.868 164.475 273.086 154.494C270.999 142.808 260.892 137.113 260.79 137.056C260.692 137.001 260.656 136.876 260.709 136.778C260.765 136.68 260.885 136.643 260.988 136.697C261.092 136.754 271.366 142.537 273.488 154.421C275.29 164.52 272.502 174.556 265.201 184.246C261.844 188.703 255.449 194.222 253.349 196.037C253.003 196.336 252.772 196.535 252.687 196.616C252.232 197.045 252.336 197.28 252.337 197.283C252.397 197.378 252.367 197.5 252.272 197.56C252.223 197.592 252.165 197.599 252.11 197.584L252.113 197.583Z",
    fill: "url(#paint143_linear_376_6503)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M246.718 191.345C246.608 191.316 246.544 191.202 246.576 191.093C246.605 190.986 246.714 190.923 246.821 190.95C246.851 190.956 247.627 191.06 250.069 189.7C250.799 189.294 267.965 179.499 267.912 158.377C267.857 137.37 248.691 131.199 248.498 131.138C248.39 131.105 248.331 130.99 248.362 130.881C248.395 130.773 248.498 130.717 248.619 130.745C248.814 130.806 268.268 137.07 268.322 158.375C268.376 179.737 251.009 189.645 250.27 190.058C247.638 191.522 246.816 191.372 246.724 191.347L246.718 191.345Z",
    fill: "url(#paint144_linear_376_6503)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M242.091 186.562C241.826 186.491 241.605 186.383 241.434 186.24C241.348 186.167 241.335 186.038 241.408 185.952C241.481 185.865 241.61 185.853 241.696 185.925C242.995 187.009 248.891 185.386 254.247 179.584C256.522 177.119 267.491 163.914 260.021 145.874C253.764 130.764 237.419 128.273 237.256 128.25C237.144 128.233 237.066 128.129 237.082 128.018C237.099 127.906 237.203 127.828 237.313 127.844C237.481 127.866 254.052 130.386 260.398 145.717C267.962 163.986 256.852 177.367 254.547 179.863C249.688 185.127 244.329 187.164 242.088 186.564L242.091 186.562Z",
    fill: "url(#paint145_linear_376_6503)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M238.692 183.11C238.589 183.082 238.524 182.979 238.543 182.874C238.564 182.763 238.671 182.69 238.783 182.711C238.806 182.717 241.29 183.149 245.433 180.86C246.03 180.529 260.039 172.553 257.142 153.332C255.932 145.305 251.276 138.077 244.367 133.5C236.933 128.573 227.584 127.206 218.043 129.649C217.934 129.679 217.821 129.612 217.794 129.502C217.765 129.392 217.831 129.28 217.942 129.253C227.597 126.78 237.062 128.168 244.596 133.158C251.6 137.799 256.321 145.13 257.548 153.27C259.895 168.841 251.162 178.163 245.631 181.219C241.346 183.587 238.811 183.133 238.706 183.114C238.702 183.113 238.698 183.112 238.692 183.11Z",
    fill: "url(#paint146_linear_376_6503)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M238.457 180.479C238.377 180.457 238.316 180.389 238.306 180.303C238.293 180.192 238.374 180.09 238.485 180.077C238.527 180.072 242.731 179.531 247.288 174.442C253.34 167.686 256.882 152.644 245.807 140.353C240.6 134.575 233.342 131.185 225.371 130.814C216.66 130.404 207.883 133.646 201.297 139.704C201.213 139.78 201.084 139.775 201.007 139.691C200.931 139.608 200.936 139.479 201.02 139.402C207.687 133.27 216.57 129.991 225.392 130.403C233.475 130.782 240.833 134.219 246.113 140.077C257.357 152.557 253.749 167.845 247.596 174.714C242.926 179.927 238.711 180.461 238.535 180.482C238.509 180.486 238.482 180.483 238.457 180.477L238.457 180.479Z",
    fill: "url(#paint147_linear_376_6503)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M238.381 178.137C238.318 178.12 238.265 178.075 238.242 178.01C238.203 177.903 238.256 177.786 238.364 177.748C238.397 177.734 241.76 176.472 245.047 172.11C249.488 166.221 251.503 153.46 242.085 143.528C229.686 130.452 213.361 135.789 210.214 136.992C205.91 138.637 195.393 143.857 190.712 156.772C190.675 156.879 190.556 156.935 190.45 156.896C190.343 156.858 190.289 156.74 190.326 156.633C195.066 143.557 205.711 138.272 210.067 136.608C213.257 135.389 229.801 129.979 242.382 143.245C251.965 153.349 249.899 166.351 245.373 172.355C242.007 176.819 238.644 178.079 238.502 178.131C238.462 178.145 238.419 178.147 238.379 178.137L238.381 178.137Z",
    fill: "url(#paint148_linear_376_6503)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M187.645 169.261C187.545 169.234 187.477 169.133 187.497 169.026C191.031 149.543 206.376 141.301 218.44 140.164C231.599 138.923 243.129 147.027 245.255 159.01C247.257 170.274 238.756 176.149 238.671 176.207C238.578 176.27 238.449 176.247 238.387 176.152C238.324 176.058 238.349 175.93 238.442 175.867C238.525 175.811 246.806 170.077 244.853 159.082C242.763 147.31 231.425 139.353 218.479 140.573C206.557 141.696 191.394 149.843 187.9 169.1C187.879 169.211 187.774 169.284 187.662 169.266C187.656 169.264 187.652 169.263 187.645 169.261Z",
    fill: "url(#paint149_linear_376_6503)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M187.23 183.279C187.146 183.256 187.08 183.18 187.078 183.087C186.359 162.217 202.585 152.494 207.576 150.011C218.466 144.594 233.657 145.547 240.236 156.523C246.327 166.688 238.969 174.741 238.893 174.822C238.815 174.904 238.685 174.91 238.603 174.831C238.52 174.755 238.517 174.624 238.593 174.541C238.665 174.463 245.812 166.627 239.882 156.732C233.427 145.962 218.481 145.044 207.757 150.377C202.823 152.832 186.775 162.446 187.487 183.073C187.491 183.187 187.402 183.282 187.289 183.285C187.268 183.287 187.246 183.283 187.228 183.278L187.23 183.279Z",
    fill: "url(#paint150_linear_376_6503)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M188.825 196.342C188.751 196.322 188.693 196.264 188.678 196.185C187.397 189.902 186.41 173.858 204.836 160.623C212.074 155.425 220.064 153.372 227.333 154.847C232.323 155.86 236.528 158.479 238.588 161.856C242.601 168.435 239.06 174.081 239.024 174.137C238.963 174.233 238.838 174.261 238.74 174.198C238.644 174.137 238.617 174.01 238.678 173.916C238.713 173.863 242.113 168.424 238.237 162.07C236.235 158.79 232.131 156.238 227.252 155.251C220.096 153.799 212.219 155.826 205.075 160.957C186.844 174.053 187.816 189.899 189.08 196.104C189.102 196.216 189.03 196.323 188.921 196.345C188.887 196.352 188.856 196.35 188.827 196.342L188.825 196.342Z",
    fill: "url(#paint151_linear_376_6503)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M191.596 208.003C191.53 207.986 191.476 207.937 191.452 207.866C189.565 201.897 189.631 192.159 195.475 182.729C201.38 173.2 216.053 160.956 228.242 162.755C232.626 163.405 235.761 165.012 237.553 167.541C239.698 170.572 239.107 173.778 239.079 173.915C239.056 174.026 238.949 174.099 238.84 174.078C238.736 174.053 238.656 173.95 238.677 173.839C238.685 173.807 239.259 170.659 237.213 167.774C235.489 165.345 232.453 163.791 228.182 163.162C216.167 161.39 201.67 173.512 195.824 182.946C190.054 192.259 189.984 201.861 191.845 207.744C191.879 207.852 191.819 207.966 191.711 208C191.672 208.012 191.633 208.013 191.596 208.003Z",
    fill: "url(#paint152_linear_376_6503)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M195.621 219.943C195.56 219.927 195.508 219.883 195.483 219.82C191.331 209.247 195.13 196.43 205.905 184.655C217.924 171.519 229.174 170.437 233.91 171.875C238.701 173.323 238.657 177.334 238.656 177.374C238.653 177.486 238.559 177.575 238.447 177.575C238.332 177.573 238.245 177.478 238.246 177.365C238.249 177.213 238.274 173.623 233.791 172.268C229.142 170.867 218.09 171.949 206.206 184.931C195.541 196.585 191.77 209.247 195.863 219.67C195.904 219.776 195.852 219.895 195.746 219.936C195.704 219.952 195.661 219.954 195.619 219.942L195.621 219.943Z",
    fill: "url(#paint153_linear_376_6503)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M200.298 230.842C200.241 230.827 200.19 230.788 200.166 230.73C196.471 222.784 199.046 212.168 207.82 199.174C212.313 192.519 223.199 181.993 231.131 180.364C234.308 179.712 236.588 179.917 237.9 180.974C238.919 181.792 238.946 182.816 238.946 182.859C238.948 182.972 238.857 183.065 238.744 183.066C238.629 183.067 238.539 182.977 238.535 182.866C238.533 182.829 238.504 181.98 237.633 181.285C236.796 180.619 235.002 179.988 231.21 180.766C223.68 182.312 212.706 192.663 208.157 199.401C199.469 212.268 196.906 222.75 200.537 230.555C200.583 230.657 200.54 230.778 200.437 230.827C200.39 230.849 200.342 230.851 200.296 230.839L200.298 230.842Z",
    fill: "url(#paint154_linear_376_6503)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M206.328 242.443C206.278 242.429 206.23 242.396 206.203 242.346C201.288 233.691 208.247 219.792 212.833 212.278C219.82 200.827 228.581 192.72 234.165 189.766C236.142 188.721 237.709 188.267 238.821 188.419C239.703 188.538 239.972 189.002 240.001 189.054C240.055 189.155 240.015 189.279 239.915 189.331C239.818 189.384 239.695 189.346 239.641 189.248C239.622 189.218 238.715 187.823 234.356 190.128C229 192.961 220.091 201.167 213.183 212.491C205.461 225.148 203.046 235.956 206.561 242.145C206.616 242.243 206.582 242.369 206.484 242.424C206.436 242.451 206.381 242.457 206.33 242.443L206.328 242.443Z",
    fill: "url(#paint155_linear_376_6503)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M213.502 254.037C213.458 254.025 213.418 253.999 213.39 253.96C209.383 248.466 212.388 237.057 222.327 220.051C233.323 201.233 241.721 196.446 241.803 196.401C241.903 196.346 242.027 196.382 242.081 196.482C242.136 196.58 242.1 196.705 242.002 196.76C241.92 196.806 233.608 201.556 222.681 220.258C212.833 237.111 209.818 248.371 213.72 253.72C213.787 253.812 213.767 253.939 213.674 254.007C213.622 254.045 213.558 254.055 213.501 254.039L213.502 254.037Z",
    fill: "url(#paint156_linear_376_6503)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M220.731 263.957C220.694 263.946 220.659 263.926 220.631 263.894C217.098 259.91 222.725 247.84 228.168 236.169C228.571 235.302 228.974 234.44 229.371 233.585C232.938 225.895 237.664 217.228 243.418 207.825L243.692 207.376C244.989 205.25 244.679 204.575 244.674 204.569C244.626 204.47 244.658 204.349 244.754 204.295C244.849 204.242 244.966 204.267 245.025 204.359C245.077 204.441 245.484 205.223 244.039 207.591L243.766 208.04C238.02 217.431 233.299 226.084 229.739 233.758C229.344 234.613 228.941 235.475 228.536 236.342C223.149 247.893 217.578 259.839 220.934 263.621C221.008 263.706 221 263.835 220.917 263.912C220.864 263.958 220.792 263.973 220.727 263.955L220.731 263.957Z",
    fill: "url(#paint157_linear_376_6503)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M228.066 272.562C228.024 272.551 227.987 272.528 227.958 272.493C226.685 270.904 229.544 264.249 233.505 255.037C233.997 253.89 234.503 252.716 235.013 251.518C239.453 241.104 246.047 224.644 247.84 219.499C249.555 214.586 248.601 212.935 248.592 212.919C248.535 212.822 248.564 212.697 248.659 212.637C248.753 212.577 248.878 212.606 248.939 212.699C248.983 212.769 250.022 214.486 248.227 219.632C246.43 224.785 239.831 241.256 235.389 251.677C234.879 252.873 234.373 254.049 233.881 255.196C230.274 263.589 227.159 270.838 228.278 272.234C228.348 272.323 228.335 272.45 228.246 272.52C228.192 272.562 228.125 272.576 228.064 272.559L228.066 272.562Z",
    fill: "url(#paint158_linear_376_6503)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M235.892 280.375C235.871 280.369 235.849 280.359 235.83 280.347C235.737 280.283 235.712 280.155 235.776 280.062C236.592 278.863 240.667 270.066 243.296 263.831C246.127 257.116 250.744 243.411 253.111 233.711C255.514 223.861 253.287 221.17 253.264 221.144C253.19 221.059 253.198 220.931 253.281 220.856C253.366 220.782 253.493 220.787 253.569 220.873C253.668 220.982 255.978 223.695 253.508 233.811C251.136 243.529 246.508 257.263 243.672 263.992C241.036 270.243 236.939 279.079 236.112 280.294C236.063 280.368 235.971 280.398 235.89 280.376L235.892 280.375Z",
    fill: "url(#paint159_linear_376_6503)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M244.213 287.268C244.14 287.249 244.086 287.216 244.043 287.182C243.954 287.111 243.941 286.982 244.012 286.895C244.083 286.806 244.212 286.793 244.299 286.864C244.316 286.875 244.375 286.891 244.496 286.851C245.974 286.376 251.112 280.442 257.071 258.966C263.556 235.594 258.445 228.829 258.393 228.763C258.322 228.674 258.336 228.545 258.425 228.474C258.514 228.404 258.641 228.417 258.712 228.504C258.932 228.777 264.025 235.442 257.467 259.074C251.674 279.948 246.533 286.625 244.624 287.241C244.449 287.298 244.314 287.295 244.213 287.268Z",
    fill: "url(#paint160_linear_376_6503)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M252.904 293.099C252.794 293.07 252.73 292.958 252.759 292.851C252.788 292.741 252.898 292.674 253.007 292.703C253.547 292.841 254.167 292.677 254.851 292.216C258.916 289.476 264.643 276.629 266.81 260.654C269.281 242.446 263.538 235.255 263.48 235.186C263.407 235.098 263.421 234.969 263.508 234.898C263.595 234.827 263.724 234.839 263.796 234.926C263.855 234.998 269.713 242.301 267.216 260.711C265.035 276.8 259.216 289.768 255.079 292.558C254.293 293.088 253.562 293.271 252.905 293.104L252.902 293.103L252.904 293.099Z",
    fill: "url(#paint161_linear_376_6503)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M261.762 297.562C261.733 297.554 261.704 297.546 261.674 297.538C261.565 297.507 261.504 297.391 261.535 297.285C261.566 297.176 261.685 297.12 261.788 297.146C262.924 297.486 264.093 297.189 265.316 296.297C269.877 292.976 274.709 281.209 275.12 265.143C275.524 249.371 270.205 242.422 268.566 240.668C268.489 240.584 268.492 240.455 268.576 240.378C268.66 240.301 268.791 240.307 268.866 240.388C270.533 242.172 275.939 249.225 275.531 265.154C275.114 281.351 270.198 293.247 265.558 296.627C264.257 297.575 262.98 297.89 261.762 297.564L261.762 297.562Z",
    fill: "url(#paint162_linear_376_6503)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M300.383 298.307C300.328 298.293 300.28 298.255 300.251 298.2C300.202 298.099 300.244 297.975 300.345 297.926C303.252 296.51 307.778 292.237 305.437 279.513C303.206 267.399 294.987 257.915 290.007 254.499C287.308 252.645 285.147 251.769 283.241 250.995C282.088 250.526 280.998 250.083 279.939 249.484C277.182 247.92 274.431 245.836 274.403 245.815C274.313 245.746 274.296 245.618 274.363 245.528C274.432 245.438 274.558 245.42 274.65 245.488C274.679 245.509 277.407 247.575 280.14 249.127C281.176 249.715 282.254 250.152 283.395 250.615C285.319 251.397 287.502 252.283 290.238 254.16C295.275 257.616 303.585 267.201 305.837 279.438C308.229 292.43 303.534 296.829 300.524 298.293C300.477 298.315 300.427 298.319 300.381 298.307L300.383 298.307Z",
    fill: "url(#paint163_linear_376_6503)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M270.847 300.636C270.744 300.608 270.677 300.505 270.699 300.398C270.722 300.287 270.829 300.215 270.94 300.238C272.53 300.553 274.197 300.03 275.76 298.724C280.575 294.7 283.313 284.717 283.083 272.023C282.729 252.403 273.247 244.91 273.152 244.837C273.063 244.768 273.045 244.64 273.114 244.55C273.183 244.461 273.312 244.443 273.401 244.512C273.499 244.586 283.134 252.183 283.495 272.016C283.727 284.834 280.935 294.936 276.024 299.04C274.362 300.428 272.577 300.982 270.862 300.64C270.857 300.639 270.853 300.638 270.849 300.636L270.847 300.636Z",
    fill: "url(#paint164_linear_376_6503)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M281.133 302.127C281.064 302.108 281.007 302.052 280.989 301.978C280.962 301.867 281.028 301.756 281.138 301.73C284.077 301.002 286.404 299.158 288.053 296.246C292.923 287.647 290.835 271.993 288.246 263.567C284.874 252.597 276.571 247.353 276.485 247.301C276.389 247.242 276.36 247.115 276.419 247.02C276.479 246.923 276.606 246.894 276.7 246.954C276.785 247.006 285.217 252.326 288.636 263.448C291.247 271.941 293.34 287.738 288.408 296.45C286.702 299.464 284.288 301.374 281.234 302.129C281.2 302.138 281.164 302.137 281.133 302.129L281.133 302.127Z",
    fill: "url(#paint165_linear_376_6503)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M291.09 301.35C291.018 301.331 290.96 301.272 290.942 301.196C290.918 301.085 290.987 300.976 291.098 300.951C291.184 300.932 299.717 298.865 298.879 282.908C298.02 266.547 289.08 254.432 281.134 250.097C281.035 250.044 280.997 249.919 281.053 249.819C281.106 249.721 281.228 249.686 281.331 249.738C289.371 254.125 298.421 266.371 299.287 282.887C300.143 299.215 291.272 301.334 291.184 301.353C291.15 301.359 291.117 301.357 291.088 301.349L291.09 301.35Z",
    fill: "url(#paint166_linear_376_6503)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M309.451 292.618C309.409 292.607 309.369 292.582 309.341 292.543C309.273 292.453 309.291 292.325 309.382 292.257C313.662 289.035 314.551 277.687 305.087 264.768C295.874 252.19 282.455 250.622 282.32 250.606C282.215 250.596 282.125 250.493 282.138 250.38C282.15 250.268 282.251 250.185 282.364 250.197C282.5 250.211 296.095 251.794 305.418 264.523C315.036 277.657 314.044 289.256 309.628 292.582C309.574 292.622 309.511 292.632 309.452 292.616L309.451 292.618Z",
    fill: "url(#paint167_linear_376_6503)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M316.63 284.995C316.611 284.99 316.59 284.982 316.573 284.971C316.477 284.909 316.45 284.785 316.509 284.688C318.035 282.279 318.239 278.981 317.097 275.153C314.657 266.969 306.519 257.934 298.163 254.136C290.121 250.479 283.408 250.76 283.342 250.763C283.23 250.769 283.132 250.682 283.128 250.569C283.123 250.455 283.209 250.358 283.323 250.355C283.391 250.351 290.198 250.066 298.335 253.765C306.925 257.67 314.979 266.617 317.49 275.037C318.666 278.983 318.449 282.396 316.857 284.91C316.808 284.986 316.715 285.02 316.631 284.997L316.63 284.995Z",
    fill: "url(#paint168_linear_376_6503)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M320.917 277.698C320.904 277.695 320.891 277.691 320.878 277.683C320.776 277.634 320.735 277.51 320.785 277.409C323.514 271.871 320.485 265.321 311.779 257.944C298.846 246.985 282.684 250.58 282.521 250.618C282.413 250.643 282.3 250.574 282.274 250.464C282.249 250.354 282.317 250.244 282.428 250.217C282.591 250.18 298.949 246.533 312.044 257.628C320.911 265.143 323.976 271.857 321.151 277.588C321.107 277.677 321.008 277.72 320.915 277.696L320.917 277.698Z",
    fill: "url(#paint169_linear_376_6503)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M324.229 268.303L324.225 268.302C324.116 268.271 324.052 268.157 324.086 268.049C324.439 266.829 324.569 265.909 324.248 264.536C323.288 260.432 318.925 255.907 312.577 252.43C300.745 245.948 288.583 247.234 281.765 250.307C281.662 250.354 281.539 250.308 281.493 250.205C281.446 250.103 281.492 249.98 281.595 249.933C288.499 246.822 300.806 245.516 312.77 252.069C319.219 255.6 323.658 260.227 324.643 264.441C324.983 265.894 324.839 266.907 324.476 268.163C324.445 268.269 324.334 268.332 324.227 268.303L324.229 268.303Z",
    fill: "url(#paint170_linear_376_6503)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M280.638 249.85C280.587 249.836 280.544 249.804 280.516 249.759C280.456 249.662 280.488 249.535 280.585 249.478L280.826 249.331C283.338 247.802 290.986 243.153 303.288 244.362C317.105 245.721 326.105 252.869 326.228 257.19C326.231 257.303 326.142 257.399 326.029 257.4C325.914 257.401 325.823 257.313 325.819 257.202C325.703 253.126 316.64 246.087 303.248 244.77C291.085 243.573 283.526 248.17 281.041 249.681L280.797 249.827C280.746 249.856 280.69 249.864 280.638 249.85Z",
    fill: "url(#paint171_linear_376_6503)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M279.504 249.222C279.475 249.214 279.445 249.199 279.422 249.177C279.336 249.102 279.33 248.972 279.405 248.889C279.46 248.825 285.177 242.528 297.329 240.438C307.761 238.643 319.693 241.141 324.293 244.597C325.562 245.549 326.262 246.543 326.372 247.549C326.385 247.663 326.304 247.763 326.192 247.776C326.079 247.788 325.979 247.707 325.966 247.596C325.866 246.707 325.22 245.809 324.048 244.925C319.518 241.519 307.727 239.066 297.399 240.841C285.385 242.908 279.767 249.099 279.712 249.16C279.658 249.22 279.578 249.241 279.507 249.222L279.504 249.222Z",
    fill: "url(#paint172_linear_376_6503)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M278.223 248.44C278.205 248.435 278.186 248.428 278.169 248.416C278.072 248.357 278.043 248.232 278.103 248.135C278.158 248.046 283.716 239.264 298.635 235.672C313.766 232.027 324.077 235.34 325.284 236.892C325.352 236.98 325.338 237.109 325.247 237.179C325.159 237.25 325.03 237.234 324.96 237.143C323.831 235.693 313.45 232.526 298.731 236.071C283.985 239.622 278.504 248.265 278.45 248.352C278.401 248.431 278.307 248.464 278.223 248.442L278.223 248.44Z",
    fill: "url(#paint173_linear_376_6503)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M276.869 247.543C276.856 247.54 276.844 247.536 276.83 247.528C276.729 247.478 276.688 247.355 276.737 247.253C280.104 240.437 286.721 235.004 296.399 231.108C304.688 227.771 315.649 226.576 318.13 226.439C320.452 226.309 322.979 226.219 323.004 226.219C323.117 226.215 323.211 226.304 323.217 226.415C323.22 226.529 323.131 226.624 323.02 226.628C322.995 226.628 320.472 226.72 318.153 226.848C315.686 226.984 304.79 228.172 296.554 231.489C286.971 235.348 280.428 240.713 277.107 247.438C277.062 247.527 276.963 247.57 276.871 247.546L276.869 247.543Z",
    fill: "url(#paint174_linear_376_6503)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M275.562 246.644C275.459 246.616 275.394 246.514 275.413 246.408C275.433 246.303 277.499 235.836 289.948 228.649C300.722 222.428 310.458 219.42 314.615 218.137C315.153 217.97 315.589 217.835 315.915 217.729C319.024 216.705 319.539 215.839 319.57 215.413C319.578 215.3 319.677 215.214 319.789 215.224C319.904 215.232 319.988 215.331 319.978 215.444C319.91 216.38 318.586 217.281 316.043 218.117C315.715 218.225 315.275 218.361 314.736 218.527C310.593 219.808 300.887 222.805 290.153 229.003C277.877 236.09 275.835 246.38 275.817 246.483C275.796 246.594 275.689 246.667 275.577 246.646C275.571 246.644 275.567 246.643 275.56 246.641L275.562 246.644Z",
    fill: "url(#paint175_linear_376_6503)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M274.597 245.939C274.52 245.919 274.456 245.852 274.448 245.766C274.434 245.65 273.183 234.08 287.658 223.834C292.786 220.204 298.138 217.233 302.86 214.615C310.253 210.512 316.091 207.273 315.314 204.386C315.285 204.277 315.349 204.163 315.458 204.134C315.567 204.105 315.681 204.169 315.71 204.278C316.573 207.476 310.904 210.621 303.059 214.975C298.346 217.59 293.006 220.553 287.895 224.17C273.619 234.276 274.84 245.604 274.855 245.718C274.87 245.83 274.788 245.932 274.676 245.947C274.648 245.951 274.622 245.948 274.599 245.942L274.597 245.939Z",
    fill: "url(#paint176_linear_376_6503)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M273.695 241.362C273.625 241.344 273.568 241.29 273.549 241.216C273.525 241.121 271.22 231.704 281.694 221.773C286.118 217.578 290.819 214.106 295.367 210.749C299.743 207.516 303.876 204.464 307.06 201.229C311.855 196.353 309.855 192.895 309.835 192.861C309.776 192.764 309.807 192.637 309.904 192.58C310 192.522 310.127 192.554 310.185 192.648C310.277 192.799 312.369 196.416 307.352 201.517C304.147 204.775 299.999 207.837 295.61 211.077C291.073 214.426 286.381 217.892 281.977 222.069C271.69 231.824 273.924 241.019 273.949 241.111C273.978 241.22 273.912 241.333 273.803 241.36C273.767 241.368 273.731 241.368 273.698 241.359L273.695 241.362Z",
    fill: "url(#paint177_linear_376_6503)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M272.19 235.568C272.131 235.552 272.079 235.509 272.053 235.448C272.024 235.379 269.258 228.414 276.208 219.598C279.792 215.052 284.427 210.941 288.909 206.967C293.122 203.232 297.102 199.702 299.764 196.185C305.692 188.36 305.044 184.58 303.46 181.662C303.406 181.562 303.443 181.439 303.543 181.385C303.643 181.331 303.766 181.368 303.82 181.468C306.074 185.624 304.993 189.96 300.089 196.435C297.401 199.982 293.408 203.525 289.178 207.276C284.71 211.238 280.087 215.336 276.526 219.854C269.733 228.472 272.4 235.228 272.428 235.294C272.472 235.398 272.421 235.52 272.318 235.562C272.275 235.579 272.229 235.583 272.187 235.571L272.19 235.568Z",
    fill: "url(#paint178_linear_376_6503)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M269.821 228.6C269.762 228.584 269.712 228.543 269.686 228.482C269.659 228.421 267.152 222.457 272.11 215.471C274.537 212.049 278.581 207.777 282.49 203.648C286.528 199.379 290.704 194.967 292.91 191.669C296.961 185.603 300.91 178.519 296.461 171.189C296.402 171.092 296.433 170.965 296.53 170.908C296.626 170.85 296.753 170.88 296.811 170.976C301.385 178.511 297.372 185.726 293.25 191.895C291.027 195.225 286.839 199.649 282.788 203.93C278.888 208.051 274.856 212.312 272.444 215.709C267.627 222.499 270.035 228.263 270.06 228.319C270.104 228.423 270.059 228.544 269.954 228.59C269.91 228.61 269.863 228.611 269.819 228.599L269.821 228.6Z",
    fill: "url(#paint179_linear_376_6503)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M266.521 220.865C266.467 220.851 266.42 220.816 266.392 220.761C266.368 220.714 263.992 215.981 268.14 210.137C269.859 207.711 272.246 204.979 274.77 202.085C278.386 197.942 282.484 193.249 286.05 187.91C290.873 180.689 295.242 170.207 288.664 161.27C288.597 161.178 288.617 161.051 288.707 160.983C288.799 160.917 288.927 160.936 288.995 161.026C295.713 170.153 291.287 180.807 286.391 188.137C282.811 193.498 278.703 198.203 275.079 202.353C272.559 205.236 270.181 207.962 268.474 210.37C264.477 216.003 266.732 220.524 266.756 220.568C266.808 220.668 266.768 220.792 266.669 220.844C266.621 220.87 266.569 220.874 266.52 220.861L266.521 220.865Z",
    fill: "url(#paint180_linear_376_6503)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M238.805 184.065C238.727 184.044 238.666 183.978 238.655 183.894C238.65 183.861 238.217 180.497 238.226 178.158C238.234 176.164 238.593 174.27 238.787 173.253C238.822 173.062 238.854 172.902 238.875 172.774L238.902 172.631C239.542 169.302 240.342 160.366 233.952 149.294C229.343 141.309 222.275 135.084 215.934 133.437C212.973 132.668 210.371 132.934 208.2 134.232C208.103 134.292 207.977 134.258 207.92 134.162C207.862 134.065 207.894 133.939 207.99 133.881C210.258 132.524 212.966 132.241 216.038 133.039C216.076 133.049 216.114 133.059 216.152 133.07C222.559 134.787 229.673 141.06 234.308 149.088C240.767 160.277 239.955 169.332 239.305 172.705L239.28 172.84C239.259 172.968 239.227 173.13 239.191 173.325C239 174.33 238.646 176.198 238.637 178.156C238.627 180.467 239.057 183.804 239.062 183.836C239.077 183.948 238.998 184.051 238.885 184.066C238.857 184.07 238.831 184.067 238.806 184.06L238.805 184.065Z",
    fill: "url(#paint181_linear_376_6503)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M261.69 207.968C260.041 207.526 258.871 206.727 257.715 205.37C257.641 205.285 257.651 205.155 257.738 205.081C257.824 205.007 257.956 205.018 258.027 205.105C259.74 207.112 261.494 207.841 264.977 207.998C268.122 208.138 273.5 207.103 279.192 206.006C285.102 204.868 291.214 203.69 295.47 203.703C305.321 203.731 315.978 205.267 320.328 216.434C320.37 216.54 320.318 216.659 320.212 216.7C320.108 216.742 319.988 216.69 319.946 216.584C315.686 205.644 305.18 204.141 295.468 204.112C291.251 204.098 285.16 205.273 279.269 206.409C273.551 207.511 268.151 208.551 264.957 208.409C263.667 208.351 262.605 208.215 261.689 207.97L261.69 207.968Z",
    fill: "url(#paint182_linear_376_6503)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M257.796 201.667C254.721 200.843 252.617 198.287 252.524 198.172C252.453 198.083 252.465 197.956 252.554 197.883C252.641 197.811 252.77 197.824 252.843 197.913C252.867 197.942 255.226 200.807 258.467 201.396C261.168 201.893 265.319 202.21 273.523 200.24L275.169 199.841C282.527 198.056 293.647 195.358 301.971 196.074C310.341 196.793 313.672 200.749 315.64 204.115C315.697 204.213 315.664 204.337 315.566 204.394C315.467 204.451 315.343 204.42 315.286 204.319C313.367 201.039 310.117 197.183 301.936 196.479C293.681 195.77 282.599 198.458 275.266 200.236L273.62 200.635C265.341 202.624 261.133 202.3 258.393 201.797C258.191 201.761 257.992 201.715 257.797 201.662L257.796 201.667Z",
    fill: "url(#paint183_linear_376_6503)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M254.846 196.312C250.703 195.201 248.928 193.666 247.342 192.059C247.262 191.979 247.263 191.849 247.343 191.769C247.425 191.69 247.553 191.69 247.633 191.77C249.232 193.389 251.02 194.931 255.386 196.027C260.48 197.304 269.18 194.809 272.039 193.988C272.834 193.759 273.985 193.395 275.316 192.973C281.294 191.076 291.299 187.903 298.397 187.578C307.28 187.174 310.109 192.504 310.135 192.556C310.187 192.657 310.147 192.78 310.046 192.831C309.946 192.883 309.822 192.843 309.77 192.744C309.743 192.692 307.021 187.595 298.416 187.988C291.372 188.309 281.399 191.474 275.438 193.363C274.105 193.787 272.951 194.151 272.151 194.382C269.266 195.21 260.486 197.728 255.286 196.425C255.137 196.387 254.991 196.351 254.846 196.312Z",
    fill: "url(#paint184_linear_376_6503)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M249.793 191.198C247.294 190.529 245.043 189.403 243.219 187.87C243.132 187.797 243.12 187.668 243.195 187.582C243.267 187.496 243.399 187.484 243.482 187.558C246.962 190.482 252.043 191.891 257.426 191.42C262.333 190.99 267.862 189.032 277.662 185.077C288.334 180.769 292.692 179.371 297.098 178.84C301.76 178.277 303.772 181.387 303.79 181.419C303.85 181.514 303.821 181.641 303.726 181.701C303.63 181.763 303.503 181.734 303.444 181.637C303.368 181.517 301.541 178.716 297.147 179.245C292.783 179.771 288.449 181.162 277.815 185.455C267.977 189.426 262.421 191.392 257.46 191.828C254.782 192.062 252.172 191.838 249.79 191.202L249.793 191.198Z",
    fill: "url(#paint185_linear_376_6503)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M245.065 186.947C243.002 186.394 241.046 185.514 239.069 184.28C238.973 184.22 238.944 184.093 239.003 183.997C239.063 183.9 239.188 183.87 239.287 183.931C243.762 186.728 248.141 187.672 253.926 187.086C259.788 186.493 267.419 183.158 272.172 180.483C277.192 177.658 287.665 171.926 291.347 170.463C295.182 168.94 296.713 170.843 296.777 170.926C296.845 171.014 296.829 171.142 296.74 171.213C296.652 171.282 296.523 171.267 296.452 171.178C296.395 171.107 295.029 169.444 291.497 170.846C287.834 172.302 277.383 178.022 272.37 180.843C267.583 183.538 259.89 186.896 253.965 187.495C250.633 187.831 247.757 187.668 245.063 186.946L245.065 186.947Z",
    fill: "url(#paint186_linear_376_6503)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M240.143 183.442C239.21 183.192 238.675 182.981 238.658 182.974C238.552 182.932 238.501 182.813 238.545 182.708C238.587 182.602 238.717 182.553 238.812 182.595C238.859 182.612 243.551 184.45 249.532 183.675C255.273 182.931 264.312 178.767 271.023 173.767C275.21 170.648 279.413 167.355 282.193 165.179C283.572 164.098 284.569 163.317 285.067 162.946L285.205 162.843C286.696 161.732 288.384 160.472 289.536 161.658C289.615 161.74 289.612 161.87 289.533 161.948C289.451 162.027 289.321 162.024 289.243 161.944C288.344 161.017 286.873 162.113 285.452 163.173L285.314 163.275C284.82 163.643 283.825 164.423 282.449 165.501C279.668 167.68 275.463 170.975 271.272 174.097C265.473 178.416 256.163 183.23 249.587 184.082C245.516 184.609 242.027 183.945 240.147 183.441L240.143 183.442Z",
    fill: "url(#paint187_linear_376_6503)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M238.533 181.478C238.434 181.451 238.37 181.355 238.384 181.253C238.398 181.14 238.503 181.062 238.614 181.076C242.043 181.534 246.288 181.057 249.972 179.807C253.935 178.46 258.946 176.246 266.059 170.031C272.666 164.26 277.711 157.538 279.572 154.917C280.632 153.424 281.263 152.968 281.29 152.948C281.382 152.883 281.511 152.906 281.575 152.995C281.64 153.087 281.62 153.214 281.527 153.282C281.522 153.287 280.917 153.73 279.907 155.153C278.038 157.787 272.971 164.54 266.331 170.338C259.163 176.599 254.105 178.832 250.106 180.191C246.366 181.463 242.05 181.943 238.562 181.479C238.554 181.477 238.545 181.474 238.537 181.472L238.533 181.478Z",
    fill: "url(#paint188_linear_376_6503)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M238.418 179.847C238.332 179.824 238.268 179.746 238.265 179.653C238.264 179.54 238.354 179.447 238.468 179.444C241.114 179.398 247.173 178.096 252.169 174.793C258.439 170.647 263.598 165.331 267.941 158.546C272.935 150.745 273.165 145.814 273.167 145.765C273.17 145.651 273.265 145.564 273.379 145.568C273.489 145.57 273.58 145.667 273.577 145.781C273.569 145.984 273.348 150.861 268.287 158.767C263.912 165.602 258.713 170.957 252.396 175.135C247.33 178.487 241.168 179.807 238.477 179.853C238.457 179.855 238.439 179.852 238.42 179.847L238.418 179.847Z",
    fill: "url(#paint189_linear_376_6503)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M238.378 178.325C238.302 178.305 238.244 178.244 238.23 178.164C238.21 178.053 238.286 177.947 238.397 177.927C238.465 177.914 245.439 176.622 253.129 169.215C260.747 161.879 268.196 145.39 265.041 139.732C264.986 139.634 265.022 139.508 265.12 139.453C265.22 139.399 265.343 139.435 265.398 139.532C268.715 145.484 261.221 161.992 253.415 169.512C245.624 177.014 238.539 178.321 238.468 178.333C238.437 178.339 238.408 178.338 238.379 178.33L238.378 178.325Z",
    fill: "url(#paint190_linear_376_6503)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M238.438 176.94C238.377 176.923 238.324 176.88 238.3 176.815C238.259 176.709 238.311 176.59 238.417 176.549C238.467 176.529 243.593 174.501 248.687 168.915C255.77 161.147 257.778 152.805 258.67 147.207C259.692 140.8 258.238 135.924 256.35 134.59C256.257 134.524 256.235 134.397 256.3 134.304C256.365 134.211 256.495 134.19 256.586 134.255C258.925 135.906 259.994 141.502 259.074 147.27C258.172 152.922 256.146 161.342 248.99 169.189C243.826 174.851 238.617 176.911 238.564 176.931C238.522 176.946 238.479 176.948 238.437 176.937L238.438 176.94Z",
    fill: "url(#paint191_linear_376_6503)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M238.562 175.757C238.514 175.744 238.472 175.715 238.443 175.671C238.381 175.576 238.411 175.449 238.506 175.388C240.738 173.954 245.037 170.503 248.743 163.493C252.204 156.945 253.681 148.886 252.797 141.383C251.716 132.236 247.3 130.713 247.257 130.699C247.149 130.663 247.09 130.549 247.126 130.441C247.161 130.333 247.287 130.268 247.384 130.31C247.577 130.371 252.096 131.928 253.206 141.335C254.102 148.92 252.609 157.065 249.108 163.686C245.357 170.777 240.995 174.279 238.73 175.734C238.679 175.766 238.621 175.775 238.566 175.76L238.562 175.757Z",
    fill: "url(#paint192_linear_376_6503)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M238.628 175.277C238.594 175.268 238.561 175.25 238.534 175.223C238.454 175.143 238.455 175.012 238.535 174.932C244.791 168.773 247.532 159.259 248.011 152.407C248.486 145.617 247.178 139.218 244.227 133.9C241.411 128.826 237.616 128.302 237.577 128.299C237.465 128.28 237.385 128.182 237.397 128.07C237.412 127.957 237.514 127.879 237.625 127.891C237.789 127.91 241.658 128.431 244.584 133.699C247.573 139.085 248.899 145.563 248.42 152.433C248.186 155.794 246.797 167.37 238.823 175.221C238.77 175.274 238.693 175.292 238.626 175.274L238.628 175.277Z",
    fill: "url(#paint193_linear_376_6503)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M238.751 174.509C238.726 174.502 238.704 174.491 238.682 174.474C238.591 174.407 238.572 174.278 238.639 174.188C238.691 174.119 243.8 167.107 244.075 156.117C244.26 148.691 241.374 137.62 235.657 131.728C233.18 129.176 230.45 127.875 227.539 127.86C227.426 127.861 227.334 127.767 227.335 127.654C227.336 127.542 227.428 127.45 227.54 127.451C230.566 127.465 233.396 128.808 235.952 131.442C241.746 137.414 244.673 148.618 244.487 156.126C244.208 167.255 239.023 174.361 238.97 174.432C238.917 174.501 238.831 174.53 238.751 174.509Z",
    fill: "url(#paint194_linear_376_6503)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M238.84 173.999C238.84 173.999 238.819 173.993 238.809 173.988C238.706 173.943 238.657 173.822 238.703 173.717C238.72 173.679 240.353 169.93 240.975 165.106C241.317 162.451 241.976 152.987 236.112 142.655C230.833 133.355 224.545 128.704 218.408 129.555C218.296 129.57 218.193 129.493 218.176 129.381C218.161 129.269 218.238 129.165 218.351 129.148C224.663 128.271 231.098 132.996 236.467 142.453C242.394 152.894 241.728 162.471 241.382 165.158C240.753 170.043 239.097 173.845 239.08 173.881C239.039 173.976 238.937 174.023 238.84 173.997L238.84 173.999Z",
    fill: "url(#paint195_linear_376_6503)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M238.461 176.675C238.362 176.649 238.296 176.55 238.311 176.446C238.328 176.34 239.843 165.646 230.667 153.536C224.159 144.949 215.304 139.01 208.103 138.407C204.853 138.135 202.18 138.961 200.16 140.864C200.078 140.943 199.947 140.937 199.87 140.856C199.792 140.774 199.796 140.643 199.878 140.565C201.985 138.58 204.765 137.715 208.135 137.999C215.442 138.611 224.418 144.613 230.992 153.289C240.279 165.545 238.73 176.401 238.715 176.509C238.698 176.622 238.592 176.697 238.482 176.681C238.476 176.679 238.467 176.677 238.461 176.675Z",
    fill: "url(#paint196_linear_376_6503)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M238.409 179.63C238.329 179.609 238.265 179.538 238.257 179.45C237.838 174.696 236.44 168.705 229.255 160.304C223.635 153.734 210.991 144.829 201.87 145.198C198.534 145.333 195.917 146.682 194.091 149.205C194.023 149.297 193.896 149.317 193.804 149.25C193.712 149.182 193.692 149.055 193.759 148.963C195.664 146.333 198.386 144.927 201.854 144.787C211.524 144.393 224.109 153.653 229.568 160.035C236.829 168.522 238.241 174.593 238.668 179.412C238.678 179.525 238.595 179.624 238.482 179.634C238.459 179.637 238.432 179.634 238.411 179.629L238.409 179.63Z",
    fill: "url(#paint197_linear_376_6503)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M238.891 184.745C238.818 184.726 238.76 184.665 238.743 184.586C237.518 178.252 234.531 172.32 223.95 163.95C217.494 158.843 204.031 152.165 195.64 154.045C193.12 154.61 191.324 155.939 190.305 157.993C190.255 158.095 190.13 158.135 190.03 158.086C189.929 158.037 189.888 157.913 189.937 157.812C191.014 155.64 192.902 154.239 195.551 153.646C204.074 151.736 217.69 158.475 224.205 163.628C234.887 172.077 237.903 178.085 239.146 184.507C239.168 184.619 239.095 184.725 238.985 184.748C238.955 184.753 238.923 184.754 238.893 184.746L238.891 184.745Z",
    fill: "url(#paint198_linear_376_6503)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M240.136 190.859C240.067 190.841 240.009 190.787 239.991 190.712C238.652 185.469 233.595 179.18 227.407 175.066C220.496 170.472 212.777 165.829 201.145 163.977C189.656 162.146 188.173 167.157 188.16 167.208C188.13 167.317 188.018 167.382 187.909 167.352C187.8 167.323 187.736 167.211 187.764 167.104C187.824 166.882 189.315 161.676 201.21 163.574C212.924 165.44 220.688 170.107 227.635 174.726C233.902 178.893 239.028 185.277 240.389 190.612C240.419 190.721 240.35 190.833 240.242 190.86C240.206 190.869 240.17 190.868 240.138 190.86L240.136 190.859Z",
    fill: "url(#paint199_linear_376_6503)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M242.083 197.474C242.022 197.458 241.97 197.415 241.944 197.351C240.034 192.509 234.622 187.457 227.467 183.84C223.415 181.791 211.082 175.558 198.751 174.473C192.041 173.884 189.259 174.944 188.105 175.938C187.405 176.543 187.366 177.077 187.364 177.099C187.357 177.212 187.261 177.299 187.15 177.294C187.037 177.286 186.952 177.194 186.955 177.082C186.956 177.053 186.991 176.374 187.808 175.654C189.01 174.594 191.892 173.459 198.786 174.066C211.195 175.158 223.583 181.417 227.652 183.476C231.129 185.234 239.523 190.089 242.327 197.202C242.368 197.307 242.316 197.426 242.21 197.468C242.167 197.485 242.122 197.487 242.082 197.476L242.083 197.474Z",
    fill: "url(#paint200_linear_376_6503)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M244.955 205.024C244.899 205.009 244.85 204.971 244.823 204.914C242.69 200.397 235.823 196.079 224.417 192.081C210.478 187.194 201.205 186.299 193.973 186.065C189.661 185.925 188.37 186.592 187.984 187.001C187.811 187.185 187.82 187.318 187.821 187.325C187.83 187.433 187.753 187.536 187.645 187.552C187.535 187.568 187.437 187.496 187.416 187.389C187.411 187.359 187.37 187.084 187.647 186.765C188.15 186.181 189.658 185.516 193.987 185.657C201.251 185.892 210.563 186.794 224.553 191.697C236.069 195.733 243.014 200.121 245.195 204.742C245.244 204.845 245.2 204.966 245.097 205.015C245.051 205.036 245.003 205.039 244.957 205.027L244.955 205.024Z",
    fill: "url(#paint201_linear_376_6503)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M189.172 198.122C189.09 198.1 189.027 198.027 189.021 197.938C189.013 197.825 189.1 197.727 189.212 197.721C198.426 197.146 218.176 200.199 233.254 204.529C247.436 208.601 249.001 212.764 249.062 212.94C249.099 213.047 249.04 213.164 248.934 213.201C248.827 213.238 248.711 213.182 248.675 213.075C248.661 213.033 247.045 208.918 233.141 204.924C218.101 200.604 198.412 197.559 189.237 198.131C189.215 198.131 189.193 198.13 189.172 198.124L189.172 198.122Z",
    fill: "url(#paint202_linear_376_6503)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M194.501 209.951C192.318 209.367 191.783 208.838 191.756 208.811C191.677 208.729 191.679 208.601 191.759 208.521C191.841 208.444 191.967 208.444 192.047 208.524C192.061 208.537 192.876 209.286 196.457 209.976C198.7 210.408 207.421 211.581 216.657 212.824C222.971 213.674 229.497 214.552 234.719 215.294C245.854 216.875 252.048 218.742 253.654 221C253.719 221.092 253.698 221.221 253.606 221.287C253.512 221.351 253.385 221.331 253.319 221.239C251.78 219.078 245.678 217.265 234.661 215.702C229.442 214.96 222.915 214.083 216.604 213.233C207.363 211.991 198.636 210.816 196.381 210.383C195.65 210.241 195.029 210.097 194.504 209.957L194.501 209.951Z",
    fill: "url(#paint203_linear_376_6503)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M201.602 223.301C198.387 222.439 196.203 221.339 195.468 219.782C195.419 219.679 195.463 219.558 195.566 219.509C195.669 219.462 195.79 219.506 195.839 219.607C197.47 223.065 207.615 224.248 219.361 225.617C231.515 227.034 250.119 227.598 254.028 227.624C257.682 227.649 258.671 228.476 258.712 228.51C258.798 228.584 258.805 228.715 258.731 228.799C258.657 228.882 258.53 228.893 258.444 228.819C258.426 228.805 257.467 228.055 254.027 228.031C250.113 228.006 231.485 227.44 219.316 226.021C212.208 225.193 205.959 224.464 201.603 223.297L201.602 223.301Z",
    fill: "url(#paint204_linear_376_6503)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M210.47 237.258C202.559 235.138 200.617 231.658 200.528 231.492C200.474 231.392 200.512 231.267 200.612 231.215C200.711 231.163 200.834 231.198 200.889 231.298C200.913 231.343 203.393 235.744 213.972 237.606C224.945 239.538 244.11 239.465 252.102 238.047C259.995 236.649 263.846 235.24 263.883 235.228C263.988 235.188 264.106 235.243 264.146 235.348C264.184 235.455 264.131 235.571 264.026 235.61C263.988 235.625 260.108 237.043 252.174 238.449C244.149 239.871 224.914 239.949 213.902 238.009C212.649 237.788 211.508 237.534 210.471 237.256L210.47 237.258Z",
    fill: "url(#paint205_linear_376_6503)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M218.133 250.091C212.91 248.692 209.114 246.443 206.783 243.356C206.715 243.266 206.733 243.138 206.823 243.07C206.914 243.002 207.042 243.02 207.11 243.111C211.41 248.803 220.862 251.592 235.199 251.396C251.484 251.172 262.448 246.891 266.358 244.393C269.674 242.279 269.193 241.274 269.187 241.264C269.136 241.167 269.167 241.042 269.261 240.987C269.355 240.931 269.474 240.956 269.535 241.049C269.559 241.086 269.679 241.299 269.593 241.688C269.462 242.285 268.833 243.298 266.577 244.738C262.629 247.257 251.582 251.581 235.202 251.804C228.427 251.897 222.725 251.324 218.13 250.093L218.133 250.091Z",
    fill: "url(#paint206_linear_376_6503)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M225.901 261.693C218.664 259.753 215.143 256.302 213.663 254.364C213.595 254.274 213.612 254.145 213.702 254.077C213.792 254.009 213.922 254.028 213.989 254.116C215.825 256.521 223.417 264.233 243.993 262.428C264.384 260.641 271.848 252.921 273.648 250.599C276.137 247.39 274.509 245.9 274.437 245.838C274.354 245.764 274.343 245.635 274.418 245.549C274.491 245.463 274.621 245.455 274.705 245.527C274.787 245.599 276.713 247.317 273.972 250.85C272.146 253.206 264.583 261.034 244.027 262.838C236.294 263.516 230.383 262.894 225.899 261.692L225.901 261.693Z",
    fill: "url(#paint207_linear_376_6503)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M234.113 272.012C224.931 269.552 221.03 264.401 220.979 264.331C220.911 264.238 220.932 264.111 221.022 264.045C221.114 263.977 221.241 263.998 221.309 264.088C221.374 264.175 227.995 272.894 244.409 272.882C261.775 272.869 274.078 265.059 278.111 259.812C280.353 256.895 281.339 254.199 280.959 252.015C280.662 250.317 279.637 249.345 278.828 248.826C278.732 248.765 278.705 248.638 278.766 248.544C278.828 248.45 278.954 248.423 279.049 248.482C279.927 249.044 281.039 250.103 281.362 251.947C281.763 254.247 280.752 257.054 278.437 260.064C274.354 265.374 261.923 273.28 244.411 273.295C240.424 273.298 237.006 272.789 234.114 272.015L234.113 272.012Z",
    fill: "url(#paint208_linear_376_6503)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M241.986 281C237.485 279.794 233.119 277.555 229.25 273.876C229.167 273.798 229.164 273.668 229.242 273.586C229.32 273.503 229.45 273.5 229.532 273.578C243.821 287.171 265.025 280.855 274.239 275.619C282.186 271.104 286.795 265.068 287.218 258.624C287.585 253.057 283.123 250.947 283.079 250.927C282.977 250.879 282.931 250.758 282.979 250.654C283.025 250.552 283.15 250.504 283.249 250.553C283.297 250.575 288.013 252.793 287.628 258.651C287.196 265.236 282.513 271.387 274.444 275.973C267.627 279.849 254.308 284.3 241.988 280.999L241.986 281Z",
    fill: "url(#paint209_linear_376_6503)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M249.925 288.449C244.974 287.122 241.639 284.936 239.923 283.813C239.72 283.68 239.54 283.562 239.384 283.463C239.288 283.404 239.261 283.277 239.32 283.181C239.382 283.085 239.509 283.056 239.603 283.117C239.759 283.215 239.941 283.334 240.148 283.47C243.814 285.873 254.977 293.183 273.588 286.186C286.892 281.184 293.279 270.872 293.584 263.407C293.803 258.047 291.201 253.812 286.256 251.476C286.154 251.428 286.11 251.306 286.158 251.202C286.206 251.098 286.329 251.059 286.432 251.104C291.535 253.514 294.219 257.889 293.994 263.422C293.616 272.707 285.285 282.225 273.733 286.567C263.623 290.368 255.682 289.989 249.925 288.447L249.925 288.449Z",
    fill: "url(#paint210_linear_376_6503)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M256.836 293.995C254.112 293.265 251.524 292.188 249.138 290.768C249.041 290.71 249.009 290.585 249.067 290.488C249.124 290.391 249.249 290.354 249.347 290.417C257.134 295.049 267.139 295.994 276.797 293.013C286.101 290.14 293.944 283.922 297.264 276.782C300.048 270.793 300.534 265.307 298.71 260.479C296.947 255.81 293.369 252.859 290.842 251.753C286.41 249.813 282.592 250.663 282.553 250.673C282.443 250.697 282.333 250.629 282.306 250.519C282.282 250.409 282.35 250.299 282.46 250.272C282.621 250.234 286.446 249.377 291.006 251.378C293.606 252.518 297.283 255.547 299.094 260.334C300.958 265.27 300.468 270.863 297.636 276.956C294.268 284.198 286.33 290.503 276.919 293.406C270.107 295.511 263.118 295.678 256.838 293.995L256.836 293.995Z",
    fill: "url(#paint211_linear_376_6503)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M264.31 298.394C261.637 297.678 260.1 296.852 260.057 296.827C259.958 296.771 259.923 296.649 259.977 296.549C260.032 296.451 260.158 296.409 260.254 296.47C260.376 296.537 272.518 303.047 288.512 295.045C304.649 286.975 307.569 271.111 304.487 262.425C301.81 254.876 296.33 250.916 292.095 249.725C287.335 248.379 283.182 249.378 281.491 250.179C281.388 250.228 281.267 250.184 281.218 250.081C281.169 249.978 281.213 249.857 281.316 249.808C283.033 248.994 287.189 247.982 291.994 249.27C292.066 249.289 292.135 249.308 292.206 249.327C297.821 250.903 302.556 255.749 304.874 262.283C308.006 271.111 305.054 287.225 288.697 295.407C278.167 300.673 269.276 299.721 264.309 298.39L264.31 298.394Z",
    fill: "url(#paint212_linear_376_6503)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M274.281 301.375C274.182 301.348 274.116 301.252 274.132 301.148C274.149 301.035 274.253 300.958 274.364 300.974C274.517 300.997 289.905 303.105 301.049 292.68C312.08 282.36 314.481 267.453 306.888 256.426C299.639 245.901 287.247 244.557 279.923 249.343C279.828 249.405 279.702 249.378 279.64 249.284C279.577 249.189 279.604 249.063 279.7 249.001C287.185 244.108 299.836 245.467 307.226 256.195C314.938 267.393 312.515 282.519 301.331 292.981C290.039 303.544 274.462 301.405 274.306 301.381C274.298 301.379 274.291 301.377 274.283 301.375L274.281 301.375Z",
    fill: "url(#paint213_linear_376_6503)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M290.605 301.443C290.54 301.425 290.484 301.374 290.462 301.305C290.428 301.197 290.49 301.083 290.598 301.049C290.797 300.988 291.046 300.917 291.338 300.836C295.031 299.786 306.276 296.589 312.444 284.902C318.952 272.57 316.935 258.861 307.301 249.98C297.788 241.209 284.474 241.972 278.009 248.19C277.927 248.27 277.797 248.267 277.72 248.185C277.641 248.103 277.644 247.973 277.725 247.896C284.326 241.55 297.897 240.754 307.579 249.681C317.354 258.692 319.404 272.595 312.807 285.096C306.556 296.938 295.187 300.172 291.452 301.233C291.162 301.315 290.918 301.385 290.72 301.444C290.681 301.456 290.643 301.455 290.607 301.446L290.605 301.443Z",
    fill: "url(#paint214_linear_376_6503)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M308.222 293.587C308.178 293.575 308.138 293.549 308.108 293.509C308.043 293.417 308.063 293.29 308.156 293.223C308.286 293.129 321.294 283.615 320.205 266.425C319.574 256.471 314.514 250.138 310.381 246.577C304.549 241.553 296.945 238.907 290.038 239.499C279.221 240.427 275.965 246.571 275.933 246.632C275.881 246.733 275.758 246.772 275.656 246.723C275.555 246.671 275.516 246.548 275.566 246.446C275.599 246.383 278.942 240.038 290.001 239.091C297.014 238.489 304.732 241.172 310.646 246.266C314.84 249.877 319.973 256.301 320.613 266.397C321.716 283.818 308.524 293.459 308.391 293.553C308.339 293.589 308.277 293.6 308.219 293.584L308.222 293.587Z",
    fill: "url(#paint215_linear_376_6503)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M320.814 277.915C320.814 277.915 320.793 277.909 320.783 277.904C320.68 277.859 320.632 277.738 320.68 277.634C326.628 264.238 322.318 248.31 310.65 240.585C298.905 232.81 287.086 234.001 280.531 237.388C274.472 240.518 274.385 243.313 274.384 243.34C274.384 243.453 274.291 243.545 274.181 243.545C274.069 243.542 273.976 243.454 273.977 243.341C273.976 243.217 274.023 240.288 280.343 237.022C286.994 233.587 298.984 232.367 310.877 240.243C322.709 248.077 327.084 264.225 321.054 277.799C321.014 277.892 320.911 277.941 320.814 277.915Z",
    fill: "url(#paint216_linear_376_6503)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M325.022 264.683C324.917 264.655 324.85 264.55 324.875 264.442C324.903 264.312 327.602 251.275 318.499 240.797C312.956 234.418 305.709 230.802 296.342 229.737C285.704 228.532 274.172 233.566 272.778 236.645C272.732 236.748 272.605 236.795 272.507 236.748C272.404 236.703 272.358 236.58 272.404 236.478C274.004 232.942 285.877 228.14 296.388 229.331C305.86 230.403 313.196 234.066 318.809 240.529C328.05 251.165 325.303 264.397 325.275 264.528C325.252 264.639 325.141 264.709 325.031 264.684C325.029 264.683 325.024 264.682 325.022 264.681L325.022 264.683Z",
    fill: "url(#paint217_linear_376_6503)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M326.187 252.548C326.096 252.524 326.031 252.439 326.035 252.343C326.038 252.231 326.347 241.073 318.119 233.128C308.092 223.443 295.924 223.46 287.645 224.314C284.768 224.61 279.64 225.652 271.545 228.921C271.321 229.012 271.164 229.076 271.086 229.104C270.229 229.424 269.97 229.156 269.91 229.066C269.848 228.971 269.873 228.844 269.969 228.782C270.056 228.725 270.171 228.742 270.237 228.821C270.285 228.851 270.492 228.889 270.944 228.722C271.019 228.692 271.17 228.632 271.392 228.542C277.928 225.902 283.383 224.343 287.603 223.909C295.965 223.046 308.256 223.032 318.404 232.835C326.765 240.913 326.45 252.247 326.444 252.361C326.441 252.474 326.345 252.561 326.231 252.558C326.216 252.558 326.201 252.554 326.186 252.55L326.187 252.548Z",
    fill: "url(#paint218_linear_376_6503)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M325.443 239.829C325.37 239.809 325.311 239.75 325.296 239.672C320.499 215.816 293.533 217.475 288.177 218.052C284.392 218.459 278.558 219.849 274.3 220.864C271.799 221.461 269.822 221.933 269.106 222C267.087 222.193 266.525 221.041 266.504 220.993C266.457 220.89 266.501 220.769 266.604 220.72C266.707 220.671 266.826 220.714 266.875 220.817C266.894 220.856 267.353 221.756 269.069 221.592C269.756 221.526 271.72 221.058 274.206 220.466C278.475 219.446 284.323 218.053 288.133 217.642C293.552 217.06 320.83 215.385 325.699 239.589C325.721 239.7 325.649 239.807 325.538 239.829C325.507 239.837 325.473 239.834 325.444 239.827L325.443 239.829Z",
    fill: "url(#paint219_linear_376_6503)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M265.309 214.782C262.946 214.149 262.295 212.858 262.264 212.791C262.215 212.688 262.258 212.567 262.359 212.517C262.46 212.468 262.584 212.51 262.633 212.613C262.652 212.652 263.619 214.478 267.439 214.696C268.911 214.779 271.915 214.189 275.716 213.438C283.092 211.984 293.194 209.993 301.077 211.121C312.84 212.803 319.899 217.761 323.292 226.719C323.332 226.824 323.28 226.943 323.172 226.984C323.067 227.024 322.948 226.971 322.907 226.864C319.573 218.06 312.618 213.185 301.016 211.526C293.203 210.407 283.141 212.391 275.793 213.839C271.964 214.593 268.939 215.19 267.413 215.103C266.593 215.056 265.897 214.94 265.307 214.782L265.309 214.782Z",
    fill: "url(#paint220_linear_376_6503)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M360.081 263.595C360.081 263.595 360.087 263.592 360.092 263.588C364.718 260.259 368.468 256.145 371.388 251.39C371.395 251.378 371.402 251.369 371.41 251.357C373.39 248.124 374.985 244.601 376.202 240.83C377.11 238.024 377.812 235.076 378.314 232.01L378.311 232.004C378.37 231.691 378.416 231.377 378.463 231.057C378.462 231.043 378.469 231.034 378.469 231.02C379.355 224.991 379.473 218.519 378.838 211.749C378.257 205.381 377.015 198.743 375.14 191.97C373.373 185.529 371.033 178.964 368.15 172.368C365.678 166.704 362.805 161.022 359.546 155.382C356.288 149.741 352.805 144.409 349.134 139.433C344.867 133.643 340.351 128.334 335.665 123.585C330.728 118.573 325.606 114.175 320.38 110.483C314.841 106.559 309.184 103.427 303.528 101.182C303.528 101.182 303.523 101.181 303.513 101.178C303.2 101.051 302.891 100.93 302.572 100.816L302.569 100.81C299.662 99.7072 296.75 98.837 293.86 98.2246L293.851 98.2223C289.964 97.3922 286.105 97.0156 282.31 97.1173C276.74 97.2705 271.303 98.4606 266.109 100.799C266.109 100.799 266.105 100.801 266.098 100.805C264.788 101.395 263.492 102.056 262.213 102.794C261.638 103.126 261.084 103.466 260.535 103.816C257.538 105.726 254.875 107.943 252.539 110.43C252.027 110.973 251.532 111.524 251.056 112.092C248.457 115.164 246.304 118.61 244.59 122.362C244.473 122.596 244.368 122.829 244.278 123.055C243.725 124.312 243.219 125.603 242.764 126.924C242.764 126.924 242.763 126.929 242.76 126.939C242.336 128.176 241.947 129.438 241.606 130.726C241.595 130.766 241.586 130.784 241.586 130.784C239.864 137.269 239.17 144.412 239.464 151.991C239.465 152.005 239.464 152.011 239.461 152.02C239.508 153.138 239.573 154.265 239.656 155.401C239.658 155.427 239.658 155.451 239.663 155.484C239.752 156.699 239.868 157.927 240.015 159.162L240.012 159.17C240.875 166.695 242.628 174.561 245.227 182.58C247.465 189.489 250.335 196.511 253.808 203.52C255.436 206.812 257.196 210.104 259.088 213.378C260.98 216.651 262.948 219.821 264.984 222.874C269.32 229.391 273.967 235.388 278.831 240.782C285.312 247.97 292.171 254.087 299.203 258.933C299.227 258.953 299.257 258.968 299.281 258.988C300.32 259.705 301.361 260.39 302.408 261.051C302.408 261.051 302.412 261.053 302.42 261.058C308.843 265.104 315.381 268.081 321.862 269.829C321.862 269.829 321.882 269.83 321.922 269.84C323.193 270.185 324.467 270.48 325.736 270.727C327.129 270.995 328.519 271.212 329.906 271.367C330.152 271.391 330.4 271.414 330.646 271.439C330.646 271.439 330.65 271.439 330.659 271.439C334.766 271.83 338.826 271.689 342.786 270.974C343.504 270.847 344.224 270.697 344.94 270.529C348.879 269.606 352.725 268.091 356.42 265.959C357.698 265.221 358.919 264.429 360.085 263.589L360.081 263.595ZM322.08 210.828C319.61 208.487 316.384 205.104 312.859 200.576C310.04 196.95 307.026 192.582 304.048 187.424C301.07 182.266 298.797 177.474 297.063 173.217C294.901 167.895 293.588 163.414 292.792 160.099C291.831 156.074 291.632 153.767 291.632 153.767C291.632 153.767 291.957 153.994 292.548 154.456C293.099 154.889 293.884 155.537 294.863 156.402C299.122 160.182 306.969 168.17 314.577 181.347C315.528 182.995 316.408 184.611 317.224 186.175C322.902 197.142 325.321 206.011 326.319 210.886C326.579 212.167 326.745 213.17 326.847 213.864C326.951 214.61 326.986 215.001 326.986 215.001C326.986 215.001 325.088 213.674 322.082 210.831L322.08 210.828Z",
    fill: "#141332"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M322.032 270.122C316.765 268.71 311.377 266.463 305.913 263.383C288.518 253.576 271.826 235.854 258.908 213.48C245.992 191.109 238.991 167.79 239.194 147.822C239.407 126.778 247.333 111.146 262.109 102.615C276.886 94.0836 294.386 95.0383 312.718 105.373C330.112 115.182 346.804 132.901 359.722 155.275C372.638 177.647 379.639 200.966 379.437 220.934C379.223 241.977 371.298 257.609 356.521 266.141C346.149 272.129 334.433 273.445 322.032 270.122ZM296.5 99.0353C284.201 95.7399 272.589 97.0403 262.315 102.972C247.672 111.426 239.817 126.938 239.604 147.828C239.401 167.724 246.384 190.966 259.263 213.276C272.143 235.586 288.783 253.253 306.112 263.024C324.31 273.287 341.669 274.24 356.315 265.784C370.959 257.329 378.813 241.818 379.026 220.927C379.23 201.031 372.246 177.789 359.368 155.48C346.487 133.17 329.85 115.503 312.518 105.731C307.087 102.669 301.732 100.437 296.5 99.0353Z",
    fill: "url(#paint221_linear_376_6503)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M326.937 215.196C326.914 215.19 326.892 215.179 326.873 215.165C326.755 215.084 314.976 206.757 303.871 187.523C292.766 168.289 291.447 153.925 291.433 153.782C291.427 153.704 291.466 153.626 291.535 153.586C291.605 153.546 291.689 153.551 291.756 153.596C291.873 153.677 303.653 162.004 314.757 181.238C325.862 200.472 327.182 214.836 327.195 214.979C327.201 215.057 327.163 215.135 327.093 215.175C327.046 215.202 326.99 215.21 326.937 215.196ZM291.893 154.209C292.215 156.805 294.278 170.091 304.225 187.321C314.173 204.548 324.647 212.98 326.735 214.556C326.413 211.96 324.348 198.673 314.403 181.445C304.454 164.211 293.98 155.786 291.893 154.209Z",
    fill: "url(#paint222_linear_376_6503)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M303.792 187.735C303.742 187.722 303.696 187.689 303.667 187.639C303.61 187.54 303.644 187.416 303.742 187.359L303.944 187.243C304.043 187.186 304.167 187.219 304.224 187.317C304.281 187.416 304.247 187.54 304.149 187.597L303.947 187.714C303.899 187.741 303.841 187.748 303.79 187.735L303.792 187.735Z",
    fill: "url(#paint223_linear_376_6503)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M296.151 192.149C296.101 192.135 296.056 192.103 296.026 192.052C295.969 191.953 296.003 191.83 296.101 191.773L301.203 188.827C301.302 188.77 301.426 188.803 301.483 188.902C301.54 189 301.506 189.124 301.408 189.181L296.306 192.127C296.258 192.155 296.2 192.161 296.149 192.148L296.151 192.149Z",
    fill: "url(#paint224_linear_376_6503)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M282.083 200.269C282.033 200.255 281.988 200.223 281.959 200.172C281.902 200.074 281.935 199.95 282.033 199.893L289.508 195.577C289.607 195.52 289.731 195.554 289.788 195.652C289.844 195.751 289.811 195.875 289.713 195.932L282.238 200.247C282.19 200.275 282.132 200.282 282.081 200.268L282.083 200.269Z",
    fill: "url(#paint225_linear_376_6503)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M267.335 208.785C267.285 208.772 267.24 208.739 267.21 208.689C267.153 208.59 267.187 208.466 267.285 208.409L274.414 204.294C274.512 204.237 274.636 204.27 274.693 204.369C274.75 204.467 274.717 204.591 274.618 204.648L267.49 208.764C267.442 208.791 267.384 208.798 267.333 208.785L267.335 208.785Z",
    fill: "url(#paint226_linear_376_6503)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M259.505 213.305C259.455 213.291 259.409 213.259 259.38 213.208C259.323 213.11 259.356 212.986 259.455 212.929L262.227 211.329C262.326 211.272 262.449 211.305 262.506 211.404C262.563 211.502 262.53 211.626 262.431 211.683L259.659 213.283C259.611 213.311 259.553 213.318 259.503 213.304L259.505 213.305Z",
    fill: "url(#paint227_linear_376_6503)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M253.756 203.726C253.741 203.722 253.724 203.718 253.711 203.708C253.613 203.654 253.574 203.529 253.63 203.429C253.726 203.257 253.842 203.076 253.977 202.892C254.044 202.802 254.171 202.78 254.263 202.849C254.353 202.916 254.372 203.045 254.306 203.135C254.181 203.305 254.074 203.47 253.987 203.626C253.942 203.711 253.844 203.75 253.756 203.726Z",
    fill: "url(#paint228_linear_376_6503)"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M256.462 200.877C256.422 200.866 256.383 200.842 256.356 200.808C256.286 200.719 256.299 200.592 256.387 200.519C257.623 199.518 259.247 198.379 261.214 197.137C261.311 197.078 261.436 197.107 261.496 197.201C261.556 197.296 261.529 197.424 261.432 197.484C259.478 198.718 257.868 199.847 256.643 200.838C256.591 200.88 256.523 200.893 256.462 200.877Z",
    fill: "url(#paint229_linear_376_6503)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M268.406 193.346C268.354 193.332 268.307 193.297 268.28 193.247C268.225 193.147 268.261 193.024 268.361 192.97C270.745 191.666 273.377 190.294 276.182 188.891C276.284 188.839 276.405 188.881 276.457 188.983C276.508 189.084 276.466 189.208 276.365 189.257C273.564 190.656 270.937 192.026 268.557 193.328C268.51 193.354 268.454 193.359 268.406 193.346Z",
    fill: "url(#paint230_linear_376_6503)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M284.003 185.519C283.947 185.504 283.896 185.466 283.871 185.407C283.825 185.305 283.868 185.184 283.971 185.135C286.538 183.939 288.909 182.93 291.014 182.137C291.118 182.095 291.238 182.15 291.277 182.257C291.316 182.362 291.264 182.481 291.157 182.52C289.062 183.309 286.701 184.315 284.144 185.507C284.098 185.529 284.05 185.532 284.003 185.519Z",
    fill: "url(#paint231_linear_376_6503)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M296.734 180.743C296.663 180.724 296.603 180.668 296.586 180.589C296.562 180.479 296.632 180.369 296.742 180.345C298.545 179.941 299.517 179.943 299.935 179.98C300.039 179.986 300.131 180.089 300.12 180.203C300.11 180.315 300.011 180.399 299.897 180.389C299.504 180.353 298.579 180.353 296.83 180.747C296.797 180.753 296.763 180.753 296.731 180.745L296.734 180.743Z",
    fill: "url(#paint232_linear_376_6503)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M245.175 182.791C245.07 182.763 245.006 182.658 245.028 182.551C245.069 182.357 245.122 182.115 245.202 181.833C245.232 181.724 245.37 181.659 245.456 181.692C245.566 181.721 245.629 181.837 245.598 181.945C245.52 182.217 245.47 182.447 245.43 182.637C245.407 182.748 245.299 182.818 245.188 182.795C245.184 182.793 245.179 182.792 245.177 182.792L245.175 182.791Z",
    fill: "url(#paint233_linear_376_6503)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M247.189 178.565C247.164 178.558 247.14 178.547 247.117 178.53C247.028 178.461 247.011 178.333 247.08 178.243C248.168 176.817 249.668 175.396 251.537 174.017C251.629 173.95 251.756 173.97 251.822 174.06C251.89 174.15 251.869 174.28 251.78 174.346C249.942 175.701 248.47 177.096 247.404 178.492C247.353 178.559 247.267 178.586 247.189 178.565Z",
    fill: "url(#paint234_linear_376_6503)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M258.8 170.125C258.745 170.11 258.697 170.072 258.669 170.017C258.619 169.916 258.661 169.793 258.762 169.743C261.179 168.563 263.933 167.406 266.946 166.302C267.053 166.263 267.17 166.317 267.208 166.424C267.247 166.531 267.194 166.647 267.086 166.686C264.086 167.784 261.347 168.937 258.941 170.111C258.894 170.134 258.844 170.136 258.798 170.124L258.8 170.125Z",
    fill: "url(#paint235_linear_376_6503)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M275.297 164.222C275.225 164.203 275.167 164.144 275.149 164.068C275.125 163.958 275.194 163.848 275.305 163.824C278.113 163.212 280.772 162.884 283.203 162.849C283.318 162.851 283.409 162.938 283.412 163.052C283.414 163.165 283.323 163.257 283.21 163.261C280.806 163.294 278.177 163.621 275.393 164.225C275.359 164.232 275.326 164.23 275.297 164.222Z",
    fill: "url(#paint236_linear_376_6503)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M293.877 165.891C293.854 165.885 293.83 165.874 293.809 165.86C293.091 165.337 291.814 164.594 289.806 164.029C289.697 163.999 289.633 163.886 289.664 163.777C289.694 163.668 289.807 163.606 289.914 163.634L289.916 163.635C291.982 164.216 293.305 164.984 294.048 165.528C294.141 165.595 294.161 165.722 294.093 165.814C294.04 165.886 293.954 165.912 293.875 165.891L293.877 165.891Z",
    fill: "url(#paint237_linear_376_6503)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M242.375 171.761C242.274 171.734 242.208 171.635 242.225 171.529C242.368 170.636 242.784 169.207 243.953 167.483C244.016 167.39 244.144 167.368 244.238 167.429C244.331 167.492 244.355 167.62 244.292 167.714C243.166 169.377 242.767 170.742 242.628 171.595C242.61 171.707 242.506 171.782 242.394 171.764C242.388 171.762 242.382 171.76 242.373 171.758L242.375 171.761Z",
    fill: "url(#paint238_linear_376_6503)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M248.385 163.368C248.343 163.356 248.305 163.332 248.276 163.296C248.208 163.205 248.225 163.077 248.313 163.008C250.289 161.487 252.719 160.056 255.53 158.756C255.633 158.707 255.753 158.753 255.802 158.856C255.849 158.959 255.805 159.08 255.702 159.129C252.917 160.417 250.517 161.832 248.563 163.334C248.51 163.374 248.444 163.385 248.385 163.37L248.385 163.368Z",
    fill: "url(#paint239_linear_376_6503)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M263.853 156.005C263.788 155.988 263.732 155.937 263.71 155.868C263.676 155.76 263.736 155.645 263.844 155.611C266.831 154.685 269.709 154.036 272.392 153.683C272.506 153.669 272.607 153.748 272.622 153.86C272.637 153.972 272.557 154.074 272.445 154.089C269.783 154.439 266.93 155.081 263.964 156.002C263.925 156.014 263.887 156.014 263.851 156.005L263.853 156.005Z",
    fill: "url(#paint240_linear_376_6503)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M287.411 155.936C287.399 155.933 287.386 155.929 287.372 155.921C285.35 154.927 283.036 154.269 280.493 153.965C280.381 153.946 280.301 153.851 280.313 153.737C280.328 153.624 280.428 153.545 280.542 153.557C283.131 153.864 285.49 154.537 287.552 155.553C287.654 155.603 287.695 155.726 287.645 155.828C287.601 155.917 287.502 155.96 287.409 155.935L287.411 155.936Z",
    fill: "url(#paint241_linear_376_6503)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M292.742 160.296C292.691 160.282 292.648 160.25 292.618 160.202C292.615 160.198 292.361 159.777 291.801 159.161C291.724 159.077 291.729 158.948 291.813 158.872C291.897 158.795 292.028 158.801 292.102 158.884C292.694 159.533 292.959 159.971 292.97 159.99C293.027 160.086 292.996 160.213 292.899 160.27C292.849 160.299 292.793 160.307 292.74 160.293L292.742 160.296Z",
    fill: "url(#paint242_linear_376_6503)"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M290.39 152.113C290.348 152.102 290.309 152.078 290.281 152.041C289.443 150.961 287.962 149.371 285.671 147.943C285.574 147.883 285.545 147.756 285.605 147.659C285.664 147.563 285.789 147.535 285.888 147.593C288.232 149.054 289.747 150.681 290.605 151.788C290.676 151.877 290.659 152.008 290.569 152.076C290.515 152.115 290.449 152.127 290.391 152.111L290.39 152.113Z",
    fill: "url(#paint243_linear_376_6503)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M270.381 144.427C270.295 144.404 270.232 144.328 270.23 144.235C270.226 144.122 270.314 144.028 270.428 144.023C273.407 143.921 276.206 144.16 278.748 144.73C278.867 144.762 278.928 144.864 278.903 144.975C278.878 145.085 278.769 145.155 278.659 145.13C276.151 144.566 273.387 144.33 270.443 144.432C270.422 144.433 270.403 144.43 270.384 144.425L270.381 144.427Z",
    fill: "url(#paint244_linear_376_6503)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M253.292 148.322C253.235 148.307 253.185 148.267 253.158 148.21C253.111 148.107 253.157 147.985 253.26 147.938C255.86 146.762 258.694 145.828 261.69 145.166C261.799 145.143 261.909 145.211 261.934 145.321C261.958 145.431 261.889 145.541 261.778 145.565C258.811 146.224 256.002 147.146 253.43 148.312C253.384 148.331 253.336 148.334 253.292 148.322Z",
    fill: "url(#paint245_linear_376_6503)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M241.879 156.687C241.851 156.68 241.824 156.666 241.8 156.646C241.713 156.573 241.703 156.444 241.775 156.358C243.019 154.886 244.485 153.487 246.134 152.207C246.222 152.138 246.353 152.153 246.421 152.243C246.49 152.332 246.475 152.46 246.385 152.531C244.76 153.795 243.313 155.172 242.089 156.624C242.036 156.687 241.954 156.71 241.88 156.69L241.879 156.687Z",
    fill: "url(#paint246_linear_376_6503)"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M239.959 159.37C239.945 159.366 239.93 159.362 239.916 159.354C239.816 159.3 239.779 159.178 239.831 159.077L239.888 158.971C239.944 158.873 240.066 158.836 240.168 158.892C240.266 158.948 240.302 159.075 240.246 159.172L240.194 159.268C240.148 159.353 240.05 159.394 239.959 159.37Z",
    fill: "url(#paint247_linear_376_6503)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M291.287 150.976C291.201 150.953 291.136 150.875 291.135 150.78C291.122 149.138 290.566 147.334 289.526 145.568C289.469 145.471 289.501 145.345 289.599 145.288C289.698 145.231 289.822 145.264 289.879 145.36C290.955 147.191 291.53 149.062 291.543 150.779C291.544 150.892 291.452 150.984 291.339 150.985C291.321 150.985 291.301 150.982 291.285 150.977L291.287 150.976Z",
    fill: "url(#paint248_linear_376_6503)"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M284.859 140.405C284.834 140.398 284.81 140.387 284.788 140.37C282.729 138.805 280.339 137.566 277.69 136.683C277.583 136.648 277.526 136.531 277.562 136.424C277.597 136.316 277.706 136.246 277.821 136.295C280.514 137.192 282.942 138.453 285.037 140.043C285.127 140.112 285.144 140.241 285.077 140.331C285.026 140.398 284.939 140.426 284.862 140.406L284.859 140.405Z",
    fill: "url(#paint249_linear_376_6503)"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M260.555 135.779C260.48 135.759 260.42 135.696 260.406 135.613C260.388 135.503 260.464 135.397 260.575 135.377C261.792 135.181 263.073 135.02 264.383 134.903C266.085 134.749 267.775 134.709 269.404 134.78C269.517 134.786 269.604 134.881 269.598 134.995C269.593 135.108 269.497 135.195 269.384 135.189C267.774 135.118 266.104 135.159 264.417 135.31C263.116 135.428 261.845 135.587 260.64 135.782C260.609 135.787 260.581 135.784 260.554 135.776L260.555 135.779Z",
    fill: "url(#paint250_linear_376_6503)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M245.169 142.222C245.131 142.212 245.094 142.191 245.066 142.159C244.992 142.073 245.002 141.943 245.087 141.869C247.021 140.19 249.377 138.78 252.095 137.676C252.199 137.634 252.321 137.683 252.362 137.788C252.404 137.892 252.354 138.013 252.25 138.055C249.575 139.142 247.256 140.53 245.358 142.18C245.305 142.227 245.234 142.239 245.171 142.223L245.169 142.222Z",
    fill: "url(#paint251_linear_376_6503)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M239.406 152.242C239.314 152.217 239.249 152.13 239.255 152.032C239.26 151.946 239.402 149.888 240.826 147.179C240.878 147.078 241 147.041 241.103 147.094C241.204 147.145 241.242 147.27 241.189 147.371C239.81 149.997 239.668 152.039 239.665 152.059C239.657 152.171 239.559 152.258 239.447 152.25C239.434 152.249 239.418 152.247 239.406 152.244L239.406 152.242Z",
    fill: "url(#paint252_linear_376_6503)"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M338.683 221.359C334.991 220.37 331.027 218.317 326.937 215.229L326.848 215.147C326.766 215.068 326.762 214.939 326.841 214.857C326.919 214.774 327.048 214.773 327.131 214.849L327.202 214.918C336.089 221.623 344.351 223.384 350.446 219.865C356.179 216.555 358.577 208.463 357.2 197.078C355.933 186.602 351.621 174.386 345.372 163.563C339.125 152.739 330.7 142.898 322.262 136.563C313.092 129.678 304.884 127.708 299.151 131.019C293.058 134.536 290.451 142.567 291.816 153.629L291.838 153.723C291.863 153.833 291.793 153.943 291.683 153.967C291.572 153.992 291.463 153.922 291.438 153.812L291.414 153.7C290.025 142.444 292.704 134.27 298.948 130.665C304.833 127.269 313.201 129.246 322.509 136.235C330.991 142.603 339.455 152.49 345.729 163.357C352.005 174.228 356.334 186.498 357.608 197.027C359.006 208.585 356.536 216.821 350.651 220.217C347.229 222.193 343.155 222.555 338.683 221.357L338.683 221.359Z",
    fill: "url(#paint253_linear_376_6503)"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M334.804 219.977C334.71 219.952 334.644 219.86 334.653 219.759C334.665 219.647 334.764 219.563 334.878 219.576C337.649 219.845 340.176 219.334 342.389 218.054C353.337 211.734 348.877 187.023 337.843 167.909C332.274 158.264 324.77 149.493 317.252 143.846C309.088 137.712 301.786 135.956 296.689 138.899C294.473 140.178 292.769 142.109 291.618 144.644C291.57 144.746 291.447 144.792 291.347 144.745C291.245 144.699 291.199 144.577 291.247 144.475C292.433 141.862 294.197 139.865 296.487 138.543C301.736 135.513 309.199 137.278 317.502 143.517C325.063 149.196 332.608 158.011 338.202 167.703C343.797 177.394 347.658 188.335 348.798 197.723C350.049 208.033 347.847 215.379 342.598 218.41C340.308 219.732 337.699 220.262 334.841 219.982C334.83 219.979 334.819 219.979 334.807 219.975L334.804 219.977Z",
    fill: "url(#paint254_linear_376_6503)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M333.936 219.574C333.882 219.56 333.833 219.522 333.807 219.47C333.755 219.368 333.797 219.247 333.896 219.194C334.076 219.103 334.255 219.007 334.431 218.905C344.618 213.025 340.485 190.061 330.231 172.304C319.979 154.547 302.16 139.485 291.972 145.366C291.797 145.467 291.624 145.574 291.455 145.684C291.359 145.746 291.234 145.719 291.172 145.624C291.109 145.528 291.136 145.403 291.232 145.341C291.406 145.227 291.587 145.116 291.768 145.011C296.66 142.187 303.609 143.824 311.336 149.622C318.368 154.899 325.384 163.09 330.585 172.099C335.786 181.108 339.373 191.28 340.426 200.008C341.584 209.599 339.526 216.437 334.635 219.262C334.451 219.368 334.267 219.467 334.081 219.561C334.035 219.585 333.984 219.589 333.936 219.576L333.936 219.574Z",
    fill: "url(#paint255_linear_376_6503)"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M331.684 218.379C331.684 218.379 331.663 218.373 331.653 218.368C331.55 218.323 331.504 218.2 331.55 218.097C335.491 209.301 331.922 191.782 323.065 176.441C314.208 161.1 300.82 149.244 291.232 148.265C291.119 148.248 291.037 148.152 291.049 148.04C291.061 147.928 291.162 147.845 291.273 147.857C300.979 148.859 314.503 160.789 323.419 176.236C332.336 191.681 335.913 209.358 331.924 218.265C331.881 218.357 331.78 218.405 331.684 218.379Z",
    fill: "url(#paint256_linear_376_6503)"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M328.748 216.521C328.652 216.495 328.587 216.401 328.598 216.3C329.643 207.151 325.338 192.334 317.888 179.43C310.438 166.525 299.756 155.388 291.312 151.719C291.209 151.673 291.161 151.552 291.206 151.45C291.252 151.347 291.373 151.298 291.475 151.344C299.994 155.045 310.752 166.249 318.244 179.226C325.735 192.199 330.061 207.119 329.007 216.347C328.994 216.461 328.892 216.541 328.781 216.527C328.77 216.524 328.759 216.524 328.751 216.521L328.748 216.521Z",
    fill: "url(#paint257_linear_376_6503)"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M326.797 214.057C326.715 214.035 326.653 213.965 326.645 213.875C325.944 204.931 321.472 192.378 314.969 181.114C308.467 169.853 299.831 159.701 292.435 154.622C292.342 154.559 292.318 154.43 292.383 154.338C292.449 154.245 292.574 154.222 292.667 154.286C300.11 159.397 308.791 169.6 315.322 180.912C321.853 192.224 326.348 204.843 327.054 213.845C327.062 213.957 326.979 214.057 326.867 214.065C326.843 214.068 326.82 214.063 326.799 214.058L326.797 214.057Z",
    fill: "url(#paint258_linear_376_6503)"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M344.179 226.235C339.992 225.113 335.457 222.806 330.743 219.348C321.078 212.261 311.209 200.705 303.667 187.641C289.079 162.375 283.065 131.005 298.244 122.24C305.059 118.306 314.72 120.541 325.447 128.534C335.226 135.821 344.968 147.156 352.172 159.636C359.376 172.115 364.324 186.219 365.745 198.332C367.303 211.619 364.409 221.103 357.595 225.035C353.821 227.214 349.254 227.593 344.18 226.233L344.179 226.235ZM311.039 121.526C306.391 120.281 302.082 120.5 298.45 122.597C283.492 131.233 289.537 162.347 304.023 187.437C311.538 200.453 321.365 211.964 330.986 219.02C341.273 226.564 350.652 228.575 357.39 224.683C364.052 220.836 366.875 211.495 365.338 198.381C363.923 186.321 358.996 172.274 351.818 159.841C341.202 141.453 324.682 125.18 311.039 121.524L311.039 121.526Z",
    fill: "url(#paint259_linear_376_6503)"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M331.627 269.35C310.09 263.579 286.041 241.304 267.211 208.689C244.366 169.12 238.541 130.506 252.369 110.312C252.432 110.219 252.56 110.195 252.653 110.258C252.747 110.321 252.771 110.449 252.707 110.543C238.967 130.607 244.798 169.051 267.565 208.482C290.332 247.915 320.708 272.187 344.954 270.319C345.067 270.311 345.166 270.396 345.174 270.508C345.182 270.621 345.099 270.72 344.984 270.728C340.696 271.058 336.217 270.578 331.626 269.348L331.627 269.35Z",
    fill: "url(#paint260_linear_376_6503)"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M325.746 270.941L325.744 270.941C303.806 264.756 280.034 242.576 262.155 211.608C244.276 180.641 236.953 148.964 242.566 126.873C242.595 126.764 242.706 126.697 242.815 126.724L242.818 126.724C242.927 126.754 242.992 126.863 242.963 126.972C237.374 148.962 244.683 180.525 262.51 211.402C280.336 242.279 304.017 264.39 325.854 270.545C325.963 270.574 326.027 270.688 325.995 270.799C325.966 270.908 325.853 270.97 325.746 270.941Z",
    fill: "url(#paint261_linear_376_6503)"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M299.229 259.19C299.206 259.184 299.184 259.174 299.163 259.159C284.392 248.592 270.635 232.703 259.381 213.209C248.035 193.556 241.14 173.545 239.444 155.337C239.433 155.224 239.516 155.125 239.629 155.115C239.743 155.102 239.842 155.187 239.852 155.301C241.544 173.449 248.418 193.402 259.735 213.004C270.962 232.449 284.677 248.293 299.401 258.826C299.494 258.892 299.513 259.021 299.448 259.112C299.397 259.183 299.309 259.212 299.229 259.19Z",
    fill: "url(#paint262_linear_376_6503)"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M348.071 233.878C332.165 229.616 313.62 210.743 301.128 189.106C292.394 173.978 286.513 157.391 284.997 143.602C283.361 128.733 286.842 118.015 294.799 113.421C302.735 108.839 313.793 111.244 325.935 120.192C337.152 128.458 348.539 141.781 357.18 156.747C365.82 171.712 371.666 188.239 373.214 202.083C374.893 217.074 371.447 227.851 363.511 232.433C358.944 235.07 353.671 235.378 348.071 233.878ZM310.054 112.457C304.337 110.925 299.215 111.34 295.002 113.772C287.195 118.28 283.787 128.856 285.403 143.556C286.914 157.291 292.774 173.819 301.482 188.902C310.191 203.985 321.573 217.321 332.714 225.5C344.634 234.249 355.499 236.584 363.304 232.078C371.091 227.583 374.465 216.946 372.806 202.129C371.263 188.338 365.438 171.871 356.824 156.951C348.209 142.03 336.861 128.752 325.689 120.52C320.18 116.46 314.902 113.758 310.051 112.458L310.054 112.457Z",
    fill: "url(#paint263_linear_376_6503)"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M338.704 265.79C316.816 259.925 291.417 234.153 274.339 204.573C251.189 164.474 241.742 114.63 266.002 100.622C266.1 100.565 266.224 100.598 266.281 100.696C266.338 100.795 266.305 100.919 266.206 100.976C242.168 114.854 251.645 164.444 274.694 204.366C297.744 244.289 335.951 277.291 359.99 263.41C360.088 263.353 360.212 263.387 360.269 263.485C360.326 263.584 360.293 263.708 360.194 263.765C353.83 267.439 346.486 267.871 338.703 265.785L338.704 265.79Z",
    fill: "url(#paint264_linear_376_6503)"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M349.483 242.729C343.87 241.225 337.757 238.086 331.372 233.361C318.62 223.927 305.737 208.869 296.026 192.05C286.316 175.231 279.719 156.545 277.923 140.784C275.975 123.668 279.841 111.389 288.807 106.212C297.795 101.021 310.327 103.756 324.092 113.904C336.814 123.283 349.73 138.402 359.535 155.381C369.34 172.363 375.972 191.11 377.736 206.815C379.642 223.812 375.742 236.03 366.755 241.219C361.921 244.009 356.045 244.485 349.484 242.727L349.483 242.729ZM306.088 105.076C299.603 103.338 293.791 103.809 289.011 106.569C269.614 117.767 277.733 159.554 296.378 191.847C315.023 224.14 347.151 252.063 366.548 240.866C375.386 235.763 379.214 223.686 377.327 206.863C375.571 191.212 368.957 172.521 359.181 155.588C349.404 138.654 336.526 123.582 323.848 114.235C317.591 109.621 311.595 106.551 306.088 105.076Z",
    fill: "url(#paint265_linear_376_6503)"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M344.466 259.39C337.907 257.633 330.771 253.974 323.314 248.466C308.389 237.442 293.317 219.841 281.961 200.175C270.607 180.509 262.898 158.653 260.816 140.215C258.554 120.201 263.091 105.842 273.588 99.7796C276.251 98.2422 279.202 97.2771 282.355 96.9108C282.466 96.9 282.569 96.9772 282.581 97.0908C282.594 97.2023 282.515 97.3049 282.401 97.3172C279.304 97.6781 276.408 98.624 273.793 100.134C251.04 113.272 260.5 162.184 282.315 199.968C304.13 237.753 341.759 270.401 364.511 257.265C367.121 255.759 369.386 253.73 371.246 251.234C371.313 251.144 371.443 251.127 371.532 251.192C371.622 251.258 371.641 251.387 371.575 251.478C369.683 254.019 367.376 256.084 364.718 257.62C359.051 260.892 352.157 261.451 344.466 259.39Z",
    fill: "url(#paint266_linear_376_6503)"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M348.028 251.395C341.877 249.747 335.18 246.31 328.184 241.135C314.203 230.796 300.079 214.293 289.435 195.857C278.791 177.422 271.562 156.939 269.598 139.661C267.467 120.902 271.707 107.445 281.536 101.77C287.65 98.2425 295.068 97.977 303.591 100.99C303.698 101.028 303.755 101.144 303.717 101.251C303.679 101.358 303.563 101.424 303.456 101.377C295.052 98.4071 287.747 98.6602 281.742 102.127C272.062 107.716 267.894 121.03 270.006 139.617C271.962 156.841 279.173 177.268 289.791 195.656C300.407 214.043 314.491 230.501 328.429 240.809C343.469 251.929 357.083 254.978 366.763 249.39C372.757 245.929 376.627 239.736 378.266 230.982C378.286 230.87 378.394 230.798 378.505 230.819C378.604 230.843 378.689 230.947 378.668 231.058C377.008 239.935 373.072 246.223 366.969 249.747C361.669 252.806 355.222 253.327 348.029 251.4L348.028 251.395Z",
    fill: "url(#paint267_linear_376_6503)"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M241.02 137.964C241.001 137.959 240.983 137.951 240.966 137.94C240.869 137.88 240.838 137.755 240.897 137.658C241.675 136.379 243.06 134.452 245.234 132.545C245.319 132.471 245.448 132.478 245.524 132.564C245.598 132.649 245.591 132.778 245.505 132.854C243.369 134.726 242.01 136.615 241.248 137.872C241.199 137.951 241.104 137.986 241.02 137.964Z",
    fill: "url(#paint268_linear_376_6503)"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M252.099 128.717C252.04 128.701 251.989 128.658 251.962 128.597C251.918 128.493 251.969 128.371 252.074 128.33C254.665 127.263 257.516 126.589 260.546 126.325C260.661 126.315 260.758 126.4 260.769 126.511C260.779 126.624 260.696 126.723 260.583 126.733C257.594 126.995 254.784 127.66 252.232 128.709C252.189 128.727 252.143 128.728 252.101 128.717L252.099 128.717Z",
    fill: "url(#paint269_linear_376_6503)"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M269.315 127.015C269.217 126.989 269.15 126.892 269.167 126.789C269.183 126.676 269.285 126.598 269.398 126.614L269.675 126.655C272.634 127.09 275.371 127.81 277.812 128.792C277.917 128.834 277.969 128.954 277.925 129.059C277.883 129.165 277.764 129.221 277.658 129.172C275.249 128.2 272.543 127.489 269.616 127.06L269.341 127.02C269.341 127.02 269.324 127.016 269.316 127.013L269.315 127.015Z",
    fill: "url(#paint270_linear_376_6503)"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M289.655 139.617C289.601 139.602 289.554 139.567 289.526 139.512C288.351 137.244 286.754 135.215 284.777 133.477C284.691 133.402 284.683 133.272 284.758 133.188C284.832 133.102 284.962 133.097 285.046 133.169C287.061 134.94 288.693 137.009 289.889 139.324C289.941 139.423 289.901 139.548 289.802 139.6C289.754 139.625 289.701 139.629 289.653 139.616L289.655 139.617Z",
    fill: "url(#paint271_linear_376_6503)"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M291.94 141.353C291.85 141.328 291.785 141.243 291.789 141.145C291.89 138.892 291.39 136.543 290.3 134.167C290.253 134.064 290.297 133.943 290.402 133.895C290.503 133.846 290.626 133.892 290.674 133.997C291.79 136.435 292.304 138.846 292.2 141.166C292.194 141.279 292.099 141.366 291.985 141.36C291.97 141.358 291.955 141.357 291.942 141.353L291.94 141.353Z",
    fill: "url(#paint272_linear_376_6503)"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M285.698 127.563C285.664 127.554 285.631 127.536 285.604 127.508C283.572 125.447 281.203 123.671 278.561 122.231C278.461 122.177 278.425 122.053 278.478 121.953C278.532 121.852 278.658 121.818 278.757 121.87C281.434 123.33 283.836 125.128 285.895 127.22C285.975 127.3 285.974 127.43 285.894 127.51C285.842 127.563 285.765 127.581 285.698 127.563Z",
    fill: "url(#paint273_linear_376_6503)"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M261.578 118.63C261.498 118.609 261.434 118.538 261.426 118.45C261.416 118.337 261.499 118.238 261.612 118.227C261.813 118.209 262.015 118.194 262.217 118.178C264.955 117.982 267.728 118.183 270.463 118.773C270.583 118.797 270.643 118.905 270.621 119.016C270.598 119.127 270.487 119.196 270.378 119.174C267.682 118.591 264.946 118.394 262.247 118.587C262.045 118.602 261.845 118.616 261.647 118.635C261.623 118.638 261.597 118.635 261.576 118.63L261.578 118.63Z",
    fill: "url(#paint274_linear_376_6503)"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M246.663 124.219C246.623 124.208 246.587 124.185 246.559 124.152C246.486 124.065 246.5 123.936 246.587 123.865C248.483 122.291 250.709 121.015 253.201 120.073C253.307 120.031 253.425 120.086 253.466 120.193C253.505 120.298 253.453 120.417 253.346 120.458C250.896 121.384 248.71 122.638 246.848 124.183C246.796 124.227 246.725 124.24 246.664 124.223L246.663 124.219Z",
    fill: "url(#paint275_linear_376_6503)"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M241.533 130.983C241.533 130.983 241.525 130.981 241.521 130.98C241.413 130.944 241.357 130.828 241.392 130.72C241.398 130.699 241.571 130.196 241.996 129.392C242.047 129.293 242.17 129.254 242.273 129.306C242.373 129.36 242.41 129.483 242.359 129.584C241.95 130.354 241.782 130.845 241.781 130.849C241.747 130.953 241.637 131.009 241.534 130.981L241.533 130.983Z",
    fill: "url(#paint276_linear_376_6503)"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M244.224 123.252C244.224 123.252 244.209 123.248 244.201 123.246C244.095 123.204 244.044 123.084 244.086 122.979C244.825 121.108 246.527 118.958 248.754 117.083C248.841 117.009 248.97 117.021 249.042 117.108C249.115 117.195 249.103 117.325 249.016 117.396C246.839 119.23 245.18 121.32 244.466 123.13C244.426 123.227 244.323 123.278 244.222 123.251L244.224 123.252Z",
    fill: "url(#paint277_linear_376_6503)"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M255.444 113.408C255.385 113.392 255.334 113.349 255.309 113.29C255.265 113.186 255.315 113.067 255.419 113.023C258.159 111.868 261.018 111.205 263.914 111.049C264.027 111.041 264.124 111.13 264.13 111.242C264.136 111.356 264.049 111.452 263.937 111.458C261.089 111.611 258.276 112.264 255.581 113.399C255.538 113.417 255.49 113.42 255.448 113.409L255.444 113.408Z",
    fill: "url(#paint278_linear_376_6503)"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M280.464 116.384C280.443 116.379 280.423 116.369 280.404 116.357L279.987 116.081C277.567 114.503 275.058 113.308 272.528 112.534C272.42 112.5 272.359 112.385 272.392 112.277C272.426 112.169 272.556 112.118 272.649 112.141C275.216 112.93 277.762 114.139 280.212 115.738L280.633 116.015C280.726 116.079 280.753 116.205 280.69 116.298C280.641 116.373 280.549 116.405 280.467 116.383L280.464 116.384Z",
    fill: "url(#paint279_linear_376_6503)"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M291.965 129.764C291.902 129.747 291.849 129.701 291.826 129.637C290.875 127.043 289.357 124.561 287.314 122.255C287.24 122.17 287.247 122.042 287.331 121.965C287.414 121.891 287.545 121.896 287.621 121.982C289.699 124.326 291.243 126.854 292.211 129.494C292.249 129.601 292.196 129.718 292.089 129.756C292.046 129.772 292.003 129.772 291.966 129.762L291.965 129.764Z",
    fill: "url(#paint280_linear_376_6503)"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M291.872 143.763C291.872 143.763 291.857 143.759 291.851 143.757C291.745 143.715 291.693 143.598 291.733 143.492C292.231 142.203 292.856 140.115 292.999 137.499C293.004 137.386 293.102 137.299 293.215 137.305C293.327 137.308 293.415 137.408 293.409 137.521C293.263 140.19 292.625 142.322 292.116 143.639C292.079 143.737 291.972 143.79 291.872 143.763Z",
    fill: "url(#paint281_linear_376_6503)"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M291.337 145.146C291.316 145.14 291.295 145.133 291.277 145.119C291.181 145.057 291.156 144.929 291.218 144.835C291.943 143.733 292.574 142.596 293.09 141.458C293.136 141.356 293.257 141.307 293.361 141.357C293.463 141.403 293.509 141.525 293.461 141.627C292.935 142.785 292.296 143.942 291.558 145.061C291.508 145.138 291.416 145.169 291.334 145.147L291.337 145.146Z",
    fill: "url(#paint282_linear_376_6503)"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M295.109 134.422C295.016 134.397 294.95 134.309 294.958 134.21C295.149 131.549 294.822 128.812 293.99 126.079C293.956 125.971 294.018 125.857 294.126 125.823C294.234 125.791 294.349 125.849 294.383 125.959C295.231 128.741 295.563 131.527 295.369 134.239C295.362 134.352 295.262 134.438 295.15 134.428C295.137 134.427 295.124 134.426 295.111 134.422L295.109 134.422Z",
    fill: "url(#paint283_linear_376_6503)"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M290.024 117.971C289.98 117.959 289.94 117.933 289.911 117.891L289.727 117.637C288.781 116.346 286.687 113.817 283.303 111.378C283.21 111.31 283.19 111.183 283.256 111.091C283.323 110.998 283.45 110.98 283.543 111.044C286.975 113.516 289.098 116.084 290.057 117.395L290.244 117.654C290.31 117.746 290.289 117.873 290.197 117.941C290.144 117.978 290.081 117.986 290.024 117.971Z",
    fill: "url(#paint284_linear_376_6503)"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M267.117 105.91C267.029 105.887 266.965 105.806 266.966 105.71C266.966 105.598 267.059 105.505 267.173 105.507C267.654 105.512 268.14 105.529 268.619 105.563C271.04 105.728 273.43 106.208 275.726 106.988C275.834 107.024 275.89 107.14 275.855 107.248C275.819 107.355 275.71 107.416 275.595 107.376C273.332 106.608 270.977 106.137 268.592 105.973C268.119 105.94 267.642 105.923 267.171 105.918C267.153 105.918 267.136 105.915 267.119 105.911L267.117 105.91Z",
    fill: "url(#paint285_linear_376_6503)"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M250.998 112.291C250.967 112.282 250.937 112.268 250.912 112.243C250.829 112.167 250.823 112.037 250.902 111.954C250.93 111.924 253.831 108.827 258.903 106.949C259.008 106.91 259.127 106.964 259.166 107.069C259.205 107.176 259.151 107.292 259.046 107.332C254.071 109.173 251.232 112.2 251.203 112.231C251.15 112.289 251.07 112.308 251.001 112.289L250.998 112.291Z",
    fill: "url(#paint286_linear_376_6503)"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M260.479 104.013C260.426 103.999 260.381 103.964 260.352 103.914C260.297 103.816 260.333 103.69 260.431 103.635C260.479 103.608 265.281 100.975 271.696 101.053C271.809 101.052 271.9 101.149 271.899 101.261C271.898 101.373 271.804 101.465 271.692 101.464C265.385 101.386 260.68 103.968 260.632 103.993C260.584 104.021 260.529 104.026 260.479 104.013Z",
    fill: "url(#paint287_linear_376_6503)"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M287.121 107.726C287.094 107.718 287.066 107.704 287.042 107.684C285.888 106.718 284.631 105.798 283.306 104.954C282.219 104.263 281.085 103.664 279.937 103.178C279.832 103.134 279.785 103.014 279.829 102.911C279.872 102.805 279.995 102.762 280.096 102.802C281.265 103.298 282.419 103.904 283.526 104.611C284.866 105.465 286.139 106.393 287.306 107.372C287.392 107.445 287.405 107.574 287.332 107.661C287.28 107.723 287.197 107.746 287.123 107.726L287.121 107.726Z",
    fill: "url(#paint288_linear_376_6503)"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M296.965 123.482C296.894 123.463 296.837 123.407 296.819 123.331C296.128 120.273 294.917 117.365 293.222 114.686C293.162 114.592 293.189 114.464 293.286 114.404C293.381 114.344 293.508 114.374 293.568 114.469C295.289 117.187 296.517 120.139 297.219 123.242C297.243 123.352 297.176 123.462 297.063 123.486C297.03 123.493 296.996 123.493 296.965 123.484L296.965 123.482Z",
    fill: "url(#paint289_linear_376_6503)"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M295.443 139.63C295.43 139.626 295.418 139.623 295.408 139.616C295.307 139.566 295.263 139.444 295.313 139.343C296.429 137.008 297.124 134.471 297.376 131.801C297.386 131.689 297.487 131.606 297.599 131.616C297.707 131.626 297.795 131.726 297.785 131.839C297.527 134.556 296.821 137.14 295.682 139.518C295.64 139.608 295.538 139.653 295.445 139.628L295.443 139.63Z",
    fill: "url(#paint290_linear_376_6503)"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M276.976 98.5833C276.884 98.5585 276.82 98.4715 276.826 98.3719C276.834 98.2592 276.931 98.1727 277.044 98.1804C279.943 98.3674 282.706 99.0267 285.254 100.142C285.357 100.187 285.406 100.308 285.36 100.411C285.315 100.514 285.19 100.557 285.091 100.517C282.588 99.4229 279.872 98.7739 277.017 98.5898C277.004 98.5885 276.991 98.5872 276.976 98.5833Z",
    fill: "url(#paint291_linear_376_6503)"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M297.554 112.54C297.502 112.526 297.453 112.491 297.426 112.439C295.943 109.617 294.091 107.144 291.927 105.088C291.845 105.009 291.841 104.88 291.919 104.798C291.998 104.715 292.127 104.713 292.21 104.79C294.405 106.877 296.284 109.386 297.788 112.247C297.84 112.347 297.802 112.472 297.703 112.524C297.655 112.549 297.603 112.553 297.554 112.54Z",
    fill: "url(#paint292_linear_376_6503)"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M300.826 130.182C300.724 130.155 300.658 130.054 300.678 129.947C301.146 127.402 301.095 124.435 300.527 121.368C300.508 121.257 300.581 121.151 300.693 121.129C300.805 121.107 300.911 121.181 300.932 121.294C301.508 124.411 301.559 127.43 301.083 130.021C301.062 130.133 300.957 130.206 300.846 130.185C300.84 130.183 300.835 130.182 300.829 130.181L300.826 130.182Z",
    fill: "url(#paint293_linear_376_6503)"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M293.481 144.624C293.446 144.614 293.412 144.596 293.386 144.567C293.309 144.485 293.312 144.355 293.394 144.276C294.668 143.069 296.517 140.973 298.084 137.848C298.133 137.746 298.26 137.704 298.358 137.757C298.459 137.807 298.5 137.93 298.449 138.031C296.854 141.21 294.973 143.342 293.675 144.574C293.621 144.625 293.546 144.641 293.481 144.624Z",
    fill: "url(#paint294_linear_376_6503)"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M297.245 104.077C297.211 104.068 297.182 104.051 297.155 104.026C295.21 102.136 292.924 100.578 290.365 99.4017C290.263 99.3541 290.217 99.2315 290.264 99.1295C290.313 99.0253 290.437 98.98 290.537 99.0291C293.14 100.226 295.462 101.81 297.441 103.731C297.521 103.809 297.525 103.94 297.445 104.02C297.391 104.076 297.315 104.093 297.245 104.075L297.245 104.077Z",
    fill: "url(#paint295_linear_376_6503)"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M304.675 120.757C304.595 120.736 304.533 120.665 304.525 120.578C304.218 117.243 303.461 114.172 302.271 111.449C302.224 111.344 302.272 111.224 302.376 111.18C302.48 111.136 302.601 111.182 302.645 111.286C303.852 114.049 304.623 117.162 304.931 120.54C304.941 120.653 304.858 120.752 304.745 120.763C304.72 120.765 304.696 120.763 304.672 120.757L304.675 120.757Z",
    fill: "url(#paint296_linear_376_6503)"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M301.468 137.503C301.451 137.499 301.434 137.494 301.421 137.484C301.324 137.429 301.287 137.304 301.343 137.204C302.716 134.77 303.677 132.083 304.201 129.22C304.222 129.109 304.327 129.036 304.439 129.055C304.556 129.079 304.625 129.181 304.605 129.293C304.073 132.2 303.097 134.928 301.702 137.404C301.655 137.488 301.559 137.526 301.471 137.502L301.468 137.503Z",
    fill: "url(#paint297_linear_376_6503)"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M291.211 147.385C291.152 147.37 291.102 147.329 291.077 147.271C291.03 147.168 291.079 147.046 291.183 147C291.206 146.99 293.42 146.003 296.018 143.735C296.103 143.661 296.233 143.671 296.307 143.754C296.381 143.839 296.374 143.968 296.288 144.044C293.64 146.357 291.442 147.335 291.348 147.375C291.305 147.395 291.257 147.398 291.213 147.386L291.211 147.385Z",
    fill: "url(#paint298_linear_376_6503)"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M296.335 99.5974C296.321 99.5935 296.306 99.5895 296.295 99.582C295.49 99.166 294.639 98.7714 293.767 98.4118C293.662 98.3679 293.613 98.2489 293.657 98.1436C293.701 98.0384 293.82 97.9892 293.925 98.0332C294.807 98.3977 295.668 98.7951 296.484 99.2186C296.585 99.2704 296.624 99.3934 296.572 99.4943C296.527 99.5811 296.428 99.6222 296.338 99.598L296.335 99.5974Z",
    fill: "url(#paint299_linear_376_6503)"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M307.629 111.897C307.568 111.881 307.515 111.835 307.489 111.77C306.439 108.953 304.847 106.442 302.766 104.303C302.687 104.221 302.69 104.093 302.77 104.013C302.852 103.934 302.982 103.935 303.059 104.016C305.181 106.197 306.802 108.756 307.872 111.627C307.911 111.732 307.857 111.85 307.752 111.889C307.71 111.905 307.667 111.905 307.627 111.894L307.629 111.897Z",
    fill: "url(#paint300_linear_376_6503)"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M308.08 129.677C307.971 129.648 307.906 129.538 307.935 129.429C308.671 126.538 309.044 123.66 309.046 120.873C309.047 120.761 309.137 120.668 309.251 120.67C309.363 120.673 309.456 120.763 309.455 120.875C309.453 123.695 309.076 126.608 308.331 129.531C308.302 129.64 308.191 129.707 308.082 129.678L308.08 129.677Z",
    fill: "url(#paint301_linear_376_6503)"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M299.455 144.273C299.415 144.262 299.378 144.239 299.351 144.207C299.278 144.12 299.29 143.99 299.376 143.919C301.472 142.173 303.23 140.114 304.602 137.799C304.667 137.69 304.731 137.579 304.795 137.465C304.85 137.368 304.975 137.331 305.075 137.387C305.172 137.443 305.208 137.569 305.153 137.667C305.088 137.783 305.022 137.895 304.956 138.008C303.562 140.363 301.771 142.458 299.641 144.233C299.589 144.277 299.52 144.291 299.457 144.274L299.455 144.273Z",
    fill: "url(#paint302_linear_376_6503)"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M291.205 148.808C291.135 148.79 291.078 148.736 291.06 148.661C291.03 148.552 291.097 148.439 291.207 148.413C291.211 148.414 291.638 148.301 292.345 148.038C292.453 147.999 292.569 148.053 292.608 148.158C292.647 148.265 292.593 148.381 292.488 148.421C291.761 148.692 291.327 148.805 291.31 148.81C291.274 148.818 291.238 148.817 291.207 148.809L291.205 148.808Z",
    fill: "url(#paint303_linear_376_6503)"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M309.146 106.023C309.106 106.013 309.067 105.989 309.04 105.955C307.213 103.7 304.948 101.988 302.491 101.001C302.385 100.959 302.334 100.84 302.378 100.735C302.42 100.629 302.545 100.581 302.645 100.621C305.167 101.635 307.49 103.39 309.362 105.696C309.432 105.785 309.419 105.912 309.331 105.985C309.279 106.028 309.211 106.041 309.15 106.025L309.146 106.023Z",
    fill: "url(#paint304_linear_376_6503)"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M313.906 122.414C313.816 122.39 313.749 122.305 313.755 122.205C313.929 119.021 313.602 115.999 312.786 113.221C312.754 113.113 312.816 112.999 312.924 112.967C313.032 112.933 313.145 112.997 313.177 113.105C314.005 115.929 314.338 118.998 314.164 122.227C314.158 122.34 314.061 122.426 313.947 122.421C313.932 122.419 313.919 122.418 313.904 122.414L313.906 122.414Z",
    fill: "url(#paint305_linear_376_6503)"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M308.666 138.867C308.645 138.861 308.625 138.852 308.606 138.84C308.513 138.776 308.486 138.65 308.549 138.556C310.139 136.169 311.381 133.501 312.241 130.627C312.272 130.519 312.38 130.46 312.495 130.491C312.604 130.522 312.665 130.637 312.632 130.746C311.761 133.659 310.503 136.365 308.889 138.785C308.839 138.859 308.748 138.891 308.666 138.869L308.666 138.867Z",
    fill: "url(#paint306_linear_376_6503)"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M295.965 149.474C295.908 149.459 295.858 149.419 295.831 149.36C295.784 149.257 295.83 149.135 295.933 149.088C298.413 147.972 300.718 146.554 302.784 144.873C302.874 144.8 303 144.816 303.073 144.903C303.144 144.992 303.133 145.119 303.043 145.192C300.948 146.895 298.614 148.332 296.1 149.463C296.057 149.483 296.007 149.486 295.962 149.474L295.965 149.474Z",
    fill: "url(#paint307_linear_376_6503)"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M292.47 152.254C292.384 152.231 292.319 152.153 292.317 152.058C292.316 151.945 292.409 151.853 292.521 151.852C294.769 151.837 297.023 151.426 299.217 150.627C299.322 150.59 299.441 150.642 299.48 150.749C299.518 150.857 299.463 150.972 299.358 151.012C297.118 151.825 294.82 152.245 292.525 152.26C292.507 152.26 292.487 152.257 292.47 152.252L292.47 152.254Z",
    fill: "url(#paint308_linear_376_6503)"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M306.409 146.884C306.369 146.873 306.33 146.849 306.304 146.815C306.233 146.726 306.247 146.599 306.334 146.526C308.476 144.79 310.446 142.687 312.192 140.278C312.26 140.186 312.387 140.166 312.479 140.233C312.571 140.301 312.591 140.428 312.524 140.52C310.758 142.959 308.761 145.087 306.59 146.846C306.538 146.889 306.469 146.902 306.408 146.886L306.409 146.884Z",
    fill: "url(#paint309_linear_376_6503)"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M316.618 132.863C316.618 132.863 316.602 132.858 316.593 132.856C316.488 132.812 316.439 132.693 316.483 132.588C317.59 129.899 318.347 127.183 318.73 124.512C318.746 124.4 318.851 124.322 318.961 124.338C319.071 124.349 319.15 124.456 319.135 124.569C318.749 127.272 317.985 130.023 316.862 132.743C316.823 132.839 316.717 132.889 316.62 132.863L316.618 132.863Z",
    fill: "url(#paint310_linear_376_6503)"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M318.701 116.014C318.63 115.995 318.569 115.936 318.554 115.857C318.016 113.278 317.024 110.948 315.604 108.931C315.539 108.839 315.562 108.71 315.654 108.645C315.748 108.58 315.874 108.602 315.94 108.694C317.393 110.756 318.407 113.139 318.955 115.773C318.976 115.885 318.907 115.992 318.795 116.016C318.762 116.023 318.73 116.022 318.699 116.013L318.701 116.014Z",
    fill: "url(#paint311_linear_376_6503)"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M322.56 113.289C322.512 113.276 322.468 113.246 322.44 113.201C321.821 112.224 321.071 111.353 320.205 110.612C320.119 110.537 320.109 110.408 320.183 110.322C320.258 110.237 320.387 110.226 320.473 110.301C321.367 111.07 322.148 111.972 322.787 112.981C322.847 113.076 322.819 113.203 322.724 113.263C322.673 113.295 322.615 113.302 322.563 113.288L322.56 113.289Z",
    fill: "url(#paint312_linear_376_6503)"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M323.957 127.944C323.85 127.915 323.784 127.805 323.811 127.698C324.518 124.808 324.752 122.077 324.509 119.581C324.499 119.468 324.58 119.368 324.693 119.358C324.806 119.345 324.906 119.428 324.916 119.541C325.165 122.082 324.927 124.859 324.208 127.795C324.181 127.905 324.071 127.972 323.961 127.945L323.957 127.944Z",
    fill: "url(#paint313_linear_376_6503)"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M316.3 143.135C316.273 143.128 316.247 143.114 316.225 143.097C316.138 143.026 316.123 142.896 316.196 142.81C317.982 140.614 319.581 138.117 320.942 135.388C320.992 135.287 321.117 135.248 321.217 135.295C321.318 135.345 321.359 135.469 321.31 135.57C319.934 138.326 318.32 140.847 316.514 143.066C316.461 143.131 316.378 143.156 316.302 143.136L316.3 143.135Z",
    fill: "url(#paint314_linear_376_6503)"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M302.994 153.393C302.937 153.377 302.889 153.34 302.862 153.281C302.815 153.178 302.859 153.057 302.96 153.007L303.182 152.9C305.749 151.637 307.968 150.295 309.961 148.797C310.051 148.729 310.179 148.747 310.247 148.837C310.315 148.928 310.297 149.056 310.206 149.124C308.192 150.635 305.953 151.991 303.361 153.266L303.131 153.375C303.085 153.397 303.037 153.4 302.991 153.387L302.994 153.393Z",
    fill: "url(#paint315_linear_376_6503)"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M292.934 154.148C292.071 153.916 291.552 153.694 291.511 153.677C291.407 153.631 291.36 153.512 291.406 153.407C291.451 153.305 291.563 153.256 291.675 153.3C291.696 153.307 293.737 154.176 296.576 154.275C296.689 154.278 296.776 154.374 296.773 154.488C296.769 154.602 296.674 154.689 296.56 154.685C295.079 154.635 293.823 154.384 292.934 154.146L292.934 154.148Z",
    fill: "url(#paint316_linear_376_6503)"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M295.47 156.904C295.47 156.904 295.451 156.899 295.441 156.896C295.215 156.8 294.991 156.695 294.774 156.58C294.673 156.528 294.634 156.405 294.685 156.304C294.737 156.204 294.86 156.164 294.961 156.216C295.171 156.324 295.384 156.426 295.603 156.519C295.707 156.565 295.754 156.683 295.711 156.788C295.669 156.883 295.566 156.932 295.47 156.906L295.47 156.904Z",
    fill: "url(#paint317_linear_376_6503)"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M300.486 157.776C300.402 157.753 300.336 157.677 300.334 157.587C300.33 157.473 300.419 157.378 300.53 157.374C302.472 157.302 304.556 156.823 306.723 155.951C306.83 155.908 306.949 155.96 306.99 156.066C307.031 156.171 306.981 156.291 306.876 156.332C304.663 157.223 302.533 157.712 300.544 157.785C300.523 157.786 300.502 157.782 300.483 157.777L300.486 157.776Z",
    fill: "url(#paint318_linear_376_6503)"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M313.91 152.194C313.868 152.182 313.827 152.158 313.799 152.119C313.731 152.029 313.749 151.901 313.84 151.833C316.049 150.167 318.188 148.188 320.2 145.949C320.276 145.864 320.404 145.857 320.489 145.934C320.573 146.01 320.581 146.139 320.504 146.224C318.474 148.482 316.316 150.479 314.085 152.162C314.031 152.201 313.968 152.211 313.909 152.196L313.91 152.194Z",
    fill: "url(#paint319_linear_376_6503)"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M325.628 139.247C325.61 139.242 325.589 139.235 325.572 139.223C325.476 139.162 325.448 139.037 325.51 138.941C327.056 136.515 328.262 134.114 329.095 131.805C329.133 131.698 329.252 131.647 329.357 131.682C329.464 131.719 329.518 131.837 329.481 131.944C328.638 134.282 327.418 136.711 325.856 139.162C325.806 139.239 325.714 139.273 325.63 139.25L325.628 139.247Z",
    fill: "url(#paint320_linear_376_6503)"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M330.663 124.466C330.575 124.443 330.511 124.363 330.511 124.268C330.507 121.703 329.939 119.825 329.463 118.702C329.419 118.598 329.467 118.478 329.571 118.434C329.675 118.39 329.795 118.438 329.839 118.542C330.328 119.699 330.915 121.635 330.919 124.267C330.92 124.38 330.828 124.472 330.715 124.472C330.698 124.471 330.68 124.469 330.663 124.464L330.663 124.466Z",
    fill: "url(#paint321_linear_376_6503)"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M336.361 125.185C336.298 125.168 336.245 125.122 336.221 125.057C336.037 124.551 335.793 124.101 335.479 123.686C335.411 123.595 335.43 123.468 335.52 123.4C335.61 123.331 335.738 123.35 335.806 123.44C336.144 123.891 336.407 124.373 336.605 124.919C336.644 125.026 336.59 125.143 336.483 125.181C336.441 125.197 336.4 125.197 336.36 125.187L336.361 125.185Z",
    fill: "url(#paint322_linear_376_6503)"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M334.38 136.864C334.38 136.864 334.359 136.858 334.349 136.853C334.246 136.808 334.198 136.684 334.246 136.582C335.382 134.03 336.121 131.75 336.445 129.804C336.463 129.692 336.569 129.617 336.681 129.636C336.789 129.662 336.868 129.76 336.85 129.872C336.521 131.853 335.77 134.168 334.621 136.751C334.581 136.843 334.478 136.892 334.381 136.866L334.38 136.864Z",
    fill: "url(#paint323_linear_376_6503)"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M324.217 149.935C324.182 149.926 324.148 149.908 324.122 149.878C324.045 149.797 324.048 149.667 324.13 149.588C326.381 147.447 328.377 145.283 330.064 143.16C330.135 143.071 330.263 143.058 330.352 143.127C330.441 143.198 330.456 143.326 330.385 143.415C328.686 145.555 326.676 147.731 324.413 149.886C324.359 149.937 324.284 149.953 324.219 149.936L324.217 149.935Z",
    fill: "url(#paint324_linear_376_6503)"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M310.517 159.856C310.46 159.84 310.408 159.8 310.383 159.741C310.336 159.639 310.383 159.516 310.487 159.47L310.815 159.321C312.74 158.43 315.041 157.007 317.471 155.207C317.563 155.139 317.691 155.16 317.759 155.25C317.827 155.341 317.806 155.47 317.715 155.538C315.263 157.355 312.936 158.791 310.988 159.694L310.655 159.845C310.611 159.865 310.563 159.868 310.519 159.856L310.517 159.856Z",
    fill: "url(#paint325_linear_376_6503)"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M300.445 161.189C300.262 161.14 300.096 161.089 299.947 161.04C299.839 161.004 299.781 160.887 299.816 160.78C299.852 160.672 299.975 160.606 300.076 160.649C300.963 160.943 302.449 161.262 304.483 161.098C304.597 161.091 304.694 161.173 304.703 161.285C304.711 161.398 304.628 161.497 304.515 161.505C302.755 161.648 301.386 161.439 300.445 161.187L300.445 161.189Z",
    fill: "url(#paint326_linear_376_6503)"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M342.546 136.546C342.546 136.546 342.533 136.543 342.529 136.542C342.422 136.502 342.368 136.386 342.405 136.279C342.958 134.764 343.154 133.479 342.987 132.462C342.969 132.351 343.045 132.246 343.156 132.226C343.267 132.208 343.372 132.284 343.392 132.395C343.569 133.482 343.369 134.835 342.791 136.418C342.755 136.519 342.648 136.574 342.546 136.546Z",
    fill: "url(#paint327_linear_376_6503)"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M334.616 148.305C334.584 148.297 334.554 148.282 334.529 148.258C334.446 148.181 334.441 148.052 334.517 147.968C336.368 145.95 337.982 143.942 339.31 142.002C339.373 141.909 339.501 141.885 339.594 141.948C339.688 142.011 339.712 142.139 339.649 142.233C338.309 144.19 336.685 146.213 334.821 148.246C334.767 148.303 334.687 148.325 334.616 148.305Z",
    fill: "url(#paint328_linear_376_6503)"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M321.313 159.651C321.267 159.639 321.223 159.609 321.194 159.566C321.132 159.47 321.157 159.344 321.253 159.282C323.629 157.713 325.976 155.942 328.229 154.02C328.316 153.947 328.446 153.959 328.518 154.043C328.592 154.128 328.582 154.258 328.494 154.332C326.23 156.264 323.869 158.045 321.478 159.624C321.427 159.657 321.366 159.665 321.313 159.651Z",
    fill: "url(#paint329_linear_376_6503)"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M308.309 165.741C308.236 165.721 308.177 165.663 308.161 165.582C308.139 165.47 308.212 165.364 308.322 165.341C310.032 165.007 311.968 164.342 314.076 163.365C314.179 163.316 314.3 163.362 314.349 163.465C314.395 163.567 314.352 163.688 314.249 163.737C312.11 164.729 310.142 165.403 308.401 165.745C308.37 165.75 308.338 165.751 308.309 165.743L308.309 165.741Z",
    fill: "url(#paint330_linear_376_6503)"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M304.144 165.788C303.571 165.635 303.305 165.451 303.292 165.443C303.199 165.378 303.177 165.25 303.242 165.157C303.307 165.064 303.432 165.044 303.526 165.105C303.534 165.109 303.81 165.296 304.418 165.432C304.532 165.458 304.597 165.568 304.572 165.678C304.547 165.788 304.436 165.858 304.326 165.833C304.263 165.818 304.204 165.802 304.145 165.786L304.144 165.788Z",
    fill: "url(#paint331_linear_376_6503)"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M359.305 155.685C359.255 155.671 359.21 155.639 359.18 155.588C359.123 155.49 359.157 155.366 359.255 155.309L359.442 155.201C359.54 155.144 359.664 155.177 359.721 155.276C359.778 155.375 359.745 155.498 359.646 155.555L359.46 155.663C359.412 155.691 359.354 155.698 359.303 155.684L359.305 155.685Z",
    fill: "url(#paint332_linear_376_6503)"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M351.94 159.937C351.89 159.923 351.844 159.891 351.815 159.84C351.758 159.742 351.791 159.618 351.89 159.561L356.898 156.671C356.997 156.614 357.121 156.647 357.178 156.746C357.235 156.844 357.201 156.968 357.103 157.025L352.094 159.915C352.047 159.943 351.988 159.95 351.938 159.936L351.94 159.937Z",
    fill: "url(#paint333_linear_376_6503)"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M337.965 168.005C337.914 167.992 337.869 167.96 337.84 167.909C337.783 167.81 337.816 167.686 337.915 167.63L345.448 163.28C345.547 163.223 345.67 163.256 345.727 163.355C345.784 163.454 345.751 163.577 345.652 163.634L338.119 167.984C338.071 168.011 338.013 168.018 337.963 168.005L337.965 168.005Z",
    fill: "url(#paint334_linear_376_6503)"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M323.188 176.537C323.138 176.524 323.092 176.491 323.063 176.441C323.006 176.342 323.04 176.218 323.138 176.161L330.307 172.022C330.405 171.966 330.529 171.999 330.586 172.097C330.643 172.196 330.61 172.32 330.511 172.377L323.343 176.515C323.295 176.543 323.237 176.55 323.186 176.536L323.188 176.537Z",
    fill: "url(#paint335_linear_376_6503)"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M315.094 181.21C315.043 181.197 314.998 181.164 314.969 181.114C314.912 181.015 314.945 180.891 315.043 180.834L317.965 179.148C318.063 179.091 318.187 179.124 318.244 179.223C318.301 179.321 318.268 179.445 318.169 179.502L315.248 181.189C315.2 181.216 315.142 181.223 315.092 181.21L315.094 181.21Z",
    fill: "url(#paint336_linear_376_6503)"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M349.099 140.146C349.007 140.121 348.94 140.033 348.949 139.932C348.962 139.767 348.955 139.607 348.932 139.466C348.915 139.356 348.99 139.25 349.101 139.23C349.212 139.21 349.318 139.288 349.337 139.399C349.365 139.573 349.373 139.762 349.358 139.961C349.35 140.073 349.251 140.159 349.138 140.15C349.125 140.148 349.112 140.147 349.1 140.144L349.099 140.146Z",
    fill: "url(#paint337_linear_376_6503)"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M344.022 148.009C343.99 148.001 343.961 147.986 343.936 147.961C343.853 147.885 343.847 147.755 343.923 147.672C345.59 145.87 346.868 144.266 347.723 142.901C347.782 142.804 347.908 142.773 348.005 142.837C348.102 142.897 348.131 143.024 348.069 143.12C347.2 144.507 345.905 146.132 344.222 147.953C344.168 148.01 344.088 148.029 344.019 148.011L344.022 148.009Z",
    fill: "url(#paint338_linear_376_6503)"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M331.925 158.875C331.883 158.864 331.844 158.84 331.816 158.803C331.747 158.715 331.762 158.584 331.852 158.516C334.194 156.699 336.444 154.821 338.54 152.936C338.623 152.862 338.755 152.867 338.829 152.95C338.906 153.034 338.898 153.165 338.815 153.239C336.712 155.132 334.456 157.014 332.106 158.838C332.052 158.878 331.986 158.89 331.927 158.874L331.925 158.875Z",
    fill: "url(#paint339_linear_376_6503)"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M317.638 168.136C317.583 168.121 317.535 168.084 317.507 168.029C317.457 167.928 317.5 167.804 317.601 167.755C319.744 166.704 322.049 165.377 324.449 163.811L324.741 163.622C324.836 163.56 324.964 163.587 325.024 163.68C325.087 163.775 325.06 163.901 324.966 163.964L324.674 164.155C322.26 165.73 319.94 167.065 317.783 168.123C317.737 168.145 317.686 168.149 317.64 168.137L317.638 168.136Z",
    fill: "url(#paint340_linear_376_6503)"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M308.43 171.04C308.346 171.018 308.283 170.943 308.278 170.851C308.275 170.738 308.363 170.642 308.475 170.638C309.15 170.612 310.307 170.479 311.995 169.99C312.102 169.96 312.219 170.021 312.248 170.13C312.28 170.24 312.218 170.354 312.109 170.383C310.38 170.886 309.187 171.02 308.489 171.047C308.468 171.048 308.447 171.045 308.428 171.04L308.43 171.04Z",
    fill: "url(#paint341_linear_376_6503)"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M353.338 151.127C353.302 151.117 353.269 151.099 353.243 151.07C353.166 150.989 353.169 150.859 353.251 150.78C354.167 149.908 354.738 149.222 355.045 148.622C355.097 148.521 355.223 148.485 355.321 148.532C355.422 148.584 355.461 148.707 355.411 148.808C355.082 149.451 354.486 150.172 353.536 151.077C353.482 151.127 353.408 151.143 353.343 151.126L353.338 151.127Z",
    fill: "url(#paint342_linear_376_6503)"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M342.769 159.208C342.723 159.195 342.683 159.169 342.653 159.127C342.588 159.033 342.611 158.907 342.705 158.842C345.074 157.19 347.108 155.724 348.748 154.485C348.838 154.416 348.966 154.435 349.034 154.525C349.102 154.616 349.084 154.743 348.994 154.811C347.35 156.055 345.311 157.523 342.937 159.176C342.885 159.212 342.823 159.222 342.767 159.207L342.769 159.208Z",
    fill: "url(#paint343_linear_376_6503)"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M328.173 168.825C328.123 168.811 328.079 168.78 328.051 168.734C327.992 168.637 328.023 168.51 328.12 168.453C330.408 167.071 332.815 165.538 335.277 163.894L335.518 163.734C335.611 163.671 335.74 163.697 335.802 163.792C335.865 163.885 335.839 164.014 335.744 164.076L335.505 164.235C333.038 165.881 330.625 167.418 328.332 168.802C328.284 168.832 328.226 168.839 328.173 168.825Z",
    fill: "url(#paint344_linear_376_6503)"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M315.524 175.458C315.465 175.442 315.414 175.399 315.387 175.34C315.343 175.236 315.393 175.114 315.497 175.072C317.14 174.383 318.963 173.521 320.912 172.512C321.014 172.461 321.136 172.5 321.188 172.6C321.24 172.699 321.2 172.823 321.101 172.876C319.141 173.89 317.308 174.756 315.655 175.45C315.612 175.468 315.564 175.471 315.522 175.459L315.524 175.458Z",
    fill: "url(#paint345_linear_376_6503)"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M311.665 176.83C311.594 176.811 311.535 176.752 311.518 176.676C311.493 176.566 311.563 176.456 311.673 176.431C311.678 176.43 311.884 176.384 312.298 176.257C312.406 176.225 312.52 176.285 312.555 176.393C312.589 176.501 312.527 176.615 312.418 176.649C311.977 176.783 311.762 176.831 311.762 176.831C311.728 176.838 311.695 176.838 311.665 176.83Z",
    fill: "url(#paint346_linear_376_6503)"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M264.925 223.073C264.835 223.048 264.771 222.966 264.772 222.87C264.776 222.756 264.87 222.666 264.981 222.669C265.158 222.674 265.354 222.663 265.565 222.641C265.679 222.629 265.779 222.709 265.791 222.823C265.804 222.934 265.723 223.036 265.609 223.049C265.379 223.075 265.165 223.085 264.97 223.08C264.952 223.08 264.937 223.078 264.922 223.074L264.925 223.073Z",
    fill: "url(#paint347_linear_376_6503)"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M268.745 222.153C268.684 222.137 268.631 222.093 268.608 222.028C268.566 221.923 268.62 221.804 268.726 221.763C270.194 221.2 271.976 220.369 274.024 219.295C274.124 219.243 274.249 219.281 274.301 219.38C274.353 219.48 274.315 219.605 274.216 219.657C272.154 220.741 270.356 221.578 268.874 222.145C268.831 222.16 268.788 222.162 268.748 222.151L268.745 222.153Z",
    fill: "url(#paint348_linear_376_6503)"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M281.239 215.575C281.191 215.562 281.146 215.529 281.118 215.483C281.058 215.386 281.09 215.26 281.186 215.202C283.499 213.794 286.001 212.204 288.616 210.476C288.711 210.414 288.837 210.439 288.9 210.534C288.962 210.628 288.937 210.756 288.841 210.818C286.222 212.547 283.719 214.141 281.399 215.552C281.35 215.582 281.292 215.589 281.239 215.575Z",
    fill: "url(#paint349_linear_376_6503)"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M295.816 205.983C295.771 205.971 295.729 205.944 295.7 205.903C295.634 205.811 295.658 205.682 295.75 205.617C298.056 203.999 300.107 202.458 301.843 201.037C301.931 200.963 302.059 200.978 302.133 201.065C302.204 201.151 302.192 201.281 302.105 201.354C300.36 202.784 298.302 204.331 295.988 205.953C295.936 205.988 295.874 205.999 295.818 205.984L295.816 205.983Z",
    fill: "url(#paint350_linear_376_6503)"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M306.317 197.345C306.286 197.336 306.256 197.322 306.231 197.297C306.148 197.221 306.142 197.091 306.218 197.008C307.434 195.688 307.896 194.889 308.062 194.53C308.11 194.426 308.231 194.377 308.334 194.43C308.436 194.477 308.482 194.6 308.434 194.702C308.258 195.083 307.774 195.925 306.52 197.284C306.467 197.342 306.387 197.363 306.315 197.344L306.317 197.345Z",
    fill: "url(#paint351_linear_376_6503)"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M312.765 201.188C312.669 201.162 312.602 201.067 312.616 200.965C312.632 200.828 312.647 200.69 312.659 200.554C312.668 200.441 312.767 200.358 312.882 200.368C312.992 200.375 313.078 200.477 313.067 200.591C313.054 200.732 313.041 200.874 313.023 201.016C313.009 201.129 312.906 201.208 312.795 201.194C312.787 201.191 312.777 201.189 312.768 201.186L312.765 201.188Z",
    fill: "url(#paint352_linear_376_6503)"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M308.055 209.886C308.026 209.878 307.996 209.863 307.973 209.841C307.887 209.766 307.881 209.637 307.956 209.553C309.598 207.699 310.767 206.05 311.527 204.509C311.576 204.407 311.702 204.367 311.801 204.416C311.903 204.465 311.944 204.589 311.894 204.691C311.119 206.266 309.931 207.944 308.263 209.827C308.208 209.886 308.128 209.908 308.057 209.889L308.055 209.886Z",
    fill: "url(#paint353_linear_376_6503)"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M295.908 220.883C295.866 220.871 295.83 220.848 295.801 220.813C295.73 220.725 295.744 220.596 295.833 220.525C298.346 218.522 300.576 216.65 302.462 214.965C302.547 214.889 302.676 214.896 302.75 214.982C302.826 215.067 302.819 215.196 302.734 215.27C300.842 216.96 298.606 218.837 296.087 220.845C296.035 220.887 295.967 220.898 295.906 220.882L295.908 220.883Z",
    fill: "url(#paint354_linear_376_6503)"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M281.471 230.103C281.415 230.088 281.365 230.048 281.337 229.991C281.29 229.888 281.337 229.765 281.439 229.719C283.744 228.668 286.185 227.314 288.7 225.69C288.795 225.63 288.923 225.657 288.983 225.75C289.043 225.845 289.016 225.973 288.923 226.033C286.394 227.668 283.933 229.032 281.612 230.089C281.566 230.111 281.518 230.113 281.474 230.102L281.471 230.103Z",
    fill: "url(#paint355_linear_376_6503)"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M272.424 232.679C272.34 232.656 272.275 232.58 272.273 232.487C272.27 232.374 272.358 232.28 272.471 232.277C273.13 232.255 274.253 232.145 275.857 231.739C275.965 231.712 276.078 231.778 276.105 231.887C276.132 231.995 276.066 232.108 275.958 232.135C274.32 232.55 273.164 232.663 272.485 232.686C272.465 232.687 272.445 232.684 272.426 232.679L272.424 232.679Z",
    fill: "url(#paint356_linear_376_6503)"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M279.334 241.141C279.108 241.081 278.917 241.02 278.755 240.968C278.648 240.932 278.588 240.818 278.624 240.71C278.659 240.603 278.769 240.539 278.882 240.579C279.062 240.638 279.286 240.71 279.556 240.777C279.667 240.798 279.732 240.917 279.705 241.027C279.676 241.136 279.566 241.203 279.456 241.176C279.414 241.165 279.372 241.154 279.332 241.143L279.334 241.141Z",
    fill: "url(#paint357_linear_376_6503)"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M283.434 241.34C283.356 241.319 283.295 241.253 283.284 241.169C283.269 241.057 283.348 240.954 283.46 240.939C285.199 240.714 287.144 240.137 289.239 239.224C289.341 239.179 289.463 239.225 289.507 239.33C289.554 239.434 289.506 239.554 289.402 239.598C287.273 240.527 285.29 241.115 283.513 241.345C283.485 241.349 283.459 241.346 283.434 241.34Z",
    fill: "url(#paint358_linear_376_6503)"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M296.55 235.503C296.504 235.491 296.462 235.462 296.433 235.42C296.37 235.327 296.395 235.199 296.489 235.136C298.711 233.638 301.077 231.841 303.524 229.798C303.611 229.724 303.741 229.736 303.812 229.823C303.885 229.91 303.873 230.04 303.787 230.111C301.33 232.165 298.951 233.968 296.718 235.474C296.666 235.508 296.605 235.516 296.55 235.501L296.55 235.503Z",
    fill: "url(#paint359_linear_376_6503)"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M309.908 224.172C309.876 224.163 309.849 224.149 309.823 224.127C309.74 224.05 309.734 223.92 309.811 223.837C311.725 221.732 313.322 219.619 314.557 217.55C314.614 217.453 314.738 217.419 314.839 217.48C314.936 217.537 314.968 217.663 314.91 217.762C313.661 219.852 312.048 221.988 310.117 224.115C310.063 224.173 309.983 224.194 309.912 224.175L309.908 224.172Z",
    fill: "url(#paint360_linear_376_6503)"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M317.332 211.699C317.223 211.669 317.158 211.56 317.187 211.45C317.702 209.427 317.697 207.952 317.603 207.069C317.59 206.957 317.673 206.856 317.785 206.843C317.898 206.833 317.998 206.913 318.01 207.025C318.109 207.941 318.114 209.47 317.583 211.552C317.554 211.661 317.443 211.728 317.334 211.699L317.332 211.699Z",
    fill: "url(#paint361_linear_376_6503)"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M287.624 249.139C287.339 249.063 287.091 248.98 286.883 248.9C286.776 248.86 286.725 248.741 286.764 248.636C286.804 248.53 286.927 248.475 287.028 248.518C287.836 248.827 289.224 249.167 291.236 249.024C291.347 249.016 291.448 249.101 291.456 249.214C291.464 249.326 291.379 249.425 291.266 249.433C289.697 249.546 288.489 249.373 287.626 249.142L287.624 249.139Z",
    fill: "url(#paint362_linear_376_6503)"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M297.191 247.902C297.132 247.887 297.081 247.844 297.054 247.782C297.012 247.679 297.061 247.557 297.166 247.515C299.446 246.575 301.872 245.202 304.378 243.435C304.472 243.37 304.598 243.393 304.664 243.485C304.729 243.577 304.706 243.706 304.614 243.771C302.083 245.555 299.629 246.944 297.323 247.895C297.28 247.913 297.235 247.914 297.193 247.903L297.191 247.902Z",
    fill: "url(#paint363_linear_376_6503)"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M311.301 238.189C311.266 238.179 311.231 238.158 311.205 238.129C311.128 238.045 311.134 237.916 311.217 237.84C313.498 235.729 315.481 233.58 317.113 231.451C317.182 231.362 317.311 231.344 317.4 231.413C317.49 231.482 317.507 231.611 317.438 231.7C315.794 233.848 313.793 236.013 311.497 238.14C311.443 238.188 311.371 238.205 311.304 238.187L311.301 238.189Z",
    fill: "url(#paint364_linear_376_6503)"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M321.379 224.824C321.379 224.824 321.36 224.819 321.35 224.816C321.245 224.77 321.198 224.651 321.242 224.546C322.251 222.192 322.84 219.86 322.988 217.611C322.996 217.498 323.093 217.411 323.206 217.419C323.319 217.425 323.405 217.524 323.397 217.637C323.246 219.931 322.647 222.309 321.62 224.706C321.579 224.801 321.476 224.85 321.379 224.824Z",
    fill: "url(#paint365_linear_376_6503)"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M322.537 212.291C322.472 212.273 322.418 212.225 322.396 212.156C322.142 211.363 321.907 210.931 321.903 210.928C321.849 210.828 321.884 210.704 321.982 210.65C322.08 210.595 322.206 210.631 322.26 210.729C322.271 210.747 322.518 211.196 322.784 212.033C322.818 212.141 322.759 212.255 322.65 212.289C322.611 212.301 322.573 212.302 322.535 212.292L322.537 212.291Z",
    fill: "url(#paint366_linear_376_6503)"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M329.2 223.266C329.116 223.244 329.051 223.168 329.049 223.075C328.957 220.376 328.323 218.3 327.804 217.033C327.763 216.927 327.813 216.808 327.916 216.766C328.022 216.724 328.139 216.774 328.184 216.878C328.714 218.175 329.364 220.301 329.458 223.061C329.461 223.174 329.373 223.268 329.259 223.273C329.238 223.274 329.219 223.271 329.2 223.266Z",
    fill: "url(#paint367_linear_376_6503)"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M324.593 238.325C324.574 238.32 324.556 238.312 324.539 238.301C324.442 238.241 324.413 238.114 324.473 238.018C326.032 235.518 327.211 233.007 327.977 230.552C328.01 230.443 328.136 230.396 328.233 230.418C328.342 230.451 328.401 230.566 328.367 230.674C327.592 233.163 326.398 235.706 324.82 238.235C324.769 238.313 324.677 238.347 324.593 238.325Z",
    fill: "url(#paint368_linear_376_6503)"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M312.674 251.176C312.63 251.164 312.59 251.137 312.56 251.098C312.494 251.006 312.515 250.879 312.607 250.811C314.901 249.166 317.106 247.195 319.16 244.954C319.237 244.871 319.368 244.866 319.45 244.942C319.533 245.018 319.538 245.148 319.462 245.231C317.391 247.492 315.165 249.482 312.846 251.145C312.793 251.183 312.731 251.191 312.674 251.176Z",
    fill: "url(#paint369_linear_376_6503)"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M299.723 256.881C299.649 256.861 299.589 256.8 299.575 256.719C299.555 256.608 299.628 256.502 299.74 256.482C301.607 256.148 303.523 255.585 305.433 254.809C305.536 254.767 305.658 254.817 305.7 254.921C305.741 255.027 305.691 255.146 305.588 255.188C303.65 255.975 301.708 256.546 299.814 256.885C299.783 256.89 299.752 256.888 299.725 256.881L299.723 256.881Z",
    fill: "url(#paint370_linear_376_6503)"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M333.16 221.02C333.11 221.007 333.062 220.974 333.035 220.924C332.025 219.14 330.742 217.757 329.324 216.924C329.227 216.867 329.193 216.741 329.25 216.643C329.308 216.546 329.434 216.513 329.531 216.57C331.011 217.439 332.344 218.875 333.391 220.722C333.446 220.82 333.412 220.946 333.314 221.001C333.266 221.028 333.211 221.034 333.16 221.02Z",
    fill: "url(#paint371_linear_376_6503)"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M334.956 235.854C334.851 235.826 334.787 235.721 334.809 235.614C335.371 232.879 335.49 230.192 335.165 227.624C335.15 227.512 335.229 227.41 335.343 227.395C335.455 227.382 335.558 227.459 335.572 227.574C335.901 230.185 335.781 232.919 335.21 235.697C335.187 235.808 335.08 235.879 334.967 235.857C334.962 235.856 334.958 235.855 334.954 235.854L334.956 235.854Z",
    fill: "url(#paint372_linear_376_6503)"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M327.169 251.157C327.142 251.149 327.116 251.136 327.092 251.118C327.005 251.047 326.99 250.917 327.064 250.829C327.838 249.877 328.612 248.855 329.36 247.793C330.334 246.411 331.205 244.983 331.948 243.552C332 243.452 332.125 243.415 332.224 243.464C332.325 243.516 332.364 243.639 332.312 243.74C331.56 245.188 330.681 246.63 329.696 248.027C328.941 249.099 328.163 250.128 327.381 251.087C327.328 251.152 327.245 251.177 327.169 251.157Z",
    fill: "url(#paint373_linear_376_6503)"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M313.895 261.263C313.832 261.246 313.777 261.198 313.754 261.133C313.717 261.027 313.774 260.909 313.88 260.872C316.259 260.051 318.621 258.737 320.899 256.966C320.987 256.897 321.118 256.912 321.186 257.002C321.255 257.09 321.24 257.221 321.15 257.289C318.835 259.089 316.436 260.425 314.015 261.262C313.975 261.276 313.932 261.275 313.894 261.265L313.895 261.263Z",
    fill: "url(#paint374_linear_376_6503)"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M303.916 261.795C302.91 261.525 302.341 261.247 302.299 261.226C302.198 261.177 302.157 261.053 302.206 260.952C302.256 260.85 302.374 260.805 302.481 260.859C302.499 260.868 304.341 261.764 307.303 261.883C307.419 261.887 307.504 261.982 307.5 262.096C307.497 262.209 307.401 262.296 307.287 262.293C305.895 262.237 304.754 262.019 303.916 261.795Z",
    fill: "url(#paint375_linear_376_6503)"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M315.511 266.984C315.425 266.96 315.362 266.883 315.36 266.79C315.357 266.677 315.447 266.584 315.56 266.58C317.03 266.547 319.345 266.316 322.035 265.4C322.142 265.364 322.259 265.422 322.296 265.529C322.332 265.635 322.274 265.752 322.167 265.789C319.426 266.72 317.067 266.955 315.57 266.988C315.55 266.989 315.53 266.986 315.511 266.981L315.511 266.984Z",
    fill: "url(#paint376_linear_376_6503)"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M329.057 262.014C329.015 262.003 328.977 261.979 328.948 261.942C328.88 261.852 328.897 261.724 328.985 261.655C331.17 259.969 333.151 257.869 334.872 255.41C334.937 255.317 335.065 255.295 335.158 255.361C335.25 255.426 335.272 255.554 335.207 255.646C333.463 258.139 331.454 260.27 329.235 261.981C329.182 262.021 329.116 262.032 329.057 262.016L329.057 262.014Z",
    fill: "url(#paint377_linear_376_6503)"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M339.138 247.953C339.138 247.953 339.121 247.948 339.113 247.946C339.007 247.904 338.958 247.785 339 247.679L339.103 247.421C340.195 244.673 340.931 241.975 341.294 239.401C341.311 239.288 341.413 239.209 341.526 239.226C341.637 239.24 341.717 239.345 341.7 239.457C341.332 242.065 340.588 244.794 339.483 247.572L339.379 247.833C339.34 247.93 339.236 247.981 339.137 247.955L339.138 247.953Z",
    fill: "url(#paint378_linear_376_6503)"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M341.273 231.24C341.2 231.22 341.141 231.162 341.126 231.083C340.611 228.503 339.652 226.103 338.274 223.953C338.214 223.858 338.241 223.731 338.336 223.671C338.431 223.61 338.559 223.638 338.619 223.733C340.023 225.926 341.002 228.374 341.528 231.004C341.55 231.116 341.478 231.223 341.367 231.245C341.336 231.252 341.302 231.25 341.273 231.242L341.273 231.24Z",
    fill: "url(#paint379_linear_376_6503)"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M343.407 226.033C343.363 226.021 343.321 225.994 343.294 225.953C341.778 223.821 339.996 222.213 337.994 221.175C337.893 221.123 337.854 221 337.906 220.899C337.958 220.798 338.081 220.759 338.182 220.811C340.243 221.881 342.074 223.531 343.627 225.716C343.693 225.808 343.672 225.938 343.58 226.003C343.527 226.041 343.466 226.049 343.407 226.033Z",
    fill: "url(#paint380_linear_376_6503)"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M347.914 242.29C347.823 242.266 347.76 242.184 347.761 242.087C347.835 239.082 347.481 236.142 346.712 233.349C346.681 233.24 346.747 233.127 346.856 233.098C346.964 233.066 347.079 233.13 347.108 233.242C347.889 236.071 348.248 239.051 348.172 242.099C348.169 242.212 348.075 242.3 347.961 242.299C347.945 242.299 347.928 242.296 347.913 242.292L347.914 242.29Z",
    fill: "url(#paint381_linear_376_6503)"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M342.532 258.845C342.509 258.839 342.487 258.828 342.468 258.814C342.375 258.749 342.353 258.621 342.419 258.529C342.532 258.365 342.646 258.2 342.76 258.035C344.276 255.796 345.473 253.328 346.317 250.7C346.353 250.592 346.463 250.532 346.575 250.569C346.683 250.602 346.742 250.719 346.706 250.827C345.852 253.493 344.637 255.994 343.099 258.265C342.984 258.435 342.869 258.602 342.754 258.765C342.703 258.837 342.614 258.867 342.532 258.845Z",
    fill: "url(#paint382_linear_376_6503)"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M330.235 268.968C330.174 268.952 330.119 268.906 330.096 268.841C330.057 268.734 330.111 268.618 330.216 268.578C332.485 267.739 334.663 266.472 336.69 264.814C336.777 264.741 336.906 264.755 336.979 264.842C337.051 264.929 337.039 265.058 336.951 265.132C334.89 266.819 332.671 268.109 330.36 268.964C330.318 268.979 330.275 268.979 330.237 268.969L330.235 268.968Z",
    fill: "url(#paint383_linear_376_6503)"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M321.81 270.029C321.705 270.001 321.641 269.898 321.662 269.791C321.685 269.68 321.793 269.608 321.904 269.631C321.908 269.632 322.417 269.732 323.288 269.763C323.402 269.769 323.489 269.862 323.486 269.976C323.482 270.09 323.387 270.177 323.273 270.173C322.363 270.141 321.844 270.038 321.823 270.032C321.819 270.031 321.815 270.03 321.81 270.029Z",
    fill: "url(#paint384_linear_376_6503)"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M329.851 271.567C329.753 271.54 329.686 271.444 329.701 271.34C329.717 271.227 329.821 271.151 329.934 271.166C331.859 271.452 334.499 271.059 337.175 270.092C337.282 270.053 337.4 270.11 337.437 270.214C337.476 270.321 337.42 270.437 337.315 270.476C334.576 271.467 331.865 271.866 329.873 271.57C329.865 271.568 329.858 271.567 329.85 271.564L329.851 271.567Z",
    fill: "url(#paint385_linear_376_6503)"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M343.988 266.769C343.946 266.758 343.905 266.733 343.877 266.694C343.809 266.604 343.825 266.476 343.916 266.408C346.246 264.639 348.218 262.532 349.775 260.14C349.837 260.044 349.965 260.02 350.059 260.081C350.155 260.142 350.18 260.268 350.118 260.364C348.535 262.794 346.531 264.938 344.161 266.735C344.108 266.774 344.044 266.784 343.985 266.768L343.988 266.769Z",
    fill: "url(#paint386_linear_376_6503)"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M353.288 252.406C353.181 252.377 353.117 252.27 353.142 252.162C353.733 249.583 353.956 246.811 353.799 243.928C353.79 243.759 353.779 243.59 353.77 243.425C353.761 243.313 353.849 243.214 353.961 243.206C354.073 243.2 354.172 243.283 354.18 243.398C354.191 243.565 354.202 243.737 354.21 243.908C354.368 246.829 354.144 249.639 353.544 252.256C353.519 252.366 353.408 252.436 353.298 252.411L353.291 252.409L353.288 252.406Z",
    fill: "url(#paint387_linear_376_6503)"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M352.255 234.63C352.19 234.612 352.136 234.564 352.113 234.497C351.138 231.573 349.746 229.017 347.977 226.899C347.903 226.812 347.915 226.683 348.002 226.611C348.089 226.54 348.219 226.55 348.29 226.637C350.091 228.794 351.508 231.395 352.501 234.367C352.538 234.474 352.48 234.591 352.371 234.627C352.331 234.641 352.29 234.642 352.253 234.631L352.255 234.63Z",
    fill: "url(#paint388_linear_376_6503)"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M341.796 221.964C341.784 221.96 341.769 221.956 341.755 221.948C339.418 220.766 337.3 220.264 335.933 220.048C335.826 220.033 335.745 219.926 335.761 219.813C335.778 219.701 335.884 219.625 335.996 219.642C337.392 219.861 339.557 220.375 341.939 221.581C342.04 221.633 342.081 221.756 342.03 221.857C341.986 221.945 341.887 221.988 341.794 221.963L341.796 221.964Z",
    fill: "url(#paint389_linear_376_6503)"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M334.448 219.817C334.364 219.794 334.303 219.722 334.298 219.63C334.292 219.518 334.377 219.42 334.491 219.414C335.829 219.336 337.148 219.359 338.414 219.482C338.528 219.492 338.609 219.593 338.597 219.706C338.585 219.818 338.486 219.902 338.372 219.889C337.127 219.767 335.829 219.746 334.512 219.823C334.489 219.823 334.467 219.822 334.446 219.816L334.448 219.817Z",
    fill: "url(#paint390_linear_376_6503)"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M352.239 226.862C352.203 226.852 352.17 226.832 352.141 226.804C350.191 224.715 347.984 223.066 345.584 221.9C345.482 221.85 345.441 221.729 345.488 221.627C345.538 221.523 345.662 221.482 345.761 221.531C348.207 222.72 350.454 224.4 352.439 226.526C352.516 226.607 352.512 226.739 352.429 226.816C352.375 226.867 352.301 226.881 352.236 226.863L352.239 226.862Z",
    fill: "url(#paint391_linear_376_6503)"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M359.682 243.586C359.602 243.565 359.539 243.496 359.531 243.408C359.111 239.255 357.966 236.178 357.322 234.715L357.194 234.429C357.147 234.326 357.194 234.204 357.296 234.157C357.399 234.11 357.52 234.156 357.568 234.259L357.7 234.551C358.355 236.036 359.515 239.159 359.942 243.37C359.952 243.483 359.871 243.583 359.758 243.595C359.733 243.597 359.708 243.595 359.683 243.589L359.682 243.586Z",
    fill: "url(#paint392_linear_376_6503)"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M356.316 260.412C356.299 260.407 356.283 260.403 356.267 260.392C356.17 260.336 356.134 260.21 356.189 260.112C356.419 259.708 356.643 259.284 356.853 258.854C357.905 256.709 358.672 254.432 359.139 252.087C359.162 251.977 359.269 251.904 359.38 251.927C359.496 251.945 359.563 252.057 359.54 252.168C359.067 254.547 358.286 256.856 357.221 259.036C357.006 259.473 356.779 259.903 356.547 260.316C356.499 260.4 356.404 260.437 356.316 260.414L356.316 260.412Z",
    fill: "url(#paint393_linear_376_6503)"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M342.733 271.178C342.661 271.159 342.604 271.103 342.587 271.026C342.562 270.916 342.63 270.806 342.74 270.782C342.781 270.772 346.822 269.827 350.904 266.439C350.993 266.366 351.122 266.38 351.192 266.467C351.265 266.554 351.251 266.683 351.164 266.754C347.004 270.207 342.869 271.172 342.829 271.181C342.795 271.188 342.762 271.188 342.73 271.18L342.733 271.178Z",
    fill: "url(#paint394_linear_376_6503)"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M357.145 265.205C357.107 265.195 357.072 265.175 357.045 265.142C356.971 265.057 356.978 264.929 357.064 264.853C358.536 263.561 360.64 261.397 362.31 258.42C362.366 258.323 362.495 258.288 362.588 258.342C362.686 258.397 362.722 258.522 362.666 258.622C360.968 261.651 358.827 263.851 357.333 265.161C357.28 265.208 357.208 265.222 357.145 265.205Z",
    fill: "url(#paint395_linear_376_6503)"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M365.098 250.645C365.001 250.619 364.934 250.525 364.948 250.423C365.102 249.183 365.151 247.902 365.094 246.617C365.026 245.048 364.858 243.499 364.598 242.016C364.579 241.905 364.654 241.799 364.765 241.78C364.876 241.76 364.983 241.833 365.002 241.946C365.266 243.447 365.434 245.013 365.504 246.601C365.561 247.908 365.511 249.212 365.353 250.475C365.338 250.588 365.236 250.666 365.125 250.652C365.117 250.65 365.106 250.647 365.098 250.645Z",
    fill: "url(#paint396_linear_376_6503)"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M361.754 233.268C361.702 233.254 361.653 233.218 361.626 233.166C360.155 230.358 358.239 227.855 355.935 225.725C355.852 225.649 355.846 225.519 355.923 225.436C355.999 225.353 356.129 225.347 356.212 225.424C358.55 227.585 360.494 230.125 361.988 232.975C362.04 233.074 362.002 233.199 361.903 233.251C361.855 233.277 361.803 233.281 361.754 233.268Z",
    fill: "url(#paint397_linear_376_6503)"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M341.277 219.02C341.185 218.995 341.119 218.905 341.127 218.806C341.135 218.694 341.234 218.61 341.347 218.618C343.978 218.821 346.566 219.501 349.047 220.636C349.149 220.683 349.195 220.804 349.147 220.908C349.099 221.012 348.972 221.057 348.875 221.008C346.437 219.892 343.894 219.226 341.314 219.025C341.301 219.024 341.287 219.023 341.277 219.02Z",
    fill: "url(#paint398_linear_376_6503)"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M367.591 255.534C367.579 255.531 367.564 255.527 367.553 255.519C367.451 255.47 367.41 255.346 367.46 255.244C368.728 252.68 369.523 250.006 369.828 247.289C369.84 247.175 369.943 247.095 370.054 247.109C370.166 247.126 370.248 247.224 370.234 247.335C369.925 250.1 369.115 252.822 367.827 255.428C367.783 255.518 367.683 255.561 367.591 255.536L367.591 255.534Z",
    fill: "url(#paint399_linear_376_6503)"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M369.436 239.234C369.367 239.215 369.308 239.159 369.29 239.084C368.591 236.182 367.375 233.345 365.673 230.647C365.613 230.552 365.643 230.425 365.738 230.365C365.835 230.305 365.96 230.334 366.02 230.429C367.745 233.162 368.979 236.043 369.687 238.988C369.714 239.099 369.646 239.209 369.535 239.236C369.501 239.245 369.466 239.242 369.434 239.233L369.436 239.234Z",
    fill: "url(#paint400_linear_376_6503)"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M359.571 223.537C359.542 223.529 359.516 223.515 359.492 223.495C357.12 221.471 354.576 219.943 352.139 219.076C352.032 219.038 351.976 218.92 352.015 218.815C352.053 218.708 352.173 218.655 352.275 218.691C354.76 219.576 357.347 221.129 359.758 223.186C359.844 223.259 359.854 223.39 359.781 223.476C359.728 223.538 359.646 223.561 359.572 223.541L359.571 223.537Z",
    fill: "url(#paint401_linear_376_6503)"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M335.972 218.22C335.905 218.202 335.848 218.151 335.829 218.08C335.797 217.973 335.859 217.859 335.967 217.825C337.682 217.316 340.471 216.751 344.021 216.962C344.132 216.965 344.22 217.065 344.213 217.178C344.207 217.291 344.11 217.377 343.997 217.37C340.507 217.164 337.768 217.717 336.085 218.217C336.048 218.229 336.01 218.228 335.974 218.218L335.972 218.22Z",
    fill: "url(#paint402_linear_376_6503)"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M373.583 243.492C373.488 243.466 373.422 243.377 373.431 243.276C373.689 240.472 373.484 237.719 372.82 235.089C372.793 234.981 372.859 234.868 372.968 234.841C373.076 234.814 373.189 234.88 373.216 234.988C373.891 237.661 374.102 240.464 373.837 243.315C373.828 243.427 373.726 243.51 373.614 243.5C373.604 243.497 373.591 243.496 373.58 243.493L373.583 243.492Z",
    fill: "url(#paint403_linear_376_6503)"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M369.061 227.023C369.017 227.011 368.979 226.985 368.949 226.945C367.186 224.555 364.906 222.362 362.171 220.429C362.078 220.364 362.056 220.236 362.121 220.144C362.187 220.051 362.316 220.031 362.407 220.094C365.178 222.052 367.49 224.274 369.278 226.701C369.346 226.791 369.325 226.92 369.235 226.986C369.183 227.024 369.119 227.036 369.06 227.02L369.061 227.023Z",
    fill: "url(#paint404_linear_376_6503)"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M346.131 214.866C346.043 214.843 345.979 214.763 345.98 214.666C345.981 214.554 346.073 214.461 346.188 214.463C349.027 214.492 351.878 215.011 354.664 216.005C354.771 216.042 354.825 216.16 354.787 216.267C354.749 216.374 354.628 216.432 354.526 216.391C351.786 215.411 348.978 214.902 346.183 214.874C346.165 214.873 346.148 214.871 346.133 214.867L346.131 214.866Z",
    fill: "url(#paint405_linear_376_6503)"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M332.447 218.808C332.403 218.796 332.363 218.77 332.335 218.731C332.268 218.638 332.288 218.511 332.378 218.443C332.46 218.384 334.406 216.967 337.734 215.831C337.838 215.793 337.956 215.85 337.994 215.959C338.031 216.066 337.972 216.183 337.866 216.22C334.6 217.334 332.641 218.759 332.621 218.774C332.568 218.811 332.504 218.821 332.446 218.805L332.447 218.808Z",
    fill: "url(#paint406_linear_376_6503)"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M376.143 241.054C376.045 241.027 375.98 240.931 375.994 240.829C376.12 239.888 376.205 238.952 376.244 238.049C376.25 237.935 376.345 237.848 376.458 237.854C376.572 237.859 376.659 237.955 376.653 238.068C376.613 238.983 376.526 239.929 376.4 240.884C376.386 240.997 376.282 241.075 376.171 241.061C376.162 241.059 376.154 241.057 376.145 241.054L376.143 241.054Z",
    fill: "url(#paint407_linear_376_6503)"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M375.533 230.231C375.466 230.213 375.41 230.162 375.389 230.089C374.578 227.216 373.197 224.584 371.284 222.266C371.212 222.179 371.224 222.049 371.311 221.978C371.398 221.907 371.527 221.919 371.599 222.006C373.547 224.369 374.956 227.051 375.783 229.979C375.814 230.088 375.75 230.202 375.641 230.231C375.605 230.242 375.567 230.24 375.533 230.231Z",
    fill: "url(#paint408_linear_376_6503)"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M364.227 216.388C364.21 216.383 364.194 216.377 364.178 216.368C361.764 214.976 359.085 213.86 356.214 213.052C356.104 213.023 356.04 212.909 356.072 212.8C356.101 212.691 356.214 212.629 356.321 212.658L356.324 212.658C359.229 213.475 361.941 214.605 364.384 216.013C364.481 216.071 364.515 216.195 364.46 216.293C364.413 216.375 364.315 216.411 364.229 216.388L364.227 216.388Z",
    fill: "url(#paint409_linear_376_6503)"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M339.263 213.222C339.202 213.205 339.147 213.159 339.124 213.094C339.085 212.987 339.139 212.871 339.246 212.832C341.848 211.875 344.558 211.372 347.294 211.342C347.423 211.341 347.554 211.34 347.688 211.342C347.804 211.339 347.893 211.435 347.892 211.547C347.891 211.66 347.799 211.752 347.686 211.751C347.556 211.75 347.427 211.752 347.301 211.752C344.61 211.782 341.948 212.275 339.39 213.218C339.348 213.233 339.305 213.233 339.267 213.223L339.263 213.222Z",
    fill: "url(#paint410_linear_376_6503)"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M331.211 218.101C331.178 218.092 331.147 218.075 331.122 218.05C331.042 217.97 331.04 217.841 331.118 217.761C331.13 217.748 331.443 217.429 332.044 216.935C332.133 216.865 332.26 216.876 332.331 216.963C332.403 217.049 332.39 217.179 332.304 217.25C331.723 217.729 331.413 218.045 331.411 218.046C331.358 218.102 331.281 218.12 331.211 218.101Z",
    fill: "url(#paint411_linear_376_6503)"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M378.26 232.207C378.161 232.18 378.094 232.084 378.111 231.98C378.485 229.359 378.135 226.539 377.096 223.83C377.055 223.724 377.109 223.606 377.215 223.564C377.32 223.523 377.438 223.577 377.48 223.683C378.542 226.457 378.903 229.345 378.517 232.037C378.5 232.15 378.396 232.225 378.285 232.211C378.277 232.209 378.268 232.207 378.262 232.205L378.26 232.207Z",
    fill: "url(#paint412_linear_376_6503)"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M372.772 217.01C372.736 217 372.702 216.982 372.677 216.953C370.679 214.858 368.224 213.065 365.38 211.621C365.279 211.57 365.24 211.447 365.29 211.345C365.342 211.244 365.464 211.207 365.566 211.255C368.451 212.719 370.943 214.541 372.973 216.67C373.052 216.752 373.049 216.882 372.965 216.958C372.911 217.009 372.837 217.025 372.772 217.008L372.772 217.01Z",
    fill: "url(#paint413_linear_376_6503)"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M348.551 207.949C348.469 207.927 348.405 207.854 348.4 207.764C348.392 207.652 348.479 207.554 348.591 207.548C351.495 207.362 354.467 207.625 357.424 208.325C357.53 208.345 357.604 208.464 357.577 208.571C357.55 208.681 357.439 208.75 357.331 208.724C354.413 208.03 351.481 207.773 348.619 207.956C348.596 207.956 348.574 207.955 348.553 207.949L348.551 207.949Z",
    fill: "url(#paint414_linear_376_6503)"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M333.013 213.645C332.969 213.634 332.929 213.607 332.899 213.568C332.834 213.476 332.854 213.349 332.947 213.281C335.184 211.67 337.597 210.365 340.117 209.404C340.222 209.364 340.341 209.417 340.383 209.522C340.424 209.628 340.37 209.746 340.264 209.788C337.777 210.735 335.397 212.024 333.188 213.614C333.135 213.651 333.072 213.661 333.015 213.646L333.013 213.645Z",
    fill: "url(#paint415_linear_376_6503)"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M328.859 215.28C328.842 215.276 328.824 215.269 328.808 215.26C328.711 215.203 328.677 215.076 328.735 214.979C329.896 212.999 331.408 211.218 333.233 209.686C333.32 209.612 333.449 209.625 333.521 209.711C333.594 209.799 333.582 209.928 333.495 209.999C331.706 211.501 330.226 213.247 329.087 215.186C329.038 215.268 328.943 215.303 328.857 215.28L328.859 215.28Z",
    fill: "url(#paint416_linear_376_6503)"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M340.479 205.894C340.418 205.878 340.364 205.834 340.341 205.77C340.299 205.664 340.354 205.546 340.459 205.504C343.068 204.504 345.909 203.84 348.905 203.529C349.017 203.516 349.118 203.599 349.131 203.711C349.143 203.824 349.061 203.924 348.949 203.937C345.988 204.244 343.182 204.901 340.607 205.886C340.564 205.902 340.521 205.903 340.481 205.893L340.479 205.894Z",
    fill: "url(#paint417_linear_376_6503)"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M357.725 204.066C357.627 204.04 357.562 203.944 357.576 203.842C357.591 203.729 357.695 203.651 357.806 203.665C360.72 204.054 363.484 204.768 366.021 205.785C366.127 205.827 366.178 205.946 366.134 206.052C366.092 206.157 365.97 206.21 365.868 206.165C363.361 205.16 360.633 204.456 357.751 204.071C357.743 204.069 357.734 204.066 357.726 204.064L357.725 204.066Z",
    fill: "url(#paint418_linear_376_6503)"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M377.932 216.769C377.876 216.754 377.826 216.714 377.8 216.657C376.764 214.419 375.242 212.395 373.277 210.639C373.193 210.565 373.185 210.435 373.26 210.349C373.334 210.265 373.465 210.258 373.55 210.332C375.557 212.126 377.112 214.195 378.173 216.485C378.22 216.587 378.176 216.709 378.073 216.757C378.027 216.779 377.979 216.782 377.935 216.77L377.932 216.769Z",
    fill: "url(#paint419_linear_376_6503)"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M378.793 211.992C378.719 211.972 378.659 211.911 378.645 211.83C378.434 210.709 378.056 209.624 377.52 208.601C377.468 208.501 377.506 208.376 377.605 208.324C377.705 208.272 377.83 208.31 377.882 208.409C378.438 209.468 378.83 210.593 379.048 211.754C379.067 211.865 378.996 211.972 378.884 211.994C378.854 211.999 378.823 211.997 378.793 211.99L378.793 211.992Z",
    fill: "url(#paint420_linear_376_6503)"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M373.095 203.654C373.072 203.648 373.05 203.637 373.029 203.623C370.994 202.163 368.511 201.003 365.651 200.169C365.542 200.138 365.48 200.024 365.512 199.916C365.543 199.807 365.659 199.743 365.765 199.776C368.669 200.624 371.193 201.807 373.266 203.292C373.359 203.358 373.379 203.487 373.314 203.577C373.263 203.649 373.175 203.677 373.095 203.656L373.095 203.654Z",
    fill: "url(#paint421_linear_376_6503)"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M348.673 199.206C348.597 199.186 348.538 199.122 348.524 199.04C348.506 198.929 348.582 198.823 348.692 198.806C351.517 198.352 354.508 198.214 357.582 198.401C357.691 198.406 357.781 198.506 357.773 198.619C357.766 198.732 357.668 198.818 357.556 198.81C354.512 198.627 351.55 198.761 348.755 199.21C348.725 199.215 348.696 199.212 348.671 199.205L348.673 199.206Z",
    fill: "url(#paint422_linear_376_6503)"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M333.138 205.597C333.092 205.585 333.052 205.558 333.022 205.517C332.958 205.423 332.98 205.296 333.074 205.231C333.143 205.184 333.212 205.135 333.284 205.087C335.684 203.481 337.976 202.22 340.293 201.232C340.397 201.188 340.517 201.236 340.561 201.34C340.606 201.444 340.558 201.564 340.454 201.608C338.161 202.587 335.888 203.835 333.51 205.427C333.441 205.474 333.373 205.518 333.306 205.566C333.254 205.601 333.193 205.612 333.136 205.597L333.138 205.597Z",
    fill: "url(#paint423_linear_376_6503)"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M327.153 215.373C327.057 215.347 326.992 215.253 327.003 215.152C327.015 215.059 327.281 212.854 328.655 210.273C328.709 210.173 328.834 210.135 328.932 210.188C329.032 210.242 329.069 210.364 329.018 210.465C327.684 212.973 327.415 215.177 327.412 215.199C327.399 215.312 327.297 215.391 327.183 215.378C327.173 215.376 327.164 215.375 327.153 215.373Z",
    fill: "url(#paint424_linear_376_6503)"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M326.272 211.08C326.182 211.056 326.117 210.971 326.121 210.873C326.133 210.626 326.151 210.382 326.181 210.137C326.195 210.024 326.295 209.945 326.409 209.958C326.517 209.973 326.601 210.072 326.588 210.186C326.561 210.422 326.542 210.655 326.532 210.893C326.526 211.006 326.431 211.093 326.317 211.088C326.302 211.086 326.287 211.084 326.274 211.081L326.272 211.08Z",
    fill: "url(#paint425_linear_376_6503)"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M328.084 205.578C328.065 205.573 328.047 205.566 328.027 205.554C327.931 205.494 327.902 205.367 327.964 205.271C329.021 203.585 330.51 201.985 332.387 200.514C332.476 200.445 332.605 200.46 332.675 200.548C332.746 200.637 332.73 200.766 332.641 200.836C330.801 202.277 329.344 203.843 328.311 205.488C328.263 205.565 328.169 205.599 328.085 205.576L328.084 205.578Z",
    fill: "url(#paint426_linear_376_6503)"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M339.631 196.744C339.572 196.728 339.521 196.685 339.496 196.627C339.452 196.523 339.5 196.403 339.604 196.359C342.177 195.267 344.988 194.395 347.956 193.768C348.066 193.744 348.175 193.816 348.2 193.926C348.224 194.036 348.152 194.145 348.042 194.169C345.098 194.792 342.314 195.655 339.766 196.737C339.723 196.755 339.675 196.758 339.633 196.747L339.631 196.744Z",
    fill: "url(#paint427_linear_376_6503)"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M356.701 193.07C356.617 193.048 356.554 192.972 356.549 192.881C356.544 192.767 356.633 192.672 356.744 192.668C359.648 192.541 362.361 192.698 364.807 193.138C364.915 193.153 364.992 193.264 364.973 193.376C364.952 193.487 364.847 193.56 364.735 193.541C362.319 193.108 359.637 192.952 356.762 193.078C356.742 193.079 356.72 193.075 356.701 193.07Z",
    fill: "url(#paint428_linear_376_6503)"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M376.379 199.844C376.337 199.833 376.296 199.809 376.268 199.77C375.532 198.796 374.191 197.367 371.972 196.079C371.874 196.024 371.84 195.898 371.898 195.801C371.955 195.703 372.081 195.67 372.177 195.727C374.454 197.048 375.837 198.522 376.595 199.524C376.663 199.614 376.645 199.742 376.554 199.81C376.501 199.85 376.438 199.86 376.379 199.844Z",
    fill: "url(#paint429_linear_376_6503)"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M375.096 192.188C375.038 192.172 374.986 192.129 374.961 192.07C374.757 191.59 374.491 191.154 374.144 190.742C374.071 190.655 374.083 190.525 374.17 190.454C374.257 190.38 374.387 190.392 374.458 190.479C374.832 190.924 375.118 191.392 375.339 191.911C375.384 192.015 375.336 192.135 375.232 192.179C375.189 192.196 375.14 192.199 375.098 192.188L375.096 192.188Z",
    fill: "url(#paint430_linear_376_6503)"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M363.141 186.682C363.047 186.657 362.979 186.564 362.991 186.461C363.003 186.35 363.104 186.267 363.216 186.279C366.029 186.573 368.407 187.082 370.287 187.788C370.393 187.828 370.447 187.946 370.407 188.052C370.367 188.159 370.25 188.211 370.143 188.173C368.297 187.478 365.95 186.977 363.173 186.688C363.163 186.685 363.152 186.685 363.141 186.682Z",
    fill: "url(#paint431_linear_376_6503)"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M346.741 188.947C346.673 188.929 346.617 188.878 346.598 188.808C346.566 188.7 346.629 188.584 346.736 188.552C349.733 187.669 352.624 187.017 355.327 186.616C355.439 186.601 355.543 186.676 355.56 186.788C355.577 186.901 355.5 187.004 355.387 187.021C352.703 187.421 349.83 188.069 346.853 188.946C346.817 188.957 346.778 188.958 346.743 188.948L346.741 188.947Z",
    fill: "url(#paint432_linear_376_6503)"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M331.299 195.851C331.255 195.84 331.215 195.813 331.187 195.774C331.122 195.682 331.14 195.554 331.233 195.487C331.33 195.416 331.429 195.344 331.531 195.274C333.287 194.036 335.696 192.741 338.493 191.526C338.597 191.482 338.717 191.53 338.764 191.632C338.808 191.736 338.763 191.857 338.658 191.903C335.884 193.107 333.501 194.388 331.767 195.61C331.667 195.68 331.57 195.748 331.475 195.819C331.422 195.857 331.358 195.867 331.302 195.852L331.299 195.851Z",
    fill: "url(#paint433_linear_376_6503)"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M324.991 204.403C324.886 204.375 324.822 204.27 324.843 204.164C325.038 203.21 325.523 201.71 326.722 199.974C326.786 199.88 326.914 199.856 327.007 199.922C327.1 199.985 327.124 200.113 327.059 200.206C325.9 201.885 325.431 203.331 325.244 204.246C325.222 204.357 325.114 204.43 325.003 204.407C324.999 204.406 324.995 204.405 324.991 204.403Z",
    fill: "url(#paint434_linear_376_6503)"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M371.191 181.217C371.164 181.209 371.138 181.196 371.114 181.178C370.316 180.525 369.108 180.053 367.517 179.773C367.407 179.746 367.33 179.646 367.351 179.535C367.37 179.423 367.478 179.348 367.589 179.369C369.251 179.661 370.522 180.162 371.374 180.861C371.461 180.933 371.474 181.061 371.403 181.149C371.349 181.214 371.267 181.237 371.191 181.217Z",
    fill: "url(#paint435_linear_376_6503)"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M353.351 180.756C353.28 180.737 353.22 180.681 353.203 180.602C353.179 180.492 353.249 180.382 353.359 180.358C356.052 179.758 358.615 179.364 360.98 179.183C361.093 179.175 361.191 179.26 361.2 179.372C361.208 179.485 361.125 179.584 361.01 179.592C358.666 179.772 356.121 180.163 353.448 180.757C353.414 180.764 353.38 180.764 353.349 180.756L353.351 180.756Z",
    fill: "url(#paint436_linear_376_6503)"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M336.876 186.604C336.822 186.589 336.773 186.551 336.745 186.496C336.694 186.395 336.736 186.271 336.837 186.222C339.4 184.941 342.122 183.786 344.928 182.791C345.034 182.755 345.153 182.809 345.189 182.915C345.226 183.022 345.172 183.14 345.065 183.177C342.274 184.167 339.567 185.314 337.02 186.588C336.973 186.612 336.923 186.616 336.874 186.603L336.876 186.604Z",
    fill: "url(#paint437_linear_376_6503)"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M325.099 194.82C325.07 194.812 325.042 194.798 325.019 194.776C324.933 194.701 324.924 194.573 324.999 194.487C326.164 193.149 327.732 191.782 329.662 190.427C329.754 190.361 329.882 190.384 329.948 190.476C330.013 190.568 329.99 190.697 329.898 190.762C327.995 192.1 326.451 193.445 325.309 194.757C325.257 194.818 325.175 194.84 325.101 194.821L325.099 194.82Z",
    fill: "url(#paint438_linear_376_6503)"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M322.854 199.243C322.774 199.221 322.709 199.15 322.704 199.063C322.701 199.046 322.67 198.658 322.883 197.972C322.917 197.864 323.015 197.807 323.14 197.836C323.248 197.869 323.31 197.985 323.276 198.093C323.091 198.692 323.115 199.024 323.113 199.029C323.122 199.141 323.039 199.24 322.926 199.248C322.903 199.251 322.879 199.249 322.856 199.243L322.854 199.243Z",
    fill: "url(#paint439_linear_376_6503)"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M368.095 172.565C368.067 172.558 368.042 172.544 368.017 172.526C367.906 172.436 367.773 172.353 367.622 172.278C367.521 172.229 367.479 172.107 367.526 172.005C367.576 171.904 367.698 171.862 367.8 171.91C367.981 171.996 368.141 172.098 368.276 172.208C368.362 172.281 368.375 172.408 368.304 172.497C368.251 172.562 368.168 172.585 368.092 172.564L368.095 172.565Z",
    fill: "url(#paint440_linear_376_6503)"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M358.312 172.76C358.241 172.741 358.184 172.685 358.166 172.608C358.142 172.498 358.209 172.388 358.32 172.363C360.735 171.815 362.79 171.508 364.427 171.447C364.541 171.442 364.636 171.532 364.64 171.644C364.643 171.757 364.554 171.853 364.443 171.857C362.831 171.915 360.8 172.22 358.41 172.764C358.377 172.77 358.343 172.77 358.312 172.762L358.312 172.76Z",
    fill: "url(#paint441_linear_376_6503)"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M342.852 177.801C342.793 177.785 342.74 177.741 342.715 177.681C342.674 177.575 342.724 177.456 342.827 177.414C345.579 176.292 348.34 175.278 351.031 174.403C351.139 174.369 351.254 174.427 351.288 174.535C351.322 174.643 351.264 174.758 351.156 174.792C348.473 175.665 345.722 176.674 342.98 177.792C342.937 177.81 342.892 177.811 342.85 177.8L342.852 177.801Z",
    fill: "url(#paint442_linear_376_6503)"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M327.688 185.544C327.641 185.531 327.6 185.502 327.57 185.46C327.508 185.367 327.533 185.239 327.626 185.176C329.621 183.838 331.937 182.498 334.508 181.192L334.82 181.035C334.92 180.983 335.044 181.025 335.095 181.127C335.147 181.228 335.105 181.35 335.003 181.402L334.693 181.559C332.135 182.857 329.833 184.189 327.854 185.518C327.802 185.552 327.742 185.56 327.687 185.546L327.688 185.544Z",
    fill: "url(#paint443_linear_376_6503)"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M320.569 192.067C320.55 192.062 320.53 192.054 320.512 192.043C320.416 191.983 320.387 191.856 320.449 191.76C320.821 191.169 321.536 190.203 322.834 188.957C322.915 188.88 323.046 188.881 323.123 188.963C323.202 189.045 323.199 189.174 323.117 189.252C321.851 190.468 321.156 191.407 320.796 191.977C320.745 192.056 320.654 192.087 320.57 192.065L320.569 192.067Z",
    fill: "url(#paint444_linear_376_6503)"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M360.268 163.132C360.201 163.114 360.145 163.063 360.125 162.992C360.093 162.885 360.156 162.769 360.264 162.737C361.522 162.365 362.444 162.209 363.166 162.247C363.276 162.256 363.366 162.348 363.36 162.463C363.354 162.577 363.257 162.663 363.144 162.658C362.469 162.623 361.59 162.775 360.378 163.132C360.342 163.143 360.303 163.144 360.267 163.134L360.268 163.132Z",
    fill: "url(#paint445_linear_376_6503)"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M347.988 168.244C347.931 168.229 347.883 168.191 347.856 168.132C347.807 168.029 347.851 167.908 347.954 167.859C350.559 166.637 352.85 165.606 354.762 164.797C354.866 164.753 354.986 164.8 355.03 164.905C355.074 165.009 355.026 165.129 354.922 165.173C353.013 165.98 350.728 167.007 348.127 168.228C348.081 168.249 348.033 168.252 347.987 168.24L347.988 168.244Z",
    fill: "url(#paint446_linear_376_6503)"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M332.359 176.077C332.306 176.063 332.259 176.028 332.232 175.978C332.178 175.878 332.213 175.754 332.313 175.7C334.654 174.409 337.191 173.088 339.856 171.772L340.115 171.643C340.216 171.594 340.34 171.636 340.389 171.737C340.439 171.838 340.397 171.962 340.296 172.011L340.037 172.138C337.378 173.449 334.847 174.77 332.513 176.057C332.465 176.085 332.41 176.088 332.361 176.075L332.359 176.077Z",
    fill: "url(#paint447_linear_376_6503)"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M320.291 183.713C320.249 183.702 320.21 183.678 320.18 183.639C320.112 183.548 320.128 183.42 320.219 183.352C321.646 182.267 323.313 181.113 325.171 179.923C325.269 179.861 325.394 179.89 325.454 179.985C325.514 180.08 325.487 180.207 325.392 180.268C323.542 181.451 321.886 182.599 320.467 183.677C320.413 183.717 320.35 183.727 320.289 183.711L320.291 183.713Z",
    fill: "url(#paint448_linear_376_6503)"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M317.173 186.371C317.141 186.362 317.113 186.348 317.088 186.323C317.005 186.247 317 186.117 317.076 186.034C317.076 186.034 317.225 185.872 317.562 185.557C317.646 185.478 317.775 185.485 317.852 185.567C317.928 185.65 317.925 185.78 317.842 185.857C317.524 186.152 317.383 186.308 317.378 186.311C317.324 186.369 317.244 186.39 317.173 186.371Z",
    fill: "url(#paint449_linear_376_6503)"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M297.014 173.411C297.002 173.408 296.991 173.405 296.979 173.399C296.855 173.341 296.73 173.285 296.603 173.231C296.498 173.187 296.449 173.066 296.495 172.963C296.539 172.858 296.658 172.809 296.762 172.855C296.896 172.911 297.027 172.969 297.155 173.03C297.257 173.078 297.3 173.2 297.253 173.302C297.21 173.394 297.108 173.438 297.014 173.413L297.014 173.411Z",
    fill: "url(#paint450_linear_376_6503)"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M286.74 172.97C286.668 172.951 286.608 172.892 286.593 172.813C286.571 172.702 286.642 172.595 286.752 172.572C289.214 172.069 291.263 171.881 293.016 171.995C293.129 172.001 293.215 172.1 293.207 172.213C293.199 172.326 293.102 172.412 292.989 172.405C291.275 172.292 289.262 172.478 286.835 172.975C286.802 172.982 286.771 172.98 286.741 172.973L286.74 172.97Z",
    fill: "url(#paint451_linear_376_6503)"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M271.144 177.988C271.083 177.972 271.031 177.929 271.005 177.865C270.964 177.76 271.016 177.641 271.122 177.599C274.12 176.422 276.864 175.424 279.273 174.631C279.38 174.594 279.497 174.653 279.531 174.761C279.568 174.868 279.507 174.984 279.401 175.019C276.999 175.809 274.265 176.805 271.272 177.98C271.229 177.995 271.186 177.997 271.144 177.986L271.144 177.988Z",
    fill: "url(#paint452_linear_376_6503)"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M255.94 185.883C255.896 185.871 255.856 185.844 255.826 185.803C255.761 185.711 255.781 185.583 255.874 185.516C257.952 184.033 260.364 182.584 263.041 181.213C263.14 181.162 263.265 181.2 263.317 181.302C263.369 181.402 263.329 181.526 263.227 181.577C260.568 182.94 258.173 184.378 256.111 185.85C256.058 185.885 255.995 185.895 255.938 185.88L255.94 185.883Z",
    fill: "url(#paint453_linear_376_6503)"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M249.187 192.426C249.168 192.421 249.15 192.414 249.133 192.403C249.036 192.343 249.007 192.216 249.067 192.119C249.426 191.543 250.102 190.598 251.279 189.39C251.36 189.308 251.488 189.306 251.568 189.386C251.649 189.464 251.652 189.595 251.572 189.675C250.42 190.859 249.762 191.775 249.414 192.336C249.365 192.416 249.271 192.449 249.187 192.426Z",
    fill: "url(#paint454_linear_376_6503)"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M413.263 232.891C413.263 232.891 413.268 232.887 413.274 232.884C417.9 229.555 421.65 225.441 424.569 220.685C424.577 220.674 424.584 220.665 424.591 220.653C426.572 217.42 428.166 213.897 429.384 210.126C430.291 207.319 430.993 204.372 431.495 201.305L431.492 201.3C431.551 200.987 431.597 200.673 431.645 200.353C431.644 200.339 431.651 200.33 431.65 200.316C432.536 194.287 432.654 187.815 432.019 181.045C431.439 174.677 430.196 168.039 428.322 161.266C426.554 154.825 424.214 148.26 421.331 141.664C418.86 136 415.986 130.318 412.728 124.678C409.47 119.035 405.986 113.705 402.316 108.728C398.048 102.939 393.533 97.63 388.847 92.8809C383.91 87.8687 378.788 83.4709 373.562 79.7791C368.023 75.8548 362.366 72.7228 356.709 70.4779C356.709 70.4779 356.704 70.4766 356.695 70.4739C356.382 70.3474 356.072 70.2261 355.754 70.1116L355.751 70.1063C352.843 69.0031 349.932 68.1329 347.041 67.5205L347.033 67.5182C343.145 66.6881 339.287 66.3115 335.491 66.4132C329.922 66.5664 324.484 67.7565 319.29 70.0947C319.29 70.0947 319.287 70.0968 319.28 70.1009C317.969 70.6906 316.673 71.3518 315.395 72.0898C314.82 72.4219 314.265 72.7617 313.717 73.1122C310.72 75.0216 308.057 77.2389 305.72 79.7259C305.208 80.2685 304.714 80.8203 304.237 81.3882C301.638 84.4599 299.486 87.9057 297.771 91.6579C297.655 91.8922 297.549 92.1251 297.46 92.3509C296.907 93.6074 296.401 94.899 295.946 96.2199C295.946 96.2199 295.945 96.2248 295.942 96.2346C295.518 97.4717 295.128 98.7335 294.787 100.022C294.777 100.062 294.768 100.08 294.768 100.08C293.046 106.565 292.352 113.708 292.646 121.287C292.647 121.301 292.645 121.307 292.643 121.316C292.69 122.434 292.755 123.561 292.838 124.697C292.84 124.722 292.84 124.747 292.845 124.78C292.933 125.995 293.05 127.223 293.196 128.458L293.194 128.466C294.057 135.991 295.81 143.857 298.408 151.876C300.647 158.785 303.517 165.807 306.99 172.815C308.617 176.108 310.378 179.4 312.27 182.674C314.161 185.947 316.13 189.117 318.166 192.17C322.502 198.687 327.148 204.684 332.013 210.077C338.494 217.266 345.353 223.383 352.385 228.229C352.409 228.249 352.438 228.264 352.462 228.284C353.501 229.001 354.543 229.685 355.59 230.347C355.59 230.347 355.594 230.349 355.602 230.354C362.024 234.4 368.563 237.377 375.043 239.125C375.043 239.125 375.063 239.125 375.103 239.136C376.375 239.481 377.649 239.775 378.917 240.023C380.311 240.291 381.7 240.508 383.088 240.663C383.334 240.686 383.582 240.71 383.827 240.735C383.827 240.735 383.832 240.735 383.841 240.735C387.948 241.126 392.008 240.985 395.968 240.27C396.686 240.143 397.406 239.993 398.122 239.825C402.061 238.902 405.906 237.386 409.602 235.255C410.88 234.517 412.101 233.725 413.267 232.885L413.263 232.891ZM375.262 180.124C372.792 177.783 369.566 174.4 366.041 169.872C363.222 166.246 360.208 161.878 357.23 156.72C354.251 151.561 351.979 146.77 350.245 142.513C348.083 137.191 346.769 132.71 345.974 129.395C345.013 125.37 344.814 123.063 344.814 123.063C344.814 123.063 345.138 123.29 345.73 123.752C346.28 124.185 347.066 124.832 348.045 125.698C352.304 129.477 360.151 137.466 367.758 150.643C368.71 152.291 369.589 153.906 370.406 155.471C376.084 166.438 378.502 175.306 379.501 180.182C379.761 181.463 379.927 182.466 380.029 183.159C380.133 183.905 380.168 184.297 380.168 184.297C380.168 184.297 378.27 182.97 375.264 180.127L375.262 180.124Z",
    fill: "#27E6D6"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M375.212 239.418C369.945 238.007 364.557 235.759 359.093 232.679C341.699 222.872 325.007 205.15 312.089 182.776C299.171 160.402 292.172 137.086 292.374 117.118C292.588 96.0747 300.513 80.4425 315.29 71.9112C330.066 63.3799 347.567 64.3325 365.898 74.6692C383.293 84.4758 399.985 102.198 412.902 124.572C425.819 146.943 432.82 170.262 432.617 190.23C432.403 211.274 424.478 226.906 409.701 235.437C399.329 241.425 387.612 242.74 375.212 239.418ZM349.681 68.3316C337.382 65.0362 325.772 66.3372 315.496 72.2681C300.852 80.7225 292.998 96.234 292.784 117.125C292.581 137.02 299.564 160.262 312.443 182.572C325.324 204.882 341.963 222.549 359.293 232.321C377.491 242.581 394.851 243.537 409.495 235.08C424.139 226.624 431.994 211.114 432.207 190.224C432.41 170.328 425.427 147.086 412.548 124.776C399.667 102.466 383.028 84.7989 365.698 75.0276C360.268 71.9654 354.912 69.7334 349.681 68.3316Z",
    fill: "url(#paint455_linear_376_6503)"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M380.116 184.491C380.093 184.485 380.071 184.474 380.052 184.46C379.934 184.379 368.155 176.052 357.05 156.818C345.945 137.584 344.626 123.22 344.612 123.077C344.606 122.999 344.645 122.921 344.714 122.881C344.783 122.841 344.868 122.846 344.934 122.891C345.052 122.972 356.831 131.298 367.936 150.533C379.041 169.767 380.361 184.131 380.374 184.274C380.38 184.352 380.341 184.43 380.272 184.47C380.224 184.497 380.168 184.505 380.116 184.491ZM345.072 123.504C345.394 126.1 347.459 139.387 357.404 156.616C367.353 173.847 377.826 182.275 379.913 183.851C379.592 181.255 377.529 167.969 367.581 150.739C357.634 133.512 347.159 125.081 345.072 123.504Z",
    fill: "url(#paint456_linear_376_6503)"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M391.863 190.655C388.171 189.665 384.208 187.613 380.117 184.525L380.029 184.443C379.946 184.364 379.943 184.235 380.021 184.152C380.099 184.07 380.229 184.066 380.311 184.145L380.383 184.213C389.269 190.921 397.531 192.682 403.629 189.161C415.937 182.055 410.941 154.312 398.555 132.86C386.169 111.407 364.639 93.2083 352.333 100.315C346.24 103.833 343.634 111.864 344.998 122.926L345.021 123.02C345.045 123.13 344.975 123.239 344.865 123.264C344.755 123.288 344.645 123.218 344.621 123.108L344.597 122.996C343.21 111.741 345.886 103.569 352.131 99.9614C358.016 96.5636 366.382 98.5419 375.692 105.532C384.174 111.899 392.637 121.786 398.912 132.654C405.188 143.524 409.517 155.795 410.79 166.324C412.189 177.881 409.718 186.118 403.834 189.513C400.412 191.489 396.337 191.851 391.866 190.653L391.863 190.655Z",
    fill: "url(#paint457_linear_376_6503)"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M387.982 189.275C387.887 189.25 387.822 189.158 387.831 189.057C387.843 188.945 387.942 188.861 388.054 188.873C390.824 189.143 393.352 188.632 395.567 187.352C406.515 181.032 402.054 156.321 391.021 137.207C379.985 118.092 360.815 101.874 349.867 108.197C347.651 109.476 345.945 111.409 344.793 113.941C344.746 114.043 344.621 114.091 344.523 114.042C344.421 113.997 344.375 113.874 344.422 113.772C345.609 111.159 347.373 109.162 349.663 107.84C354.911 104.81 362.375 106.576 370.678 112.814C378.239 118.493 385.783 127.308 391.378 137.001C396.972 146.691 400.836 157.633 401.974 167.021C403.225 177.33 401.023 184.677 395.774 187.707C393.484 189.029 390.875 189.559 388.017 189.28C388.006 189.277 387.995 189.276 387.982 189.273L387.982 189.275Z",
    fill: "url(#paint458_linear_376_6503)"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M387.119 188.87C387.064 188.855 387.016 188.818 386.989 188.766C386.938 188.664 386.979 188.542 387.079 188.49C387.258 188.399 387.437 188.303 387.613 188.201C397.801 182.319 393.667 159.356 383.416 141.6C373.162 123.843 355.343 108.781 345.157 114.662C344.981 114.764 344.809 114.87 344.64 114.98C344.545 115.04 344.418 115.016 344.356 114.92C344.294 114.825 344.321 114.699 344.416 114.637C344.591 114.524 344.769 114.412 344.953 114.308C349.844 111.484 356.796 113.121 364.523 118.919C371.555 124.196 378.571 132.387 383.772 141.396C388.973 150.405 392.559 160.577 393.613 169.305C394.771 178.896 392.714 185.732 387.822 188.557C387.64 188.663 387.454 188.762 387.269 188.856C387.222 188.88 387.171 188.884 387.123 188.871L387.119 188.87Z",
    fill: "url(#paint459_linear_376_6503)"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M384.862 187.674C384.862 187.674 384.841 187.668 384.831 187.663C384.729 187.618 384.683 187.495 384.728 187.393C388.67 178.596 385.101 161.077 376.244 145.736C367.386 130.395 353.998 118.54 344.41 117.56C344.3 117.544 344.215 117.447 344.227 117.335C344.239 117.224 344.34 117.14 344.452 117.152C354.154 118.149 367.679 130.084 376.598 145.532C385.515 160.977 389.091 178.653 385.102 187.56C385.059 187.653 384.959 187.7 384.862 187.674Z",
    fill: "url(#paint460_linear_376_6503)"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M381.93 185.817C381.834 185.791 381.769 185.697 381.78 185.596C382.825 176.447 378.52 161.63 371.07 148.725C363.619 135.821 352.938 124.684 344.494 121.015C344.391 120.969 344.342 120.848 344.388 120.746C344.433 120.643 344.554 120.594 344.657 120.64C353.176 124.341 363.934 135.545 371.426 148.522C378.916 161.495 383.243 176.415 382.188 185.645C382.175 185.759 382.073 185.839 381.962 185.825C381.951 185.822 381.94 185.822 381.932 185.819L381.93 185.817Z",
    fill: "url(#paint461_linear_376_6503)"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M379.977 183.353C379.895 183.331 379.833 183.26 379.826 183.17C379.125 174.226 374.651 161.673 368.149 150.41C361.647 139.148 353.014 128.997 345.616 123.917C345.523 123.854 345.498 123.726 345.564 123.633C345.629 123.54 345.755 123.518 345.848 123.581C353.291 128.693 361.972 138.895 368.503 150.207C375.034 161.519 379.529 174.139 380.235 183.14C380.243 183.253 380.16 183.352 380.047 183.36C380.024 183.363 380 183.359 379.979 183.353L379.977 183.353Z",
    fill: "url(#paint462_linear_376_6503)"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M397.395 195.588C383.643 191.903 367.629 175.614 356.845 156.936C342.258 131.67 336.244 100.301 351.423 91.5353C358.235 87.6004 367.896 89.8356 378.623 97.8287C388.403 105.115 398.144 116.453 405.349 128.931C412.553 141.41 417.501 155.514 418.921 167.627C420.48 180.913 417.585 190.398 410.771 194.332C406.811 196.618 402.242 196.886 397.392 195.587L397.395 195.588ZM364.314 90.8207C359.465 89.5213 355.152 89.858 351.629 91.8921C336.671 100.528 342.716 131.642 357.202 156.732C364.717 169.749 374.544 181.26 384.165 188.315C394.452 195.857 403.829 197.87 410.569 193.979C424.863 185.725 419.228 153.789 404.996 129.138C397.818 116.705 388.116 105.414 378.379 98.1595C373.388 94.4406 368.639 91.9794 364.314 90.8207Z",
    fill: "url(#paint463_linear_376_6503)"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M384.807 238.646C363.269 232.875 339.221 210.6 320.39 177.985C297.545 138.416 291.721 99.8019 305.548 79.6082C305.612 79.5149 305.74 79.4907 305.833 79.554C305.926 79.6172 305.95 79.7453 305.887 79.8386C292.149 99.903 297.98 138.348 320.745 177.778C343.512 217.211 373.888 241.483 398.134 239.615C398.247 239.607 398.346 239.69 398.354 239.804C398.362 239.917 398.279 240.016 398.164 240.024C393.875 240.353 389.396 239.874 384.805 238.643L384.807 238.646Z",
    fill: "url(#paint464_linear_376_6503)"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M378.924 240.236L378.922 240.236C356.985 234.051 333.213 211.871 315.334 180.903C297.455 149.936 290.132 118.259 295.745 96.1679C295.774 96.0587 295.884 95.9915 295.994 96.0186L295.996 96.0192C296.105 96.0485 296.171 96.1582 296.141 96.2674C290.553 118.257 297.862 149.82 315.688 180.697C333.515 211.574 357.195 233.685 379.033 239.84C379.142 239.869 379.206 239.983 379.174 240.094C379.145 240.203 379.032 240.265 378.924 240.236Z",
    fill: "url(#paint465_linear_376_6503)"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M352.41 228.486C352.387 228.48 352.365 228.47 352.344 228.455C337.573 217.888 323.816 201.997 312.562 182.505C301.216 162.852 294.321 142.841 292.624 124.633C292.614 124.52 292.697 124.421 292.81 124.411C292.923 124.401 293.023 124.483 293.033 124.597C294.725 142.745 301.601 162.699 312.918 182.301C324.143 201.743 337.86 217.589 352.584 228.123C352.677 228.188 352.696 228.317 352.631 228.408C352.58 228.48 352.492 228.508 352.412 228.487L352.41 228.486Z",
    fill: "url(#paint466_linear_376_6503)"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M401.252 203.176C385.343 198.913 366.801 180.041 354.309 158.404C337.421 129.155 330.435 92.8448 347.978 82.7161C355.914 78.1345 366.972 80.5394 379.114 89.4876C390.331 97.7516 401.718 111.076 410.359 126.042C418.999 141.008 424.845 157.534 426.393 171.378C428.071 186.369 424.625 197.147 416.69 201.728C412.123 204.365 406.849 204.674 401.25 203.174L401.252 203.176ZM363.234 81.7549C357.517 80.2231 352.396 80.638 348.183 83.0703C330.863 93.0698 337.876 129.121 354.663 158.198C363.37 173.278 374.754 186.617 385.895 194.796C397.815 203.545 408.68 205.88 416.488 201.375C424.274 196.879 427.649 186.243 425.989 171.425C424.446 157.634 418.619 141.167 410.007 126.247C401.392 111.327 390.046 98.049 378.872 89.8169C373.363 85.7565 368.086 83.0549 363.236 81.7555L363.234 81.7549Z",
    fill: "url(#paint467_linear_376_6503)"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M391.885 235.086C369.994 229.221 344.596 203.449 327.52 173.869C304.369 133.771 294.923 83.926 319.185 69.9184C319.283 69.8615 319.407 69.8947 319.464 69.9932C319.521 70.0917 319.488 70.2156 319.389 70.2725C295.351 84.1511 304.826 133.74 327.875 173.663C350.924 213.585 389.132 246.587 413.17 232.709C413.269 232.652 413.392 232.685 413.449 232.783C413.506 232.882 413.473 233.006 413.374 233.063C407.01 236.737 399.669 237.17 391.883 235.084L391.885 235.086Z",
    fill: "url(#paint468_linear_376_6503)"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M402.665 212.028C397.051 210.523 390.939 207.384 384.553 202.661C371.801 193.228 358.918 178.169 349.207 161.35C339.496 144.531 332.9 125.845 331.104 110.084C329.155 92.968 333.022 80.6894 341.988 75.5129C350.975 70.324 363.506 73.0537 377.273 83.2049C389.994 92.5854 402.911 107.702 412.715 124.684C422.52 141.665 429.153 160.41 430.916 176.118C432.822 193.114 428.922 205.332 419.935 210.521C415.102 213.312 409.225 213.788 402.664 212.03L402.665 212.028ZM359.27 74.3722C352.785 72.6344 346.973 73.1052 342.193 75.8649C333.376 80.9554 329.581 93.0912 331.51 110.036C333.298 125.743 339.877 144.372 349.562 161.144C359.245 177.915 372.089 192.927 384.797 202.331C398.507 212.473 410.914 215.255 419.731 210.165C428.569 205.062 432.397 192.985 430.51 176.162C428.754 160.511 422.141 141.82 412.364 124.887C402.587 107.953 389.71 92.8807 377.032 83.5321C370.775 78.9179 364.779 75.8483 359.272 74.3727L359.27 74.3722Z",
    fill: "url(#paint469_linear_376_6503)"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M397.644 228.686C391.085 226.928 383.949 223.269 376.492 217.762C361.567 206.737 346.495 189.137 335.138 169.47C323.784 149.804 316.076 127.948 313.994 109.511C311.732 89.4969 316.268 75.1379 326.766 69.0773C329.431 67.5383 332.38 66.5726 335.53 66.2079C335.642 66.1929 335.744 66.2743 335.756 66.3879C335.769 66.4994 335.69 66.6019 335.576 66.6143C332.482 66.9736 329.585 67.9217 326.968 69.4309C304.216 82.5668 313.676 131.479 335.491 169.263C346.819 188.884 361.849 206.439 376.732 217.43C392.795 229.293 407.339 232.535 417.687 226.56C420.296 225.054 422.562 223.025 424.422 220.529C424.489 220.437 424.617 220.422 424.708 220.487C424.798 220.553 424.817 220.682 424.75 220.773C422.858 223.313 420.552 225.379 417.893 226.915C412.227 230.187 405.333 230.746 397.642 228.685L397.644 228.686Z",
    fill: "url(#paint470_linear_376_6503)"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M401.209 220.691C395.057 219.042 388.361 215.605 381.365 210.43C367.383 200.091 353.259 183.588 342.616 165.153C331.972 146.717 324.742 126.234 322.779 108.956C320.647 90.1974 324.888 76.7405 334.719 71.0664C340.831 67.5358 348.251 67.273 356.774 70.286C356.88 70.3237 356.937 70.4401 356.899 70.5471C356.862 70.6541 356.745 70.7127 356.638 70.673C348.234 67.7052 340.93 67.9562 334.925 71.4232C325.245 77.0118 321.076 90.3259 323.189 108.911C325.147 126.136 332.358 146.562 342.974 164.95C353.59 183.337 367.674 199.795 381.612 210.103C396.654 221.224 410.266 224.272 419.948 218.684C425.942 215.223 429.812 209.03 431.451 200.276C431.472 200.165 431.579 200.092 431.69 200.113C431.798 200.131 431.874 200.241 431.853 200.353C430.193 209.229 426.258 215.515 420.154 219.041C414.854 222.101 408.408 222.622 401.214 220.694L401.209 220.691Z",
    fill: "url(#paint471_linear_376_6503)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_376_6503",
    x1: 35.7493,
    y1: 207.596,
    x2: 175.948,
    y2: 264.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_376_6503",
    x1: 78.0863,
    y1: 275.186,
    x2: 122.515,
    y2: 293.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_376_6503",
    x1: 55.514,
    y1: 299.47,
    x2: 88.2322,
    y2: 312.793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_376_6503",
    x1: 49.5941,
    y1: 291.722,
    x2: 83.8618,
    y2: 306.284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_376_6503",
    x1: 43.8557,
    y1: 283.836,
    x2: 79.9249,
    y2: 300.159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_376_6503",
    x1: 39.5925,
    y1: 275.379,
    x2: 76.9167,
    y2: 293.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_376_6503",
    x1: 36.0319,
    y1: 266.675,
    x2: 74.8574,
    y2: 286.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_376_6503",
    x1: 32.666,
    y1: 257.652,
    x2: 72.3132,
    y2: 279.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_376_6503",
    x1: 32.2697,
    y1: 249.322,
    x2: 73.2301,
    y2: 272.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_376_6503",
    x1: 81.36,
    y1: 247.285,
    x2: 152.856,
    y2: 276.399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_376_6503",
    x1: 79.7586,
    y1: 255.822,
    x2: 143.332,
    y2: 281.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_376_6503",
    x1: 78.2099,
    y1: 263.371,
    x2: 134.861,
    y2: 286.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_376_6503",
    x1: 77.4808,
    y1: 269.231,
    x2: 128.471,
    y2: 289.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_376_6503",
    x1: 77.7372,
    y1: 272.926,
    x2: 124.728,
    y2: 292.062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_376_6503",
    x1: 79.0522,
    y1: 275.894,
    x2: 122.166,
    y2: 293.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_376_6503",
    x1: 79.9771,
    y1: 238.017,
    x2: 161.947,
    y2: 271.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_376_6503",
    x1: 33.9546,
    y1: 230.504,
    x2: 151.394,
    y2: 278.327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_376_6503",
    x1: 26.777,
    y1: 247.692,
    x2: 130.64,
    y2: 289.987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_376_6503",
    x1: 24.8533,
    y1: 276.409,
    x2: 99.6533,
    y2: 306.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_376_6503",
    x1: 75.527,
    y1: 228.052,
    x2: 170.54,
    y2: 266.743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_376_6503",
    x1: 42.1706,
    y1: 219.44,
    x2: 166.188,
    y2: 269.942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_376_6503",
    x1: 68.6374,
    y1: 219.884,
    x2: 176.291,
    y2: 263.723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_376_6503",
    x1: 51.5102,
    y1: 213.9,
    x2: 175.677,
    y2: 264.462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_376_6503",
    x1: 60.5436,
    y1: 214.587,
    x2: 178.574,
    y2: 262.651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_376_6503",
    x1: 31.6691,
    y1: 241.46,
    x2: 71.7159,
    y2: 266.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_376_6503",
    x1: 32.8633,
    y1: 233.944,
    x2: 72.2227,
    y2: 260.188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_376_6503",
    x1: 35.2519,
    y1: 227.365,
    x2: 77.6582,
    y2: 250.507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_376_6503",
    x1: 40.438,
    y1: 222.733,
    x2: 82.198,
    y2: 242.765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_376_6503",
    x1: 48.782,
    y1: 219.467,
    x2: 86.9934,
    y2: 235.799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_376_6503",
    x1: 60.2409,
    y1: 218.429,
    x2: 92.1103,
    y2: 230.603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_376_6503",
    x1: 69.4964,
    y1: 218.273,
    x2: 96.7335,
    y2: 227.988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_376_6503",
    x1: 81.3099,
    y1: 219.917,
    x2: 101.61,
    y2: 226.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_376_6503",
    x1: 90.1975,
    y1: 222.548,
    x2: 106.37,
    y2: 227.634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_376_6503",
    x1: 92.0078,
    y1: 225.13,
    x2: 110.319,
    y2: 231.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_376_6503",
    x1: 91.6392,
    y1: 227.818,
    x2: 114.38,
    y2: 235.489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_376_6503",
    x1: 94.2179,
    y1: 232.986,
    x2: 118.964,
    y2: 241.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_376_6503",
    x1: 97.9781,
    y1: 238.521,
    x2: 123.985,
    y2: 247.749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_376_6503",
    x1: 101.637,
    y1: 245.565,
    x2: 129.314,
    y2: 255.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_376_6503",
    x1: 111.008,
    y1: 267.426,
    x2: 143.73,
    y2: 280.751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_376_6503",
    x1: 105.464,
    y1: 252.789,
    x2: 134.463,
    y2: 263.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_376_6503",
    x1: 108.562,
    y1: 260.262,
    x2: 139.466,
    y2: 272.337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_376_6503",
    x1: 62.0269,
    y1: 306.977,
    x2: 93.0245,
    y2: 319.114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_376_6503",
    x1: 69.7169,
    y1: 314.067,
    x2: 98.2548,
    y2: 324.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_376_6503",
    x1: 77.2169,
    y1: 320.526,
    x2: 104.272,
    y2: 330.341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_376_6503",
    x1: 85.22,
    y1: 326.003,
    x2: 110.935,
    y2: 335.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_376_6503",
    x1: 96.4312,
    y1: 331.861,
    x2: 118.374,
    y2: 339.226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_376_6503",
    x1: 102.627,
    y1: 334.62,
    x2: 125.649,
    y2: 342.379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_376_6503",
    x1: 113.477,
    y1: 339.126,
    x2: 132.903,
    y2: 345.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_376_6503",
    x1: 122.786,
    y1: 341.655,
    x2: 140.426,
    y2: 347.274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_376_6503",
    x1: 122.064,
    y1: 341.094,
    x2: 146.405,
    y2: 349.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_376_6503",
    x1: 121.906,
    y1: 340.001,
    x2: 151.473,
    y2: 350.648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_376_6503",
    x1: 121.923,
    y1: 338.295,
    x2: 156.048,
    y2: 351.591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_376_6503",
    x1: 121.409,
    y1: 335.575,
    x2: 159.097,
    y2: 352.091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_376_6503",
    x1: 121.174,
    y1: 332.223,
    x2: 160.818,
    y2: 351.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_376_6503",
    x1: 120.68,
    y1: 328.357,
    x2: 160.218,
    y2: 351.776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_376_6503",
    x1: 119.641,
    y1: 323.45,
    x2: 157.707,
    y2: 350.254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_376_6503",
    x1: 119.916,
    y1: 318.454,
    x2: 158.999,
    y2: 343.452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_376_6503",
    x1: 119.996,
    y1: 312.768,
    x2: 160.324,
    y2: 335.051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_376_6503",
    x1: 119.636,
    y1: 306.213,
    x2: 159.055,
    y2: 326.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_376_6503",
    x1: 118.745,
    y1: 299.151,
    x2: 157.284,
    y2: 318.146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_376_6503",
    x1: 117.388,
    y1: 291.105,
    x2: 154.456,
    y2: 308.385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_376_6503",
    x1: 115.337,
    y1: 283.07,
    x2: 151.16,
    y2: 299.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_376_6503",
    x1: 113.174,
    y1: 274.866,
    x2: 147.525,
    y2: 289.499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_376_6503",
    x1: 88.9331,
    y1: 176.896,
    x2: 229.128,
    y2: 233.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_376_6503",
    x1: 131.275,
    y1: 244.502,
    x2: 175.702,
    y2: 262.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_376_6503",
    x1: 161.619,
    y1: 229.93,
    x2: 192.871,
    y2: 242.232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_376_6503",
    x1: 155.099,
    y1: 215.742,
    x2: 183.233,
    y2: 226.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_376_6503",
    x1: 148.674,
    y1: 204.126,
    x2: 174.285,
    y2: 213.114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_376_6503",
    x1: 85.9668,
    y1: 203.239,
    x2: 130.777,
    y2: 227.599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_376_6503",
    x1: 145.064,
    y1: 195.87,
    x2: 166.303,
    y2: 202.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_376_6503",
    x1: 142.534,
    y1: 191.538,
    x2: 159.281,
    y2: 196.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_376_6503",
    x1: 125.854,
    y1: 187.963,
    x2: 151.014,
    y2: 196.727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_376_6503",
    x1: 105.992,
    y1: 187.868,
    x2: 142.425,
    y2: 202.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_376_6503",
    x1: 91.4393,
    y1: 192.848,
    x2: 134.009,
    y2: 214.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_376_6503",
    x1: 85.2147,
    y1: 216.649,
    x2: 126.345,
    y2: 239.624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_376_6503",
    x1: 87.6738,
    y1: 231.27,
    x2: 127.09,
    y2: 251.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_376_6503",
    x1: 93.5373,
    y1: 246.383,
    x2: 130.832,
    y2: 263.776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_376_6503",
    x1: 102.544,
    y1: 260.994,
    x2: 137.022,
    y2: 275.731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_376_6503",
    x1: 113.822,
    y1: 274.601,
    x2: 145.114,
    y2: 286.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_376_6503",
    x1: 126.676,
    y1: 286.747,
    x2: 154.836,
    y2: 297.128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_376_6503",
    x1: 140.62,
    y1: 296.766,
    x2: 166.14,
    y2: 305.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_376_6503",
    x1: 155.723,
    y1: 303.822,
    x2: 178.866,
    y2: 311.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_376_6503",
    x1: 171.641,
    y1: 309.386,
    x2: 191.702,
    y2: 315.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_376_6503",
    x1: 176.171,
    y1: 310.218,
    x2: 202.315,
    y2: 319.259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_376_6503",
    x1: 175.512,
    y1: 307.094,
    x2: 210.174,
    y2: 320.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_376_6503",
    x1: 174.587,
    y1: 301.771,
    x2: 214.113,
    y2: 321.152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_376_6503",
    x1: 173.599,
    y1: 294.551,
    x2: 211.57,
    y2: 320.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_376_6503",
    x1: 173.074,
    y1: 285.509,
    x2: 212.95,
    y2: 309.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_376_6503",
    x1: 172.662,
    y1: 274.384,
    x2: 212.211,
    y2: 294.526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_376_6503",
    x1: 170.833,
    y1: 261.366,
    x2: 208.213,
    y2: 278.845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_376_6503",
    x1: 167.135,
    y1: 245.97,
    x2: 201.591,
    y2: 260.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_376_6503",
    x1: 166.472,
    y1: 305.695,
    x2: 197.342,
    y2: 338.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_376_6503",
    x1: 126.492,
    y1: 187.325,
    x2: 181.74,
    y2: 207.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_376_6503",
    x1: 92.6954,
    y1: 185.417,
    x2: 159.886,
    y2: 213.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_376_6503",
    x1: 102.109,
    y1: 202.722,
    x2: 143.79,
    y2: 216.795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_376_6503",
    x1: 118.332,
    y1: 224.969,
    x2: 140.115,
    y2: 231.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_376_6503",
    x1: 132.407,
    y1: 247.934,
    x2: 162.326,
    y2: 257.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_376_6503",
    x1: 141.069,
    y1: 272.944,
    x2: 180.084,
    y2: 286.287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_376_6503",
    x1: 155.699,
    y1: 295.068,
    x2: 196.535,
    y2: 310.565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_376_6503",
    x1: 168.072,
    y1: 306.697,
    x2: 208.404,
    y2: 325.779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_376_6503",
    x1: 179.324,
    y1: 294.473,
    x2: 211.499,
    y2: 314.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_376_6503",
    x1: 189.097,
    y1: 238.526,
    x2: 206.439,
    y2: 243.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_376_6503",
    x1: 172.367,
    y1: 210.784,
    x2: 194.39,
    y2: 217.451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_376_6503",
    x1: 184.841,
    y1: 266.814,
    x2: 213.278,
    y2: 277.248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_376_6503",
    x1: 150.356,
    y1: 267.022,
    x2: 218.24,
    y2: 293.427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_376_6503",
    x1: 127.529,
    y1: 281.911,
    x2: 198.533,
    y2: 315.007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_376_6503",
    x1: 94.1617,
    y1: 285.639,
    x2: 162.082,
    y2: 338.174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_376_6503",
    x1: 79.8065,
    y1: 260.824,
    x2: 146.588,
    y2: 315.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_376_6503",
    x1: 77.9631,
    y1: 232.049,
    x2: 148.069,
    y2: 273.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_376_6503",
    x1: 85.5129,
    y1: 209.195,
    x2: 142.568,
    y2: 236.622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_376_6503",
    x1: 103.15,
    y1: 193.022,
    x2: 140.617,
    y2: 207.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_376_6503",
    x1: 126.223,
    y1: 188.178,
    x2: 143.633,
    y2: 193.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_376_6503",
    x1: 144.886,
    y1: 193.19,
    x2: 149.7,
    y2: 194.561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_376_6503",
    x1: 141.231,
    y1: 201.524,
    x2: 169.849,
    y2: 212.673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_376_6503",
    x1: 136.977,
    y1: 215.778,
    x2: 183.763,
    y2: 244.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_376_6503",
    x1: 132.505,
    y1: 232.974,
    x2: 180.385,
    y2: 283.509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_376_6503",
    x1: 135.417,
    y1: 249.072,
    x2: 210.086,
    y2: 295.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_376_6503",
    x1: 142.108,
    y1: 146.189,
    x2: 282.306,
    y2: 203.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_376_6503",
    x1: 184.454,
    y1: 213.798,
    x2: 228.883,
    y2: 231.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_376_6503",
    x1: 187.451,
    y1: 188.598,
    x2: 256.252,
    y2: 216.626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_376_6503",
    x1: 186.225,
    y1: 194.615,
    x2: 249.512,
    y2: 220.393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_376_6503",
    x1: 185.164,
    y1: 200.098,
    x2: 243.4,
    y2: 223.819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_376_6503",
    x1: 184.319,
    y1: 204.953,
    x2: 238.102,
    y2: 226.869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_376_6503",
    x1: 183.912,
    y1: 208.589,
    x2: 234.038,
    y2: 228.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_376_6503",
    x1: 184.172,
    y1: 211.837,
    x2: 230.666,
    y2: 230.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_376_6503",
    x1: 185.502,
    y1: 214.54,
    x2: 227.409,
    y2: 231.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_376_6503",
    x1: 187.51,
    y1: 182.099,
    x2: 263.168,
    y2: 212.931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_376_6503",
    x1: 185.957,
    y1: 175.154,
    x2: 269.586,
    y2: 209.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_376_6503",
    x1: 183.137,
    y1: 168.37,
    x2: 275.637,
    y2: 206.007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_376_6503",
    x1: 177.662,
    y1: 160.997,
    x2: 281.183,
    y2: 203.186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_376_6503",
    x1: 172.288,
    y1: 156.334,
    x2: 284.088,
    y2: 201.837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_376_6503",
    x1: 166.47,
    y1: 152.934,
    x2: 285.13,
    y2: 201.169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_376_6503",
    x1: 159.991,
    y1: 151.265,
    x2: 283.784,
    y2: 201.575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_376_6503",
    x1: 153.885,
    y1: 151.923,
    x2: 280.787,
    y2: 203.554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_376_6503",
    x1: 148.02,
    y1: 154.327,
    x2: 275.712,
    y2: 206.236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_376_6503",
    x1: 140.886,
    y1: 166.972,
    x2: 263.406,
    y2: 217.394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_376_6503",
    x1: 135.912,
    y1: 178.749,
    x2: 247.723,
    y2: 224.607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_376_6503",
    x1: 132.53,
    y1: 189.126,
    x2: 228.19,
    y2: 227.282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_376_6503",
    x1: 144.1,
    y1: 256.376,
    x2: 165.884,
    y2: 265.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_376_6503",
    x1: 194.878,
    y1: 116.061,
    x2: 334.723,
    y2: 173.008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_376_6503",
    x1: 236.88,
    y1: 183.123,
    x2: 281.707,
    y2: 201.377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_376_6503",
    x1: 276.628,
    y1: 151.027,
    x2: 289.146,
    y2: 154.748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_376_6503",
    x1: 269.592,
    y1: 142.907,
    x2: 283.942,
    y2: 147.237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_376_6503",
    x1: 260.018,
    y1: 136.432,
    x2: 278.413,
    y2: 142.184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_376_6503",
    x1: 247.414,
    y1: 130.422,
    x2: 272.578,
    y2: 138.779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_376_6503",
    x1: 235.942,
    y1: 127.372,
    x2: 266.533,
    y2: 138.133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_376_6503",
    x1: 217.347,
    y1: 124.239,
    x2: 259.245,
    y2: 140.826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_376_6503",
    x1: 203.02,
    y1: 123.666,
    x2: 251.968,
    y2: 145.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_376_6503",
    x1: 196.134,
    y1: 126.516,
    x2: 245.811,
    y2: 150.406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_376_6503",
    x1: 195.108,
    y1: 132.118,
    x2: 242.083,
    y2: 154.393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_376_6503",
    x1: 195.31,
    y1: 138.874,
    x2: 239.867,
    y2: 157.883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_376_6503",
    x1: 196.774,
    y1: 146.615,
    x2: 237.987,
    y2: 162.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_376_6503",
    x1: 199.769,
    y1: 154.966,
    x2: 236.714,
    y2: 168.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_376_6503",
    x1: 204.107,
    y1: 163.884,
    x2: 236.135,
    y2: 175.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_376_6503",
    x1: 209.88,
    y1: 173.13,
    x2: 236.636,
    y2: 182.155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_376_6503",
    x1: 216.914,
    y1: 182.527,
    x2: 238.063,
    y2: 189.297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_376_6503",
    x1: 225.218,
    y1: 191.898,
    x2: 240.717,
    y2: 196.615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_376_6503",
    x1: 234.322,
    y1: 201.437,
    x2: 244.421,
    y2: 204.378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_376_6503",
    x1: 243.272,
    y1: 211.126,
    x2: 249.552,
    y2: 212.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_376_6503",
    x1: 251.575,
    y1: 220.303,
    x2: 256.381,
    y2: 221.645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_376_6503",
    x1: 258.154,
    y1: 228.315,
    x2: 264.65,
    y2: 230.157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_376_6503",
    x1: 263.093,
    y1: 234.698,
    x2: 273.295,
    y2: 237.691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear_376_6503",
    x1: 268.018,
    y1: 240.129,
    x2: 282.062,
    y2: 244.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_376_6503",
    x1: 272.856,
    y1: 244.992,
    x2: 310.239,
    y2: 259.962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_376_6503",
    x1: 272.419,
    y1: 244.233,
    x2: 290.459,
    y2: 249.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_376_6503",
    x1: 275.547,
    y1: 246.636,
    x2: 298.223,
    y2: 254.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear_376_6503",
    x1: 280.082,
    y1: 249.398,
    x2: 305.234,
    y2: 258.169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_376_6503",
    x1: 280.837,
    y1: 249.604,
    x2: 314.835,
    y2: 264.141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear_376_6503",
    x1: 281.965,
    y1: 248.829,
    x2: 317.198,
    y2: 266.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear_376_6503",
    x1: 281.652,
    y1: 246.227,
    x2: 317.306,
    y2: 267.256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear_376_6503",
    x1: 281.695,
    y1: 242.601,
    x2: 313.996,
    y2: 267.641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_376_6503",
    x1: 281.819,
    y1: 237.988,
    x2: 311.684,
    y2: 264.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_376_6503",
    x1: 282.143,
    y1: 232.083,
    x2: 316.513,
    y2: 254.549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear_376_6503",
    x1: 282.703,
    y1: 224.759,
    x2: 318.173,
    y2: 243.296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear_376_6503",
    x1: 283.668,
    y1: 215.67,
    x2: 317.985,
    y2: 230.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint175_linear_376_6503",
    x1: 284.905,
    y1: 205.873,
    x2: 316.128,
    y2: 217.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint176_linear_376_6503",
    x1: 285.748,
    y1: 196.144,
    x2: 313.067,
    y2: 205.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint177_linear_376_6503",
    x1: 285.819,
    y1: 186.062,
    x2: 309.071,
    y2: 193.729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint178_linear_376_6503",
    x1: 284.949,
    y1: 176.345,
    x2: 304.379,
    y2: 182.481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint179_linear_376_6503",
    x1: 283.192,
    y1: 167.269,
    x2: 299.434,
    y2: 172.245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint180_linear_376_6503",
    x1: 280.421,
    y1: 158.683,
    x2: 294.226,
    y2: 162.824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint181_linear_376_6503",
    x1: 207.132,
    y1: 130.653,
    x2: 245.068,
    y2: 146.053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint182_linear_376_6503",
    x1: 258.753,
    y1: 191.993,
    x2: 297.552,
    y2: 228.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint183_linear_376_6503",
    x1: 254.119,
    y1: 182.847,
    x2: 296.27,
    y2: 217.648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint184_linear_376_6503",
    x1: 249.81,
    y1: 173.661,
    x2: 294.465,
    y2: 205.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint185_linear_376_6503",
    x1: 247.075,
    y1: 164.79,
    x2: 292.071,
    y2: 191.932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint186_linear_376_6503",
    x1: 244.361,
    y1: 156.388,
    x2: 287.882,
    y2: 179.206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint187_linear_376_6503",
    x1: 245.697,
    y1: 149.673,
    x2: 283.617,
    y2: 166.711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint188_linear_376_6503",
    x1: 247.107,
    y1: 143.712,
    x2: 277.713,
    y2: 155.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint189_linear_376_6503",
    x1: 248.21,
    y1: 138.818,
    x2: 271.287,
    y2: 146.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint190_linear_376_6503",
    x1: 249.033,
    y1: 135.084,
    x2: 266.003,
    y2: 140.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint191_linear_376_6503",
    x1: 249.669,
    y1: 132.388,
    x2: 261.371,
    y2: 135.966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint192_linear_376_6503",
    x1: 246.764,
    y1: 130.142,
    x2: 257.247,
    y2: 133.303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint193_linear_376_6503",
    x1: 236.825,
    y1: 127.646,
    x2: 252.956,
    y2: 132.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint194_linear_376_6503",
    x1: 226.578,
    y1: 126.848,
    x2: 249.142,
    y2: 134.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint195_linear_376_6503",
    x1: 217.3,
    y1: 127.971,
    x2: 245.816,
    y2: 138.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint196_linear_376_6503",
    x1: 199.423,
    y1: 135.385,
    x2: 238.985,
    y2: 154.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint197_linear_376_6503",
    x1: 193.683,
    y1: 141.789,
    x2: 235.158,
    y2: 165.215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint198_linear_376_6503",
    x1: 189.892,
    y1: 150.104,
    x2: 231.406,
    y2: 177.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint199_linear_376_6503",
    x1: 187.576,
    y1: 159.587,
    x2: 226.943,
    y2: 190.677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint200_linear_376_6503",
    x1: 186.567,
    y1: 169.974,
    x2: 219.961,
    y2: 204.757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint201_linear_376_6503",
    x1: 186.702,
    y1: 181.162,
    x2: 208.597,
    y2: 216.977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint202_linear_376_6503",
    x1: 188.097,
    y1: 192.404,
    x2: 198.921,
    y2: 223.815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint203_linear_376_6503",
    x1: 190.868,
    y1: 202.628,
    x2: 205.204,
    y2: 236.811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint204_linear_376_6503",
    x1: 195.23,
    y1: 211.315,
    x2: 223.297,
    y2: 249.627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint205_linear_376_6503",
    x1: 201.537,
    y1: 218.483,
    x2: 241.846,
    y2: 254.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint206_linear_376_6503",
    x1: 209.324,
    y1: 224.862,
    x2: 254.737,
    y2: 255.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint207_linear_376_6503",
    x1: 217.794,
    y1: 230.257,
    x2: 264.75,
    y2: 256.785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint208_linear_376_6503",
    x1: 226.746,
    y1: 234.459,
    x2: 273.659,
    y2: 257.869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint209_linear_376_6503",
    x1: 236.687,
    y1: 238.073,
    x2: 282.234,
    y2: 258.733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint210_linear_376_6503",
    x1: 248.751,
    y1: 241.005,
    x2: 291.005,
    y2: 258.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint211_linear_376_6503",
    x1: 260.109,
    y1: 242.911,
    x2: 299.108,
    y2: 258.089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint212_linear_376_6503",
    x1: 272.555,
    y1: 244.061,
    x2: 306.907,
    y2: 256.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint213_linear_376_6503",
    x1: 279.793,
    y1: 243.038,
    x2: 313.536,
    y2: 255.092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint214_linear_376_6503",
    x1: 278.4,
    y1: 238.855,
    x2: 318.092,
    y2: 253.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint215_linear_376_6503",
    x1: 276.928,
    y1: 234.084,
    x2: 321.24,
    y2: 252.253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint216_linear_376_6503",
    x1: 275.693,
    y1: 228.833,
    x2: 322.139,
    y2: 251.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint217_linear_376_6503",
    x1: 273.817,
    y1: 222.775,
    x2: 320.581,
    y2: 249.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint218_linear_376_6503",
    x1: 271.013,
    y1: 215.919,
    x2: 315.952,
    y2: 247.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint219_linear_376_6503",
    x1: 267.366,
    y1: 208.635,
    x2: 306.49,
    y2: 244.234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint220_linear_376_6503",
    x1: 263.062,
    y1: 200.58,
    x2: 298.928,
    y2: 237.606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint221_linear_376_6503",
    x1: 247.338,
    y1: 85.4356,
    x2: 387.537,
    y2: 142.527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint222_linear_376_6503",
    x1: 289.674,
    y1: 153.026,
    x2: 334.103,
    y2: 171.118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint223_linear_376_6503",
    x1: 303.721,
    y1: 187.12,
    x2: 304.228,
    y2: 187.327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint224_linear_376_6503",
    x1: 296.972,
    y1: 187.631,
    x2: 301.005,
    y2: 189.273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint225_linear_376_6503",
    x1: 283.335,
    y1: 193.861,
    x2: 289.076,
    y2: 196.198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint226_linear_376_6503",
    x1: 268.524,
    y1: 202.653,
    x2: 274.016,
    y2: 204.889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint227_linear_376_6503",
    x1: 259.902,
    y1: 210.643,
    x2: 262.258,
    y2: 211.603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint228_linear_376_6503",
    x1: 253.794,
    y1: 202.708,
    x2: 254.332,
    y2: 202.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint229_linear_376_6503",
    x1: 257.384,
    y1: 196.044,
    x2: 261.104,
    y2: 197.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint230_linear_376_6503",
    x1: 269.607,
    y1: 187.075,
    x2: 275.658,
    y2: 189.613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint231_linear_376_6503",
    x1: 284.9,
    y1: 180.458,
    x2: 290.462,
    y2: 182.929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint232_linear_376_6503",
    x1: 296.821,
    y1: 179.142,
    x2: 299.503,
    y2: 180.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint233_linear_376_6503",
    x1: 245.238,
    y1: 181.633,
    x2: 245.631,
    y2: 181.758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint234_linear_376_6503",
    x1: 248.31,
    y1: 173.073,
    x2: 251.544,
    y2: 174.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint235_linear_376_6503",
    x1: 259.846,
    y1: 164.361,
    x2: 266.252,
    y2: 167.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint236_linear_376_6503",
    x1: 275.693,
    y1: 160.83,
    x2: 281.811,
    y2: 164.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint237_linear_376_6503",
    x1: 289.543,
    y1: 163.535,
    x2: 292.554,
    y2: 166.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint238_linear_376_6503",
    x1: 243.312,
    y1: 167.17,
    x2: 244.285,
    y2: 167.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint239_linear_376_6503",
    x1: 249.607,
    y1: 157.119,
    x2: 255.12,
    y2: 159.351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint240_linear_376_6503",
    x1: 264.517,
    y1: 151.557,
    x2: 271.242,
    y2: 155.114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint241_linear_376_6503",
    x1: 280.162,
    y1: 153.192,
    x2: 282.028,
    y2: 157.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint242_linear_376_6503",
    x1: 291.752,
    y1: 158.757,
    x2: 293.055,
    y2: 159.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint243_linear_376_6503",
    x1: 285.418,
    y1: 147.459,
    x2: 290.347,
    y2: 150.102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint244_linear_376_6503",
    x1: 270.358,
    y1: 142.482,
    x2: 275.409,
    y2: 147.518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint245_linear_376_6503",
    x1: 254.17,
    y1: 143.128,
    x2: 260.803,
    y2: 146.302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint246_linear_376_6503",
    x1: 242.98,
    y1: 151.278,
    x2: 246.154,
    y2: 152.407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint247_linear_376_6503",
    x1: 239.881,
    y1: 158.809,
    x2: 240.27,
    y2: 158.958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint248_linear_376_6503",
    x1: 289.436,
    y1: 145.181,
    x2: 292.464,
    y2: 146.267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint249_linear_376_6503",
    x1: 277.312,
    y1: 136.157,
    x2: 282.726,
    y2: 140.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint250_linear_376_6503",
    x1: 260.886,
    y1: 132.493,
    x2: 267.503,
    y2: 136.891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint251_linear_376_6503",
    x1: 246.364,
    y1: 136.097,
    x2: 251.704,
    y2: 138.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint252_linear_376_6503",
    x1: 240.459,
    y1: 146.916,
    x2: 241.195,
    y2: 147.128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint253_linear_376_6503",
    x1: 292.95,
    y1: 125.126,
    x2: 364.445,
    y2: 154.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint254_linear_376_6503",
    x1: 291.351,
    y1: 133.66,
    x2: 354.925,
    y2: 159.549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint255_linear_376_6503",
    x1: 289.798,
    y1: 141.21,
    x2: 346.447,
    y2: 164.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint256_linear_376_6503",
    x1: 289.069,
    y1: 147.07,
    x2: 340.058,
    y2: 167.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint257_linear_376_6503",
    x1: 289.325,
    y1: 150.765,
    x2: 336.316,
    y2: 169.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint258_linear_376_6503",
    x1: 290.641,
    y1: 153.731,
    x2: 333.755,
    y2: 171.288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint259_linear_376_6503",
    x1: 291.52,
    y1: 115.845,
    x2: 373.527,
    y2: 149.246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint260_linear_376_6503",
    x1: 245.544,
    y1: 108.342,
    x2: 362.984,
    y2: 156.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint261_linear_376_6503",
    x1: 238.368,
    y1: 125.532,
    x2: 342.231,
    y2: 167.826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint262_linear_376_6503",
    x1: 236.441,
    y1: 154.247,
    x2: 311.24,
    y2: 184.671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint263_linear_376_6503",
    x1: 287.119,
    y1: 105.892,
    x2: 382.136,
    y2: 144.578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint264_linear_376_6503",
    x1: 253.68,
    y1: 97.2574,
    x2: 377.766,
    y2: 147.787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint265_linear_376_6503",
    x1: 280.223,
    y1: 97.7209,
    x2: 387.878,
    y2: 141.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint266_linear_376_6503",
    x1: 263.1,
    y1: 91.7375,
    x2: 387.267,
    y2: 142.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint267_linear_376_6503",
    x1: 272.133,
    y1: 92.4269,
    x2: 390.161,
    y2: 140.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint268_linear_376_6503",
    x1: 242.364,
    y1: 131.681,
    x2: 245.312,
    y2: 132.676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint269_linear_376_6503",
    x1: 252.778,
    y1: 124.231,
    x2: 259.433,
    y2: 127.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint270_linear_376_6503",
    x1: 268.976,
    y1: 126.188,
    x2: 270.325,
    y2: 130.591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint271_linear_376_6503",
    x1: 284.528,
    y1: 133.009,
    x2: 290.236,
    y2: 135.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint272_linear_376_6503",
    x1: 290.208,
    y1: 133.793,
    x2: 293.557,
    y2: 134.938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint273_linear_376_6503",
    x1: 278.202,
    y1: 121.716,
    x2: 284.994,
    y2: 125.846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint274_linear_376_6503",
    x1: 261.612,
    y1: 116.401,
    x2: 267.254,
    y2: 121.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint275_linear_376_6503",
    x1: 247.743,
    y1: 118.57,
    x2: 252.828,
    y2: 120.644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint276_linear_376_6503",
    x1: 241.782,
    y1: 129.17,
    x2: 242.371,
    y2: 129.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint277_linear_376_6503",
    x1: 245.772,
    y1: 116.193,
    x2: 248.823,
    y2: 117.205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint278_linear_376_6503",
    x1: 256.117,
    y1: 108.949,
    x2: 262.78,
    y2: 112.447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint279_linear_376_6503",
    x1: 272.116,
    y1: 111.998,
    x2: 277.626,
    y2: 117.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint280_linear_376_6503",
    x1: 287.08,
    y1: 121.802,
    x2: 292.995,
    y2: 124.252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint281_linear_376_6503",
    x1: 293.028,
    y1: 137.249,
    x2: 293.809,
    y2: 137.472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint282_linear_376_6503",
    x1: 292.173,
    y1: 141.035,
    x2: 293.409,
    y2: 141.421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint283_linear_376_6503",
    x1: 293.915,
    y1: 125.734,
    x2: 297.083,
    y2: 126.769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint284_linear_376_6503",
    x1: 282.969,
    y1: 110.877,
    x2: 290.102,
    y2: 114.518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint285_linear_376_6503",
    x1: 266.918,
    y1: 104.565,
    x2: 270.387,
    y2: 109.937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint286_linear_376_6503",
    x1: 252.43,
    y1: 105.176,
    x2: 258.432,
    y2: 107.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint287_linear_376_6503",
    x1: 261.393,
    y1: 98.2854,
    x2: 270.094,
    y2: 102.894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint288_linear_376_6503",
    x1: 279.565,
    y1: 102.659,
    x2: 285.845,
    y2: 107.048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint289_linear_376_6503",
    x1: 293.028,
    y1: 114.268,
    x2: 298.535,
    y2: 116.339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint290_linear_376_6503",
    x1: 297.366,
    y1: 131.551,
    x2: 298.087,
    y2: 131.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint291_linear_376_6503",
    x1: 276.696,
    y1: 97.5753,
    x2: 278.886,
    y2: 102.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint292_linear_376_6503",
    x1: 291.646,
    y1: 104.614,
    x2: 298.293,
    y2: 107.565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint293_linear_376_6503",
    x1: 300.484,
    y1: 121.052,
    x2: 303.043,
    y2: 121.849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint294_linear_376_6503",
    x1: 295.21,
    y1: 136.908,
    x2: 298.216,
    y2: 137.885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint295_linear_376_6503",
    x1: 290.009,
    y1: 98.8838,
    x2: 296.284,
    y2: 102.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint296_linear_376_6503",
    x1: 302.133,
    y1: 111.069,
    x2: 306.635,
    y2: 112.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint297_linear_376_6503",
    x1: 303.539,
    y1: 128.813,
    x2: 304.644,
    y2: 129.129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint298_linear_376_6503",
    x1: 292.117,
    y1: 142.596,
    x2: 295.917,
    y2: 144.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint299_linear_376_6503",
    x1: 293.587,
    y1: 97.9405,
    x2: 295.74,
    y2: 99.6931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint300_linear_376_6503",
    x1: 302.517,
    y1: 103.841,
    x2: 308.624,
    y2: 106.397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint301_linear_376_6503",
    x1: 309.049,
    y1: 120.609,
    x2: 310.483,
    y2: 121.027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint302_linear_376_6503",
    x1: 301.212,
    y1: 136.346,
    x2: 304.847,
    y2: 137.565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint303_linear_376_6503",
    x1: 291.234,
    y1: 147.701,
    x2: 292.465,
    y2: 148.261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint304_linear_376_6503",
    x1: 302.13,
    y1: 100.482,
    x2: 308.537,
    y2: 104.343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint305_linear_376_6503",
    x1: 312.705,
    y1: 112.876,
    x2: 316.072,
    y2: 113.969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint306_linear_376_6503",
    x1: 310.75,
    y1: 130.023,
    x2: 312.527,
    y2: 130.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint307_linear_376_6503",
    x1: 297.18,
    y1: 143.284,
    x2: 302.463,
    y2: 145.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint308_linear_376_6503",
    x1: 292.901,
    y1: 148.897,
    x2: 298.298,
    y2: 151.879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint309_linear_376_6503",
    x1: 308.124,
    y1: 139.051,
    x2: 312.174,
    y2: 140.447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint310_linear_376_6503",
    x1: 318.684,
    y1: 124.261,
    x2: 319.345,
    y2: 124.445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint311_linear_376_6503",
    x1: 315.443,
    y1: 108.512,
    x2: 319.998,
    y2: 110.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint312_linear_376_6503",
    x1: 320.075,
    y1: 110.173,
    x2: 322.894,
    y2: 111.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint313_linear_376_6503",
    x1: 324.502,
    y1: 119.292,
    x2: 326.2,
    y2: 119.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint314_linear_376_6503",
    x1: 318.282,
    y1: 134.506,
    x2: 321.104,
    y2: 135.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint315_linear_376_6503",
    x1: 304.212,
    y1: 147.175,
    x2: 309.609,
    y2: 149.347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint316_linear_376_6503",
    x1: 291.337,
    y1: 152.866,
    x2: 293.663,
    y2: 156.161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint317_linear_376_6503",
    x1: 294.682,
    y1: 156.137,
    x2: 295.587,
    y2: 156.651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint318_linear_376_6503",
    x1: 300.953,
    y1: 154.362,
    x2: 306.002,
    y2: 157.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint319_linear_376_6503",
    x1: 315.541,
    y1: 144.584,
    x2: 320.089,
    y2: 146.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint320_linear_376_6503",
    x1: 327.5,
    y1: 131.183,
    x2: 329.368,
    y2: 131.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint321_linear_376_6503",
    x1: 329.402,
    y1: 118.344,
    x2: 332.029,
    y2: 119.234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint322_linear_376_6503",
    x1: 335.443,
    y1: 123.298,
    x2: 336.789,
    y2: 123.838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint323_linear_376_6503",
    x1: 336.111,
    y1: 129.483,
    x2: 336.915,
    y2: 129.711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint324_linear_376_6503",
    x1: 325.976,
    y1: 141.937,
    x2: 330.041,
    y2: 143.332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint325_linear_376_6503",
    x1: 311.747,
    y1: 153.594,
    x2: 317.126,
    y2: 155.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint326_linear_376_6503",
    x1: 299.876,
    y1: 159.852,
    x2: 302.882,
    y2: 162.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint327_linear_376_6503",
    x1: 343.012,
    y1: 132.169,
    x2: 343.846,
    y2: 132.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint328_linear_376_6503",
    x1: 336.216,
    y1: 141.031,
    x2: 339.403,
    y2: 142.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint329_linear_376_6503",
    x1: 322.798,
    y1: 152.474,
    x2: 327.98,
    y2: 154.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint330_linear_376_6503",
    x1: 308.905,
    y1: 161.929,
    x2: 313.601,
    y2: 164.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint331_linear_376_6503",
    x1: 303.213,
    y1: 165.01,
    x2: 304.282,
    y2: 165.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint332_linear_376_6503",
    x1: 359.232,
    y1: 155.082,
    x2: 359.727,
    y2: 155.284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint333_linear_376_6503",
    x1: 352.743,
    y1: 155.495,
    x2: 356.709,
    y2: 157.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint334_linear_376_6503",
    x1: 339.227,
    y1: 161.551,
    x2: 345.01,
    y2: 163.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint335_linear_376_6503",
    x1: 324.384,
    y1: 170.373,
    x2: 329.905,
    y2: 172.621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint336_linear_376_6503",
    x1: 315.517,
    y1: 178.43,
    x2: 317.981,
    y2: 179.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint337_linear_376_6503",
    x1: 348.97,
    y1: 139.176,
    x2: 349.476,
    y2: 139.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint338_linear_376_6503",
    x1: 345.283,
    y1: 142.096,
    x2: 347.88,
    y2: 142.961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint339_linear_376_6503",
    x1: 333.483,
    y1: 151.485,
    x2: 338.355,
    y2: 153.274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint340_linear_376_6503",
    x1: 318.837,
    y1: 161.969,
    x2: 324.35,
    y2: 164.212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint341_linear_376_6503",
    x1: 308.608,
    y1: 169.053,
    x2: 311.64,
    y2: 170.682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint342_linear_376_6503",
    x1: 353.866,
    y1: 148.138,
    x2: 355.324,
    y2: 148.636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint343_linear_376_6503",
    x1: 343.987,
    y1: 153.128,
    x2: 348.553,
    y2: 154.874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint344_linear_376_6503",
    x1: 329.529,
    y1: 162.057,
    x2: 335.146,
    y2: 164.281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint345_linear_376_6503",
    x1: 316.256,
    y1: 171.21,
    x2: 320.607,
    y2: 173.083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint346_linear_376_6503",
    x1: 311.625,
    y1: 176.045,
    x2: 312.472,
    y2: 176.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint347_linear_376_6503",
    x1: 264.845,
    y1: 222.433,
    x2: 265.677,
    y2: 222.852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint348_linear_376_6503",
    x1: 269.453,
    y1: 218.014,
    x2: 273.727,
    y2: 219.862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint349_linear_376_6503",
    x1: 282.598,
    y1: 208.792,
    x2: 288.24,
    y2: 211.027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint350_linear_376_6503",
    x1: 297.095,
    y1: 199.675,
    x2: 301.666,
    y2: 201.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint351_linear_376_6503",
    x1: 306.927,
    y1: 194.048,
    x2: 308.353,
    y2: 194.522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint352_linear_376_6503",
    x1: 312.701,
    y1: 200.316,
    x2: 313.132,
    y2: 200.465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint353_linear_376_6503",
    x1: 309.385,
    y1: 203.764,
    x2: 311.728,
    y2: 204.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint354_linear_376_6503",
    x1: 297.458,
    y1: 213.528,
    x2: 302.283,
    y2: 215.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint355_linear_376_6503",
    x1: 282.647,
    y1: 223.999,
    x2: 288.277,
    y2: 226.318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint356_linear_376_6503",
    x1: 272.569,
    y1: 230.832,
    x2: 275.489,
    y2: 232.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint357_linear_376_6503",
    x1: 278.633,
    y1: 240.512,
    x2: 279.491,
    y2: 241.074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint358_linear_376_6503",
    x1: 283.963,
    y1: 237.764,
    x2: 288.695,
    y2: 240.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint359_linear_376_6503",
    x1: 298.058,
    y1: 228.242,
    x2: 303.271,
    y2: 230.207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint360_linear_376_6503",
    x1: 311.595,
    y1: 216.602,
    x2: 314.674,
    y2: 217.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint361_linear_376_6503",
    x1: 317.619,
    y1: 206.785,
    x2: 318.68,
    y2: 207.104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint362_linear_376_6503",
    x1: 286.799,
    y1: 247.824,
    x2: 289.625,
    y2: 250.561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint363_linear_376_6503",
    x1: 298.381,
    y1: 241.753,
    x2: 303.975,
    y2: 244.044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint364_linear_376_6503",
    x1: 313.05,
    y1: 230.231,
    x2: 317.094,
    y2: 231.619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint365_linear_376_6503",
    x1: 323.02,
    y1: 217.365,
    x2: 323.733,
    y2: 217.565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint366_linear_376_6503",
    x1: 321.893,
    y1: 210.566,
    x2: 322.987,
    y2: 210.983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint367_linear_376_6503",
    x1: 327.734,
    y1: 216.675,
    x2: 330.638,
    y2: 217.666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint368_linear_376_6503",
    x1: 326.549,
    y1: 229.966,
    x2: 328.267,
    y2: 230.478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint369_linear_376_6503",
    x1: 314.305,
    y1: 243.539,
    x2: 319.022,
    y2: 245.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint370_linear_376_6503",
    x1: 300.238,
    y1: 253.374,
    x2: 304.895,
    y2: 255.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint371_linear_376_6503",
    x1: 329.097,
    y1: 216.446,
    x2: 333.441,
    y2: 218.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint372_linear_376_6503",
    x1: 335.145,
    y1: 227.327,
    x2: 337.117,
    y2: 227.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint373_linear_376_6503",
    x1: 329.116,
    y1: 242.627,
    x2: 332.091,
    y2: 243.575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint374_linear_376_6503",
    x1: 315.037,
    y1: 255.311,
    x2: 320.514,
    y2: 257.565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint375_linear_376_6503",
    x1: 302.117,
    y1: 260.488,
    x2: 304.356,
    y2: 263.745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint376_linear_376_6503",
    x1: 315.924,
    y1: 263.727,
    x2: 321.153,
    y2: 266.615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint377_linear_376_6503",
    x1: 330.773,
    y1: 254.173,
    x2: 334.851,
    y2: 255.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint378_linear_376_6503",
    x1: 341.256,
    y1: 239.152,
    x2: 341.913,
    y2: 239.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint379_linear_376_6503",
    x1: 338.119,
    y1: 223.544,
    x2: 342.641,
    y2: 225.233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint380_linear_376_6503",
    x1: 337.696,
    y1: 220.676,
    x2: 343.343,
    y2: 223.691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint381_linear_376_6503",
    x1: 346.631,
    y1: 233.007,
    x2: 350.007,
    y2: 234.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint382_linear_376_6503",
    x1: 344.597,
    y1: 250.038,
    x2: 346.581,
    y2: 250.634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint383_linear_376_6503",
    x1: 331.323,
    y1: 263.287,
    x2: 336.382,
    y2: 265.343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint384_linear_376_6503",
    x1: 321.714,
    y1: 269.336,
    x2: 323.066,
    y2: 270.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint385_linear_376_6503",
    x1: 330.261,
    y1: 268.201,
    x2: 336.044,
    y2: 271.555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint386_linear_376_6503",
    x1: 345.708,
    y1: 258.904,
    x2: 349.761,
    y2: 260.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint387_linear_376_6503",
    x1: 353.754,
    y1: 243.14,
    x2: 355.664,
    y2: 243.711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint388_linear_376_6503",
    x1: 347.756,
    y1: 226.455,
    x2: 353.437,
    y2: 228.731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint389_linear_376_6503",
    x1: 335.608,
    y1: 219.429,
    x2: 337.911,
    y2: 223.318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint390_linear_376_6503",
    x1: 334.451,
    y1: 218.417,
    x2: 337.469,
    y2: 220.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint391_linear_376_6503",
    x1: 345.237,
    y1: 221.387,
    x2: 351.597,
    y2: 225.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint392_linear_376_6503",
    x1: 357.055,
    y1: 234.044,
    x2: 361.596,
    y2: 235.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint393_linear_376_6503",
    x1: 358.398,
    y1: 251.663,
    x2: 359.548,
    y2: 251.992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint394_linear_376_6503",
    x1: 344.029,
    y1: 264.508,
    x2: 350.382,
    y2: 267.157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint395_linear_376_6503",
    x1: 358.892,
    y1: 257.345,
    x2: 362.379,
    y2: 258.507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint396_linear_376_6503",
    x1: 364.549,
    y1: 241.702,
    x2: 367.235,
    y2: 242.548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint397_linear_376_6503",
    x1: 355.644,
    y1: 225.247,
    x2: 362.461,
    y2: 228.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint398_linear_376_6503",
    x1: 340.983,
    y1: 218.133,
    x2: 342.759,
    y2: 222.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint399_linear_376_6503",
    x1: 369.632,
    y1: 246.994,
    x2: 370.463,
    y2: 247.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint400_linear_376_6503",
    x1: 365.481,
    y1: 230.228,
    x2: 370.949,
    y2: 232.297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint401_linear_376_6503",
    x1: 351.748,
    y1: 218.549,
    x2: 358.022,
    y2: 223.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint402_linear_376_6503",
    x1: 336.345,
    y1: 214.9,
    x2: 342.518,
    y2: 218.714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint403_linear_376_6503",
    x1: 372.761,
    y1: 234.759,
    x2: 375.626,
    y2: 235.676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint404_linear_376_6503",
    x1: 361.83,
    y1: 219.927,
    x2: 369.068,
    y2: 223.674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint405_linear_376_6503",
    x1: 345.922,
    y1: 213.569,
    x2: 349.23,
    y2: 218.878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint406_linear_376_6503",
    x1: 333.181,
    y1: 214.575,
    x2: 337.425,
    y2: 216.386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint407_linear_376_6503",
    x1: 376.272,
    y1: 237.799,
    x2: 377.089,
    y2: 238.049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint408_linear_376_6503",
    x1: 371.064,
    y1: 221.823,
    x2: 376.782,
    y2: 224.092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint409_linear_376_6503",
    x1: 355.799,
    y1: 212.518,
    x2: 360.198,
    y2: 217.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint410_linear_376_6503",
    x1: 339.809,
    y1: 209.222,
    x2: 346.387,
    y2: 212.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint411_linear_376_6503",
    x1: 331.345,
    y1: 216.66,
    x2: 332.308,
    y2: 217.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint412_linear_376_6503",
    x1: 377.015,
    y1: 223.47,
    x2: 380.234,
    y2: 224.524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint413_linear_376_6503",
    x1: 365.007,
    y1: 211.101,
    x2: 371.952,
    y2: 215.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint414_linear_376_6503",
    x1: 348.526,
    y1: 205.94,
    x2: 353.782,
    y2: 211.297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint415_linear_376_6503",
    x1: 334.134,
    y1: 207.761,
    x2: 339.663,
    y2: 210.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint416_linear_376_6503",
    x1: 330.254,
    y1: 208.797,
    x2: 333.296,
    y2: 209.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint417_linear_376_6503",
    x1: 341.151,
    y1: 201.437,
    x2: 347.792,
    y2: 204.917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint418_linear_376_6503",
    x1: 357.394,
    y1: 203.239,
    x2: 358.79,
    y2: 207.606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint419_linear_376_6503",
    x1: 373.038,
    y1: 210.173,
    x2: 378.581,
    y2: 212.635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint420_linear_376_6503",
    x1: 377.471,
    y1: 208.232,
    x2: 379.593,
    y2: 209.011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint421_linear_376_6503",
    x1: 365.257,
    y1: 199.64,
    x2: 370.252,
    y2: 204.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint422_linear_376_6503",
    x1: 348.955,
    y1: 196.085,
    x2: 355.513,
    y2: 200.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint423_linear_376_6503",
    x1: 334.294,
    y1: 199.579,
    x2: 339.85,
    y2: 201.869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint424_linear_376_6503",
    x1: 328.262,
    y1: 210.003,
    x2: 329.021,
    y2: 210.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint425_linear_376_6503",
    x1: 326.22,
    y1: 209.905,
    x2: 326.711,
    y2: 210.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint426_linear_376_6503",
    x1: 329.337,
    y1: 199.612,
    x2: 332.431,
    y2: 200.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint427_linear_376_6503",
    x1: 340.461,
    y1: 191.736,
    x2: 347.045,
    y2: 194.938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint428_linear_376_6503",
    x1: 356.731,
    y1: 190.972,
    x2: 361.979,
    y2: 195.707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint429_linear_376_6503",
    x1: 371.728,
    y1: 195.599,
    x2: 376.3,
    y2: 198.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint430_linear_376_6503",
    x1: 374.099,
    y1: 190.344,
    x2: 375.495,
    y2: 190.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint431_linear_376_6503",
    x1: 362.895,
    y1: 185.715,
    x2: 365.157,
    y2: 190.069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint432_linear_376_6503",
    x1: 347.411,
    y1: 184.478,
    x2: 354.172,
    y2: 188.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint433_linear_376_6503",
    x1: 332.447,
    y1: 189.86,
    x2: 338.042,
    y2: 192.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint434_linear_376_6503",
    x1: 325.996,
    y1: 199.638,
    x2: 327.046,
    y2: 199.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint435_linear_376_6503",
    x1: 367.265,
    y1: 179.226,
    x2: 369.744,
    y2: 181.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint436_linear_376_6503",
    x1: 353.791,
    y1: 177.245,
    x2: 359.768,
    y2: 180.685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint437_linear_376_6503",
    x1: 337.915,
    y1: 180.875,
    x2: 344.248,
    y2: 183.694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint438_linear_376_6503",
    x1: 326.187,
    y1: 189.419,
    x2: 329.631,
    y2: 190.674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint439_linear_376_6503",
    x1: 322.912,
    y1: 197.775,
    x2: 323.379,
    y2: 197.923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint440_linear_376_6503",
    x1: 367.534,
    y1: 171.835,
    x2: 368.291,
    y2: 172.211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint441_linear_376_6503",
    x1: 358.638,
    y1: 169.886,
    x2: 363.492,
    y2: 172.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint442_linear_376_6503",
    x1: 343.788,
    y1: 172.429,
    x2: 350.252,
    y2: 175.427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint443_linear_376_6503",
    x1: 328.882,
    y1: 179.39,
    x2: 334.407,
    y2: 181.641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint444_linear_376_6503",
    x1: 321.254,
    y1: 188.432,
    x2: 323.037,
    y2: 189.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint445_linear_376_6503",
    x1: 360.378,
    y1: 161.497,
    x2: 362.863,
    y2: 162.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint446_linear_376_6503",
    x1: 348.893,
    y1: 163.179,
    x2: 354.269,
    y2: 165.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint447_linear_376_6503",
    x1: 333.553,
    y1: 169.833,
    x2: 339.59,
    y2: 172.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint448_linear_376_6503",
    x1: 321.229,
    y1: 178.797,
    x2: 325.048,
    y2: 180.276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint449_linear_376_6503",
    x1: 317.203,
    y1: 185.361,
    x2: 317.873,
    y2: 185.611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint450_linear_376_6503",
    x1: 296.508,
    y1: 172.785,
    x2: 297.196,
    y2: 173.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint451_linear_376_6503",
    x1: 286.982,
    y1: 170.374,
    x2: 291.852,
    y2: 173.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint452_linear_376_6503",
    x1: 272.067,
    y1: 172.665,
    x2: 278.497,
    y2: 175.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint453_linear_376_6503",
    x1: 257.175,
    y1: 179.587,
    x2: 262.649,
    y2: 181.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint454_linear_376_6503",
    x1: 249.85,
    y1: 188.898,
    x2: 251.503,
    y2: 189.456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint455_linear_376_6503",
    x1: 300.519,
    y1: 54.731,
    x2: 440.717,
    y2: 111.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint456_linear_376_6503",
    x1: 342.853,
    y1: 122.321,
    x2: 387.281,
    y2: 140.413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint457_linear_376_6503",
    x1: 346.133,
    y1: 94.4217,
    x2: 417.628,
    y2: 123.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint458_linear_376_6503",
    x1: 344.527,
    y1: 102.958,
    x2: 408.101,
    y2: 128.846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint459_linear_376_6503",
    x1: 342.982,
    y1: 110.506,
    x2: 399.633,
    y2: 133.576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint460_linear_376_6503",
    x1: 342.247,
    y1: 116.364,
    x2: 393.237,
    y2: 137.128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint461_linear_376_6503",
    x1: 342.507,
    y1: 120.061,
    x2: 389.498,
    y2: 139.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint462_linear_376_6503",
    x1: 343.822,
    y1: 123.026,
    x2: 386.936,
    y2: 140.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint463_linear_376_6503",
    x1: 344.699,
    y1: 85.1409,
    x2: 426.707,
    y2: 118.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint464_linear_376_6503",
    x1: 298.724,
    y1: 77.6374,
    x2: 416.163,
    y2: 125.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint465_linear_376_6503",
    x1: 291.547,
    y1: 94.8269,
    x2: 395.409,
    y2: 137.121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint466_linear_376_6503",
    x1: 289.622,
    y1: 123.543,
    x2: 364.422,
    y2: 153.969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint467_linear_376_6503",
    x1: 340.245,
    y1: 75.173,
    x2: 435.305,
    y2: 113.883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint468_linear_376_6503",
    x1: 306.861,
    y1: 66.5538,
    x2: 430.947,
    y2: 117.083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint469_linear_376_6503",
    x1: 333.404,
    y1: 67.0211,
    x2: 441.059,
    y2: 110.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint470_linear_376_6503",
    x1: 316.278,
    y1: 61.0334,
    x2: 440.443,
    y2: 111.594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint471_linear_376_6503",
    x1: 325.313,
    y1: 61.7222,
    x2: 443.345,
    y2: 109.787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataAssurance);
export default __webpack_public_path__ + "static/media/data-assurance.a52de3135d0a128c4cad20ce8b28af13.svg";
export { ForwardRef as ReactComponent };